var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
var ErrorMessage = /* @__PURE__ */ ((ErrorMessage2) => {
  ErrorMessage2["ABR_UNAVAILABLE"] = "Single bitrate stream detected, adaptive bitrate system is unavailable";
  ErrorMessage2["ABR_MANUAL_SWITCHING_REACHED_LOWER_BOUNDS"] = "You have reached the lowest available quality for this presentation.";
  ErrorMessage2["ABR_MANUAL_SWITCHING_REACHED_UPPER_BOUNDS"] = "You have reached the highest available quality for this presentation at this screen size";
  ErrorMessage2["ABR_MIN_BITRATE_RESTRICTION_UNAVAILABLE"] = "Min bitrate restrictions are not offered with this streaming library";
  ErrorMessage2["ACTION_HANDLER_ERROR"] = "An error occurred within a registered action handler";
  ErrorMessage2["AD_STALLED"] = "Stalled ad detected";
  ErrorMessage2["ADAPTER_UNAVAILABLE"] = "Unable to play the requested resource - mediaUrl not recognized";
  ErrorMessage2["ADAPTER_LIB_UNAVAILABLE"] = "Unable to play the requested resource - External library is not loading";
  ErrorMessage2["ADAPTER_NOT_FOUND"] = "Unable to find an adapter for the requested resource";
  ErrorMessage2["API_INVALID_ARG"] = "API method called with missing or invalid param";
  ErrorMessage2["CAP_LEVEL_MAXBITRATE"] = "Max bitrate setting will be ignored since capQualityToPlayerSize is enabled";
  ErrorMessage2["CONTENT_PLAYBACK_SETTING_IGNORED"] = "This API is only available after the CONTENT_START event has been dispatched. This setting will be ignored.";
  ErrorMessage2["DAI_MISSING_ASSET_URL"] = "Unexpected condition = valid assetUrl not found in DAI stream data";
  ErrorMessage2["DAI_SDK_UNAVAILABLE"] = "A DAI SDK is required for playback, but is not found";
  ErrorMessage2["ENVIRONMENT_NOT_SUPPORTED"] = 'Unable to locate a global "window" object or suitable alternative';
  ErrorMessage2["FAIRPLAY_LICENSE_ERROR"] = "Issue with fairplay DRM and the provided license acquisition url";
  ErrorMessage2["FAIRPLAY_APP_CERT_ERROR"] = "Issue creating a fairplay keysession with the provided application certificate";
  ErrorMessage2["FAIRPLAY_NO_CONTENT_ID"] = "A valid content or asset id was not detected when creating fairplay drm session";
  ErrorMessage2["FAIRPLAY_WEBKIT_ERROR"] = "Issue with webkit and keysession creations while using fairplay drm.";
  ErrorMessage2["FATAL_PLAYBACK_MEDIA_ERROR"] = "Fatal media error, no option for recovery";
  ErrorMessage2["NONFATAL_PLAYBACK_MEDIA_ERROR"] = "Nonfatal media error";
  ErrorMessage2["FATAL_PLAYBACK_NETWORK_ERROR"] = "Fatal network error, no option for recovery";
  ErrorMessage2["NONFATAL_PLAYBACK_NETWORK_ERROR"] = "Nonfatal network error";
  ErrorMessage2["IMA_SDK_MISSING"] = "IMA SDK not found.";
  ErrorMessage2["INVALID_RESOURCE"] = "Resource configuration appears to be invalid";
  ErrorMessage2["MANUAL_ABR_SWITCHING_UNAVAILABLE"] = "Native HTML5 Video does not allow manual bitrate switching";
  ErrorMessage2["PAUSING_LINEAR_LIVE_STREAM_NOT_ALLOWED"] = "StreamType.LIVE is detected. Redirecting to the stop method since a LTS window is not detected.";
  ErrorMessage2["PLUGIN_LOAD_ERROR"] = "Unable to load plugin";
  ErrorMessage2["PLUGIN_FACTORY_ERROR"] = "Invalid plugin factory";
  ErrorMessage2["PLUGIN_ID_ERROR"] = "Invalid plugin ID";
  ErrorMessage2["RESOURCE_MISSING"] = "Resource missing";
  ErrorMessage2["RESOURCE_NOT_SUPPORTED"] = "Resource is not recognized or is currently unsupported";
  ErrorMessage2["RETRY_PLAYBACK_MEDIA_ERROR"] = "Media error detected";
  ErrorMessage2["RETRY_PLAYBACK_NETWORK_ERROR"] = "Network error detected";
  ErrorMessage2["UNEXPECTED_CONDITION"] = "An unexpected condition was encountered";
  ErrorMessage2["UNSPECIFIED_ERROR"] = "Unspecified error";
  ErrorMessage2["VIDEO_PLAYBACK_UNAVAILABLE"] = "Unable to locate a video element or suitable alternative";
  ErrorMessage2["WEBKIT_KEY_ADDED_SUCCESS"] = "Webkit key added successfully";
  ErrorMessage2["WEBKIT_MEDIA_KEYS_NOT_SUPPORTED"] = "WebKitMediaKeys are not supported for this type of media on this user agent";
  return ErrorMessage2;
})(ErrorMessage || {});
const _AppResources = class _AppResources {
  constructor() {
  }
};
_AppResources.blankVideoUrl = "https:/avia.vtg.paramount.tech/h5/blanks/uvp_blank.mp4";
_AppResources.blankDataUrl = "data:video/mp4;base64,AAAAHGZ0eXBpc29tAAACAGlzb21pc28ybXA0MQAAAAhmcmVlAAAC721kYXQhEAUgpBv/wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA3pwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcCEQBSCkG//AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADengAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcAAAAsJtb292AAAAbG12aGQAAAAAAAAAAAAAAAAAAAPoAAAALwABAAABAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAAAB7HRyYWsAAABcdGtoZAAAAAMAAAAAAAAAAAAAAAIAAAAAAAAALwAAAAAAAAAAAAAAAQEAAAAAAQAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAACRlZHRzAAAAHGVsc3QAAAAAAAAAAQAAAC8AAAAAAAEAAAAAAWRtZGlhAAAAIG1kaGQAAAAAAAAAAAAAAAAAAKxEAAAIAFXEAAAAAAAtaGRscgAAAAAAAAAAc291bgAAAAAAAAAAAAAAAFNvdW5kSGFuZGxlcgAAAAEPbWluZgAAABBzbWhkAAAAAAAAAAAAAAAkZGluZgAAABxkcmVmAAAAAAAAAAEAAAAMdXJsIAAAAAEAAADTc3RibAAAAGdzdHNkAAAAAAAAAAEAAABXbXA0YQAAAAAAAAABAAAAAAAAAAAAAgAQAAAAAKxEAAAAAAAzZXNkcwAAAAADgICAIgACAASAgIAUQBUAAAAAAfQAAAHz+QWAgIACEhAGgICAAQIAAAAYc3R0cwAAAAAAAAABAAAAAgAABAAAAAAcc3RzYwAAAAAAAAABAAAAAQAAAAIAAAABAAAAHHN0c3oAAAAAAAAAAAAAAAIAAAFzAAABdAAAABRzdGNvAAAAAAAAAAEAAAAsAAAAYnVkdGEAAABabWV0YQAAAAAAAAAhaGRscgAAAAAAAAAAbWRpcmFwcGwAAAAAAAAAAAAAAAAtaWxzdAAAACWpdG9vAAAAHWRhdGEAAAABAAAAAExhdmY1Ni40MC4xMDE=";
_AppResources.messages = ErrorMessage;
let AppResources = _AppResources;
const HTML5 = "html5";
var AdapterRole = /* @__PURE__ */ ((AdapterRole2) => {
  AdapterRole2["AD"] = "ad";
  AdapterRole2["PLAYBACK"] = "playback";
  AdapterRole2["VIDEO"] = "video";
  return AdapterRole2;
})(AdapterRole || {});
var AudioTrackType = /* @__PURE__ */ ((AudioTrackType2) => {
  AudioTrackType2["MAIN"] = "main";
  AudioTrackType2["DESCRIPTION"] = "description";
  return AudioTrackType2;
})(AudioTrackType || {});
var MimeType = /* @__PURE__ */ ((MimeType2) => {
  MimeType2["MP4_VIDEO"] = "video/mp4";
  MimeType2["MP4_AUDIO"] = "audio/mp4";
  MimeType2["HLS"] = "application/vnd.apple.mpegurl";
  MimeType2["HLS_ALT"] = "application/x-mpegURL";
  MimeType2["DASH"] = "application/dash+xml";
  MimeType2["WEBM_VIDEO"] = "video/webm";
  MimeType2["WEBM_AUDIO"] = "audio/webm";
  MimeType2["TS_VIDEO"] = "video/mp2t";
  MimeType2["VTT"] = "text/vtt";
  MimeType2["TTML"] = "application/ttml+xml";
  MimeType2["ISM"] = "application/vnd.ms-sstr+xml";
  MimeType2["UNKNOWN"] = "";
  return MimeType2;
})(MimeType || {});
var PlayerHookType = /* @__PURE__ */ ((PlayerHookType2) => {
  PlayerHookType2["EVENT"] = "event";
  PlayerHookType2["AD_BREAK"] = "adbreak";
  PlayerHookType2["AD"] = "ad";
  PlayerHookType2["ATTACH_RESOURCE"] = "attachresource";
  PlayerHookType2["REQUEST"] = "request";
  PlayerHookType2["RESPONSE"] = "response";
  PlayerHookType2["SEEK"] = "seek";
  return PlayerHookType2;
})(PlayerHookType || {});
var RequestObjectType = /* @__PURE__ */ ((RequestObjectType2) => {
  RequestObjectType2["MANIFEST"] = "manifest";
  RequestObjectType2["SEGMENT"] = "segment";
  RequestObjectType2["KEY"] = "key";
  RequestObjectType2["OTHER"] = "other";
  return RequestObjectType2;
})(RequestObjectType || {});
var TextTrackEvent = /* @__PURE__ */ ((TextTrackEvent2) => {
  TextTrackEvent2["CUE_CHANGE"] = "cuechange";
  TextTrackEvent2["ADD_TRACK"] = "addtrack";
  TextTrackEvent2["CHANGE"] = "change";
  return TextTrackEvent2;
})(TextTrackEvent || {});
function isEmpty(obj) {
  return obj === null || obj === void 0 || Array.isArray(obj) && obj.length === 0 || isObject(obj) && Object.keys(obj).length === 0 || isString(obj) && obj === "";
}
function isFunction(obj) {
  return typeof obj === "function";
}
function isString(obj) {
  return typeof obj === "string";
}
function isUndefined(obj) {
  return typeof obj === "undefined";
}
function isNumber(obj) {
  return typeof obj === "number";
}
function isBoolean(obj) {
  return typeof obj === "boolean";
}
function isObject(obj) {
  return typeof obj === "object";
}
const Type = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  isBoolean,
  isEmpty,
  isFunction,
  isNumber,
  isObject,
  isString,
  isUndefined
}, Symbol.toStringTag, { value: "Module" }));
function base64DecodeUint8Array(input) {
  const raw = atob(input);
  const rawLength = raw.length;
  const array = new Uint8Array(new ArrayBuffer(rawLength));
  for (let i = 0; i < rawLength; i++) {
    array[i] = raw.charCodeAt(i);
  }
  return array;
}
function base64EncodeUint8Array(input) {
  const str = String.fromCharCode.apply(null, input);
  return btoa(str);
}
function isValid$1(list, func) {
  return (list == null ? void 0 : list.length) && isFunction(func);
}
function find(list, func) {
  if (!isValid$1(list, func)) {
    return null;
  }
  for (let i = 0, len = list.length; i < len; i++) {
    const result = func(list[i], i, list);
    if (result) {
      return list[i];
    }
  }
  return null;
}
function forEach(list, func) {
  if (!isValid$1(list, func)) {
    return;
  }
  for (let i = 0, len = list.length; i < len; i++) {
    func(list[i], i, list);
  }
}
function forEachReverse(list, func) {
  if (!isValid$1(list, func)) {
    return;
  }
  for (let i = list.length - 1; i > -1; i--) {
    func(list[i], i, list);
  }
}
function bufferToString(buffer) {
  return typeof TextDecoder !== "undefined" ? new TextDecoder().decode(buffer) : String.fromCharCode.apply(null, new Uint8Array(buffer));
}
function arrayToString(array) {
  const uint16array = new Uint16Array(array.buffer);
  return String.fromCharCode.apply(null, uint16array);
}
function stringToArray(string) {
  const buffer = new ArrayBuffer(string.length * 2);
  const array = new Uint16Array(buffer);
  for (let i = 0, strLen = string.length; i < strLen; i++) {
    array[i] = string.charCodeAt(i);
  }
  return array;
}
const ArrayUtil = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  arrayToString,
  base64DecodeUint8Array,
  base64EncodeUint8Array,
  bufferToString,
  find,
  forEach,
  forEachReverse,
  stringToArray
}, Symbol.toStringTag, { value: "Module" }));
var ErrorCategory = /* @__PURE__ */ ((ErrorCategory2) => {
  ErrorCategory2["AD"] = "Ad";
  ErrorCategory2["RESOURCE"] = "Resource";
  ErrorCategory2["PLAYBACK"] = "Playback";
  ErrorCategory2["VIDEO_START"] = "Video start";
  ErrorCategory2["HOOK"] = "Hook";
  ErrorCategory2["API"] = "API";
  ErrorCategory2["EVENT"] = "Event";
  ErrorCategory2["PLUGIN"] = "Plugin";
  ErrorCategory2["ACTION_KEY"] = "Action Key";
  return ErrorCategory2;
})(ErrorCategory || {});
var ErrorCode = /* @__PURE__ */ ((ErrorCode2) => {
  ErrorCode2["INVALID_RESOURCE_FORMAT"] = "1000";
  ErrorCode2["RESOURCE_UNAVAILABLE"] = "1100";
  ErrorCode2["GEO_LOCATION_BLOCKED"] = "1101";
  ErrorCode2["DOMAIN_BLOCKED"] = "1102";
  ErrorCode2["IP_BLOCKED"] = "1103";
  ErrorCode2["SATELLITE_PROVIDER_BLOCKED"] = "1104";
  ErrorCode2["EXPIRED"] = "1105";
  ErrorCode2["SELECTOR_CALL_ERROR"] = "1106";
  ErrorCode2["IMA_SDK_MISSING"] = "1200";
  ErrorCode2["DAI_SDK_MISSING"] = "1201";
  ErrorCode2["DASH_SDK_MISSING"] = "1202";
  ErrorCode2["HLS_SDK_MISSING"] = "1203";
  ErrorCode2["SHAKA_SDK_MISSING"] = "1204";
  ErrorCode2["TWITCH_SDK_MISSING"] = "1205";
  ErrorCode2["FW_SDK_MISSING"] = "1206";
  ErrorCode2["HLSJS_PARSE_ERROR"] = "2101";
  ErrorCode2["DASHJS_PARSE_ERROR"] = "2102";
  ErrorCode2["SHAKA_PARSE_ERROR"] = "2103";
  ErrorCode2["TWITCH_PARSE_ERROR"] = "2104";
  ErrorCode2["WEBMAF_START_ERROR"] = "2105";
  ErrorCode2["USER_GESTURE_REQUIRED"] = "2300";
  ErrorCode2["HTML5_NETWORK_ERROR"] = "3001";
  ErrorCode2["HLSJS_NETWORK_ERROR"] = "3002";
  ErrorCode2["DASHJS_NETWORK_ERROR"] = "3003";
  ErrorCode2["WEBMAF_NETWORK_ERROR"] = "3004";
  ErrorCode2["SHAKA_NETWORK_ERROR"] = "3005";
  ErrorCode2["TWITCH_NETWORK_ERROR"] = "3006";
  ErrorCode2["OIPF_NETWORK_ERROR"] = "3007";
  ErrorCode2["MEDIA_ABORTED"] = "3100";
  ErrorCode2["HTML5_SRC_NOT_SUPPORTED"] = "3101";
  ErrorCode2["HLSJS_SRC_NOT_SUPPORTED"] = "3102";
  ErrorCode2["DASHJS_SRC_NOT_SUPPORTED"] = "3103";
  ErrorCode2["SHAKA_SRC_NOT_SUPPORTED"] = "3105";
  ErrorCode2["TWITCH_SRC_NOT_SUPPORTED"] = "3106";
  ErrorCode2["OIPF_SRC_NOT_SUPPORTED"] = "3107";
  ErrorCode2["HTML5_MEDIA_ERROR"] = "3200";
  ErrorCode2["HLSJS_MEDIA_ERROR"] = "3201";
  ErrorCode2["HLSJS_MUX_ERROR"] = "3202";
  ErrorCode2["DASHJS_MEDIA_ERROR"] = "3203";
  ErrorCode2["SHAKA_MEDIA_ERROR"] = "3205";
  ErrorCode2["TWITCH_MEDIA_ERROR"] = "3206";
  ErrorCode2["OIPF_MEDIA_ERROR"] = "3207";
  ErrorCode2["FAIRPLAY_APP_CERT_ERROR"] = "3300";
  ErrorCode2["FAIRPLAY_LIC_ERROR"] = "3301";
  ErrorCode2["DASHJS_DRM_ERROR"] = "3302";
  ErrorCode2["SHAKA_DRM_ERROR"] = "3304";
  ErrorCode2["OIPF_DRM_ERROR"] = "3305";
  ErrorCode2["UNSPECIFIED_VIDEO_PLAYBACK_ERROR"] = "3400";
  ErrorCode2["UNSPECIFIED_HLSJS_ERROR"] = "3401";
  ErrorCode2["UNSPECIFIED_DASHJS_ERROR"] = "3402";
  ErrorCode2["UNSPECIFIED_SHAKA_ERROR"] = "3404";
  ErrorCode2["UNSPECIFIED_TWITCH_ERROR"] = "3405";
  ErrorCode2["AD_STALLED"] = "4000";
  ErrorCode2["IMA_INIT_FAILURE"] = "4100";
  ErrorCode2["IMA_AD_ERROR"] = "4101";
  ErrorCode2["DAI_DATA_ERROR"] = "4200";
  ErrorCode2["DAI_NETWORK_ERROR"] = "4201";
  ErrorCode2["AD_BLOCKING_DETECTED"] = "4300";
  ErrorCode2["AD_ADAPTER_ERROR"] = "4400";
  ErrorCode2["ADAPTER_NOT_FOUND"] = "5000";
  ErrorCode2["HOOK_ERROR"] = "6000";
  ErrorCode2["EVENT_HOOK"] = "6001";
  ErrorCode2["AD_BREAK_HOOK"] = "6002";
  ErrorCode2["AD_HOOK"] = "6003";
  ErrorCode2["ATTACH_RESOURCE_HOOK"] = "6004";
  ErrorCode2["REQUEST_HOOK"] = "6005";
  ErrorCode2["RESPONSE_HOOK"] = "6006";
  ErrorCode2["CREATE_PLAYER_HOOK"] = "6007";
  ErrorCode2["REMOVE_PLAYER_HOOK"] = "6008";
  ErrorCode2["DEVICE_CAPABILITIES"] = "6009";
  ErrorCode2["SCRIPT_LOAD"] = "6010";
  ErrorCode2["PLUGIN_ERROR"] = "7000";
  ErrorCode2["PLUGIN_FACTORY_ERROR"] = "7001";
  ErrorCode2["PLUGIN_ID_ERROR"] = "7002";
  ErrorCode2["PLUGIN_LOAD_ERROR"] = "7003";
  ErrorCode2["INVALID_ARGUMENT"] = "9000";
  ErrorCode2["CALL_AFTER_DESTROY"] = "9001";
  ErrorCode2["ACTION_KEY"] = "9111";
  ErrorCode2["UNEXPECTED_CONDITION"] = "9999";
  return ErrorCode2;
})(ErrorCode || {});
class CoreError extends Error {
  constructor(message, cause) {
    super(message);
    this.cause = cause;
  }
}
class PlayerError extends CoreError {
  constructor(code, message, cause, fatal = true, category) {
    super(message, cause);
    this.code = code;
    this.fatal = fatal;
    this.category = category;
    this.name = "PlayerError";
  }
  static eventToError(event, category = ErrorCategory.EVENT) {
    if (event instanceof Error || !event.detail && !event.error) {
      return event;
    }
    const detail = event.detail;
    if (detail instanceof Error) {
      return detail;
    }
    const error = event.error || detail.error;
    if (error instanceof Error) {
      return error;
    }
    if (error.code && error.message) {
      return new PlayerError(
        error.code,
        error.message,
        error.cause || event,
        true,
        category
      );
    }
    return new PlayerError(
      ErrorCode.UNEXPECTED_CONDITION,
      ErrorMessage.UNEXPECTED_CONDITION,
      event,
      true,
      category
    );
  }
}
function waitFor(milliseconds) {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
}
function waitUntil(func, interval = 100) {
  return new Promise((resolve, reject) => {
    const i = setInterval(() => {
      try {
        if (func()) {
          clearInterval(i);
          resolve();
        }
      } catch (error) {
        clearInterval(i);
        reject(error);
      }
    }, interval);
  });
}
function waitForEvent(target, success, fail = "error", timeout = NaN) {
  if (typeof fail === "number") {
    timeout = fail;
  }
  return new Promise((resolve, reject) => {
    let timeoutId;
    const undo = [];
    const cleanUp = () => undo.forEach((u) => u());
    const apply = (action, event) => {
      const on = target.on ? "on" : "addEventListener";
      const off = target.off ? "off" : "removeEventListener";
      const complete = (e, d) => {
        clearTimeout(timeoutId);
        cleanUp();
        action(d || e);
      };
      target[on](event, complete);
      undo.push(() => target[off](event, complete));
    };
    apply(resolve, success);
    if (typeof fail === "string") {
      apply((event) => reject(PlayerError.eventToError(event)), fail);
    }
    if (timeout > -1) {
      timeoutId = setTimeout(() => {
        cleanUp();
        reject(new Error("timeout"));
      }, timeout);
    }
  });
}
function waitForTime(target, time, prop) {
  if (!prop) {
    prop = target instanceof HTMLVideoElement ? "currentTime" : "contentTime";
  }
  return waitUntil(() => target[prop] >= time);
}
function queue(tasks) {
  let canceled = false;
  let task;
  let running = false;
  return {
    run(context) {
      return __async(this, null, function* () {
        running = true;
        let result = context;
        for (let i = 0; i < tasks.length; i++) {
          task = tasks[i](result);
          result = yield task;
          if (canceled) {
            break;
          }
        }
        task = null;
        running = false;
        return result;
      });
    },
    get running() {
      return running;
    },
    cancel() {
      return __async(this, null, function* () {
        canceled = true;
        return yield task;
      });
    }
  };
}
function eventsToPromise(success, failure, timeout = NaN) {
  return new Promise((resolve, reject) => {
    let timeoutId;
    const undo = [];
    const cleanUp = () => undo.forEach((u) => u());
    const apply = (action) => ({ target, events }) => {
      const t = target;
      const on = t.on ? "on" : "addEventListener";
      const off = t.off ? "off" : "removeEventListener";
      const complete = (e, d) => {
        clearTimeout(timeoutId);
        cleanUp();
        action(d || e);
      };
      events.forEach((event) => {
        t[on](event, complete);
        undo.push(() => t[off](event, complete));
      });
    };
    success.forEach(apply(resolve));
    failure.forEach(apply(reject));
    if (timeout > -1) {
      timeoutId = setTimeout(() => {
        cleanUp();
        reject(new Error("timeout"));
      }, timeout);
    }
  });
}
function values(obj) {
  return Object.keys(obj).reduce((a, k, i) => {
    a[i] = obj[k];
    return a;
  }, []);
}
function entries(obj) {
  return Object.keys(obj).reduce((a, k, i) => {
    a[i] = [k, obj[k]];
    return a;
  }, []);
}
function fromEntries(entries2) {
  return entries2.reduce((o, [k, v]) => {
    o[k] = v;
    return o;
  }, {});
}
function clone(obj, freeze2 = false) {
  const result = Array.isArray(obj) ? obj.map((o) => clone(o, freeze2)) : Object.assign({}, obj);
  return freeze2 ? Object.freeze(result) : result;
}
function freeze(obj) {
  if (Array.isArray(obj)) {
    obj.forEach((o) => freeze(o));
  }
  return Object.freeze(obj);
}
function merge(...args) {
  const override = (base2, overrides) => {
    if (base2 == null) {
      return overrides;
    } else if (overrides == null) {
      return base2;
    }
    const isNode = (obj) => {
      try {
        return obj instanceof Node;
      } catch (error) {
        return false;
      }
    };
    Object.getOwnPropertyNames(overrides).forEach((key) => {
      const value = overrides[key];
      const baseValue = base2[key];
      const type = typeof value;
      switch (type) {
        case "undefined":
          return;
        case "number":
        case "string":
        case "boolean":
        case "symbol":
        case "function":
        case "bigint":
          base2[key] = value;
          break;
        case "object":
          if (Array.isArray(value)) {
            base2[key] = value.slice();
          } else if (value === null || isNode(value)) {
            base2[key] = value;
          } else {
            const target = baseValue == null ? {} : baseValue;
            base2[key] = override(target, value);
          }
          break;
      }
    });
    return base2;
  };
  const [base, ...rest] = args;
  return rest.reduce((acc, obj) => override(acc, obj), base);
}
function mapProperties(from, to, map) {
  Object.keys(map).forEach((fromKey) => {
    const toKey = map[fromKey];
    to[toKey] = from[fromKey];
  });
}
const cached = {};
function cache(key, factory) {
  if (!cached[key]) {
    cached[key] = factory();
  }
  return cached[key];
}
const ObjectUtil = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  cache,
  clone,
  entries,
  freeze,
  fromEntries,
  mapProperties,
  merge,
  values
}, Symbol.toStringTag, { value: "Module" }));
class QueryString {
  static encode(obj) {
    if (isEmpty(obj)) {
      return "";
    }
    const str = entries(obj).map(([k, v]) => k + "=" + encodeURIComponent(v));
    return str.join("&");
  }
  static decode(uri) {
    const results = {};
    if (uri == null) {
      return results;
    }
    uri.replace(/^[^?]*\?/, "").replace(new RegExp("([^?=&]+)(=([^&]*))?", "g"), ($0, $1, $2, $3) => {
      let value;
      try {
        value = isUndefined($3) ? $3 : decodeURIComponent($3);
      } catch (error) {
        value = $3;
      }
      results[decodeURIComponent($1)] = value;
    });
    return results;
  }
  static parseValue(value) {
    if (isUndefined(value)) {
      return true;
    }
    let temp = value.toLowerCase();
    if (temp === "true" || temp === "false") {
      return temp === "true";
    }
    if (value === "undefined") {
      return void 0;
    }
    if (temp === "null") {
      return null;
    }
    temp = parseFloat(value);
    if (!isNaN(temp)) {
      return temp;
    }
    return value;
  }
  static parse(uri) {
    const params = QueryString.decode(uri);
    for (const k in params) {
      params[k] = QueryString.parseValue(params[k]);
    }
    return params;
  }
  static append(url, params) {
    const prefix = url.includes("?") ? "&" : "?";
    return url + prefix + QueryString.encode(params);
  }
}
var RequestCredentials = /* @__PURE__ */ ((RequestCredentials2) => {
  RequestCredentials2["INCLUDE"] = "include";
  RequestCredentials2["SAME_ORIGIN"] = "same-origin";
  RequestCredentials2["OMIT"] = "omit";
  return RequestCredentials2;
})(RequestCredentials || {});
var ResponseType = /* @__PURE__ */ ((ResponseType2) => {
  ResponseType2["ARRAY_BUFFER"] = "arraybuffer";
  ResponseType2["TEXT"] = "text";
  ResponseType2["JSON"] = "json";
  ResponseType2["DOCUMENT"] = "document";
  ResponseType2["DEFAULT"] = "";
  return ResponseType2;
})(ResponseType || {});
class Network {
  static get TIMEOUT() {
    return 5e3;
  }
}
var RequestMethod = /* @__PURE__ */ ((RequestMethod2) => {
  RequestMethod2["GET"] = "GET";
  RequestMethod2["POST"] = "POST";
  RequestMethod2["DELETE"] = "DELETE";
  RequestMethod2["OPTIONS"] = "OPTIONS";
  RequestMethod2["PUT"] = "PUT";
  return RequestMethod2;
})(RequestMethod || {});
class AsyncDataRequestOptions {
  constructor() {
  }
  static create(options) {
    return {
      url: options.url || "",
      method: options.method || RequestMethod.GET,
      timeout: options.timeout || Network.TIMEOUT,
      headers: options.headers || {},
      data: this.getBody(options.data, options.encodeList, options.sendJson),
      withCredentials: options.withCredentials === true,
      responseType: options.responseType || ResponseType.TEXT,
      onComplete: options.onComplete || null,
      errorRecovery: options.errorRecovery || null
    };
  }
  /**
  	 * @param objOrStr - - can be a plain object or string
  	 * @param enc - - if supplying an object, an array of property names whose values should be encoded
  	 * @param asJson - - set TRUE if the body should be sent as a JSON string
  	 */
  static getBody(objOrStr, enc, asJson = false) {
    if (!objOrStr) {
      return null;
    }
    if (typeof objOrStr === "string") {
      return objOrStr;
    }
    if (!Object.keys(objOrStr).length) {
      return null;
    }
    const useEnc = Array.isArray(enc) && enc.length;
    !useEnc && (enc = []);
    for (const q in objOrStr) {
      objOrStr[q] = this.getValue(q, objOrStr[q], enc);
    }
    if (asJson) {
      return JSON.stringify(objOrStr);
    }
    let str = "", v;
    for (const q in objOrStr) {
      v = objOrStr[q];
      v != null && v !== void 0 && v !== "" && (str += `${q}=${v}&`);
    }
    str = str.substr(0, str.length - 1);
    return str;
  }
  static getValue(name, val, enc) {
    return enc.indexOf(name) >= 0 ? encodeURIComponent(val) : val;
  }
}
class CoreEvent {
  /**
  	 * Custom event class
  	 */
  constructor(type, target, detail) {
    this.defaultPrevented_ = false;
    this.timeStamp = Date.now();
    this.detail = detail;
    this.target = target;
    this.type = type;
  }
  get defaultPrevented() {
    return this.defaultPrevented_;
  }
  preventDefault() {
    this.defaultPrevented_ = true;
  }
}
class LinkedNode {
  constructor(value, next) {
    this.value = value;
    this.next = next;
  }
}
class LinkedList {
  constructor() {
    this.head = null;
    this.tail = null;
  }
  get empty() {
    return this.head == null;
  }
  forEach(func) {
    let node = this.head;
    while (node) {
      func(node.value);
      node = node.next;
    }
  }
  add(value) {
    const node = new LinkedNode(value);
    if (this.head == null) {
      this.head = node;
      this.head.next = null;
      this.tail = null;
    } else if (this.tail == null) {
      this.head.next = this.tail = node;
    } else {
      this.tail.next = this.tail = node;
    }
  }
  has(value) {
    let node = this.head;
    while (node) {
      if (node.value === value) {
        return true;
      }
      node = node.next;
    }
    return false;
  }
  delete(value) {
    let previous = null;
    let node = this.head;
    while (node) {
      if (node.value === value) {
        if (previous) {
          previous.next = node.next;
        }
        if (node === this.head) {
          this.head = node.next;
        } else if (node === this.tail) {
          this.tail = previous !== this.head ? previous : null;
        }
        return true;
      }
      previous = node;
      node = node.next;
    }
    return false;
  }
  clear() {
    let node = this.head;
    let next;
    while (node) {
      next = node.next;
      node.value = node.next = null;
      node = next;
    }
    this.head = this.tail = null;
  }
}
class Emitter {
  /**
   * An event emitter, with methods to add and remove event listeners.
   * Base class for any class using event-based communication.
   */
  constructor(options, target) {
    this.target = target || this;
    this.opts = options || {};
    this.eventMap = {};
    const o = this.opts;
    for (const q in o) {
      if (isFunction(o[q]) && /^on[A-Z]/.test(q)) {
        const e = q.charAt(2).toLowerCase() + q.substring(3);
        this.on(e, o[q]);
        delete this.opts[q];
      }
    }
  }
  destroy() {
    let q;
    if (this.opts) {
      this.opts = null;
    }
    this.offAll(null);
    if (this.eventMap) {
      for (q in this.eventMap) {
        delete this.eventMap[q];
      }
      this.eventMap = null;
    }
    this.target = null;
  }
  /**
   * Adds an event listener
   */
  on(name, func) {
    if (!this.eventMap || !name || !isFunction(func)) {
      return;
    }
    const handlers = this.eventMap[name] || (this.eventMap[name] = new LinkedList());
    if (handlers.has(func)) {
      return;
    }
    handlers.add(func);
  }
  /**
   * Adds a one time event listener
   */
  once(name, func) {
    if (!this.eventMap || !name || !isFunction(func)) {
      return;
    }
    const handler = (event) => {
      this.off(name, handler);
      func(event);
    };
    this.on(name, handler);
  }
  /**
   * Removes the supplied EventHandler, or, if omitted, will remove all
   * handlers for the supplied (required) event name
   */
  off(name, func) {
    !func && this.offAll(name);
    func && this.remove(name, func);
  }
  /**
   * Removes all event handlers for the supplied (required) event name
   */
  offAll(name) {
    if (!this.eventMap) {
      return;
    }
    const map = this.eventMap;
    if (name) {
      this.remove(name, null);
      return;
    }
    for (const q in map) {
      this.remove(q, null);
    }
  }
  hasListenerFor(name) {
    return !!(this.eventMap && this.eventMap[name] && !this.eventMap[name].empty);
  }
  emit(name, detail) {
    const e = new CoreEvent(name, this.target || this, detail);
    this.dispatchEvt(e);
  }
  dispatchEvt(event) {
    if (!this.eventMap || !this.eventMap[event.type]) {
      return;
    }
    this.eventMap[event.type].forEach((h) => {
      var _a;
      try {
        h(event);
      } catch (e) {
        (_a = console == null ? void 0 : console.error) == null ? void 0 : _a.call(console, e);
      }
    });
  }
  remove(name, func = null) {
    if (!this.eventMap || !this.eventMap[name]) {
      return;
    }
    if (!func) {
      this.eventMap[name].clear();
    } else {
      this.eventMap[name].delete(func);
    }
  }
}
class RecoveryEnabledRequest extends Emitter {
  constructor(options) {
    super(options);
    this.retryCount = 0;
    this.limit = 0;
    this.retryIntervals = null;
    const er = this.opts.errorRecovery;
    if (er && !isNaN(er.retryAttempts) && er.retryAttempts > 0) {
      this.limit = er.retryAttempts;
    }
    if (er && er.retryIntervals && Array.isArray(er.retryIntervals)) {
      this.retryIntervals = er.retryIntervals;
    }
  }
  shouldRetry() {
    return this.limit && !this.atLimit;
  }
  incrementAttempts() {
    this.retryCount++;
  }
  get retryLimit() {
    return this.limit;
  }
  get atLimit() {
    return this.retryCount === this.limit;
  }
  get retryInterval() {
    return this.retryIntervals && this.retryIntervals[this.retryCount - 1] || this.retryCount * 300;
  }
}
const _AsyncDataRequest = class _AsyncDataRequest extends RecoveryEnabledRequest {
  static load(options) {
    return new Promise((resolve, reject) => {
      const requestOptions = options;
      if (requestOptions.credentials) {
        requestOptions.withCredentials = requestOptions.credentials === RequestCredentials.INCLUDE;
      }
      if (requestOptions.body) {
        requestOptions.data = requestOptions.body;
      }
      requestOptions.onComplete = ({ detail }) => {
        if (!detail || detail.error) {
          reject(detail);
        } else {
          resolve(detail);
        }
      };
      new _AsyncDataRequest(requestOptions);
    });
  }
  constructor(options) {
    super(AsyncDataRequestOptions.create(options));
    this.requestOptions = this.opts;
    if (this.opts.url) {
      this.createXhr();
    }
  }
  createXhr() {
    this.request(this.requestOptions).then((request2) => {
      const { response } = request2;
      const contentType = request2.getResponseHeader("content-type");
      let data = response;
      if (this.requestOptions.responseType === ResponseType.TEXT && contentType) {
        if (contentType.includes("application/smil") || contentType.includes("application/xml")) {
          const parser = new DOMParser();
          data = parser.parseFromString(data, "application/xml");
        } else if (contentType == null ? void 0 : contentType.includes("application/json")) {
          data = JSON.parse(data);
        }
      }
      if (request2.status !== 204 && data == null) {
        this.emitCompleteWithError("Unable to parse response.");
      } else {
        setTimeout(() => {
          this.emitComplete({ contentType, data });
        }, 1);
      }
    }).catch((error) => {
      if (this.shouldRetry()) {
        this.incrementAttempts();
        setTimeout(() => {
          this.createXhr();
        }, this.retryInterval);
      } else {
        const msg = this.getErrorMessage(error);
        this.emitCompleteWithError(msg, error.status);
      }
    });
  }
  getErrorMessage(error) {
    var _a;
    if (typeof error.response === "string") {
      return error.response;
    } else if (typeof ((_a = error.response) == null ? void 0 : _a.message) === "string") {
      return error.response.message;
    }
    return _AsyncDataRequest.statusMessages[error.status] || _AsyncDataRequest.statusMessages["0"];
  }
  request(options) {
    return new Promise((resolve, reject) => {
      if (options.query) {
        options.url = QueryString.append(options.url, options.query);
      }
      const xhr = new XMLHttpRequest();
      xhr.open(options.method, options.url);
      xhr.onload = () => {
        if (options.checkStatus !== false && xhr.status > 399) {
          reject(xhr);
        }
        resolve(xhr);
      };
      xhr.onerror = (event) => {
        reject(xhr);
      };
      xhr.withCredentials = options.withCredentials;
      if (options.responseType != null) {
        try {
          xhr.responseType = options.responseType;
        } catch (error) {
        }
      }
      if (options.headers != null) {
        const headers = options.headers;
        entries(headers).forEach(([key, value]) => {
          if (key != null && value != null) {
            xhr.setRequestHeader(key, value);
          }
        });
      }
      return xhr.send(options.data);
    });
  }
  emitComplete(res) {
    this.emit(_AsyncDataRequest.event.COMPLETE, {
      response: res.data,
      contentType: res.contentType,
      error: false
    });
  }
  emitCompleteWithError(errResponse, status) {
    const msg = isString(errResponse) ? errResponse : null;
    const res = !msg ? errResponse : null;
    this.emit(_AsyncDataRequest.event.COMPLETE, {
      status: status || res && res.status,
      error: true,
      url: this.requestOptions.url || "not available",
      message: msg || this.getMsg((res == null ? void 0 : res.status) || 0, (res == null ? void 0 : res.data) || null)
    });
  }
  getMsg(stat, errorData) {
    let m = _AsyncDataRequest.statusMessages["" + stat];
    if (!m) {
      m = isString(errorData) ? errorData : "Unspecified error";
    }
    return "XhrDataRequest error: " + m;
  }
};
_AsyncDataRequest.event = {
  COMPLETE: "complete"
};
_AsyncDataRequest.statusMessages = {
  "0": "Request failed; blocked or timed out",
  "400": "Bad Request",
  "500": "Server error encountered.",
  "404": "Resource not found.",
  "403": "Access denied."
};
let AsyncDataRequest = _AsyncDataRequest;
function request(options) {
  if (options.query) {
    options.url = QueryString.append(options.url, options.query);
  }
  return AsyncDataRequest.load(options).then((xhr) => xhr.response);
}
var DrmType = /* @__PURE__ */ ((DrmType2) => {
  DrmType2["WIDEVINE"] = "com.widevine.alpha";
  DrmType2["PLAYREADY"] = "com.microsoft.playready";
  DrmType2["PLAYREADY_REC"] = "com.microsoft.playready.recommendation";
  DrmType2["CLEAR_KEY"] = "org.w3.clearkey";
  DrmType2["FAIRPLAY_1_0"] = "com.apple.fps.1_0";
  return DrmType2;
})(DrmType || {});
var DrmVendor = /* @__PURE__ */ ((DrmVendor2) => {
  DrmVendor2["IRDETO"] = "irdeto";
  DrmVendor2["DRM_TODAY"] = "drmtoday";
  DrmVendor2["UNKNOWN"] = "unknown";
  return DrmVendor2;
})(DrmVendor || {});
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var screenfull$1 = { exports: {} };
/*!
* screenfull
* v5.2.0 - 2021-11-03
* (c) Sindre Sorhus; MIT License
*/
(function(module) {
  (function() {
    var document2 = typeof window !== "undefined" && typeof window.document !== "undefined" ? window.document : {};
    var isCommonjs = module.exports;
    var fn = function() {
      var val;
      var fnMap = [
        [
          "requestFullscreen",
          "exitFullscreen",
          "fullscreenElement",
          "fullscreenEnabled",
          "fullscreenchange",
          "fullscreenerror"
        ],
        // New WebKit
        [
          "webkitRequestFullscreen",
          "webkitExitFullscreen",
          "webkitFullscreenElement",
          "webkitFullscreenEnabled",
          "webkitfullscreenchange",
          "webkitfullscreenerror"
        ],
        // Old WebKit
        [
          "webkitRequestFullScreen",
          "webkitCancelFullScreen",
          "webkitCurrentFullScreenElement",
          "webkitCancelFullScreen",
          "webkitfullscreenchange",
          "webkitfullscreenerror"
        ],
        [
          "mozRequestFullScreen",
          "mozCancelFullScreen",
          "mozFullScreenElement",
          "mozFullScreenEnabled",
          "mozfullscreenchange",
          "mozfullscreenerror"
        ],
        [
          "msRequestFullscreen",
          "msExitFullscreen",
          "msFullscreenElement",
          "msFullscreenEnabled",
          "MSFullscreenChange",
          "MSFullscreenError"
        ]
      ];
      var i = 0;
      var l = fnMap.length;
      var ret = {};
      for (; i < l; i++) {
        val = fnMap[i];
        if (val && val[1] in document2) {
          for (i = 0; i < val.length; i++) {
            ret[fnMap[0][i]] = val[i];
          }
          return ret;
        }
      }
      return false;
    }();
    var eventNameMap = {
      change: fn.fullscreenchange,
      error: fn.fullscreenerror
    };
    var screenfull2 = {
      request: function(element, options) {
        return new Promise(function(resolve, reject) {
          var onFullScreenEntered = function() {
            this.off("change", onFullScreenEntered);
            resolve();
          }.bind(this);
          this.on("change", onFullScreenEntered);
          element = element || document2.documentElement;
          var returnPromise = element[fn.requestFullscreen](options);
          if (returnPromise instanceof Promise) {
            returnPromise.then(onFullScreenEntered).catch(reject);
          }
        }.bind(this));
      },
      exit: function() {
        return new Promise(function(resolve, reject) {
          if (!this.isFullscreen) {
            resolve();
            return;
          }
          var onFullScreenExit = function() {
            this.off("change", onFullScreenExit);
            resolve();
          }.bind(this);
          this.on("change", onFullScreenExit);
          var returnPromise = document2[fn.exitFullscreen]();
          if (returnPromise instanceof Promise) {
            returnPromise.then(onFullScreenExit).catch(reject);
          }
        }.bind(this));
      },
      toggle: function(element, options) {
        return this.isFullscreen ? this.exit() : this.request(element, options);
      },
      onchange: function(callback) {
        this.on("change", callback);
      },
      onerror: function(callback) {
        this.on("error", callback);
      },
      on: function(event, callback) {
        var eventName = eventNameMap[event];
        if (eventName) {
          document2.addEventListener(eventName, callback, false);
        }
      },
      off: function(event, callback) {
        var eventName = eventNameMap[event];
        if (eventName) {
          document2.removeEventListener(eventName, callback, false);
        }
      },
      raw: fn
    };
    if (!fn) {
      if (isCommonjs) {
        module.exports = { isEnabled: false };
      } else {
        window.screenfull = { isEnabled: false };
      }
      return;
    }
    Object.defineProperties(screenfull2, {
      isFullscreen: {
        get: function() {
          return Boolean(document2[fn.fullscreenElement]);
        }
      },
      element: {
        enumerable: true,
        get: function() {
          return document2[fn.fullscreenElement];
        }
      },
      isEnabled: {
        enumerable: true,
        get: function() {
          return Boolean(document2[fn.fullscreenEnabled]);
        }
      }
    });
    if (isCommonjs) {
      module.exports = screenfull2;
    } else {
      window.screenfull = screenfull2;
    }
  })();
})(screenfull$1);
var screenfullExports = screenfull$1.exports;
const screenfull = /* @__PURE__ */ getDefaultExportFromCjs(screenfullExports);
var Browser = /* @__PURE__ */ ((Browser2) => {
  Browser2["NONE"] = "None";
  Browser2["ANDROID"] = "Android";
  Browser2["CHROME"] = "Chrome";
  Browser2["CHROME_IOS"] = "Chrome-iOS";
  Browser2["FIREFOX"] = "Firefox";
  Browser2["FIREFOX_IOS"] = "Firefox-iOS";
  Browser2["EDGE"] = "Edge";
  Browser2["MSIE"] = "MSIE";
  Browser2["SAFARI"] = "Safari";
  Browser2["OPERA"] = "Opera";
  Browser2["OPERA_MOBILE"] = "Opera-Mobile";
  Browser2["SILK"] = "Silk";
  Browser2["WEBKIT"] = "Webkit Browser";
  Browser2["PLAYSTATION_4_WEBMAF"] = "PlayStation 4 (WebMAF)";
  Browser2["PLAYSTATION_4_MSE"] = "PlayStation 4 (Media Source API)";
  Browser2["PLAYSTATION_5"] = "PlayStation 5 (Media Source API)";
  Browser2["UNKNOWN"] = "Unknown";
  return Browser2;
})(Browser || {});
var Device = /* @__PURE__ */ ((Device2) => {
  Device2["DESKTOP"] = "Desktop";
  Device2["ANDROID_PHONE"] = "Android Phone";
  Device2["WINDOWS_PHONE"] = "Windows Phone";
  Device2["IPHONE"] = "iPhone";
  Device2["IPOD"] = "iPod";
  Device2["IPAD"] = "iPad";
  Device2["KINDLE"] = "Kindle";
  Device2["TABLET"] = "Tablet";
  Device2["MOBILE"] = "Mobile";
  Device2["EMBEDDED"] = "Embedded";
  Device2["LG_SMART_TV"] = "LG Smart Tv";
  Device2["VIZIO_SMART_TV"] = "Vizio Smart Tv";
  Device2["SAMSUNG_SMART_TV"] = "Samsung Smart Tv";
  Device2["PHILLIPS_SMART_TV"] = "Phillips Smart Tv";
  Device2["COMCAST_X1"] = "Comcast X1";
  Device2["XBOX_ONE"] = "Xbox One";
  Device2["CHROMECAST"] = "Chromecast";
  Device2["PLAYSTATION_4"] = "PlayStation 4";
  Device2["PLAYSTATION_5"] = "PlayStation 5";
  Device2["SKY_Q"] = "Sky STB";
  Device2["SWISSCOM"] = "Swisscom STB";
  Device2["FOXTEL"] = "Foxtel";
  Device2["ORANGE"] = "Orange STB";
  Device2["VIRGIN_MEDIA"] = "Virgin Media STB";
  Device2["VESTEL"] = "Vestel Smart Tv";
  Device2["VODAFONE"] = "VODAFONE_STB";
  Device2["YOUVIEW"] = "YouView";
  Device2["FREEVIEWPLAY"] = "FreeviewPlay";
  Device2["UNKNOWN"] = "UNKNOWN";
  return Device2;
})(Device || {});
var Os = /* @__PURE__ */ ((Os2) => {
  Os2["OSX"] = "OS X";
  Os2["WINDOWS"] = "Windows";
  Os2["WINDOWS7"] = "Windows 7";
  Os2["WINDOWS8"] = "Windows 8";
  Os2["WINDOWS10"] = "Windows 10";
  Os2["WINDOWS_VISTA"] = "Windows Vista";
  Os2["WINDOWS_PHONE"] = "Windows Phone";
  Os2["IOS"] = "iOS";
  Os2["ANDROID"] = "Android";
  Os2["CHROMIUM"] = "Chromium";
  Os2["WEBOS"] = "Web0S";
  Os2["SMARTCAST"] = "SmartCast";
  Os2["TIZEN"] = "Tizen";
  Os2["ORBIS"] = "Orbis OS";
  Os2["PROSPERO"] = "Prospero OS";
  Os2["TIVO"] = "TiVo OS";
  Os2["LINUX"] = "Linux";
  Os2["UNKNOWN"] = "Unknown";
  return Os2;
})(Os || {});
var Platform = /* @__PURE__ */ ((Platform2) => {
  Platform2["MAC"] = "Macintosh";
  Platform2["WINDOWS"] = "Windows";
  Platform2["LINUX"] = "Linux";
  Platform2["UNKNOWN"] = "Unknown";
  return Platform2;
})(Platform || {});
var Codec = /* @__PURE__ */ ((Codec2) => {
  Codec2["AVC"] = "avc1.4D401E,mp4a.40.2";
  Codec2["HEVC"] = "hvc1.2.4.L63.90";
  Codec2["HEVC_SDR"] = "hvc1.1.6.L63.90";
  Codec2["DOLBY_VISION"] = "dvhe.05.06";
  Codec2["DOLBY_DIGITAL_PLUS"] = "ec-3";
  Codec2["STEREO_AUDIO"] = "aac";
  Codec2["DOLBY_DIGITAL"] = "ac3";
  return Codec2;
})(Codec || {});
const codecs = "; codecs=";
const MediaTypes = {
  video: {
    HLS: MimeType.HLS,
    AVC: MimeType.MP4_VIDEO + codecs + Codec.AVC,
    HEVC: MimeType.MP4_VIDEO + codecs + Codec.HEVC,
    HEVC_SDR: MimeType.MP4_VIDEO + codecs + Codec.HEVC_SDR,
    DOLBY_VISION: MimeType.MP4_VIDEO + codecs + Codec.DOLBY_VISION
  },
  audio: {
    AVC: MimeType.MP4_AUDIO + codecs + Codec.AVC,
    HEVC: MimeType.MP4_AUDIO + codecs + Codec.HEVC,
    HEVC_SDR: MimeType.MP4_AUDIO + codecs + Codec.HEVC_SDR,
    DOLBY_DIGITAL_PLUS: MimeType.MP4_AUDIO + codecs + Codec.DOLBY_DIGITAL_PLUS
  }
};
const systemGlobal = typeof window === "object" ? window : null;
function isLinux(userAgent, platformInfo, nav) {
  const regex = new RegExp(Platform.LINUX, "i");
  const uaData = nav.userAgentData;
  const platform = nav.platform || (uaData == null ? void 0 : uaData.platform);
  const isArm = /Linux armv/.test(platform);
  const fvpre = /FVC\/(\d+\.\d+)/i;
  const os = userAgent.indexOf(Os.ANDROID) >= 0 ? Os.ANDROID : Platform.LINUX;
  const VODAFONE = "VODAFONE";
  const YOUVIEW = "YouView";
  if (regex.test(userAgent) || userAgent.indexOf(Os.ANDROID) >= 0 || userAgent.indexOf(VODAFONE) >= 0 || userAgent.indexOf(YOUVIEW) >= 0 || fvpre.test(userAgent)) {
    platformInfo.platform = Platform.LINUX;
    platformInfo.device = Device.UNKNOWN;
    if (userAgent.indexOf(Os.CHROMIUM) >= 0) {
      const re = /Chromium\/([\d+\.]*)\s/;
      const test = re.exec(userAgent);
      platformInfo.os = Os.CHROMIUM;
      platformInfo.osVersion = test && test[1] || "";
    } else if (fvpre.test(userAgent)) {
      platformInfo.os = os;
      platformInfo.device = Device.FREEVIEWPLAY;
    } else if (userAgent.indexOf(YOUVIEW) >= 0) {
      platformInfo.os = os;
      platformInfo.device = Device.YOUVIEW;
    } else if (userAgent.indexOf(Os.ANDROID) >= 0) {
      const re = / Android ([^\s]+);/;
      const test = re.exec(userAgent);
      platformInfo.os = Os.ANDROID;
      platformInfo.osVersion = test && test[1] || "";
      platformInfo.device = Device.ANDROID_PHONE;
    } else if (userAgent.indexOf(Os.WEBOS) >= 0) {
      platformInfo.os = Os.WEBOS;
      platformInfo.osVersion = "n/a";
      platformInfo.device = Device.LG_SMART_TV;
    } else if (userAgent.indexOf(Os.SMARTCAST) >= 0) {
      platformInfo.os = Os.SMARTCAST;
      platformInfo.osVersion = "n/a";
      platformInfo.device = Device.VIZIO_SMART_TV;
    } else if (userAgent.indexOf(Os.TIZEN) >= 0) {
      const re = /Tizen ([^\s]+)(;|\))/;
      const test = re.exec(userAgent);
      platformInfo.os = Os.TIZEN;
      platformInfo.osVersion = test && test[1] || "";
      platformInfo.device = Device.SAMSUNG_SMART_TV;
    } else if (userAgent.indexOf("Sky") >= 0 || userAgent.indexOf("_sky-") >= 0) {
      platformInfo.os = Platform.LINUX;
      platformInfo.osVersion = "n/a";
      platformInfo.device = Device.SKY_Q;
    } else if (userAgent.indexOf("Foxtel") >= 0) {
      platformInfo.os = Platform.LINUX;
      platformInfo.osVersion = "n/a";
      platformInfo.device = Device.FOXTEL;
    } else if (userAgent.indexOf("VirginMedia") >= 0) {
      platformInfo.os = Platform.LINUX;
      platformInfo.osVersion = "n/a";
      platformInfo.device = Device.VIRGIN_MEDIA;
    } else if (userAgent.indexOf("Philips") >= 0) {
      platformInfo.os = Platform.LINUX;
      platformInfo.osVersion = "n/a";
      platformInfo.device = Device.PHILLIPS_SMART_TV;
    } else if (userAgent.indexOf("SOPOpenBrowser") >= 0) {
      platformInfo.os = Platform.LINUX;
      platformInfo.osVersion = "n/a";
      platformInfo.device = Device.ORANGE;
    } else if (userAgent.indexOf("Swisscom") >= 0) {
      platformInfo.os = Os.ANDROID;
      const version = userAgent.match(/IP(\d+)/);
      platformInfo.osVersion = version ? `IP ${version[1]}` : "n/a";
      platformInfo.device = Device.SWISSCOM;
    } else if (userAgent.indexOf("Vestel") >= 0) {
      platformInfo.os = Os.TIVO;
      const version = userAgent.match(/TiVoOS\/([\d.]+)/);
      platformInfo.osVersion = version ? version[1] : "n/a";
      platformInfo.device = Device.VESTEL;
    } else if (userAgent.indexOf(VODAFONE) >= 0) {
      platformInfo.os = os;
      platformInfo.osVersion = "n/a";
      platformInfo.device = Device.VODAFONE;
    } else if (typeof $badger !== "undefined" || / Xfinity/.test(userAgent) || / WPE/.test(userAgent)) {
      platformInfo.os = Platform.LINUX;
      platformInfo.osVersion = "n/a";
      platformInfo.device = Device.COMCAST_X1;
    } else if (isArm) {
      platformInfo.os = Platform.LINUX;
      platformInfo.osVersion = "n/a";
      platformInfo.device = Device.EMBEDDED;
    }
    return true;
  }
  return false;
}
function isMac(userAgent, platformInfo, nav) {
  if (userAgent.indexOf(Platform.MAC) >= 0) {
    platformInfo.platform = Platform.MAC;
    const iPad = userAgent.match(/(iPad)/) || nav.maxTouchPoints > 1;
    if (iPad) {
      platformInfo.device = Device.IPAD;
      platformInfo.os = Os.IOS;
    } else if (userAgent.indexOf(Os.OSX) >= 0) {
      platformInfo.device = Device.DESKTOP;
      platformInfo.os = Os.OSX;
    }
    const test = /Mac OS X ([\d.]+)/.exec(userAgent);
    platformInfo.osVersion = test && test[1] ? test[1] : null;
    return true;
  } else if (userAgent.indexOf("like Mac OS X") !== -1) {
    platformInfo.platform = Platform.MAC;
    platformInfo.os = Os.IOS;
    platformInfo.device = Device.UNKNOWN;
    const re = /\sOS\s([^\s]*)\s/;
    const version = re.exec(userAgent);
    if (version && version[1]) {
      platformInfo.osVersion = version[1];
    }
    const devices = [/\(iPhone;/, /\(iPad;/, /\(iPod;/];
    const names = [Device.IPHONE, Device.IPAD, Device.IPOD];
    let i = devices.length;
    while (i--) {
      if (devices[i].test(userAgent)) {
        platformInfo.device = names[i];
        return true;
      }
    }
    return true;
  }
  return false;
}
function isWin(userAgent, platformInfo, nav) {
  let re = /(Windows Phone |Windows Phone OS )([^\s]+);/, reNt = /Windows NT ([^\s]+)[;\)]/, win = re.exec(userAgent);
  if (win && win[2]) {
    platformInfo.platform = Platform.WINDOWS;
    platformInfo.os = Os.WINDOWS_PHONE;
    platformInfo.osVersion = win[2];
    platformInfo.device = Device.WINDOWS_PHONE;
    return true;
  } else {
    const test = reNt.exec(userAgent);
    if (test && test[1]) {
      platformInfo.device = Device.DESKTOP;
      platformInfo.platform = Platform.WINDOWS;
      platformInfo.os = Os.WINDOWS;
      const osVersionNbr = test[1];
      if (/Xbox; Xbox One/.test(userAgent)) {
        platformInfo.device = Device.XBOX_ONE;
      }
      if (parseInt(osVersionNbr) === 10) {
        platformInfo.os = Os.WINDOWS10;
        platformInfo.osVersion = osVersionNbr;
      } else {
        switch (osVersionNbr) {
          case "6.0":
            platformInfo.os = Os.WINDOWS_VISTA;
            break;
          case "6.1":
            platformInfo.os = Os.WINDOWS7;
            platformInfo.osVersion = "7";
            break;
          case "6.2":
            platformInfo.os = Os.WINDOWS8;
            platformInfo.osVersion = "8";
            break;
        }
      }
      return true;
    }
  }
  return false;
}
function getMsBrowser(reEdge, reIe, userAgent) {
  const tri = /Trident.[^\s]+;.*rv:([^\s]+)[);]/;
  if (reIe.test(userAgent)) {
    return { browser: Browser.MSIE, re: reIe };
  } else if (reEdge.test(userAgent)) {
    return { browser: Browser.EDGE, re: reEdge };
  } else if (tri.test(userAgent)) {
    return { browser: Browser.MSIE, re: tri };
  }
  return { browser: Browser.UNKNOWN, re: null };
}
function getSafariBrowser(re, userAgent, platformInfo, nav) {
  const test = re.test(userAgent), browserName = platformInfo.os === Os.ANDROID ? Browser.ANDROID : Browser.SAFARI;
  if (test && platformInfo.os !== "Unknown" && /MacIntel|iPhone|iPad/.test(nav.platform)) {
    return browserName;
  }
  return null;
}
function getBrowserInfo(userAgent, platformInfo, nav) {
  const re = {
    [Browser.CHROME]: /Chrome\/(\S+)/,
    [Browser.CHROME_IOS]: /CriOS\/(\S+)/,
    [Browser.FIREFOX_IOS]: /FxiOS\/(\S+)/,
    [Browser.EDGE]: / Edge?\/([^\s]+)/,
    [Browser.FIREFOX]: /Firefox\/(\S+)/,
    [Browser.OPERA]: /Opera|OPR\/(\S+)/,
    [Browser.SAFARI]: /Version\/(\S+).*Safari/,
    [Browser.MSIE]: /MSIE ([^\s]+)[);] Windows/,
    [Browser.ANDROID]: /Android/,
    [Browser.SILK]: /Silk\/(\S+)/,
    [Browser.PLAYSTATION_4_WEBMAF]: /Playstation 4 (WebMAF) (\S+)/,
    [Browser.PLAYSTATION_4_MSE]: /WebMAF\/v3/,
    [Browser.PLAYSTATION_5]: /PlayStation 5/,
    [Browser.WEBKIT]: / WPE/,
    [Browser.UNKNOWN]: null
  };
  const isChromeIos = re[Browser.CHROME_IOS].test(userAgent);
  const isChrome = (re[Browser.CHROME].test(userAgent) || isChromeIos) && !re[Browser.OPERA].test(userAgent) && !re[Browser.EDGE].test(userAgent);
  const assembleInfo = (bName, re2, ua) => {
    const browser = re2 && re2.exec(ua), out = {
      userAgent,
      browser: bName,
      browserVersion: "0",
      browserMajorVersion: 0
    };
    if (browser && browser.length && browser.length > 1) {
      out.browserVersion = browser[1] || "";
      if (out.browserVersion.indexOf(".")) {
        const ar = out.browserVersion.split(".");
        if (Array.isArray(ar) && ar.length) {
          const mv = parseInt(ar[0]);
          !isNaN(mv) && (out.browserMajorVersion = mv);
        }
      } else {
        const mv = parseInt(out.browserVersion);
        !isNaN(mv) && (out.browserMajorVersion = mv);
      }
    }
    return out;
  };
  if (isChrome) {
    const name = isChromeIos ? Browser.CHROME_IOS : Browser.CHROME;
    return assembleInfo(name, re[name], userAgent);
  }
  const b = getMsBrowser(re[Browser.EDGE], re[Browser.MSIE], userAgent);
  if (b.browser !== Browser.UNKNOWN) {
    return assembleInfo(b.browser, b.re, userAgent);
  }
  for (const q in re) {
    switch (q) {
      case Browser.FIREFOX:
      case Browser.FIREFOX_IOS:
      case Browser.SILK:
      case Browser.ANDROID:
        if (re[q].test(userAgent)) {
          if (q === Browser.SILK) {
            platformInfo.device = Device.KINDLE;
          }
          return assembleInfo(q, re[q], userAgent);
        }
        break;
      case Browser.WEBKIT:
        return assembleInfo(Browser.WEBKIT, re[Browser.WEBKIT], userAgent);
      case Browser.PLAYSTATION_4_WEBMAF:
      case Browser.PLAYSTATION_4_MSE:
      case Browser.PLAYSTATION_5:
        if (re[q].test(userAgent)) {
          const isPS5 = re[Browser.PLAYSTATION_5].test(userAgent);
          let browser;
          if (isPS5) {
            browser = Browser.PLAYSTATION_5;
          } else {
            browser = re[Browser.PLAYSTATION_4_MSE].test(userAgent) ? Browser.PLAYSTATION_4_MSE : Browser.PLAYSTATION_4_WEBMAF;
          }
          platformInfo.device = isPS5 ? Device.PLAYSTATION_5 : Device.PLAYSTATION_4;
          platformInfo.platform = isPS5 ? Device.PLAYSTATION_5 : Device.PLAYSTATION_4;
          platformInfo.os = isPS5 ? Os.PROSPERO : Os.ORBIS;
          return assembleInfo(browser, re[browser], userAgent);
        }
        break;
      case Browser.SAFARI:
        let b2 = getSafariBrowser(re[q], userAgent, platformInfo, nav);
        if (b2) {
          return assembleInfo(q, re[q], userAgent);
        }
        break;
      case Browser.OPERA:
        let test = re[q].exec(userAgent);
        if (test) {
          const browser = test.indexOf("Opera Mini/") >= 0 || test.indexOf("Opera Mobi") >= 0 ? Browser.OPERA_MOBILE : Browser.OPERA;
          return assembleInfo(browser, re[q], userAgent);
        }
        break;
      case Browser.UNKNOWN:
        break;
    }
  }
  return assembleInfo(Browser.UNKNOWN, re[Browser.UNKNOWN], userAgent);
}
function getPlatform(userAgent, nav) {
  const ual = userAgent.toLowerCase();
  const out = {
    userAgent,
    os: Os.UNKNOWN,
    platform: Platform.UNKNOWN,
    osVersion: "",
    device: Device.UNKNOWN
  };
  if (ual.indexOf("fxios") >= 0) {
    out.os = Os.IOS;
    out.platform = Platform.MAC;
    if (ual.indexOf("iphone") >= 0) {
      out.device = Device.IPHONE;
    } else {
      out.device = Device.IPAD;
    }
    return out;
  }
  if (ual.indexOf("crkey") >= 0) {
    out.platform = Platform.LINUX;
    out.device = Device.CHROMECAST;
    return out;
  }
  const re = /\s(\([^)]+\))/;
  const test = re.exec(userAgent);
  if (test && test.length && test.length > 1) {
    const pStr = test[1].replace(/_/gi, ".");
    const tests = [
      (str, obj) => isLinux(str, obj, nav),
      (str, obj) => isMac(str, obj, nav),
      (str, obj) => isWin(str, obj)
    ];
    let i = tests.length;
    while (i--) {
      const ti = tests[i];
      if (ti(i === 0 ? userAgent : pStr, out)) {
        break;
      }
    }
  }
  return out;
}
function parseVerStr(str) {
  const out = {
    majorVersion: null,
    minorVersion: null,
    versionString: null
  };
  if (isString(str)) {
    out.versionString = str;
    const spl = str.split(".");
    const mj = parseInt(spl[0], 10);
    const mn = parseInt(spl[1], 10);
    !isNaN(mj) && (out.majorVersion = mj);
    !isNaN(mn) && (out.minorVersion = mn);
  }
  return out;
}
function getNavigator(global) {
  return global.navigator || { userAgent: "" };
}
function update(global, systemInfo2) {
  const document2 = global.document || null;
  const nav = getNavigator(global);
  const { os, platform, osVersion, device, browser, browserVersion, userAgent } = systemInfo2;
  const osVersionInfo = parseVerStr(osVersion);
  const browserVersionInfo = parseVerStr(browserVersion);
  const isTv = (() => {
    switch (device) {
      case Device.LG_SMART_TV:
      case Device.VIZIO_SMART_TV:
      case Device.SAMSUNG_SMART_TV:
      case Device.PHILLIPS_SMART_TV:
      case Device.COMCAST_X1:
      case Device.SKY_Q:
      case Device.SWISSCOM:
      case Device.FOXTEL:
      case Device.VIRGIN_MEDIA:
      case Device.VESTEL:
      case Device.VODAFONE:
      case Device.ORANGE:
      case Device.YOUVIEW:
      case Device.FREEVIEWPLAY:
        return true;
      default:
        return false;
    }
  })();
  const isDesktop = device === Device.DESKTOP;
  const isConsole = (() => {
    switch (device) {
      case Device.PLAYSTATION_4:
      case Device.PLAYSTATION_5:
      case Device.XBOX_ONE:
        return true;
      default:
        return false;
    }
  })();
  const isReactNative = nav.product === "ReactNative";
  const isWebkit = !!global.WebKitMediaSource;
  const hasMediaSource = !!(global.MediaSource || isWebkit);
  const isTypeSupported = (codec) => {
    let supported = false;
    if (isWebkit) {
      supported = global.WebKitMediaSource.isTypeSupported(codec);
    } else if (hasMediaSource) {
      supported = global.MediaSource.isTypeSupported(codec);
    }
    if (!supported && document2) {
      const element = document2.createElement("video");
      if (isObject(element) && isFunction(element.canPlayType)) {
        if (element.canPlayType(codec) === "probably" || element.canPlayType(codec) === "maybe") {
          supported = true;
        }
      }
    }
    return supported;
  };
  const supportsUnrestrictedAutoplay = isTv || isConsole || isReactNative;
  const isWebMaf = !!global["WM_videoPlayer"];
  const supportedMedia = {
    supportsHevc: isTypeSupported(MediaTypes.video.HEVC),
    supportsHevcSdr: isTypeSupported(MediaTypes.video.HEVC_SDR),
    supportsDolbyDigitalPlus: isTypeSupported(MediaTypes.audio.DOLBY_DIGITAL_PLUS),
    supportsDolbyVision: isTypeSupported(MediaTypes.video.DOLBY_VISION)
  };
  return {
    isBrowser: browser !== Browser.NONE && !isWebMaf && !!document2 && !isReactNative,
    userAgent,
    browser,
    browserVersionInfo,
    device,
    os,
    osVersionInfo,
    platform,
    isAndroid: device === Device.ANDROID_PHONE || os === Os.ANDROID,
    isChromecast: device === Device.CHROMECAST,
    isDesktop,
    isEmbedded: device === Device.EMBEDDED,
    isIos: os === Os.IOS,
    isMobile: !isDesktop,
    isTizen: device === Device.SAMSUNG_SMART_TV,
    isTv,
    isConsole,
    isWebkit,
    isWebMaf,
    isWebOs: os === Os.WEBOS,
    isXboxOne: device === Device.XBOX_ONE,
    hasFullscreenApi: screenfull.isEnabled,
    hasMediaSource,
    hasEncryptedMediaSource: !!(global.MediaKeys || global.WebKitMediaKeys || global.MSMediaKeys),
    supportsHevc: isTypeSupported(MediaTypes.video.HEVC),
    supportsMediaDecodeConfigurations: !!nav.mediaCapabilities,
    supportsNativeHls: isTypeSupported(MediaTypes.video.HLS),
    supportsRequestMediaKeySystemAccess: !!global.MediaKeySystemAccess,
    supportsUnrestrictedAutoplay,
    supportedMedia
  };
}
const systemInfo = {};
function createSystem() {
  if (!systemGlobal) {
    return { global: systemGlobal, isBrowser: false };
  }
  const nav = getNavigator(systemGlobal);
  const userAgent = nav.userAgent || "";
  const platformInfo = getPlatform(userAgent, nav);
  const browserInfo = getBrowserInfo(userAgent, platformInfo, nav);
  merge(systemInfo, __spreadValues(__spreadValues({}, platformInfo), browserInfo));
  return Object.assign(update(systemGlobal, systemInfo), {
    appNamespace: null,
    document: systemGlobal.document,
    global: systemGlobal,
    language: nav.language || "en"
  });
}
const System = createSystem();
function updateSystem(systemInfoUpdate) {
  merge(System, update(systemGlobal, Object.assign(systemInfo, systemInfoUpdate)));
}
const WEBKIT_NEED_KEY = "webkitneedkey";
const WEBKIT_KEY_MESSAGE = "webkitkeymessage";
const WEBKIT_KEY_ADDED = "webkitkeyadded";
const WEBKIT_KEY_ERROR = "webkitkeyerror";
class FairPlay {
  constructor(video, drm, logger2, delegate, onError) {
    this.appCertLoaded = false;
    this.webKitNeedKeyCalled = false;
    this.webkitNeedKeyHandler = (e) => this.onWebkitNeedKey(e);
    this.onError = onError;
    this.drmInfo = drm;
    this.keySystem = drm.keySystem || DrmType.FAIRPLAY_1_0;
    this.video = video;
    this.video.addEventListener(WEBKIT_NEED_KEY, this.webkitNeedKeyHandler);
    this.logger = logger2;
    this.delegate = delegate;
  }
  ////////////////////
  //Public Methods
  ////////////////////
  initialize() {
    return __async(this, null, function* () {
      const value = yield this.delegate.applyHook(PlayerHookType.REQUEST, { url: this.drmInfo.appCertUrl, headers: {} });
      const response = yield request(merge({ responseType: ResponseType.ARRAY_BUFFER }, value));
      this.appCertData = new Uint8Array(response);
      this.appCertLoaded = true;
      if (this.webKitNeedKeyCalled) {
        this.initializeFairplayCDM();
      }
    });
  }
  destroy() {
    this.appCertData = null;
    this.initData = null;
    this.onError = null;
    this.drmInfo = null;
    this.logger = null;
    this.video.removeEventListener(WEBKIT_NEED_KEY, this.webkitNeedKeyHandler);
    this.video = null;
  }
  ////////////////////
  //Events Methods
  ////////////////////
  /*
   * Async dependent on app certdata to continue.
   */
  onWebkitNeedKey(event) {
    this.initData = event.initData;
    this.webKitNeedKeyCalled = true;
    if (this.appCertLoaded) {
      this.initializeFairplayCDM();
    }
  }
  onLicenseRequestReady(url, event) {
    const drmVendor = this.getDrmVendor(url);
    const session = event.target;
    const spcMessage = base64EncodeUint8Array(event.message);
    const data = {
      spc: spcMessage,
      contentId: session.contentId
    };
    const responseType = drmVendor === DrmVendor.IRDETO || drmVendor === DrmVendor.UNKNOWN ? ResponseType.ARRAY_BUFFER : ResponseType.TEXT;
    const headers = { "Content-Type": "application/x-www-form-urlencoded" };
    const { header } = this.drmInfo;
    if (!isEmpty(header)) {
      Object.assign(headers, header);
    }
    this.delegate.applyHook(PlayerHookType.REQUEST, { url, method: RequestMethod.POST, responseType, headers, data }).then((value) => {
      const requestOptions = clone(value);
      const contentType = value.headers["Content-Type"];
      if (contentType === "application/x-www-form-urlencoded") {
        requestOptions.data = "spc=" + encodeURIComponent(value.data.spc) + "&" + value.data.contentId;
      } else if (contentType === "application/json") {
        requestOptions.data = JSON.stringify(value.data);
      }
      return request(requestOptions).then((response) => {
        const key = typeof response === "string" ? base64DecodeUint8Array(response) : new Uint8Array(response);
        session.update(key);
      }).catch((error) => {
        this.throwFatalError(ErrorCode.FAIRPLAY_LIC_ERROR, AppResources.messages.FAIRPLAY_LICENSE_ERROR);
      });
    });
  }
  onWebkitKeyAdded(event) {
    this.logger.info(AppResources.messages.WEBKIT_KEY_ADDED_SUCCESS);
  }
  onWebkitError(event) {
    this.throwFatalError(ErrorCode.FAIRPLAY_LIC_ERROR, `${AppResources.messages.FAIRPLAY_LICENSE_ERROR}`);
  }
  ////////////////////
  //Private Methods
  ////////////////////
  initializeFairplayCDM() {
    const licenseServerUrl = this.getLicenseServerUrl(this.initData);
    const contentId = this.getId(licenseServerUrl, this.initData);
    const video = this.video;
    const global = System.global;
    const errMsg = AppResources.messages;
    if (!contentId) {
      this.throwFatalError(ErrorCode.FAIRPLAY_APP_CERT_ERROR, errMsg.FAIRPLAY_NO_CONTENT_ID);
      return;
    }
    if (!video.webkitKeys) {
      const keySystem = this.keySystem;
      if (!global.WebKitMediaKeys.isTypeSupported(keySystem, "video/mp4")) {
        this.throwFatalError(ErrorCode.FAIRPLAY_APP_CERT_ERROR, errMsg.FAIRPLAY_WEBKIT_ERROR);
        return;
      }
      try {
        video.webkitSetMediaKeys(new global.WebKitMediaKeys(keySystem));
      } catch (e) {
        this.throwFatalError(ErrorCode.FAIRPLAY_APP_CERT_ERROR, e.message);
        return;
      }
    }
    const appCertInitData = this.concatInitDataIdAndCertificate(this.initData, contentId, this.appCertData);
    const keySession = video.webkitKeys.createSession("video/mp4", appCertInitData);
    if (!keySession) {
      this.throwFatalError(ErrorCode.FAIRPLAY_APP_CERT_ERROR, errMsg.FAIRPLAY_WEBKIT_ERROR);
      return;
    }
    keySession.contentId = contentId;
    keySession.addEventListener(WEBKIT_KEY_MESSAGE, this.onLicenseRequestReady.bind(this, licenseServerUrl), false);
    keySession.addEventListener(WEBKIT_KEY_ADDED, this.onWebkitKeyAdded.bind(this), false);
    keySession.addEventListener(WEBKIT_KEY_ERROR, this.onWebkitError.bind(this), false);
  }
  concatInitDataIdAndCertificate(initData, id, cert) {
    if (typeof id === "string") {
      id = stringToArray(id);
    }
    let offset = 0;
    const buffer = new ArrayBuffer(initData.byteLength + 4 + id.byteLength + 4 + cert.byteLength);
    const dataView = new DataView(buffer);
    const initDataArray = new Uint8Array(buffer, offset, initData.byteLength);
    initDataArray.set(initData);
    offset += initData.byteLength;
    dataView.setUint32(offset, id.byteLength, true);
    offset += 4;
    const idArray = new Uint16Array(buffer, offset, id.length);
    idArray.set(id);
    offset += idArray.byteLength;
    dataView.setUint32(offset, cert.byteLength, true);
    offset += 4;
    const certArray = new Uint8Array(buffer, offset, cert.byteLength);
    certArray.set(cert);
    return new Uint8Array(buffer, 0, buffer.byteLength);
  }
  getLicenseServerUrl(initData) {
    let url = null;
    if (!isEmpty(this.drmInfo.licenseUrl)) {
      url = this.drmInfo.licenseUrl;
    } else {
      const initDataString = String.fromCharCode.apply(null, new Uint16Array(initData.buffer));
      const splitString = initDataString.split("://");
      url = "https://" + splitString[1];
    }
    return url;
  }
  extractContentId(initData) {
    return arrayToString(initData).split("skd://")[1];
  }
  getId(licenseServerUrl, initData) {
    const obj = QueryString.decode(licenseServerUrl);
    return obj.ContentId || obj.contentId || obj.assetId || this.extractContentId(initData);
  }
  /**
   * license server url needed to parse vendor
   */
  getDrmVendor(url) {
    let v = DrmVendor.UNKNOWN;
    if (url.indexOf(DrmVendor.IRDETO) !== -1) {
      v = DrmVendor.IRDETO;
    } else if (url.indexOf(DrmVendor.DRM_TODAY) !== -1) {
      v = DrmVendor.DRM_TODAY;
    }
    return v;
  }
  throwFatalError(code, message) {
    this.logger.error(`${code} ${message}`);
    this.onError({
      code,
      message,
      fatal: true
    });
  }
}
const FileExtensionToMimeType = {
  VTT: MimeType.VTT,
  XML: MimeType.TTML,
  M3U8: MimeType.HLS,
  MPD: MimeType.DASH,
  TS: MimeType.TS_VIDEO,
  MP4: MimeType.MP4_VIDEO,
  MPV: MimeType.MP4_VIDEO,
  MPA: MimeType.MP4_AUDIO,
  WEBM: MimeType.WEBM_VIDEO,
  ISM: MimeType.ISM
};
function getFileExtension(uri) {
  return uri.replace(/\?.*/, "").replace(/#.*/, "").split(".").pop();
}
function getMimeType(uri) {
  if (!uri) {
    return MimeType.UNKNOWN;
  }
  const ext = getFileExtension(uri).toUpperCase();
  return FileExtensionToMimeType[ext];
}
const File = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getFileExtension,
  getMimeType
}, Symbol.toStringTag, { value: "Module" }));
function debounce(func, delay) {
  let timeout;
  const pending = () => timeout != null;
  const cancel = () => {
    clearTimeout(timeout);
    timeout = null;
  };
  const run = (...args) => {
    cancel();
    timeout = setTimeout(func, delay, ...args);
  };
  run.cancel = cancel;
  run.flush = func;
  run.pending = pending;
  return run;
}
function throttle(func, delay) {
  let timeout;
  let pending = false;
  let trigger = null;
  const cancel = () => {
    clearTimeout(timeout);
    timeout = null;
    pending = false;
    trigger = null;
  };
  const run = (...args) => {
    if (pending) {
      trigger = args;
      return;
    }
    cancel();
    pending = true;
    func(...args);
    timeout = setTimeout(() => {
      pending = false;
      if (trigger != null) {
        const args2 = trigger;
        trigger = null;
        run(...args2);
      }
    }, delay);
  };
  run.cancel = cancel;
  run.flush = func;
  run.pending = () => pending;
  return run;
}
const FunctionUtil = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  debounce,
  throttle
}, Symbol.toStringTag, { value: "Module" }));
var VideoFormat = /* @__PURE__ */ ((VideoFormat2) => {
  VideoFormat2["HLS"] = "hls";
  VideoFormat2["DASH"] = "dash";
  VideoFormat2["MP4"] = "mp4";
  VideoFormat2["UNKNOWN"] = "unknown";
  return VideoFormat2;
})(VideoFormat || {});
function getResourceMimeType(resource) {
  var _a, _b, _c, _d;
  const override = (_a = resource.overrides) == null ? void 0 : _a.mimeType;
  if (override) {
    return override.split(";").shift();
  }
  const format = (_c = (_b = resource.ad) == null ? void 0 : _b.ssai) == null ? void 0 : _c.format;
  if (format) {
    switch (format) {
      case VideoFormat.DASH:
        return MimeType.DASH;
      case VideoFormat.HLS:
        return MimeType.HLS;
    }
  }
  return getMimeType((_d = resource.location) == null ? void 0 : _d.mediaUrl);
}
function getResourceMetadata(resource) {
  return {
    manifest: {
      mimeType: getResourceMimeType(resource)
    },
    fragment: {
      mimeType: ""
    }
  };
}
const Resource = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getResourceMetadata,
  getResourceMimeType
}, Symbol.toStringTag, { value: "Module" }));
var TextTrackKind = /* @__PURE__ */ ((TextTrackKind2) => {
  TextTrackKind2["CAPTIONS"] = "captions";
  TextTrackKind2["SUBTITLES"] = "subtitles";
  TextTrackKind2["DESCRIPTIONS"] = "descriptions";
  TextTrackKind2["CHAPTERS"] = "chapters";
  TextTrackKind2["METADATA"] = "metadata";
  TextTrackKind2["FORCED"] = "forced";
  return TextTrackKind2;
})(TextTrackKind || {});
var CmcdObjectType;
(function(CmcdObjectType2) {
  CmcdObjectType2["MANIFEST"] = "m";
  CmcdObjectType2["AUDIO"] = "a";
  CmcdObjectType2["VIDEO"] = "v";
  CmcdObjectType2["MUXED"] = "av";
  CmcdObjectType2["INIT"] = "i";
  CmcdObjectType2["CAPTION"] = "c";
  CmcdObjectType2["TIMED_TEXT"] = "tt";
  CmcdObjectType2["KEY"] = "k";
  CmcdObjectType2["OTHER"] = "o";
})(CmcdObjectType || (CmcdObjectType = {}));
var CmcdStreamType;
(function(CmcdStreamType2) {
  CmcdStreamType2["VOD"] = "v";
  CmcdStreamType2["LIVE"] = "l";
})(CmcdStreamType || (CmcdStreamType = {}));
var CmcdStreamingFormat;
(function(CmcdStreamingFormat2) {
  CmcdStreamingFormat2["DASH"] = "d";
  CmcdStreamingFormat2["HLS"] = "h";
  CmcdStreamingFormat2["SMOOTH"] = "s";
  CmcdStreamingFormat2["OTHER"] = "o";
})(CmcdStreamingFormat || (CmcdStreamingFormat = {}));
const CMCD_PARAM = "CMCD";
const isTokenField = (key) => key === "ot" || key === "sf" || key === "st";
const toRounded = (value) => Math.round(value);
const toUrlSafe = (value) => encodeURIComponent(value);
const toHundred = (value) => toRounded(value / 100) * 100;
const CmcdFormatters = {
  br: toRounded,
  d: toRounded,
  bl: toHundred,
  dl: toHundred,
  mtp: toHundred,
  nor: toUrlSafe,
  rtp: toHundred,
  tb: toRounded
};
const isValid = (value) => value != null && value !== "" && value !== false;
function processCmcd(obj, map, options) {
  const results = [];
  if (obj == null || typeof obj !== "object") {
    return results;
  }
  const keys = Object.keys(obj).sort();
  const formatters = Object.assign({}, CmcdFormatters, options == null ? void 0 : options.formatters);
  keys.forEach((key) => {
    let value = obj[key];
    if (!isValid(value)) {
      return;
    }
    if (key === "v" && value === 1) {
      return;
    }
    if (key == "pr" && value === 1) {
      return;
    }
    const formatter = formatters[key];
    if (formatter) {
      value = formatter(value);
    }
    const result = map(key, value);
    results.push(result);
  });
  return results;
}
function encodeCmcd(obj, options = {}) {
  return processCmcd(obj, (key, value) => {
    switch (typeof value) {
      case "boolean":
        return key;
      case "number":
        return `${key}=${value}`;
      case "symbol":
        return `${key}=${value.description || value.toString().replace(/^Symbol\((.*)\)$/, "$1")}`;
      case "string":
        if (isTokenField(key)) {
          return `${key}=${value}`;
        }
        return `${key}=${JSON.stringify(value)}`;
      default:
        return void 0;
    }
  }, options).join(",");
}
function toCmcdQuery(cmcd, options = {}) {
  if (!cmcd) {
    return "";
  }
  const params = encodeCmcd(cmcd, options);
  return `${CMCD_PARAM}=${encodeURIComponent(params)}`;
}
function appendCmcdQuery(url, cmcd, options) {
  const query = toCmcdQuery(cmcd, options);
  if (!query) {
    return url;
  }
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}${query}`;
}
function decodeCmcd(cmcd) {
  if (!cmcd) {
    return {};
  }
  return decodeURIComponent(cmcd.replace(/^CMCD=/, "")).split(",").reduce((acc, part) => {
    const [key, value] = part.split("=");
    if (!key) {
      return acc;
    }
    if (!value) {
      acc[key] = true;
    } else if (isTokenField(key) || /^[a-zA-Z]$/.test(value)) {
      acc[key] = value;
    } else {
      acc[key] = JSON.parse(value);
    }
    return acc;
  }, {});
}
function fromCmcdQuery(query) {
  if (typeof query === "string") {
    query = new URLSearchParams(query);
  }
  const value = query.get(CMCD_PARAM);
  return decodeCmcd(value);
}
const CMCD_VERSION = 1;
const index = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CMCD_VERSION,
  get CmcdObjectType() {
    return CmcdObjectType;
  },
  get CmcdStreamType() {
    return CmcdStreamType;
  },
  get CmcdStreamingFormat() {
    return CmcdStreamingFormat;
  },
  appendCmcdQuery,
  decodeCmcd,
  encodeCmcd,
  fromCmcdQuery
}, Symbol.toStringTag, { value: "Module" }));
function parseLanguageTag(tag = "") {
  const regex = /^([a-zA-Z]{2,3})(?:[_-]+([a-zA-Z]{3})(?=$|[_-]+))?(?:[_-]+([a-zA-Z]{4})(?=$|[_-]+))?(?:[_-]+([a-zA-Z]{2}|[0-9]{3})(?=$|[_-]+))?/;
  const match = tag.match(regex) || [];
  return {
    tag,
    language: match[1] || "",
    extended: match[2] || "",
    script: match[3] || "",
    region: match[4] || "",
    toString() {
      return this.tag;
    }
  };
}
function compareLanguageTags(a, b) {
  if (a === b) {
    return true;
  }
  const tagA = this.parseLanguageTag(a);
  const tagB = this.parseLanguageTag(b);
  if (tagA.language.slice(0, 2).toLowerCase() === tagB.language.slice(0, 2).toLowerCase()) {
    const regionA = tagA.region.toUpperCase();
    const regionB = tagB.region.toUpperCase();
    return regionA === regionB || !!regionA && !regionB || !regionA && !!regionB;
  }
  return false;
}
const Language = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  compareLanguageTags,
  parseLanguageTag
}, Symbol.toStringTag, { value: "Module" }));
function uuid$1() {
  try {
    return crypto.randomUUID();
  } catch (error) {
    try {
      const url = URL.createObjectURL(new Blob());
      const uuid2 = url.toString();
      URL.revokeObjectURL(url);
      return uuid2.slice(uuid2.lastIndexOf("/") + 1);
    } catch (error2) {
      let dt = (/* @__PURE__ */ new Date()).getTime();
      const uuid2 = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        const r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c == "x" ? r : r & 3 | 8).toString(16);
      });
      return uuid2;
    }
  }
}
const dre = /([a-z\d])([A-Z])/g;
const cdr = /\W+/g;
const dashToCamelRe = /-([a-z])/g;
function camelToDash(term) {
  const d = "-";
  return term.replace(cdr, d).replace(dre, "$1-$2").toLowerCase();
}
function dashToCamel(term) {
  return term.replace(dashToCamelRe, (r) => r[1].toUpperCase());
}
function uid8() {
  const s4 = function() {
    return Math.floor((1 + Math.random()) * 65536).toString(16).substring(1);
  };
  return s4() + s4();
}
function uuid() {
  return uuid$1();
}
function getNumLines(text) {
  return text && (text.match(/\n/g) || []).length + 1;
}
function template(input, context, open = "{{", close = "}}") {
  if (!input) {
    return input;
  }
  const regex = new RegExp(`${open}((?:(?!(${open}|${close})).)+)${close}`, "g");
  return input.replace(regex, (match, token) => !isUndefined(context == null ? void 0 : context[token]) ? context[token] : match);
}
function padStart(str, targetLength, padString = " ") {
  targetLength = targetLength | 0;
  const len = str.length;
  if (len > targetLength) {
    return str;
  }
  targetLength = targetLength - len;
  if (targetLength > padString.length) {
    padString += padString.repeat(targetLength / padString.length);
  }
  return padString.slice(0, targetLength) + str;
}
function secToHms(seconds, max = 61) {
  if (seconds == null || isNaN(seconds)) {
    return "00:00";
  }
  seconds = seconds | 0;
  let time = zeroFill(seconds % 60);
  seconds = seconds / 60 | 0;
  time = zeroFill(seconds % 60) + ":" + time;
  seconds = seconds / 60 | 0;
  if (seconds > 0) {
    time = zeroFill(seconds) + ":" + time;
  }
  if (max >= 3600 && time.length === 5) {
    time = "00:" + time;
  }
  return time;
}
function msToHms(ms) {
  return formatTime(new Date(ms), "HH:mm:ss:sss", { offset: 0 });
}
function zeroFill(time, len = 2) {
  return padStart(String(time), len, "0");
}
function hmsToSec(timeCode, framerate = 30) {
  if (!timeCode) {
    return NaN;
  }
  const pieces = timeCode.split(":");
  let ms = 0;
  if (pieces.length === 4) {
    ms = parseInt(pieces.pop()) / framerate;
  } else if (pieces.length === 3) {
    pieces[2] = pieces[2].replace(",", ".");
    if (pieces[2].indexOf(".") !== -1) {
      const parts = pieces[2].split(".");
      if ((parts != null ? parts.length : void 0) > 1) {
        pieces[2] = parts[0];
        ms = parseInt(parts[1]) / 1e3;
      }
    }
  }
  let time = parseInt(pieces.pop());
  while (pieces.length > 0) {
    time += Math.pow(60, pieces.length) * parseInt(pieces.shift());
  }
  return time + ms;
}
function formatTime(date, format = "h:mm:ss A", tz = { timezone: "", offset: -((/* @__PURE__ */ new Date()).getTimezoneOffset() / 60) }) {
  if (tz.offset != null && tz.offset !== 0) {
    date = new Date(date.getTime() + Math.round(tz.offset * 60 * 60 * 1e3));
  }
  if (isNaN(date.getTime())) {
    return "";
  }
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const seconds = date.getUTCSeconds();
  const milliseconds = date.getUTCMilliseconds();
  const twelve = hours % 12 || 12;
  const a = hours < 12 ? "am" : "pm";
  const replace = {
    hh: zeroFill(twelve),
    h: twelve,
    HH: zeroFill(hours),
    H: hours,
    mm: zeroFill(minutes),
    m: minutes,
    sss: zeroFill(milliseconds, 3),
    ss: zeroFill(seconds),
    s: seconds,
    a,
    A: a.toUpperCase(),
    z: tz.timezone
  };
  for (const key in replace) {
    format = format.replace(key, replace[key]);
  }
  return format;
}
const StringUtil = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  camelToDash,
  dashToCamel,
  formatTime,
  getNumLines,
  hmsToSec,
  msToHms,
  padStart,
  secToHms,
  template,
  uid8,
  uuid,
  zeroFill
}, Symbol.toStringTag, { value: "Module" }));
function clearCue(textTrack, time) {
  try {
    const Cue = VTTCue || TextTrackCue;
    textTrack.addCue(new Cue(time - 0.1, time + 0.1, " "));
  } catch (error) {
  }
}
function clearAllCues(textTrack) {
  const clearCues = (cues) => {
    if (!cues) {
      return;
    }
    Array.from(cues).forEach((cue) => {
      try {
        textTrack.removeCue(cue);
      } catch (error) {
      }
    });
  };
  clearCues(textTrack.cues);
  clearCues(textTrack.activeCues);
}
function dedupeCues(track, time) {
  const map = {};
  const cues = [];
  processCues(track, time);
  if (!track.activeCues) {
    return cues;
  }
  Array.from(track.activeCues).forEach((cue) => {
    try {
      if (!cue) {
        return;
      }
      const { text, startTime, endTime, line } = cue;
      if (!text) {
        return;
      }
      const mapped = map[text];
      if (!mapped) {
        map[text] = cue;
      } else if (mapped.startTime === startTime) {
        if (mapped.endTime !== endTime) {
          mapped.endTime = Math.max(mapped.endTime, endTime);
        }
        if (mapped.line !== line) {
          mapped.line = mapped.line === "auto" || line === "auto" ? "auto" : mapped.line;
        }
        track.removeCue(cue);
        return;
      }
      cues.push(cue);
    } catch (error) {
    }
  });
  return cues;
}
function processCues(textTrack, playhead) {
  const map = {};
  const time = Math.max(0, playhead - 15);
  if (!textTrack.cues) {
    return;
  }
  Array.from(textTrack.cues).forEach((cue) => {
    try {
      const { startTime, endTime, text } = cue;
      if (endTime < time) {
        return;
      }
      if (!map[text]) {
        map[text] = {};
      }
      const prev = map[text][endTime];
      if (prev && prev.line === cue.line) {
        textTrack.removeCue(cue);
        return;
      }
      const split = map[text][startTime];
      if (split && cue.line === split.line) {
        split.endTime = endTime;
        delete map[text][startTime];
        textTrack.removeCue(cue);
        cue = split;
      }
      map[text][endTime] = cue;
    } catch (error) {
    }
  });
}
function isTextTrack(kind) {
  return kind === TextTrackKind.CAPTIONS || kind === TextTrackKind.SUBTITLES;
}
function smpteToVtt(url, textTrack) {
  return __async(this, null, function* () {
    const xml = yield request({ url, responseType: ResponseType.DOCUMENT });
    const smpteCues = xml.querySelectorAll("tt body div p");
    if (!smpteCues.length) {
      throw new Error(`No cues found in ${url}`);
    }
    const align = System.browser === Browser.SAFARI ? "middle" : "center";
    const lineOffset = System.browser === Browser.SAFARI ? -1 : 0;
    const isVTTCueSupported = System.global.VTTCue !== void 0;
    const Cue = isVTTCueSupported ? System.global.VTTCue : System.global.TextTrackCue;
    smpteCues.forEach((item, i, cues) => {
      if (isEmpty(item.textContent)) {
        return;
      }
      const text = item.textContent.replace(/(.*)<span.*tts:fontStyle="italic">(.*)<\/span>(.*)/g, "$1<i>$2</i>$3").replace(/(.*)<span.*tts:fontWeight="bold">(.*)<\/span>(.*)/g, "$1<b>$2</b>$3").replace(/(.*)<span.*tts:textDecoration="under">(.*)<\/span>(.*)/g, "$1<u>$2</u>$3");
      const lc = getNumLines(text);
      item._lineCountPrev = item._lineCountPrev || 0;
      item._lineCountNext = item._lineCountNext || 0;
      let n = i + 1;
      let nextItem = cues[n];
      const begin = item.getAttribute("begin");
      while ((nextItem == null ? void 0 : nextItem.getAttribute("begin")) === begin) {
        nextItem._lineCountPrev = lc + item._lineCountNext;
        item._lineCountNext += getNumLines(nextItem.textContent);
        nextItem = cues[++n];
      }
      const cue = new Cue(hmsToSec(begin), hmsToSec(item.getAttribute("end")), text);
      try {
        const ttsAlign = item.getAttribute("tts:textAlign");
        cue.align = !ttsAlign ? align : ttsAlign;
      } catch (error) {
        cue.align = "middle";
      }
      if (isVTTCueSupported) {
        const metadata = item.querySelector("metadata");
        if (metadata) {
          cue.snapToLines = true;
          const col = parseInt(metadata.getAttribute("cccol"));
          const row = parseInt(metadata.getAttribute("ccrow"));
          const position = Math.round(col / 35 * 100);
          cue.position = position;
          try {
            cue.align = position < 45 ? "start" : position > 55 ? "end" : align;
          } catch (error) {
            cue.align = "center";
          }
          cue.positionAlign = position < 45 ? "line-left" : position > 55 ? "line-right" : "center";
          cue.line = row - 17 + lineOffset;
        }
      }
      try {
        textTrack.addCue(cue);
      } catch (error) {
      }
    });
  });
}
function createSidecarTextTrack(resource, video, language = "en", label = "English") {
  var _a;
  let url = (_a = resource.location) == null ? void 0 : _a.textTrackUrl;
  if (!url) {
    return Promise.reject("Invalid text track url");
  }
  const isVtt = url.indexOf(".vtt") >= 0;
  const { cmcd } = resource;
  if (cmcd.enabled) {
    url = appendCmcdQuery(url, {
      ot: CmcdObjectType.CAPTION,
      su: true,
      sid: cmcd.sessionId,
      cid: cmcd.contentId,
      pr: video.playbackRate,
      v: CMCD_VERSION
    });
  }
  if (isVtt) {
    const track = document.createElement("track");
    track.kind = TextTrackKind.CAPTIONS;
    track.label = label;
    track.srclang = language;
    track.id = "sidecar-vtt";
    track.src = url;
    video.appendChild(track);
    return Promise.resolve(track.track);
  } else {
    const track = video.addTextTrack(TextTrackKind.CAPTIONS, label, language);
    return smpteToVtt(url, track).then(() => track);
  }
}
function findLanguageTracks(tracks, language, exact = false) {
  const regex = (language2) => new RegExp(`^${language2}`, "i");
  const exactMatch = regex(language);
  let matches = tracks.filter((t) => exactMatch.test(t.language));
  if (!exact) {
    const shortMatch = regex(parseLanguageTag(language).language);
    matches = matches.concat(tracks.filter((t) => !exactMatch.test(t.language) && shortMatch.test(t.language)));
  }
  return matches;
}
function findDefaultTrack(tracks, language, role) {
  let results = tracks;
  if (language) {
    results = findLanguageTracks(results, language).sort((a, b) => a.default === b.default ? 0 : a.default === true ? -1 : b.default === true ? 1 : 0);
  }
  if (role) {
    const resultsWithRole = results.filter((track) => track.type === role);
    if (resultsWithRole.length > 0) {
      results = resultsWithRole;
    }
  }
  return results[0] || tracks.find((t) => t.default) || tracks[0];
}
const TimedText = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clearAllCues,
  clearCue,
  createSidecarTextTrack,
  dedupeCues,
  findDefaultTrack,
  findLanguageTracks,
  isTextTrack,
  processCues,
  smpteToVtt
}, Symbol.toStringTag, { value: "Module" }));
class VirtualVideoElement {
  constructor() {
    this.muted = false;
    this.volume = NaN;
    this.currentTime = NaN;
    this.duration = NaN;
  }
}
function isValidPlayheadTime(value) {
  return isNumber(value) && Number.isFinite(value) && value >= 0;
}
function createSimpleVideoInterface() {
  return new VirtualVideoElement();
}
function isBuffered(video, time = video.currentTime) {
  const buffered = video.buffered;
  for (let i = 0, len = buffered.length; i < len; i++) {
    if (buffered.start(i) <= time && buffered.end(i) >= time) {
      return true;
    }
  }
  return false;
}
const Video = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createSimpleVideoInterface,
  isBuffered,
  isValidPlayheadTime
}, Symbol.toStringTag, { value: "Module" }));
function roundTo(num, len) {
  return Math.round(num * Math.pow(10, len)) / Math.pow(10, len);
}
function clampValue(value, min, max) {
  return Math.max(min, Math.min(max, value));
}
function inRange(value, lower, upper) {
  return isNumber(value) && value >= lower && value <= upper;
}
function mapToRange(value, fromMin, fromMax, toMin = 0, toMax = 1) {
  return (value - fromMin) * (toMax - toMin) / (fromMax - fromMin) + toMin;
}
const NumberUtil = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clampValue,
  inRange,
  mapToRange,
  roundTo
}, Symbol.toStringTag, { value: "Module" }));
var HdrCodec = /* @__PURE__ */ ((HdrCodec2) => {
  HdrCodec2["HVC"] = "hvc1.2";
  HdrCodec2["HEV"] = "hev1.2";
  HdrCodec2["DVH"] = "dvh";
  return HdrCodec2;
})(HdrCodec || {});
var QualityCategory = /* @__PURE__ */ ((QualityCategory2) => {
  QualityCategory2["AUTO"] = "AUTO";
  QualityCategory2["SD"] = "SD";
  QualityCategory2["HD"] = "HD";
  QualityCategory2["UHD"] = "UHD";
  QualityCategory2["UHD_4K"] = "UHD 4K";
  QualityCategory2["UHD_8K"] = "UHD 8K";
  QualityCategory2["SDR"] = "SDR";
  QualityCategory2["HDR"] = "HDR";
  return QualityCategory2;
})(QualityCategory || {});
var SdrCodec = /* @__PURE__ */ ((SdrCodec2) => {
  SdrCodec2["AVC"] = "avc";
  SdrCodec2["HVC"] = "hvc1.1";
  SdrCodec2["HEV"] = "hev1.1";
  return SdrCodec2;
})(SdrCodec || {});
const QualityMap = {
  [QualityCategory.UHD_8K]: 4320,
  [QualityCategory.UHD_4K]: 2160,
  [QualityCategory.UHD]: 1440,
  [QualityCategory.HD]: 720,
  [QualityCategory.SD]: 0
};
function getMinAndMaxValuesForCategory(list, category) {
  let minIndex = Infinity;
  let maxIndex = 0;
  let minBitrate = Infinity;
  let maxBitrate = 0;
  list.forEach((q) => {
    if (q.category.indexOf(category) >= 0) {
      maxIndex = Math.max(maxIndex, q.index);
      minIndex = Math.min(minIndex, q.index);
      maxBitrate = Math.max(maxBitrate, q.bitrate);
      minBitrate = Math.min(minBitrate, q.bitrate);
    }
  });
  return { maxIndex, minIndex, minBitrate, maxBitrate };
}
function getQualityCategoryForVideoHeight(height) {
  var _a;
  return ((_a = entries(QualityMap).find((map) => height >= map[1])) == null ? void 0 : _a[0]) || QualityCategory.SD;
}
function getMaxHeightForQualityCategory(category) {
  if (!category || category === QualityCategory.AUTO) {
    return Infinity;
  }
  const item = entries(QualityMap).find((map, index2, arr) => {
    var _a;
    return ((_a = arr[index2 + 1]) == null ? void 0 : _a[0]) === category;
  });
  return (item == null ? void 0 : item[1]) - 1 || Infinity;
}
function getMaxIndexForHeight(qualities, maxHeight) {
  return qualities.reduce((max, level, index2) => {
    if (level.height <= maxHeight) {
      const current = qualities[max];
      if (isNaN(max)) {
        max = index2;
      } else if (level.height > current.height) {
        max = index2;
      } else if (level.height === current.height && level.bitrate > current.bitrate) {
        max = index2;
      }
    }
    return max;
  }, NaN);
}
function getDynamicRange(quality) {
  const { codec } = quality;
  if (!codec) {
    return "";
  }
  if (codec.startsWith(SdrCodec.AVC)) {
    return QualityCategory.SDR;
  }
  return values(HdrCodec).some((val) => codec.startsWith(val)) ? QualityCategory.HDR : QualityCategory.SDR;
}
function processQuality(quality) {
  const category = [
    getQualityCategoryForVideoHeight(quality.height),
    `${quality.height}p`,
    `${Math.round(quality.bitrate / 1e3)} kbps`,
    getDynamicRange(quality)
  ];
  const { frameRate } = quality;
  return __spreadProps(__spreadValues({}, quality), {
    frameRate: Number.isFinite(frameRate) && frameRate > 0 ? frameRate : NaN,
    category
  });
}
function getMinBitrateIndex(qualities, target) {
  const max = qualities.length - 1;
  if (target >= qualities[max].bitrate) {
    return max;
  }
  for (let i = max - 1; i > 0; i--) {
    const { bitrate } = qualities[i];
    if (target === bitrate) {
      return i;
    } else if (target > bitrate) {
      return i + 1;
    }
  }
  return 0;
}
function getMaxBitrateIndex(qualities, target) {
  if (target <= qualities[0].bitrate) {
    return 0;
  }
  const max = qualities.length - 1;
  for (let i = 1; i < max; i++) {
    const { bitrate } = qualities[i];
    if (target === bitrate) {
      return i;
    } else if (target < bitrate) {
      return i - 1;
    }
  }
  return max;
}
function validateQuality(quality, minBitrate, maxBitrate, maxHeight, bounds) {
  let valid = true;
  if (Number.isFinite(minBitrate)) {
    valid && (valid = quality.bitrate >= minBitrate);
  }
  if (Number.isFinite(maxBitrate)) {
    valid && (valid = quality.bitrate <= maxBitrate);
  }
  if (Number.isFinite(maxHeight)) {
    valid && (valid = quality.height <= maxHeight);
  }
  if (bounds) {
    const { width, height } = bounds;
    valid && (valid = quality.width <= width || quality.height <= height);
  }
  return valid;
}
function validateQualities(qualities, minBitrate, maxBitrate, maxHeight, bounds) {
  return qualities.some((quality) => quality.enabled && validateQuality(quality, minBitrate, maxBitrate, maxHeight, bounds));
}
function toKbits(bitrate) {
  return Math.round(bitrate / 1e3);
}
const Quality = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QualityMap,
  getDynamicRange,
  getMaxBitrateIndex,
  getMaxHeightForQualityCategory,
  getMaxIndexForHeight,
  getMinAndMaxValuesForCategory,
  getMinBitrateIndex,
  getQualityCategoryForVideoHeight,
  processQuality,
  toKbits,
  validateQualities,
  validateQuality
}, Symbol.toStringTag, { value: "Module" }));
var TextTrackSurfaceEvents = /* @__PURE__ */ ((TextTrackSurfaceEvents2) => {
  TextTrackSurfaceEvents2["METADATA_CUEPOINT"] = "metadataCuepoint";
  TextTrackSurfaceEvents2["TEXT_CUEPOINT"] = "textCuepoint";
  TextTrackSurfaceEvents2["TEXT_TRACK_DISPLAY_MODE_CHANGE"] = "textTrackModeChange";
  TextTrackSurfaceEvents2["TEXT_TRACK_ADDED"] = "textTrackAdded";
  TextTrackSurfaceEvents2["TEXT_TRACK_CHANGE"] = "textTrackChange";
  TextTrackSurfaceEvents2["TEXT_TRACK_AVAILABLE"] = "textTrackAvailable";
  return TextTrackSurfaceEvents2;
})(TextTrackSurfaceEvents || {});
var VideoSurfaceEvents = /* @__PURE__ */ ((VideoSurfaceEvents2) => {
  VideoSurfaceEvents2["ABORT"] = "abort";
  VideoSurfaceEvents2["CAN_PLAY"] = "canplay";
  VideoSurfaceEvents2["CAN_PLAY_THROUGH"] = "canplaythrough";
  VideoSurfaceEvents2["DURATION_CHANGE"] = "durationchange";
  VideoSurfaceEvents2["ENDED"] = "ended";
  VideoSurfaceEvents2["ERROR"] = "error";
  VideoSurfaceEvents2["LOADED_METADATA"] = "loadedmetadata";
  VideoSurfaceEvents2["LOAD_START"] = "loadstart";
  VideoSurfaceEvents2["PAUSE"] = "pause";
  VideoSurfaceEvents2["PLAY"] = "play";
  VideoSurfaceEvents2["PLAYING"] = "playing";
  VideoSurfaceEvents2["PROGRESS"] = "progress";
  VideoSurfaceEvents2["RATE_CHANGE"] = "ratechange";
  VideoSurfaceEvents2["SEEKED"] = "seeked";
  VideoSurfaceEvents2["SEEKING"] = "seeking";
  VideoSurfaceEvents2["STALLED"] = "stalled";
  VideoSurfaceEvents2["TIME_UPDATE"] = "timeupdate";
  VideoSurfaceEvents2["VOLUME_CHANGE"] = "volumechange";
  VideoSurfaceEvents2["WAITING"] = "waiting";
  return VideoSurfaceEvents2;
})(VideoSurfaceEvents || {});
const WILDCARD = "*";
var TextTrackMode = /* @__PURE__ */ ((TextTrackMode2) => {
  TextTrackMode2["SHOWING"] = "showing";
  TextTrackMode2["HIDDEN"] = "hidden";
  TextTrackMode2["DISABLED"] = "disabled";
  return TextTrackMode2;
})(TextTrackMode || {});
function utf8ArrayToStr(array, exitOnNull = false) {
  if (typeof TextDecoder !== "undefined") {
    const decoder = new TextDecoder("utf-8");
    const decoded = decoder.decode(array);
    if (exitOnNull) {
      const idx = decoded.indexOf("\0");
      return idx !== -1 ? decoded.substring(0, idx) : decoded;
    }
    return decoded.replace(/\0/g, "");
  }
  const len = array.length;
  let c;
  let char2;
  let char3;
  let out = "";
  let i = 0;
  while (i < len) {
    c = array[i++];
    if (c === 0 && exitOnNull) {
      return out;
    } else if (c === 0 || c === 3) {
      continue;
    }
    switch (c >> 4) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
        out += String.fromCharCode(c);
        break;
      case 12:
      case 13:
        char2 = array[i++];
        out += String.fromCharCode((c & 31) << 6 | char2 & 63);
        break;
      case 14:
        char2 = array[i++];
        char3 = array[i++];
        out += String.fromCharCode((c & 15) << 12 | (char2 & 63) << 6 | (char3 & 63) << 0);
        break;
    }
  }
  return out;
}
function decodeId3PrivFrame(frame) {
  if (frame.size < 2) {
    return void 0;
  }
  const owner = utf8ArrayToStr(frame.data, true);
  const privateData = new Uint8Array(frame.data.subarray(owner.length + 1));
  return { key: frame.type, info: owner, data: privateData.buffer };
}
function decodeId3TextFrame(frame) {
  if (frame.size < 2) {
    return void 0;
  }
  if (frame.type === "TXXX") {
    let index2 = 1;
    const description = utf8ArrayToStr(frame.data.subarray(index2), true);
    index2 += description.length + 1;
    const value = utf8ArrayToStr(frame.data.subarray(index2));
    return { key: frame.type, info: description, data: value };
  }
  const text = utf8ArrayToStr(frame.data.subarray(1));
  return { key: frame.type, info: "", data: text };
}
function decodeId3UrlFrame(frame) {
  if (frame.type === "WXXX") {
    if (frame.size < 2) {
      return void 0;
    }
    let index2 = 1;
    const description = utf8ArrayToStr(frame.data.subarray(index2), true);
    index2 += description.length + 1;
    const value = utf8ArrayToStr(frame.data.subarray(index2));
    return { key: frame.type, info: description, data: value };
  }
  const url = utf8ArrayToStr(frame.data);
  return { key: frame.type, info: "", data: url };
}
function decodeId3Frame(frame) {
  if (frame.type === "PRIV") {
    return decodeId3PrivFrame(frame);
  } else if (frame.type[0] === "W") {
    return decodeId3UrlFrame(frame);
  }
  return decodeId3TextFrame(frame);
}
function readId3Size(data, offset) {
  let size = 0;
  size = (data[offset] & 127) << 21;
  size |= (data[offset + 1] & 127) << 14;
  size |= (data[offset + 2] & 127) << 7;
  size |= data[offset + 3] & 127;
  return size;
}
function getId3FrameData(data) {
  const type = String.fromCharCode(data[0], data[1], data[2], data[3]);
  const size = readId3Size(data, 4);
  const offset = 10;
  return { type, size, data: data.subarray(offset, offset + size) };
}
function isId3Footer(data, offset) {
  if (offset + 10 <= data.length) {
    if (data[offset] === 51 && data[offset + 1] === 68 && data[offset + 2] === 73) {
      if (data[offset + 3] < 255 && data[offset + 4] < 255) {
        if (data[offset + 6] < 128 && data[offset + 7] < 128 && data[offset + 8] < 128 && data[offset + 9] < 128) {
          return true;
        }
      }
    }
  }
  return false;
}
function isId3Header(data, offset) {
  if (offset + 10 <= data.length) {
    if (data[offset] === 73 && data[offset + 1] === 68 && data[offset + 2] === 51) {
      if (data[offset + 3] < 255 && data[offset + 4] < 255) {
        if (data[offset + 6] < 128 && data[offset + 7] < 128 && data[offset + 8] < 128 && data[offset + 9] < 128) {
          return true;
        }
      }
    }
  }
  return false;
}
function getId3Frames(id3Data) {
  let offset = 0;
  const frames = [];
  while (isId3Header(id3Data, offset)) {
    const size = readId3Size(id3Data, offset + 6);
    offset += 10;
    const end = offset + size;
    while (offset + 8 < end) {
      const frameData = getId3FrameData(id3Data.subarray(offset));
      const frame = decodeId3Frame(frameData);
      if (frame) {
        frames.push(frame);
      }
      offset += frameData.size + 10;
    }
    if (isId3Footer(id3Data, offset)) {
      offset += 10;
    }
  }
  return frames;
}
const id3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getId3Frames
}, Symbol.toStringTag, { value: "Module" }));
class MetadataSurface {
  constructor(config2, onMetadataCuepoint) {
    this.daiId3 = /^google_/;
    this.lastTickTime = -1;
    this.onTextTrackAdded = ({ track }) => {
      if (!this.isValidTrack(track)) {
        return;
      }
      track.mode = TextTrackMode.HIDDEN;
    };
    this.onSeeking = () => {
      this.lastTickTime = this.video.currentTime;
    };
    this.onMetadataCuepoint = onMetadataCuepoint;
    this.video = config2.video;
    this.id3OwnerIds = ["com.cbsi.live.sg"].concat(config2.resource.playback.id3OwnerIds || []);
    this.addEvents();
    this.logger = config2.logger;
    this.logger.info("MetadataSurface created");
    forEach(this.video.textTracks, (track) => this.onTextTrackAdded({ track }));
  }
  destroy() {
    this.onMetadataCuepoint = null;
    this.removeEvents();
    forEach(this.video.textTracks, (t) => this.cleanupTrack(t));
    this.video = null;
    this.id3OwnerIds = null;
    this.logger = null;
  }
  /*
   Active cues discovered manually rather than
   using cue change event. AVIAJS-730
  */
  onTick() {
    const trk = this.getId3Track();
    if (!trk) {
      return;
    }
    const cues = trk.cues;
    const now = this.video.currentTime;
    const lastTickTime = this.lastTickTime;
    if (now === lastTickTime) {
      return;
    }
    for (let i = 0, n = cues.length; i < n; i++) {
      try {
        const cue = cues[i];
        if (cue.endTime < lastTickTime) {
          continue;
        }
        const startTime = cue.startTime;
        if (startTime > now) {
          break;
        }
        if (startTime > lastTickTime && startTime <= now) {
          this.processCue(cue);
        }
      } catch (error) {
        this.logger.warn("Failed to process ID3 metadata", error);
      }
    }
    this.lastTickTime = now;
  }
  addEvents() {
    this.video.textTracks.addEventListener(TextTrackEvent.ADD_TRACK, this.onTextTrackAdded);
    this.video.addEventListener(VideoSurfaceEvents.SEEKING, this.onSeeking);
  }
  removeEvents() {
    this.video.textTracks.removeEventListener(TextTrackEvent.ADD_TRACK, this.onTextTrackAdded);
    this.video.removeEventListener(VideoSurfaceEvents.SEEKING, this.onSeeking);
  }
  cleanupTrack(track) {
    if (track.kind !== TextTrackKind.METADATA) {
      return;
    }
    function cleanupCue(cue) {
      try {
        if (cue) {
          track.removeCue(cue);
        }
      } catch (error) {
      }
    }
    forEachReverse(track.cues, cleanupCue);
    forEachReverse(track.activeCues, cleanupCue);
  }
  processCue(cue) {
    if (!cue.value && cue.data) {
      const { data: data2 } = cue;
      if (data2.constructor === ArrayBuffer) {
        const frames = getId3Frames(new Uint8Array(data2));
        frames.forEach((frame) => {
          cue.value = frame;
          this.processCue(cue);
        });
        return;
      }
    }
    const { value, startTime, endTime } = cue;
    const { key, data, info = "" } = value;
    this.processId3(key, {
      id: void 0,
      text: typeof data === "string" ? data : "",
      info,
      data,
      startTime,
      endTime,
      source: cue
    });
  }
  addId3Metadata(key, metadata) {
    try {
      const track = this.getId3Track();
      const { startTime, id, info, data, text } = metadata;
      const cue = new VTTCue(startTime, startTime, text);
      cue.id = id || key;
      cue.value = { key, data, info };
      track.addCue(cue);
    } catch (error) {
      this.logger.warn("Failed to add ID3 metadata", error);
    }
  }
  processId3(key, metadata) {
    const { info, data } = metadata;
    if (key === "TXXX" && this.daiId3.test(metadata.text)) {
      if (isEmpty(info)) {
        metadata.info = metadata.text;
      }
      metadata.id = "google_dai";
    } else {
      metadata.id = this.id3OwnerIds.find((id) => id === WILDCARD || info.includes(id));
    }
    if (!metadata.id) {
      return;
    }
    let text;
    try {
      text = data instanceof ArrayBuffer ? bufferToString(data) : data;
    } catch (error) {
      text = "";
    }
    if (key === "PRIV" && this.id3OwnerIds[0] === info) {
      metadata.data = text;
    }
    metadata.text = text;
    this.onMetadataCuepoint(metadata);
  }
  getId3Track() {
    const id3Track = find(this.video.textTracks, (t) => this.isValidTrack(t));
    if (id3Track) {
      return id3Track;
    }
    const isSafari = System.browser === Browser.SAFARI;
    if (!isSafari) {
      return this.video.addTextTrack("metadata", "id3");
    }
    return null;
  }
  isValidTrack(track) {
    if (!track) {
      return false;
    }
    if (track.kind !== TextTrackKind.METADATA) {
      return false;
    }
    if (track.expired) {
      return false;
    }
    return true;
  }
}
class TextTrackSurface {
  constructor(config2, emit) {
    var _a;
    this.pTextTracks = null;
    this.currentTextTrack = null;
    this.currentTextTrackMode = TextTrackMode.DISABLED;
    this.existingTrack = [];
    this.addedTracks = [];
    this.ignoreBlankTracks = false;
    this.processCues = true;
    this.onVideoSeeked = (e) => {
      this.updateForcedNarrative();
    };
    this.onVideoTextTrackAdded = (e) => {
      const track = e.track;
      track.expired = false;
      this.onTextTrackAdded(e);
    };
    this.onTextTrackAdded = (e) => {
      const track = e.track;
      const isEmpty2 = track.kind === TextTrackKind.SUBTITLES && !track.language && !track.label;
      const isMetadata = track.kind === TextTrackKind.METADATA;
      if (isMetadata || isEmpty2) {
        return;
      }
      this.addDebounced();
    };
    this.onTextTrackChange = (e) => {
      this.processDebounced();
    };
    this.onCueChange = (e) => {
      const track = e.target;
      const forced = track.kind === TextTrackKind.FORCED;
      if (!this.config.textTrackSettings.enabled && !forced) {
        return;
      }
      const activeCues = this.processCues ? dedupeCues(track, this.video.currentTime) : Array.from(track.activeCues || []);
      this.emit(TextTrackSurfaceEvents.TEXT_CUEPOINT, { activeCues, forced });
    };
    this.addTracks = () => {
      forEach(this.pTextTracks, (t) => {
        const invalid = this.isExpired(t) || this.isDuplicateTrack(t);
        t.mode = !invalid ? TextTrackMode.HIDDEN : TextTrackMode.DISABLED;
        if (invalid) {
          return;
        }
        this.addTrack(t);
      });
      if (!this.currentTextTrack) {
        this.textTrack = findDefaultTrack(this.textTracks, this.config.textTrackSettings.language);
        if (!this.textTrack) {
          return;
        }
        this.textTrack.mode = this.config.textTrackSettings.mode;
        this.emit(TextTrackSurfaceEvents.TEXT_TRACK_AVAILABLE);
      }
      this.processTracks();
    };
    this.processTracks = () => {
      const { enabled, native, enabledMode } = this.config.textTrackSettings;
      const tracks = this.textTracks;
      forEach(this.pTextTracks, (t) => {
        if (this.isExpired(t) && t.mode !== TextTrackMode.DISABLED) {
          t.mode = TextTrackMode.DISABLED;
        }
      });
      if (!native) {
        if (enabled) {
          const track2 = tracks.find((t) => t.mode === TextTrackMode.SHOWING);
          if (track2) {
            track2.mode = enabledMode;
          }
        } else {
          const track2 = tracks.find((t) => t.mode !== TextTrackMode.DISABLED);
          if (track2) {
            track2.mode = TextTrackMode.DISABLED;
          }
        }
        return;
      }
      const track = tracks.find((t) => t.mode === TextTrackMode.SHOWING);
      if (enabled) {
        if (track === this.currentTextTrack) {
          return;
        }
        if (!track) {
          this.textTrackMode = TextTrackMode.DISABLED;
        } else {
          this.textTrack = track;
        }
      } else {
        if (!track) {
          return;
        }
        if (track !== this.currentTextTrack) {
          this.textTrack = track;
        }
        this.textTrackMode = TextTrackMode.SHOWING;
      }
    };
    this.config = config2;
    this.video = config2.video;
    this.pTextTracks = this.video.textTracks;
    this.currentTextTrackMode = config2.textTrackSettings.mode;
    this.pForcedLanguage = config2.textTrackSettings.language;
    this.ignoreBlankTracks = config2.playerOptions.ignoreBlankTextTracks;
    this.processCues = ((_a = config2.playerOptions.overrides) == null ? void 0 : _a.processCues) !== false;
    this.emit = emit || (() => {
    });
    this.processDebounced = debounce(this.processTracks, 100);
    this.addDebounced = debounce(this.addTracks, 25);
    this.addEvents();
    this.logger = config2.logger;
    this.logger.info("TextTrackSurface created");
    if (this.config.resource.location.textTrackUrl) {
      createSidecarTextTrack(this.config.resource, this.video);
    }
  }
  destroy() {
    this.processDebounced.cancel();
    this.addDebounced.cancel();
    this.emit = null;
    this.removeEvents();
    forEach(this.pTextTracks, (t) => this.cleanupTrack(t));
    forEach(this.video.querySelectorAll("track"), (element) => this.video.removeChild(element));
  }
  clearCue() {
    clearCue(this.currentTextTrack, this.video.currentTime);
  }
  cleanupTrack(track) {
    if (!this.isTextTrack(track.kind)) {
      return;
    }
    function cleanupCue(cue) {
      try {
        if (cue) {
          track.removeCue(cue);
        }
      } catch (error) {
      }
    }
    forEachReverse(track.cues, cleanupCue);
    forEachReverse(track.activeCues, cleanupCue);
    track.expired = true;
    track.textTrack1 = true;
    track.textTrack2 = true;
    track.isTTML = true;
    track.isEmbedded = false;
    try {
      track.mode = TextTrackMode.DISABLED;
    } catch (error) {
    }
  }
  set textTrackMode(mode) {
    if (this.currentTextTrack) {
      this.setTrackMode(mode);
    } else {
      this.logger.warn("No text track detected");
    }
  }
  set textTrack(newTrack) {
    if (!this.isValidTrack(newTrack) || newTrack === this.currentTextTrack) {
      return;
    }
    if (this.currentTextTrack && this.currentTextTrack.mode !== TextTrackMode.DISABLED) {
      this.currentTextTrack.mode = TextTrackMode.DISABLED;
    }
    this.currentTextTrack = newTrack;
    this.setTrackMode(this.currentTextTrackMode).then(() => {
      this.logger.info(`${newTrack.language} is being set as the current text track`);
      this.emit(TextTrackSurfaceEvents.TEXT_TRACK_CHANGE, newTrack);
    });
  }
  get textTrack() {
    return this.currentTextTrack;
  }
  get textTracks() {
    return Array.from(this.pTextTracks).filter((t) => this.isValidTrack(t));
  }
  set forcedLanguage(value) {
    this.pForcedLanguage = value;
    this.updateForcedNarrative();
  }
  get forcedLanguage() {
    return this.pForcedLanguage;
  }
  setTrackMode(mode) {
    return new Promise((resolve, reject) => {
      const modeChanged = mode !== this.currentTextTrackMode;
      const applyMode = () => {
        this.currentTextTrack.mode = mode;
        this.updateForcedNarrative();
        if (modeChanged) {
          setTimeout(() => this.emit(TextTrackSurfaceEvents.TEXT_TRACK_DISPLAY_MODE_CHANGE, { mode }), 0);
        }
        let msg = TextTrackMode.DISABLED;
        mode === TextTrackMode.HIDDEN && (msg = "enabled for event driven external custom rendering");
        mode === TextTrackMode.SHOWING && (msg = "enabled for native rendering by the user agent");
        this.logger.info(`The ${this.currentTextTrack.kind} track for language code ${this.currentTextTrack.language} is being ${msg} `);
        resolve();
      };
      this.currentTextTrackMode = mode;
      if (mode === TextTrackMode.SHOWING && this.currentTextTrack.mode === TextTrackMode.DISABLED) {
        this.currentTextTrack.mode = TextTrackMode.HIDDEN;
        setTimeout(applyMode, 10);
      } else {
        applyMode();
      }
    });
  }
  updateForcedNarrative() {
    const isForced = (track) => track.kind === TextTrackKind.FORCED;
    const tracks = Array.from(this.pTextTracks).filter(isForced);
    tracks.forEach((track) => track.mode = TextTrackMode.DISABLED);
    const disabled = this.currentTextTrackMode === TextTrackMode.DISABLED;
    if (!disabled) {
      return;
    }
    const forced = tracks.find((track) => track.language === this.pForcedLanguage);
    if (!forced) {
      return;
    }
    forced.addEventListener(TextTrackEvent.CUE_CHANGE, this.onCueChange);
    forced.mode = this.config.textTrackSettings.enabledMode;
  }
  addTrack(track) {
    if (this.addedTracks.includes(track)) {
      return;
    }
    this.addedTracks.push(track);
    if (!this.isValidTrack(track)) {
      return;
    }
    track.addEventListener(TextTrackEvent.CUE_CHANGE, this.onCueChange);
    this.logger.info(`A ${track.kind} text track was added for ${track.language}`);
    this.emit(TextTrackSurfaceEvents.TEXT_TRACK_ADDED, track);
  }
  addEvents() {
    this.pTextTracks.addEventListener(TextTrackEvent.ADD_TRACK, this.onTextTrackAdded);
    this.pTextTracks.addEventListener(TextTrackEvent.CHANGE, this.onTextTrackChange);
    this.video.addEventListener(TextTrackEvent.ADD_TRACK, this.onVideoTextTrackAdded);
    this.video.addEventListener(VideoSurfaceEvents.SEEKED, this.onVideoSeeked);
  }
  removeEvents() {
    this.pTextTracks.removeEventListener(TextTrackEvent.ADD_TRACK, this.onTextTrackAdded);
    this.pTextTracks.removeEventListener(TextTrackEvent.CHANGE, this.onTextTrackChange);
    this.video.removeEventListener(TextTrackEvent.ADD_TRACK, this.onVideoTextTrackAdded);
    this.video.removeEventListener(VideoSurfaceEvents.SEEKED, this.onVideoSeeked);
    forEach(this.pTextTracks, (t) => t.removeEventListener(TextTrackEvent.CUE_CHANGE, this.onCueChange));
  }
  // Util
  isDuplicateTrack(t) {
    if (this.existingTrack.includes(t)) {
      return false;
    }
    const result = this.existingTrack.some((track) => t.language === track.language && t.label === track.label && t.kind === track.kind);
    if (!result) {
      this.existingTrack.push(t);
    }
    return result;
  }
  isTextTrack(type) {
    return type === TextTrackKind.CAPTIONS || type === TextTrackKind.SUBTITLES;
  }
  isExpired(track) {
    return track.expired;
  }
  isValidTrack(track) {
    if (!track) {
      return false;
    }
    if (!this.isTextTrack(track.kind)) {
      return false;
    }
    if (this.ignoreBlankTracks && !track.label && !track.language) {
      return false;
    }
    if (this.isExpired(track)) {
      return false;
    }
    return true;
  }
}
class WaitingSurface {
  constructor(context, onWaitingChange) {
    this.waiting = false;
    this.time = NaN;
    this.next = null;
    this.video = context.video;
    this.onWaitingChange = onWaitingChange;
    this.onWaiting = this.onWaiting.bind(this);
    this.onSeeking = this.onSeeking.bind(this);
    this.onUpdateTime = this.onUpdateTime.bind(this);
    this.onTimeUpdate = this.onTimeUpdate.bind(this);
    this.video.addEventListener(VideoSurfaceEvents.WAITING, this.onWaiting);
    this.video.addEventListener(VideoSurfaceEvents.SEEKING, this.onSeeking);
    this.video.addEventListener(VideoSurfaceEvents.ERROR, this.onError);
  }
  clearUpdate() {
    const { video } = this;
    video.removeEventListener(VideoSurfaceEvents.TIME_UPDATE, this.onUpdateTime);
  }
  destroy() {
    const { video } = this;
    this.onWaitingChange = null;
    video.removeEventListener(VideoSurfaceEvents.WAITING, this.onWaiting);
    video.removeEventListener(VideoSurfaceEvents.SEEKING, this.onSeeking);
    video.removeEventListener(VideoSurfaceEvents.TIME_UPDATE, this.onTimeUpdate);
    video.removeEventListener(VideoSurfaceEvents.ERROR, this.onError);
    this.clearUpdate();
  }
  setWaiting(value) {
    var _a;
    this.waiting = value;
    (_a = this.onWaitingChange) == null ? void 0 : _a.call(this, value);
    if (value) {
      this.video.addEventListener(VideoSurfaceEvents.TIME_UPDATE, this.onUpdateTime);
    }
  }
  onWaiting() {
    if (!this.waiting && !this.video.seeking) {
      this.setWaiting(true);
    }
  }
  onSeeking() {
    this.setWaiting(true);
  }
  onUpdateTime() {
    this.clearUpdate();
    if (this.video.paused) {
      this.setWaiting(false);
      return;
    }
    this.time = this.video.currentTime;
    this.video.addEventListener(VideoSurfaceEvents.TIME_UPDATE, this.onTimeUpdate);
  }
  onTimeUpdate() {
    if (this.time < this.video.currentTime) {
      this.setWaiting(false);
      this.time = NaN;
      this.video.removeEventListener(VideoSurfaceEvents.TIME_UPDATE, this.onTimeUpdate);
    }
  }
  onError() {
    if (!this.waiting) {
      return;
    }
    this.setWaiting(false);
  }
}
class PlaybackAdapterBase {
  constructor(context, options = {}, useTextSurface = true) {
    this.metadataLoaded = false;
    this.suppressErrors = false;
    this.segmentDuration = 6;
    this.pauseTime = NaN;
    this.eventsEnabled = false;
    this.startedPlaying = false;
    this.liveStreamInfo = {
      isPlayingLive: false,
      liveEdgeOffset: NaN,
      ltsWindowSize: NaN,
      relativeTime: NaN,
      relativeDuration: NaN,
      absoluteStart: NaN,
      absoluteTime: NaN,
      absoluteDuration: NaN
    };
    this.audioTrack = null;
    this.audioTracks = [];
    this.quality = null;
    this.qualities = null;
    this.textTrack = null;
    this.textTracks = [];
    this.minBitrate = 0;
    this.maxBitrate = Infinity;
    this.maxHeight = Infinity;
    this.qualityCappedToScreenSize = null;
    this.onTextEvent = (type, data) => {
      if (!this.eventsEnabled) {
        return;
      }
      const { delegate } = this;
      switch (type) {
        case TextTrackSurfaceEvents.TEXT_CUEPOINT:
          delegate.textCuepoints(data.activeCues, data.forced);
          break;
        case TextTrackSurfaceEvents.TEXT_TRACK_DISPLAY_MODE_CHANGE:
          delegate.textTrackDisplayModeChange(data.mode);
          break;
        case TextTrackSurfaceEvents.TEXT_TRACK_ADDED:
          this.textTracks.push({
            id: this.textTracks.length.toString(),
            kind: data.kind,
            language: data.language,
            label: data.label || data.language
          });
          delegate.textTracksChange(this.textTracks);
          break;
        case TextTrackSurfaceEvents.TEXT_TRACK_AVAILABLE:
          delegate.textTracksChange(this.textTracks);
          break;
        case TextTrackSurfaceEvents.TEXT_TRACK_CHANGE:
          const track = this.textTracks.find((track2) => data.language === track2.language && data.kind === track2.kind && (data.label === track2.label || data.language === track2.label));
          this.textTrack = track;
          delegate.textTrackChange(track);
          break;
      }
    };
    this.onCueChange = this.onCueChange.bind(this);
    this.onMetadataCuepoint = this.onMetadataCuepoint.bind(this);
    this.onWaitingChange = this.onWaitingChange.bind(this);
    this.videoEventMap = {
      [VideoSurfaceEvents.PLAYING]: this.onPlaying = this.onPlaying.bind(this),
      [VideoSurfaceEvents.PAUSE]: this.onPause = this.onPause.bind(this),
      [VideoSurfaceEvents.SEEKING]: this.onSeeking = this.onSeeking.bind(this),
      [VideoSurfaceEvents.SEEKED]: this.onSeeked = this.onSeeked.bind(this),
      [VideoSurfaceEvents.TIME_UPDATE]: this.onTimeUpdate = this.onTimeUpdate.bind(this),
      [VideoSurfaceEvents.VOLUME_CHANGE]: this.onVolumeChange = this.onVolumeChange.bind(this),
      [VideoSurfaceEvents.ENDED]: this.onEnded = this.onEnded.bind(this),
      [VideoSurfaceEvents.ERROR]: this.onVideoError = this.onVideoError.bind(this)
    };
    this.context = context;
    this.options = options;
    this.video = context.video;
    this.delegate = this.context.getDelegate();
    this.logger = context.logger;
    this.metadataSurface = this.createMetadataSurface();
    this.waitingSurface = this.createWaitingSurface();
    const playback = context.resource.playback;
    this.isLtsRestricted = this.isValidRestrictionTimestamp(playback.lts.restrictionTimestamp);
    this.qualityCappedToScreenSize = playback.abr.capQualityToScreenSize;
    const abr = playback == null ? void 0 : playback.abr;
    if (abr) {
      if (abr.maxBitrate) {
        this.maxBitrate = abr.maxBitrate;
      }
      if (abr.minBitrate) {
        this.minBitrate = abr.minBitrate;
      }
      if (abr.maxHeight) {
        this.maxHeight = abr.maxHeight;
      }
    }
    if (useTextSurface) {
      this.textTrackSurface = this.createTextTrackSurface();
    }
  }
  static canPlay(context, mimeTypes) {
    const { avia: avia2, resource } = context;
    const systemInfo2 = avia2.getSystemInfo();
    const mimeType = getResourceMimeType(resource);
    const validMimeType = mimeTypes.includes(mimeType);
    return systemInfo2.hasMediaSource && validMimeType;
  }
  destroy() {
    var _a, _b, _c;
    this.video.removeEventListener(VideoSurfaceEvents.LOADED_METADATA, this.onLoadedMetadata);
    this.video.removeEventListener(VideoSurfaceEvents.DURATION_CHANGE, this.onDurationChange);
    this.removeEvents(this.video, this.videoEventMap);
    this.listenToTextTracks(false, true);
    (_a = this.metadataSurface) == null ? void 0 : _a.destroy();
    this.metadataSurface = null;
    (_b = this.textTrackSurface) == null ? void 0 : _b.destroy();
    this.textTrackSurface = null;
    (_c = this.waitingSurface) == null ? void 0 : _c.destroy();
    this.waitingSurface = null;
    this.context = null;
    this.options = null;
    this.delegate = null;
    this.logger = null;
    this.video = null;
    return Promise.resolve();
  }
  get info() {
    return {
      id: "base",
      version: "n/a"
    };
  }
  onTick() {
    var _a;
    (_a = this.metadataSurface) == null ? void 0 : _a.onTick();
  }
  getIsLiveStream() {
    return this.video.duration === Infinity;
  }
  setAutoQualitySwitching(auto) {
    throw new Error("setAutoQualitySwitching Method not implemented.");
  }
  setQuality(quality) {
    throw new Error("setQuality Method not implemented.");
  }
  setMinBitrate(value) {
    this.minBitrate = value;
  }
  setMaxBitrate(value) {
    this.maxBitrate = value;
  }
  setQualityCappedToScreenSize(value) {
    this.qualityCappedToScreenSize = value;
    this.resize();
  }
  setTextTrack(value) {
    if (!this.textTrackSurface) {
      return;
    }
    const tracks = Array.from(this.video.textTracks);
    const track = tracks.find((track2) => value.language === track2.language && value.kind === track2.kind && value.label === track2.label);
    this.textTrackSurface.textTrack = track;
  }
  setTextTrackMode(mode) {
    if (!this.textTrackSurface) {
      return;
    }
    this.textTrackSurface.textTrackMode = mode;
  }
  setAudioTrack(track) {
    throw new Error("setAudioTrack Method not implemented.");
  }
  getId() {
    throw new Error("getId Method not implemented.");
  }
  getCurrentTime() {
    return this.video.currentTime;
  }
  getDuration() {
    return this.video.duration;
  }
  getBuffered(asStreamTime = false) {
    const { buffered } = this.video;
    const result = [];
    const offset = asStreamTime ? 0 : this.getSeekable().start;
    for (let i = 0, len = buffered.length; i < len; i++) {
      result.push({
        startTime: buffered.start(i) - offset,
        endTime: buffered.end(i) - offset
      });
    }
    return result;
  }
  getLiveStreamUtcStart() {
    return NaN;
  }
  getLiveStreamUtcTime() {
    return NaN;
  }
  isValidRestrictionTimestamp(timestamp) {
    return timestamp === -1 || timestamp !== null && !isNaN(timestamp) && timestamp >= 0;
  }
  calculateStart(currentTime = this.video.currentTime, start = this.getSeekable().start, liveStreamUtcStart = this.getLiveStreamUtcStart(), liveStreamUtcTime = this.getLiveStreamUtcTime()) {
    var _a;
    if (this.getIsLiveStream()) {
      const lts = (_a = this.context.resource.playback) == null ? void 0 : _a.lts;
      if (this.isLtsRestricted && !this.restrictedStartTime && currentTime > 0) {
        const restrictionTimestamp = lts == null ? void 0 : lts.restrictionTimestamp;
        const useTimestamp = restrictionTimestamp !== -1;
        if (useTimestamp && restrictionTimestamp > liveStreamUtcStart) {
          this.restrictedStartTimeUtc = restrictionTimestamp;
          this.restrictedStartTime = currentTime - (liveStreamUtcTime - restrictionTimestamp) * 1e-3;
        } else if (!useTimestamp) {
          this.restrictedStartTime = currentTime;
          this.restrictedStartTimeUtc = liveStreamUtcTime;
        }
        if (lts == null ? void 0 : lts.startTimestamp) {
          this.setLtsStartTime(lts.startTimestamp, this.restrictedStartTime, currentTime, liveStreamUtcTime);
        }
      } else if ((lts == null ? void 0 : lts.startTimestamp) && currentTime > 0 && this.pendingSeekTime === void 0) {
        this.setLtsStartTime(lts.startTimestamp, start, currentTime, liveStreamUtcTime);
      }
    }
    const useRestricted = !isNaN(this.restrictedStartTime) && this.restrictedStartTimeUtc > liveStreamUtcStart;
    return {
      videoStart: useRestricted ? this.restrictedStartTime : start,
      utcStart: useRestricted ? this.restrictedStartTimeUtc : liveStreamUtcStart
    };
  }
  setLtsStartTime(startTimestamp, videoStart, currentTime, currentUtcTime) {
    if (this.pendingSeekTime === void 0) {
      const relativeTime = Math.max(0, currentTime - videoStart);
      this.pendingSeekTime = Math.max(0, relativeTime - (currentUtcTime - startTimestamp) * 1e-3);
    }
  }
  getLiveStreamInfo() {
    const details = this.liveStreamInfo;
    const currentTime = this.video.currentTime;
    const liveStreamUtcStart = this.getLiveStreamUtcStart();
    const liveStreamUtcTime = this.getLiveStreamUtcTime();
    const { start, end } = this.getSeekable();
    const { videoStart, utcStart } = this.calculateStart(currentTime, start, liveStreamUtcStart, liveStreamUtcTime);
    const duration = end - videoStart;
    const offset = this.getLiveEdgeOffset();
    const relativeTime = Math.max(currentTime - videoStart, 0);
    details.relativeTime = relativeTime;
    details.relativeDuration = duration;
    details.absoluteStart = utcStart;
    details.absoluteDuration = utcStart + duration * 1e3;
    details.absoluteTime = liveStreamUtcTime;
    details.ltsWindowSize = Math.floor(duration);
    details.liveEdgeOffset = offset;
    details.isPlayingLive = Math.ceil(currentTime) >= this.calculateLiveBoundary(end);
    return details;
  }
  getThumbnails(time) {
    return Promise.resolve([]);
  }
  load() {
    this.enableSurfaceEvents(true);
    this.suppressErrors = true;
    return Promise.resolve(getResourceMetadata(this.context.resource));
  }
  play() {
    return Promise.resolve().then(() => {
      if (!isNaN(this.pauseTime)) {
        this.pauseTime = NaN;
        if (this.pauseTime < this.liveStreamInfo.absoluteStart) {
          this.logger.info(`Playhead outside of LTS window bounds. Moving to start of LTS window.`);
          return this.seek(0);
        }
      }
      if (this.getIsLiveStream()) {
        return this.seek(this.liveStreamInfo.relativeTime);
      }
    }).then(() => this.video.play());
  }
  pause() {
    var _a, _b;
    if (this.getIsLiveStream() && ((_b = (_a = this.context.resource.playback) == null ? void 0 : _a.lts) == null ? void 0 : _b.clearOutOfBoundsLtsBuffer) === true) {
      this.pauseTime = this.liveStreamInfo.absoluteTime;
    }
    this.video.pause();
  }
  suspend() {
  }
  resume() {
  }
  seek(position) {
    if (isNaN(position)) {
      return Promise.resolve();
    }
    const seekable = this.getSeekable();
    let start = seekable.start;
    const end = seekable.end;
    const duration = end - start;
    if (this.getIsLiveStream()) {
      const { startTime, endTime } = this.getNoSeekRange(duration);
      if (inRange(position, startTime, endTime)) {
        const currentTime = this.liveStreamInfo.relativeTime;
        position = position < currentTime ? startTime : endTime;
      }
      position = clampValue(position, this.getLiveEdgeOffset(), endTime);
      start = this.calculateStart().videoStart;
    }
    const time = mapToRange(position, 0, duration, start, end);
    if (isValidPlayheadTime(time)) {
      this.video.currentTime = time;
      return waitForEvent(this.video, VideoSurfaceEvents.SEEKED);
    }
    return Promise.resolve();
  }
  resize() {
  }
  clearText() {
    var _a;
    (_a = this.textTrackSurface) == null ? void 0 : _a.clearCue();
  }
  getMetrics() {
    const { video } = this;
    const result = {
      bandwidth: NaN,
      framerate: NaN,
      droppedVideoFrames: Number.NaN,
      totalVideoFrames: Number.NaN
    };
    if ("getVideoPlaybackQuality" in video) {
      Object.assign(result, video.getVideoPlaybackQuality());
    } else if ("webkitDroppedFrameCount" in video && "webkitDecodedFrameCount" in video) {
      result.droppedVideoFrames = video.webkitDroppedFrameCount;
      result.totalVideoFrames = video.webkitDroppedFrameCount + video.webkitDecodedFrameCount;
    }
    const frames = video.webkitDecodedFrameCount || video.mozPresentedFrames;
    if (frames) {
      result.framerate = frames / video.currentTime;
    }
    return result;
  }
  getLiveEdgeOffset() {
    const segmentDuration = this.getSegmentDuration();
    const count = this.context.resource.playback.liveEdgeSyncFragmentCount;
    return Math.max(segmentDuration, segmentDuration * count);
  }
  getRefreshInterval() {
    return this.getSegmentDuration() * 2;
  }
  calculateLiveBoundary(duration) {
    return duration - this.getLiveEdgeOffset() - this.getRefreshInterval();
  }
  getNoSeekRange(duration) {
    const boundary = this.calculateLiveBoundary(duration);
    const padding = this.getRefreshInterval();
    return {
      startTime: boundary - padding,
      endTime: boundary + padding
    };
  }
  createMetadataSurface() {
    return new MetadataSurface(this.context, this.onMetadataCuepoint);
  }
  createTextTrackSurface() {
    return new TextTrackSurface(this.context, this.onTextEvent);
  }
  createWaitingSurface() {
    return new WaitingSurface(this.context, this.onWaitingChange);
  }
  enableSurfaceEvents(enabled) {
    this.eventsEnabled = true;
    this.video.addEventListener(VideoSurfaceEvents.LOADED_METADATA, this.onLoadedMetadata = this.onLoadedMetadata.bind(this));
    this.video.addEventListener(VideoSurfaceEvents.DURATION_CHANGE, this.onDurationChange = this.onDurationChange.bind(this));
  }
  addEvents(adapter, map) {
    const action = isFunction(adapter.on) ? "on" : "addEventListener";
    entries(map).forEach((entry) => adapter[action](entry[0], entry[1]));
  }
  removeEvents(adapter, map) {
    const action = isFunction(adapter.off) ? "off" : "removeEventListener";
    entries(map).forEach((entry) => {
      var _a, _b;
      (_b = (_a = entry[1]).cancel) == null ? void 0 : _b.call(_a);
      adapter[action](entry[0], entry[1]);
    });
  }
  createVideoElementError() {
    const error = this.video.error;
    let message = Object.keys(MediaError)[error.code - 1] || AppResources.messages.UNSPECIFIED_ERROR;
    let code = ErrorCode.UNSPECIFIED_VIDEO_PLAYBACK_ERROR;
    switch (error.code) {
      case MediaError.MEDIA_ERR_ABORTED:
        message = error.toString();
        code = ErrorCode.MEDIA_ABORTED;
        break;
      case MediaError.MEDIA_ERR_NETWORK:
        code = ErrorCode.HTML5_NETWORK_ERROR;
        break;
      case MediaError.MEDIA_ERR_DECODE:
        code = ErrorCode.HTML5_MEDIA_ERROR;
        break;
      case MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED:
        code = ErrorCode.HTML5_SRC_NOT_SUPPORTED;
        break;
      default:
        code = ErrorCode.UNSPECIFIED_VIDEO_PLAYBACK_ERROR;
    }
    return { code, message, fatal: true, cause: error };
  }
  onLoadedMetadata() {
    this.metadataLoaded = true;
    this.addEvents(this.video, this.videoEventMap);
  }
  onDurationChange() {
    this.delegate.durationChange();
  }
  onPlaying() {
    return __async(this, null, function* () {
      if (this.pendingSeekTime) {
        const t = this.pendingSeekTime;
        this.pendingSeekTime = null;
        yield this.seek(t);
      }
      this.startedPlaying = true;
      this.delegate.playing();
    });
  }
  onPause() {
    this.delegate.paused();
  }
  onSeeking() {
    this.delegate.seeking();
  }
  onSeeked() {
    this.delegate.seeked();
  }
  onTimeUpdate() {
    this.delegate.timeUpdate();
  }
  onVolumeChange() {
    this.delegate.volumeChange(this.video.volume, this.video.muted);
  }
  onEnded() {
    this.delegate.ended();
  }
  onVideoError() {
    if (!this.suppressErrors) {
      this.error(this.createVideoElementError());
    }
  }
  getSegmentDuration() {
    return this.segmentDuration;
  }
  getSeekable() {
    const result = { start: 0, end: 0 };
    const range = this.video.seekable;
    const index2 = range.length - 1;
    if (index2 >= 0) {
      result.start = range.start(index2);
      result.end = range.end(index2);
    }
    return result;
  }
  getErrorMessage(msg, isFatal, retry = "n/a") {
    return `${msg} fatal: ${isFatal} retry: ${retry}`;
  }
  createError(code, message, cause, fatal = true) {
    return new PlayerError(code, message, cause, fatal);
  }
  throwError(code, message, cause, fatal = true) {
    this.error(this.createError(code, message, cause, fatal));
  }
  error(error) {
    this.delegate.error(error);
  }
  createSidecarTextTrack() {
    var _a;
    const { resource, video } = this.context;
    if (!((_a = resource.location) == null ? void 0 : _a.textTrackUrl)) {
      return;
    }
    createSidecarTextTrack(resource, video);
  }
  updateQuality(quality) {
    var _a;
    if (((_a = this.quality) == null ? void 0 : _a.bitrate) === quality.bitrate) {
      return;
    }
    this.quality = quality;
    this.delegate.qualityChange(quality);
  }
  updateQualities(qualities) {
    if (!qualities) {
      return;
    }
    qualities.sort((a, b) => {
      if (a.bitrate !== b.bitrate) {
        return a.bitrate - b.bitrate;
      } else if (a.height !== b.height) {
        return a.height - b.height;
      } else if (a.width !== b.width) {
        return a.width - b.width;
      }
      return 0;
    });
    const cap = this.qualityCappedToScreenSize;
    const bounds = cap && this.video.getBoundingClientRect();
    qualities.forEach((quality) => {
      quality.enabled = validateQuality(quality, this.minBitrate, this.maxBitrate, this.maxHeight, bounds);
    });
    if (!qualities.some((quality) => quality.enabled)) {
      this.logger.warn("Invalid qualities array. None of the values meet the current size/bitrate constraints.");
    }
    if (JSON.stringify(this.qualities) === JSON.stringify(qualities)) {
      return;
    }
    this.qualities = qualities;
    this.delegate.qualitiesChange(qualities);
  }
  listenToTextTracks(flag, clearCues = false) {
    const verb = flag ? "addEventListener" : "removeEventListener";
    Array.from(this.context.video.textTracks).forEach((textTrack) => {
      if (!isTextTrack(textTrack.kind)) {
        return;
      }
      textTrack[verb](TextTrackEvent.CUE_CHANGE, this.onCueChange);
      if (clearCues) {
        clearAllCues(textTrack);
      }
    });
  }
  onCueChange(event, forced) {
    const track = event.target;
    const activeCues = dedupeCues(track, this.video.currentTime);
    const forcedTrack = event.target.forced === true;
    forced != null ? forced : forced = track.kind === TextTrackKind.FORCED || event.forced || forcedTrack;
    this.delegate.textCuepoints(activeCues, forced);
  }
  onMetadataCuepoint(metadata) {
    this.delegate.metadataCuepoint(metadata);
  }
  onWaitingChange(waiting) {
    this.delegate.waitingChange(waiting);
  }
}
class Html5Adapter extends PlaybackAdapterBase {
  constructor(context, options = {}) {
    super(context, options, true);
    this.isNonZeroStartTime = false;
    this.onAddAudioEvent = (event) => {
      this.audioTracks = [];
      this.audioTrack = null;
      forEach(this.domAudioTracks, (audioTrack, index2) => {
        if (!audioTrack.label && !audioTrack.language) {
          return;
        }
        const { kind } = audioTrack;
        const track = {
          index: index2,
          id: index2.toString(),
          type: kind === "alternative" || kind === "description" ? AudioTrackType.DESCRIPTION : AudioTrackType.MAIN,
          codec: "",
          language: audioTrack.language,
          label: audioTrack.label
        };
        this.audioTracks.push(track);
      });
      this.delegate.audioTracksChange(this.audioTracks);
      this.setAudioTrack(findDefaultTrack(this.audioTracks, this.context.playerOptions.audioLanguage, this.context.playerOptions.audioRole));
      if (!this.audioTrack) {
        this.changeAudioDebounced();
      }
    };
    this.onChangeAudioEvent = (event) => {
      const audioTrack = Array.from(this.domAudioTracks).find((track) => track.enabled);
      this.audioTrack = this.audioTracks.find((track) => track.id === audioTrack.id);
      this.delegate.audioTrackChange(this.audioTrack);
    };
    this.onFairPlayError = (error) => {
      this.delegate.error(error);
    };
    const { fairplay } = this.context.resource.location.drm;
    if (fairplay.appCertUrl) {
      this.fairplay = new FairPlay(this.video, fairplay, this.logger, this.delegate, this.onFairPlayError);
      this.fairplay.initialize();
      this.delegate.drmKeySystemCreated(this.fairplay.keySystem);
    }
    const audioTracks = this.domAudioTracks;
    if (audioTracks) {
      this.addAudioDebounced = debounce(this.onAddAudioEvent, 100);
      this.changeAudioDebounced = debounce(this.onChangeAudioEvent, 100);
      audioTracks.addEventListener(TextTrackEvent.ADD_TRACK, this.addAudioDebounced);
      audioTracks.addEventListener(TextTrackEvent.CHANGE, this.changeAudioDebounced);
    }
  }
  static get ID() {
    return HTML5;
  }
  static get config() {
    return {
      id: Html5Adapter.ID,
      role: [AdapterRole.PLAYBACK],
      factory: (context, options = {}) => {
        return new Html5Adapter(context, options);
      },
      isSupported: (context) => {
        var _a;
        const type = getResourceMimeType(context.resource);
        return ((_a = context.video) == null ? void 0 : _a.canPlayType(type)) !== "";
      }
    };
  }
  get domAudioTracks() {
    return this.video.audioTracks;
  }
  getId() {
    return Html5Adapter.ID;
  }
  get info() {
    return {
      id: this.getId(),
      version: "n/a"
    };
  }
  destroy() {
    const audioTracks = this.domAudioTracks;
    if (audioTracks) {
      this.addAudioDebounced.cancel();
      this.changeAudioDebounced.cancel();
      audioTracks.removeEventListener(TextTrackEvent.ADD_TRACK, this.addAudioDebounced);
      audioTracks.removeEventListener(TextTrackEvent.CHANGE, this.changeAudioDebounced);
    }
    if (this.fairplay) {
      this.fairplay.destroy();
      this.fairplay = null;
    }
    this.destroyMediaElement();
    return super.destroy();
  }
  destroyMediaElement() {
    const video = this.video;
    video.removeAttribute("src");
    video.load();
  }
  applySrc(src, mimeType) {
    this.video.src = src;
  }
  load() {
    var _a;
    this.suppressErrors = true;
    super.load();
    const { resource } = this.context;
    let src = resource.location.mediaUrl;
    const mimeType = ((_a = resource.overrides) == null ? void 0 : _a.mimeType) || getMimeType(src);
    const getFormat = (mimeType2) => {
      switch (mimeType2) {
        case MimeType.HLS:
        case MimeType.HLS_ALT:
          return CmcdStreamingFormat.HLS;
        case MimeType.DASH:
          return CmcdStreamingFormat.DASH;
        default:
          return CmcdStreamingFormat.OTHER;
      }
    };
    const { cmcd } = resource;
    if (cmcd.enabled) {
      src = appendCmcdQuery(src, {
        ot: CmcdObjectType.MANIFEST,
        sf: getFormat(mimeType),
        su: true,
        sid: cmcd.sessionId,
        cid: cmcd.contentId,
        pr: this.video.playbackRate,
        v: CMCD_VERSION
      });
    }
    return this.delegate.applyHook(PlayerHookType.REQUEST, { url: src }, { objectType: RequestObjectType.MANIFEST }).then((value) => {
      this.applySrc(value.url, mimeType);
      return waitForEvent(this.video, VideoSurfaceEvents.LOADED_METADATA).then(() => {
        const startTime = resource.playback.startTime;
        if (isValidPlayheadTime(startTime) && startTime > 0) {
          this.isNonZeroStartTime = true;
          const h = () => {
            this.video.removeEventListener(VideoSurfaceEvents.PLAYING, h);
            this.seek(startTime);
          };
          this.video.addEventListener(VideoSurfaceEvents.PLAYING, h);
        }
      }).then(() => {
        this.suppressErrors = false;
        return {
          manifest: {
            mimeType
          },
          fragment: {
            mimeType: void 0
          }
        };
      }).catch(() => {
        throw this.createVideoElementError();
      });
    });
  }
  setAudioTrack(track) {
    if (!track) {
      return;
    }
    forEach(this.domAudioTracks, (audioTrack, index2) => {
      audioTrack.enabled = track.index === index2;
    });
    this.textTrackSurface.forcedLanguage = track.language;
  }
  setQuality(value) {
    this.logger.info(AppResources.messages.MANUAL_ABR_SWITCHING_UNAVAILABLE);
  }
  setAutoQualitySwitching(value) {
    this.logger.info(AppResources.messages.MANUAL_ABR_SWITCHING_UNAVAILABLE);
  }
  setMinBitrate(value) {
    this.logger.info(AppResources.messages.MANUAL_ABR_SWITCHING_UNAVAILABLE);
  }
  setMaxBitrate(value) {
    this.logger.info(AppResources.messages.MANUAL_ABR_SWITCHING_UNAVAILABLE);
  }
  setTextTrackMode(mode) {
    if (!this.textTrackSurface) {
      return;
    }
    if (this.isNonZeroStartTime && !this.startedPlaying) {
      this.isNonZeroStartTime = false;
      waitForEvent(this.video, VideoSurfaceEvents.SEEKED).then(() => this.textTrackSurface.textTrackMode = mode);
    } else {
      this.textTrackSurface.textTrackMode = mode;
    }
  }
  calculateUtcTime(time) {
    const video = this.video;
    if (!video.getStartDate) {
      return NaN;
    }
    const startDate = video.getStartDate().getTime();
    const offset = time * 1e3;
    return Math.round(startDate + offset);
  }
  getLiveStreamUtcStart() {
    return this.calculateUtcTime(this.getSeekable().start);
  }
  getLiveStreamUtcTime() {
    return this.calculateUtcTime(this.video.currentTime);
  }
}
const DOM_VIDEO = "dom-video-adapter";
const buildInfo = Object.freeze({
  env: "__ENV__",
  playerVersion: "2.46.0",
  playerName: "@cbsinteractive/avia-js",
  buildTime: "2025-03-26T17:08:06.984Z"
});
var LogLevel = /* @__PURE__ */ ((LogLevel2) => {
  LogLevel2["OFF"] = "off";
  LogLevel2["ERROR"] = "error";
  LogLevel2["WARN"] = "warn";
  LogLevel2["INFO"] = "info";
  LogLevel2["DEBUG"] = "debug";
  LogLevel2["VERBOSE"] = "verbose";
  return LogLevel2;
})(LogLevel || {});
var LoggerEvent = /* @__PURE__ */ ((LoggerEvent2) => {
  LoggerEvent2["LOG_EVENT"] = "logevent";
  LoggerEvent2["TIME_EVENT"] = "logtimeevent";
  LoggerEvent2["TIME_END_EVENT"] = "logtimeendevent";
  return LoggerEvent2;
})(LoggerEvent || {});
const getPath = (logger2) => {
  var _a;
  return ((_a = logger2.parent) == null ? void 0 : _a.id) ? `${getPath(logger2.parent)}/${logger2.id}` : logger2.id;
};
const Levels = {
  [LogLevel.OFF]: 0,
  [LogLevel.ERROR]: 100,
  [LogLevel.WARN]: 200,
  [LogLevel.INFO]: 300,
  [LogLevel.DEBUG]: 400,
  [LogLevel.VERBOSE]: 500
};
const _Logger = class _Logger extends Emitter {
  constructor(opts) {
    super(opts);
    this.useConsole_ = false;
    this.startTime_ = {};
    this.parent_ = this.opts.parent;
    this.useConsole_ = isObject(console);
    this.id_ = opts.id || opts.id === "" && !this.parent_ ? opts.id : uid8();
    this.logLevel = this.opts.logLevel ? this.opts.logLevel : this.opts.debug ? LogLevel.DEBUG : null;
    this.path_ = getPath(this);
  }
  static error(e) {
    console && console.error(e);
  }
  static warn(m) {
    console && console.warn(m);
  }
  static log(m) {
    console && console.log(m);
  }
  /**
   * @deprecated Log deprecation message
   */
  static deprecated(msg) {
    if (_Logger.deprecatedCounts[msg] >= _Logger.maxDeprecatedWarnings) {
      return;
    }
    _Logger.warn(msg);
    _Logger.deprecatedCounts[msg] = (_Logger.deprecatedCounts[msg] || 0) + 1;
  }
  get id() {
    return this.id_;
  }
  get parent() {
    return this.parent_;
  }
  get logLevel() {
    var _a;
    return this.logLevel_ || ((_a = this.parent) == null ? void 0 : _a.logLevel) || LogLevel.OFF;
  }
  set logLevel(level) {
    this.logLevel_ = level;
    this.level_ = Levels[this.logLevel];
  }
  emit(name, detail) {
    var _a;
    super.emit(name, detail);
    (_a = this.parent) == null ? void 0 : _a.emit(name, detail);
  }
  create(options) {
    var _a;
    (_a = options.parent) != null ? _a : options.parent = this;
    return new _Logger(options);
  }
  assert(expression, label) {
    if (!expression) {
      this.error(`Assertion failed! - "${label || ""}"`);
    }
  }
  log(logLevel, ...items) {
    for (let i = 0, n = items.length; i < n; i++) {
      this.emit(LoggerEvent.LOG_EVENT, this.assembleEvent(items[i], logLevel));
    }
    if (!this.shouldLog(logLevel)) {
      return;
    }
    items.unshift(this.getStamp());
    console.log(...items);
  }
  dir(logLevel, obj, label) {
    const lbl = label || "Unnamed Object";
    this.emit(LoggerEvent.LOG_EVENT, this.assembleEvent(obj, logLevel, lbl));
    if (!this.shouldLog(logLevel)) {
      return;
    }
    console.log(this.getStamp() + `Object: ${lbl}`);
    console.dir(obj);
  }
  error(...msg) {
    this.log(LogLevel.ERROR, ...msg);
  }
  warn(...msg) {
    this.log(LogLevel.WARN, ...msg);
  }
  info(...msg) {
    this.log(LogLevel.INFO, ...msg);
  }
  debug(...msg) {
    this.log(LogLevel.DEBUG, ...msg);
  }
  verbose(...msg) {
    this.log(LogLevel.VERBOSE, ...msg);
  }
  time(label, startTime = performance.now()) {
    if (this.startTime_[label]) {
      this.warn(`Timer ${label} already exists`);
      return;
    }
    this.startTime_[label] = startTime;
    this.emit(LoggerEvent.TIME_EVENT, this.assembleEvent({ startTime }, LogLevel.INFO, label));
  }
  timeEnd(label) {
    if (!this.startTime_[label]) {
      this.warn(`Timer ${label} does not exist`);
      return;
    }
    const startTime = this.startTime_[label];
    delete this.startTime_[label];
    const duration = performance.now() - startTime;
    this.emit(LoggerEvent.TIME_END_EVENT, this.assembleEvent({ startTime, duration }, LogLevel.INFO, label));
    this.info(`Timer: ${label} ${Math.round(duration)}ms`);
  }
  assembleEvent(item, level, label = null) {
    return {
      id: this.id,
      item,
      level,
      label
    };
  }
  shouldLog(level) {
    return this.useConsole_ && this.level_ >= Levels[level];
  }
  getStamp() {
    return `[${this.path_}] ${msToHms(performance.now())} > `;
  }
  destroy() {
    this.parent_ = null;
    this.opts = null;
    this.startTime_ = null;
    super.destroy();
  }
};
_Logger.maxDeprecatedWarnings = 1;
_Logger.deprecatedCounts = {};
let Logger = _Logger;
class Metric {
  constructor(key, value, type) {
    this.key = key;
    this.value = value;
    this.type = type;
    this.timeStamp = Date.now();
  }
}
const logger = new Logger({ id: "", logLevel: LogLevel.OFF });
const configuration = {};
function configure(config2) {
  merge(configuration, config2);
  if (config2.system) {
    updateSystem(config2.system);
  }
  if (config2.logLevel) {
    logger.logLevel = config2.logLevel;
  }
}
function getConfiguration() {
  return configuration;
}
function assert(condition, message) {
  if (!condition) {
    throw new CoreError(message);
  }
}
var AviaHookType = /* @__PURE__ */ ((AviaHookType2) => {
  AviaHookType2["CREATE_PLAYER"] = "createplayer";
  AviaHookType2["REMOVE_PLAYER"] = "removeplayer";
  AviaHookType2["DEVICE_CAPABILITIES"] = "devicecapabilities";
  AviaHookType2["SCRIPT_LOAD"] = "scriptload";
  return AviaHookType2;
})(AviaHookType || {});
class HookError extends PlayerError {
  constructor(type, message, cause) {
    super(HookError.getErrorCode(type), message, cause, true, ErrorCategory.HOOK);
    this.type = type;
    this.name = "HookError";
  }
  static getErrorCode(type) {
    switch (type) {
      case AviaHookType.CREATE_PLAYER:
        return ErrorCode.CREATE_PLAYER_HOOK;
      case AviaHookType.REMOVE_PLAYER:
        return ErrorCode.REMOVE_PLAYER_HOOK;
      case AviaHookType.DEVICE_CAPABILITIES:
        return ErrorCode.DEVICE_CAPABILITIES;
      case AviaHookType.SCRIPT_LOAD:
        return ErrorCode.SCRIPT_LOAD;
      case PlayerHookType.AD:
        return ErrorCode.AD_HOOK;
      case PlayerHookType.AD_BREAK:
        return ErrorCode.AD_BREAK_HOOK;
      case PlayerHookType.ATTACH_RESOURCE:
        return ErrorCode.ATTACH_RESOURCE_HOOK;
      case PlayerHookType.EVENT:
        return ErrorCode.EVENT_HOOK;
      case PlayerHookType.REQUEST:
        return ErrorCode.REQUEST_HOOK;
      case PlayerHookType.RESPONSE:
        return ErrorCode.RESPONSE_HOOK;
      default:
        return ErrorCode.HOOK_ERROR;
    }
  }
}
class HookManager {
  constructor(config2, context, player) {
    this.hookMap = {};
    this.hookConfig = null;
    this.context = null;
    this.player = null;
    this.hookConfig = config2;
    this.context = context;
    this.player = player;
  }
  destroy() {
    this.hookMap = null;
    this.hookConfig = null;
    this.context = null;
    this.player = null;
  }
  hasHook(type) {
    const hooks = this.hookMap[type];
    return (hooks == null ? void 0 : hooks.length) > 0;
  }
  defineHook(type, config2 = { multiple: true }) {
    assert(!this.hookConfig[type], `Hook type already exists: ${type}`);
    this.hookConfig[type] = config2;
  }
  validateHookType(type) {
    assert(type in this.hookConfig, `Invalid hook type: ${type}`);
  }
  registerHook(type, hook) {
    var _a;
    this.validateHookType(type);
    if (!this.hookMap[type]) {
      this.hookMap[type] = [];
    }
    if (((_a = this.hookConfig[type]) == null ? void 0 : _a.multiple) === false && this.hookMap[type].length) {
      return;
    }
    if (this.hookMap[type].includes(hook)) {
      return;
    }
    this.hookMap[type].push(hook);
  }
  removeHook(type, hook) {
    this.validateHookType(type);
    if (!this.hookMap[type]) {
      return;
    }
    this.hookMap[type] = this.hookMap[type].filter((h) => h !== hook);
  }
  applyHook(type, data, metadata) {
    return __async(this, null, function* () {
      var _a;
      const hooks = (_a = this.hookMap) == null ? void 0 : _a[type];
      if (!hooks || hooks.length === 0) {
        return data;
      }
      let cancelled = false;
      const cancel = () => cancelled = true;
      const context = __spreadProps(__spreadValues({ type, value: null, metadata, cancel }, this.context), { player: this.player });
      const exec = (value, index2 = 0) => __async(this, null, function* () {
        if (index2 >= hooks.length) {
          return value;
        }
        const transform = hooks[index2];
        if (typeof transform !== "function") {
          throw new HookError(type, "Hook must be a valid function");
        }
        context.value = value;
        try {
          yield transform(context);
        } catch (error) {
          throw new HookError(type, error.toString(), error);
        }
        return cancelled ? null : exec(context.value, ++index2);
      });
      return exec(data);
    });
  }
}
const player_hook_config = {
  [PlayerHookType.EVENT]: {
    multiple: true
  },
  [PlayerHookType.AD_BREAK]: {
    multiple: false
  },
  [PlayerHookType.AD]: {
    multiple: false
  },
  [PlayerHookType.ATTACH_RESOURCE]: {
    multiple: true
  },
  [PlayerHookType.REQUEST]: {
    multiple: true
  },
  [PlayerHookType.RESPONSE]: {
    multiple: true
  },
  [PlayerHookType.SEEK]: {
    multiple: true
  }
};
const sdk_hook_config = __spreadProps(__spreadValues({}, player_hook_config), {
  [AviaHookType.CREATE_PLAYER]: {
    multiple: true
  },
  [AviaHookType.REMOVE_PLAYER]: {
    multiple: true
  },
  [AviaHookType.DEVICE_CAPABILITIES]: {
    multiple: true
  },
  [AviaHookType.SCRIPT_LOAD]: {
    multiple: true
  }
});
const extensionContext = {
  get avia() {
    return System.appNamespace;
  },
  logger,
  buildInfo,
  system: System
};
function use(extension) {
  return __async(this, null, function* () {
    if (!Array.isArray(extension)) {
      extension = [extension];
    }
    for (const ext of extension) {
      yield ext(extensionContext);
    }
  });
}
const hookManager = new HookManager(sdk_hook_config, extensionContext);
function defineHook(type, config2) {
  hookManager.defineHook(type, config2);
}
function hasHook(type) {
  return hookManager.hasHook(type);
}
function registerHook(type, hook) {
  hookManager.registerHook(type, hook);
}
function removeHook(type, hook) {
  hookManager.removeHook(type, hook);
}
function applyHook(type, value, metadata) {
  return hookManager.applyHook(type, value, metadata);
}
const _ScriptLoader = class _ScriptLoader extends RecoveryEnabledRequest {
  static load(options) {
    return new Promise((resolve, reject) => {
      options.onComplete = ({ detail }) => detail.error || detail.timedOut ? reject(detail) : resolve(detail);
      new _ScriptLoader(options);
    });
  }
  constructor(options) {
    const opts = Object.assign({ timeout: Network.TIMEOUT }, options || {});
    if (!opts.timeout) {
      opts.timeout = Network.TIMEOUT;
    }
    super(opts);
    this.timeoutHandles = {};
    this.map = {};
    const hasListener = this.hasListenerFor(_ScriptLoader.event.COMPLETE);
    if (this.opts.url && hasListener) {
      this.loadScript(this.opts.url);
    } else if (this.opts.urls && hasListener) {
      this.loadScripts(this.opts.urls);
    } else {
      throw new Error(`Script load error: Missing url or listener. url: ${this.opts.url || this.opts.urls}, hasListener: ${hasListener}`);
    }
  }
  destroy() {
    if (!this.timeoutHandles) {
      return;
    }
    for (const q in this.timeoutHandles) {
      clearTimeout(this.timeoutHandles[q]);
    }
    this.timeoutHandles = null;
    super.destroy();
  }
  loadScript(scriptUrl, completeListener) {
    const scr = document.createElement("script"), sec = window.location.protocol === "https:", url = sec ? scriptUrl.replace("http:", "https:") : scriptUrl;
    this.map[url] = {
      hLoad: () => this.hLoadOrError(url),
      hError: () => this.hLoadOrError(url, true, false),
      scriptEl: scr
    };
    const mapObj = this.map[url];
    completeListener && this.on(_ScriptLoader.event.COMPLETE, completeListener);
    scr.async = true;
    scr.addEventListener("load", mapObj.hLoad);
    scr.addEventListener("error", mapObj.hError);
    this.timeoutHandles[url] = setTimeout(
      () => this.hLoadOrError(url, true, true),
      this.opts.timeout
    );
    document.head.appendChild(scr);
    scr.src = url;
  }
  loadScripts(urls, completeListener) {
    completeListener && this.on(_ScriptLoader.event.COMPLETE, completeListener);
    for (let i = 0, n = urls.length; i < n; i++) {
      this.loadScript(urls[i]);
    }
  }
  hLoadOrError(url, error, timedOut) {
    clearTimeout(this.timeoutHandles[url]);
    delete this.timeoutHandles[url];
    const mapObj = this.map[url];
    mapObj.scriptEl.removeEventListener("load", mapObj.hLoad);
    mapObj.scriptEl.removeEventListener("error", mapObj.hError);
    for (const q in mapObj) {
      delete mapObj[q];
    }
    delete this.map[url];
    if (error && this.shouldRetry()) {
      this.incrementAttempts();
      setTimeout(() => {
        this.loadScript(url);
      }, this.retryInterval);
    } else {
      this.emit(_ScriptLoader.event.COMPLETE, {
        url,
        error,
        timedOut: timedOut === true
      });
    }
  }
};
_ScriptLoader.event = {
  COMPLETE: "complete"
};
let ScriptLoader = _ScriptLoader;
function createRequest(url, headers = {}, credentials = RequestCredentials.SAME_ORIGIN) {
  return { url, headers, credentials };
}
function applyRequestToXhr(request2, xhr) {
  entries(request2.headers).forEach(([key, value]) => {
    xhr.setRequestHeader(key, value);
  });
  xhr.withCredentials = request2.credentials === RequestCredentials.INCLUDE;
}
function getHeader(headerName, rawHeaders) {
  var _a;
  if (!headerName || !rawHeaders) {
    return null;
  }
  const matchHeader = new RegExp(`${headerName}:([^\\n\\r]+)`, "i");
  return (_a = rawHeaders.match(matchHeader)) == null ? void 0 : _a[1].trim();
}
function loadScript(options, playerOptions, getter) {
  return __async(this, null, function* () {
    const { overrides, network } = merge({ network: {} }, getConfiguration(), playerOptions);
    yield ScriptLoader.load({
      url: makeUrl(options.url),
      timeout: (overrides == null ? void 0 : overrides.streamingLibLoaderTimeout) || network.timeout,
      errorRecovery: merge({}, network, options.errorRecovery)
    });
    const value = (getter == null ? void 0 : getter()) || {};
    const metadata = {
      url: options.url
    };
    return applyHook(AviaHookType.SCRIPT_LOAD, value, metadata);
  });
}
function makeUrl(url) {
  const urlData = new URL(url, window.location.toString());
  if (System.isWebOs || urlData.protocol === "file:" && /^\/\//.test(url)) {
    urlData.protocol = "https:";
  }
  return urlData.toString();
}
const Net = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  applyRequestToXhr,
  createRequest,
  getHeader,
  loadScript,
  makeUrl
}, Symbol.toStringTag, { value: "Module" }));
function renderThumbnail(cue, container) {
  if ((cue == null ? void 0 : cue.style) && (container == null ? void 0 : container.style)) {
    Object.assign(container.style, cue.style);
  }
}
function createThumbnailStyles(url, width, height, x = 0, y = 0) {
  const styles = {};
  if (url) {
    styles.backgroundImage = `url(${url})`;
  }
  if (width) {
    styles.width = `${width}px`;
  }
  if (height) {
    styles.height = `${height}px`;
  }
  if (x !== 0) {
    styles.backgroundPositionX = `-${x}px`;
  }
  if (y !== 0) {
    styles.backgroundPositionY = `-${y}px`;
  }
  return styles;
}
const Thumbnail = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createThumbnailStyles,
  renderThumbnail
}, Symbol.toStringTag, { value: "Module" }));
function stringToXml(text) {
  const parser = new DOMParser();
  return parser.parseFromString(text, "text/xml");
}
function xmlToString(xml) {
  const serializer = new XMLSerializer();
  return serializer.serializeToString(xml);
}
function xmlToJson(xml) {
  let obj = {};
  if (xml.nodeType === 1 && xml.attributes.length > 0) {
    for (let j = 0, k = xml.attributes.length; j < k; j++) {
      const attribute = xml.attributes.item(j);
      obj[attribute.nodeName] = attribute.nodeValue;
    }
  } else if (xml.nodeType === 3) {
    obj = xml.nodeValue;
  }
  if (xml.nodeName === "p") {
    obj.text = "";
    xml.childNodes.forEach((node) => {
      if (node.nodeName === "metadata") {
        return;
      }
      const text = new XMLSerializer().serializeToString(node);
      if (node.nodeType === 1) {
        obj.text += node.tagName === "br" ? "\n" : text;
      }
      if (node.nodeType === 3) {
        obj.text += text;
      }
    });
  }
  if (xml.hasChildNodes()) {
    for (let i = 0, h = xml.childNodes.length; i < h; i++) {
      const item = xml.childNodes.item(i), nodeName = item.nodeName;
      if (isUndefined(obj[nodeName])) {
        obj[nodeName] = xmlToJson(item);
        continue;
      }
      if (isUndefined(obj[nodeName].push)) {
        const old = obj[nodeName];
        obj[nodeName] = [];
        obj[nodeName].push(old);
      }
      obj[nodeName].push(xmlToJson(item));
    }
  }
  return obj;
}
const XmlUtil = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  stringToXml,
  xmlToJson,
  xmlToString
}, Symbol.toStringTag, { value: "Module" }));
const Util = __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadProps(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadProps(__spreadValues({}, ArrayUtil), {
  eventsToPromise
}), File), FunctionUtil), Language), Net), NumberUtil), ObjectUtil), Quality), {
  request
}), Resource), StringUtil), Thumbnail), TimedText), Type), Video), XmlUtil);
var AccessibilityAction = /* @__PURE__ */ ((AccessibilityAction2) => {
  AccessibilityAction2["ENTER_FULLSCREEN"] = "mediaenterfullscreen";
  AccessibilityAction2["INCREASE_VOLUME"] = "mediaincreasevolume";
  AccessibilityAction2["DECREASE_VOLUME"] = "mediadecreasevolume";
  AccessibilityAction2["SEEK_BACK"] = "mediaskipbackward";
  AccessibilityAction2["SEEK_FORWARD"] = "mediaskipforward";
  AccessibilityAction2["TOGGLE_PLAY"] = "mediaplaypause";
  AccessibilityAction2["TOGGLE_TT"] = "mediatexttrack";
  AccessibilityAction2["TOGGLE_MUTE"] = "mediamuteunmute";
  AccessibilityAction2["PLAYLIST_NEXT"] = "mediaplaylistnext";
  AccessibilityAction2["PLAYLIST_PREV"] = "mediaplaylistprevious";
  AccessibilityAction2["STOP"] = "mediastop";
  return AccessibilityAction2;
})(AccessibilityAction || {});
var ActionKey = /* @__PURE__ */ ((ActionKey2) => {
  ActionKey2["NONE"] = "none";
  ActionKey2["PLAY"] = "play";
  ActionKey2["PAUSE"] = "pause";
  ActionKey2["PLAY_PAUSE"] = "playpause";
  ActionKey2["STOP"] = "stop";
  ActionKey2["FAST_FORWARD"] = "fastforward";
  ActionKey2["REWIND"] = "rewind";
  ActionKey2["FULLSCREEN"] = "fullscreen";
  ActionKey2["SKIP_FORWARD"] = "skipforward";
  ActionKey2["SKIP_BACKWARD"] = "skipbackward";
  ActionKey2["CAPTIONS"] = "texttrack";
  ActionKey2["TEXT_TRACK"] = "texttrack";
  ActionKey2["INFO"] = "info";
  ActionKey2["INCREASE_VOLUME"] = "increasevolume";
  ActionKey2["DECREASE_VOLUME"] = "decreasevolume";
  ActionKey2["MUTE_UNMUTE"] = "muteunmute";
  ActionKey2["PLAYLIST_NEXT"] = "playlistnext";
  ActionKey2["PLAYLIST_PREVIOUS"] = "playlistprevious";
  ActionKey2["LEFT"] = "left";
  ActionKey2["RIGHT"] = "right";
  ActionKey2["UP"] = "up";
  ActionKey2["DOWN"] = "down";
  ActionKey2["SELECT"] = "select";
  ActionKey2["CANCEL"] = "cancel";
  ActionKey2["SPACE"] = "space";
  ActionKey2["BACK"] = "back";
  ActionKey2["RECORD"] = "record";
  ActionKey2["LIVE"] = "live";
  return ActionKey2;
})(ActionKey || {});
var ActionKeyContext = /* @__PURE__ */ ((ActionKeyContext2) => {
  ActionKeyContext2["DEFAULT"] = "default";
  ActionKeyContext2["HOTKEY"] = "hotkey";
  ActionKeyContext2["AD"] = "ad";
  return ActionKeyContext2;
})(ActionKeyContext || {});
var ActiveState = /* @__PURE__ */ ((ActiveState2) => {
  ActiveState2["ACTIVE"] = "active";
  ActiveState2["INACTIVE"] = "inactive";
  ActiveState2["IDLE"] = "idle";
  return ActiveState2;
})(ActiveState || {});
var AdBreakType = /* @__PURE__ */ ((AdBreakType2) => {
  AdBreakType2["PRE"] = "PRE";
  AdBreakType2["MID"] = "MID";
  AdBreakType2["POST"] = "POST";
  return AdBreakType2;
})(AdBreakType || {});
var AdTechnology = /* @__PURE__ */ ((AdTechnology2) => {
  AdTechnology2["SSAI"] = "ssai";
  AdTechnology2["CSAI"] = "csai";
  AdTechnology2["POD_SERVING"] = "ssai_podserving";
  return AdTechnology2;
})(AdTechnology || {});
var ApiMetric = /* @__PURE__ */ ((ApiMetric2) => {
  ApiMetric2["PLAY"] = "play";
  ApiMetric2["PAUSE"] = "pause";
  ApiMetric2["SEEK"] = "seek";
  ApiMetric2["GO_LIVE"] = "go_live";
  return ApiMetric2;
})(ApiMetric || {});
var AudioRole = /* @__PURE__ */ ((AudioRole2) => {
  AudioRole2["MAIN"] = "main";
  AudioRole2["DESCRIPTION"] = "description";
  AudioRole2["ALTERNATE"] = "alternate";
  return AudioRole2;
})(AudioRole || {});
var Autoplay = /* @__PURE__ */ ((Autoplay2) => {
  Autoplay2["NONE"] = "none";
  Autoplay2["ATTEMPT_MUTED"] = "attemptMuted";
  Autoplay2["ATTEMPT_UNMUTED"] = "attemptUnmuted";
  Autoplay2["ATTEMPT_UNMUTED_THEN_MUTED"] = "attemptUnmutedThenMuted";
  return Autoplay2;
})(Autoplay || {});
var DrmKeySystemAvailability = /* @__PURE__ */ ((DrmKeySystemAvailability2) => {
  DrmKeySystemAvailability2["UNKNOWN"] = "unknown";
  DrmKeySystemAvailability2["DETECTED"] = "detected";
  DrmKeySystemAvailability2["INFERRED"] = "inferred";
  return DrmKeySystemAvailability2;
})(DrmKeySystemAvailability || {});
var DrmRobustness = /* @__PURE__ */ ((DrmRobustness2) => {
  DrmRobustness2["SW_SECURE_CRYPTO"] = "SW_SECURE_CRYPTO";
  DrmRobustness2["SW_SECURE_DECODE"] = "SW_SECURE_DECODE";
  DrmRobustness2["HW_SECURE_CRYPTO"] = "HW_SECURE_CRYPTO";
  DrmRobustness2["HW_SECURE_DECODE"] = "HW_SECURE_DECODE";
  DrmRobustness2["HW_SECURE_ALL"] = "HW_SECURE_ALL";
  DrmRobustness2["UNKNOWN"] = "unknown";
  return DrmRobustness2;
})(DrmRobustness || {});
var HdcpStatus = /* @__PURE__ */ ((HdcpStatus2) => {
  HdcpStatus2["USABLE"] = "usable";
  HdcpStatus2["OUTPUT_RESTRICTED"] = "output-restricted";
  HdcpStatus2["UNKNOWN"] = "unknown";
  return HdcpStatus2;
})(HdcpStatus || {});
var Header = /* @__PURE__ */ ((Header2) => {
  Header2["MULTI_CDN"] = "x-cdn";
  return Header2;
})(Header || {});
var KeyboardEventType = /* @__PURE__ */ ((KeyboardEventType2) => {
  KeyboardEventType2["DOWN"] = "keydown";
  KeyboardEventType2["UP"] = "keyup";
  KeyboardEventType2["PRESS"] = "keypress";
  return KeyboardEventType2;
})(KeyboardEventType || {});
var KeyboardScope = /* @__PURE__ */ ((KeyboardScope2) => {
  KeyboardScope2["NONE"] = "none";
  KeyboardScope2["DOCUMENT"] = "document";
  KeyboardScope2["PLAYER"] = "player";
  return KeyboardScope2;
})(KeyboardScope || {});
const KeyCode = {
  ALT: 18,
  BACKSPACE: 8,
  CAPS_LOCK: 20,
  CONTROL: 17,
  END: 35,
  ENTER: 13,
  TAB: 9,
  SHIFT: 16,
  ESCAPE: 27,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  LEFT_ARROW: 37,
  UP_ARROW: 38,
  RIGHT_ARROW: 39,
  DOWN_ARROW: 40,
  INSERT: 45,
  DELETE: 46,
  SPACE: 32,
  "0": 48,
  "1": 49,
  "2": 50,
  "3": 51,
  "4": 52,
  "5": 53,
  "6": 54,
  "7": 55,
  "8": 56,
  "9": 57,
  A: 65,
  B: 66,
  C: 67,
  D: 68,
  E: 69,
  F: 70,
  G: 71,
  H: 72,
  I: 73,
  J: 74,
  K: 75,
  L: 76,
  M: 77,
  N: 78,
  O: 79,
  P: 80,
  Q: 81,
  R: 82,
  S: 83,
  T: 84,
  U: 85,
  V: 86,
  W: 87,
  X: 88,
  Y: 89,
  Z: 90,
  NUM_0: 96,
  NUM_1: 97,
  NUM_2: 98,
  NUM_3: 99,
  NUM_4: 100,
  NUM_5: 101,
  NUM_6: 102,
  NUM_7: 103,
  NUM_8: 104,
  NUM_9: 105,
  MULTIPLY: 106,
  ADD: 107,
  SUBTRACT: 109,
  DECIMAL: 110,
  DIVIDE: 111,
  SEMICOLON: 186,
  EQUAL: 187,
  COMMA: 188,
  DASH: 189,
  PERIOD: 190,
  FORWARD_SLASH: 191,
  BACKSLASH: 220,
  GRAVE_ACCENT: 192,
  OPEN_BRACKET: 219,
  CLOSE_BRACKET: 221,
  SINGLE_QUOTE: 222,
  MINUS: 173,
  PAUSE: 19,
  MEDIA_PLAY_PAUSE: 179,
  MEDIA_STOP: 178,
  MEDIA_INCREASE_VOLUME: 175,
  MEDIA_INCREASE_VOLUME_ALT: 183,
  MEDIA_DECREASE_VOLUME: 174,
  MEDIA_DECREASE_VOLUME_ALT: 182,
  MEDIA_TRACK_NEXT: 176,
  MEDIA_TRACK_PREVIOUS: 177,
  // Pseudo key codes
  MEDIA_REWIND: 9e3,
  MEDIA_FAST_FORWARD: 9001,
  MEDIA_RECORD: 9002,
  MEDIA_PLAY: 9003,
  MEDIA_PAUSE: 9004,
  MEDIA_CAPTIONS: 9005,
  MEDIA_INFO: 9006,
  MEDIA_LIVE: 9007
};
var LocalizationId = /* @__PURE__ */ ((LocalizationId2) => {
  LocalizationId2["MEDIA_PLAYER"] = "media-player";
  LocalizationId2["LEARN_MORE"] = "learn-more";
  return LocalizationId2;
})(LocalizationId || {});
var LocalizedLanguage = /* @__PURE__ */ ((LocalizedLanguage2) => {
  LocalizedLanguage2["EN"] = "English";
  LocalizedLanguage2["ES"] = "Español";
  LocalizedLanguage2["FR"] = "Français";
  LocalizedLanguage2["PT"] = "Português";
  LocalizedLanguage2["DE"] = "Deutsche";
  LocalizedLanguage2["PL"] = "Polski";
  LocalizedLanguage2["JA"] = "日本人";
  LocalizedLanguage2["KO"] = "한국어";
  LocalizedLanguage2["ZH"] = "简体中文";
  LocalizedLanguage2["IT"] = "Italiano";
  LocalizedLanguage2["RU"] = "Русский";
  return LocalizedLanguage2;
})(LocalizedLanguage || {});
var Measurement = /* @__PURE__ */ ((Measurement2) => {
  Measurement2["PLAYER_CREATION"] = "player-creation";
  Measurement2["RESOURCE_ATTACHMENT"] = "resource-attachment";
  Measurement2["AD_ADAPTER_CREATION"] = "ad-adapter-creation";
  Measurement2["AD_RESOURCE_CREATION"] = "ad-resource-creation";
  Measurement2["PLAYBACK_ADAPTER_CREATION"] = "playback-adapter-creation";
  Measurement2["RESOURCE_LOAD"] = "resource-load";
  Measurement2["RESOURCE_PLAYBACK"] = "resource-playback";
  Measurement2["FIRST_FRAME"] = "first-frame";
  return Measurement2;
})(Measurement || {});
var MetricType = /* @__PURE__ */ ((MetricType2) => {
  MetricType2["API"] = "api";
  MetricType2["UI"] = "ui";
  MetricType2["MARK"] = "mark";
  MetricType2["MEASURE"] = "measure";
  return MetricType2;
})(MetricType || {});
var PerformanceMode = /* @__PURE__ */ ((PerformanceMode2) => {
  PerformanceMode2["AUTO"] = "auto";
  PerformanceMode2["DESKTOP"] = "desktop";
  PerformanceMode2["MOBILE"] = "mobile";
  PerformanceMode2["TV"] = "tv";
  PerformanceMode2["LOW"] = "low";
  return PerformanceMode2;
})(PerformanceMode || {});
var PlaybackState = /* @__PURE__ */ ((PlaybackState2) => {
  PlaybackState2["IDLE"] = "idle";
  PlaybackState2["STOPPED"] = "stopped";
  PlaybackState2["PLAYING"] = "playing";
  PlaybackState2["PAUSED"] = "paused";
  PlaybackState2["WAITING"] = "waiting";
  return PlaybackState2;
})(PlaybackState || {});
var PluginPriority = /* @__PURE__ */ ((PluginPriority2) => {
  PluginPriority2["LOW"] = "low";
  PluginPriority2["HIGH"] = "high";
  return PluginPriority2;
})(PluginPriority || {});
var QualityLabel = /* @__PURE__ */ ((QualityLabel2) => {
  QualityLabel2[QualityLabel2["DEFINITION"] = 0] = "DEFINITION";
  QualityLabel2[QualityLabel2["HEIGHT"] = 1] = "HEIGHT";
  QualityLabel2[QualityLabel2["BITRATE"] = 2] = "BITRATE";
  QualityLabel2[QualityLabel2["CUSTOM"] = 3] = "CUSTOM";
  return QualityLabel2;
})(QualityLabel || {});
var QualityMode = /* @__PURE__ */ ((QualityMode2) => {
  QualityMode2["AUTO"] = "auto";
  QualityMode2["MANUAL"] = "manual";
  QualityMode2["UNAVAILABLE"] = "unavailable";
  return QualityMode2;
})(QualityMode || {});
var PlayerEvent = /* @__PURE__ */ ((PlayerEvent2) => {
  PlayerEvent2["HOTKEY_ACTION"] = "hotkeyaction";
  PlayerEvent2["ACTION_KEY"] = "actionkey";
  PlayerEvent2["ACTION_KEY_METADATA"] = "actionkeymetadata";
  PlayerEvent2["READY"] = "ready";
  PlayerEvent2["AD_SKIPPABLE_STATE_CHANGE"] = "adskippablestatechange";
  PlayerEvent2["AD_CUEPOINTS_AVAILABLE"] = "adcuepointsavailable";
  PlayerEvent2["AD_BREAK_START"] = "adbreakstart";
  PlayerEvent2["AD_BREAK_METADATA"] = "adbreakmetadata";
  PlayerEvent2["AD_BREAK_COMPLETE"] = "adbreakcomplete";
  PlayerEvent2["AD_START"] = "adstart";
  PlayerEvent2["AD_COMPLETE"] = "adcomplete";
  PlayerEvent2["AD_FIRST_QUARTILE"] = "adfirstquartile";
  PlayerEvent2["AD_MIDPOINT"] = "admidpoint";
  PlayerEvent2["AD_THIRD_QUARTILE"] = "adthirdquartile";
  PlayerEvent2["AD_SEGMENT_START"] = "adsegmentstart";
  PlayerEvent2["AD_SEGMENT_END"] = "adsegmentend";
  PlayerEvent2["AD_SEGMENT_REENTERED"] = "adsegmentreentered";
  PlayerEvent2["AD_SKIPPED"] = "adskipped";
  PlayerEvent2["AD_PROGRESS"] = "adprogress";
  PlayerEvent2["AD_PAUSED"] = "adpaused";
  PlayerEvent2["AD_PLAYING"] = "adplaying";
  PlayerEvent2["AD_STALLED"] = "adstalled";
  PlayerEvent2["AD_BREAK_DISCARDED"] = "adbreakdiscarded";
  PlayerEvent2["AD_CLICK"] = "adclick";
  PlayerEvent2["SHOW_AD_UI"] = "showadui";
  PlayerEvent2["HIDE_AD_UI"] = "hideadui";
  PlayerEvent2["AUDIO_TRACK_CHANGE"] = "audiotrackchange";
  PlayerEvent2["AUDIO_TRACKS_CHANGE"] = "audiotrackschange";
  PlayerEvent2["QUALITY_CHANGE"] = "qualitychange";
  PlayerEvent2["QUALITIES_CHANGE"] = "qualitieschange";
  PlayerEvent2["CDN_CHANGE"] = "cdnchange";
  PlayerEvent2["CLOCK"] = "aviaclock";
  PlayerEvent2["CONTENT_START"] = "contentstart";
  PlayerEvent2["CONTENT_DURATION_AVAILABLE"] = "contentdurationavailable";
  PlayerEvent2["CONTENT_SEGMENT_START"] = "contentsegmentstart";
  PlayerEvent2["CONTENT_PLAYING"] = "contentplaying";
  PlayerEvent2["CONTENT_PROGRESS"] = "contentprogress";
  PlayerEvent2["CONTENT_PAUSED"] = "contentpaused";
  PlayerEvent2["CONTENT_SEGMENT_END"] = "contentsegmentend";
  PlayerEvent2["CONTENT_COMPLETE"] = "contentcomplete";
  PlayerEvent2["CONTENT_IS_PLAYING_LIVE"] = "contentisplayinglive";
  PlayerEvent2["STREAM_TYPE_CHANGE"] = "streamtypechange";
  PlayerEvent2["STREAM_METADATA"] = "streammetadata";
  PlayerEvent2["STREAM_ID_AVAILABLE"] = "streamidavailable";
  PlayerEvent2["DRM_KEY_SYSTEM_CREATED"] = "drmkeysystemcreated";
  PlayerEvent2["ERROR"] = "error";
  PlayerEvent2["PLAYBACK_STARTED"] = "playbackstarted";
  PlayerEvent2["PLAYBACK_SUSPENDED"] = "playbacksuspended";
  PlayerEvent2["PLAYBACK_RESUMED"] = "playbackresumed";
  PlayerEvent2["RESOURCE_START"] = "resourcestart";
  PlayerEvent2["RESOURCE_END"] = "resourceend";
  PlayerEvent2["RESOURCE_BUFFERING"] = "resourcebuffering";
  PlayerEvent2["WAITING_CHANGE"] = "waitingchange";
  PlayerEvent2["SEEK_COMPLETE"] = "seekcomplete";
  PlayerEvent2["SEEK_START"] = "seekstart";
  PlayerEvent2["SEEK_REDIRECT_START"] = "seekredirectstart";
  PlayerEvent2["SEEK_REDIRECT_COMPLETE"] = "seekredirectcomplete";
  PlayerEvent2["METADATA_CUEPOINT"] = "metadatacuepoint";
  PlayerEvent2["TEXT_CUEPOINT"] = "textcuepoint";
  PlayerEvent2["TEXT_TRACK_CHANGE"] = "texttrackchange";
  PlayerEvent2["TEXT_TRACKS_CHANGE"] = "texttrackschange";
  PlayerEvent2["TEXT_TRACK_ENABLED_CHANGE"] = "texttrackenabledchange";
  PlayerEvent2["TEXT_TRACK_AVAILABLE"] = "texttrackavailable";
  PlayerEvent2["THUMBNAIL_TRACK_AVAILABLE"] = "thumbnailtrackavailable";
  PlayerEvent2["LIVE_PRESENTATION_STOPPED"] = "livepresentationstopped";
  PlayerEvent2["PRESENTATION_SIZE_CHANGE"] = "presentationsizechange";
  PlayerEvent2["FULLSCREEN_CHANGE"] = "fullscreenchange";
  PlayerEvent2["LOG_EVENT"] = "logevent";
  PlayerEvent2["PLUGIN_EVENT"] = "pluginevent";
  PlayerEvent2["LANGUAGE_CHANGE"] = "languagechange";
  PlayerEvent2["AUTOPLAY_BLOCKED"] = "autoplayblocked";
  PlayerEvent2["VOLUME_CHANGE"] = "volumechange";
  PlayerEvent2["MUTE_CHANGE"] = "mutechange";
  PlayerEvent2["ACTIVE_STATE_CHANGE"] = "activestatechange";
  PlayerEvent2["PLAYBACK_STATE_CHANGE"] = "playbackstatechange";
  PlayerEvent2["METRIC"] = "metric";
  PlayerEvent2["VIDEO_ELEMENT_ADDED"] = "videoelementadded";
  PlayerEvent2["VIDEO_ELEMENT_REMOVED"] = "videoelementremoved";
  return PlayerEvent2;
})(PlayerEvent || {});
const _Deprecated = class _Deprecated {
  /**
   * @deprecated deprecation warning
   */
  static warn(msg) {
    Logger.deprecated(msg);
  }
  /**
   * @deprecated The callback argument of the registerPlugins function is deprecated. Please use the promise returned by registerPlugins instead. Access to the info property will be removed July 1st, 2024.
   */
  static registerPlugins() {
    _Deprecated.warn("The callback argument of the registerPlugins function is deprecated. Please use the promise returned by registerPlugins instead. Access to the info property will be removed July 1st, 2024.");
  }
  static checkEventName(name) {
    if (_Deprecated.events.includes(name)) {
      _Deprecated.warn(`The "${name}" event has been deprecated. This check will be removed July 1st, 2024`);
    }
  }
  static checkPlayerOptions(options) {
    const playerOptions = _Deprecated.playerOptions;
    Object.keys(options).forEach((key) => {
      const index2 = playerOptions.old.indexOf(key);
      if (index2 > -1) {
        _Deprecated.warn(`The "${key}" player option has been deprecated. Please use "${playerOptions.new[index2]}". This check will be removed July 1st, 2024`);
      }
    });
  }
};
_Deprecated.events = [
  PlayerEvent.HOTKEY_ACTION
];
_Deprecated.playerOptions = {
  old: ["keyboardScope", "networkTimeout", "networkErrorRecovery"],
  new: ["keyboard.scope", "network.timeout", "network.retryAttempts"]
};
let Deprecated = _Deprecated;
const StreamType = {
  VOD: "VOD",
  LIVE: "LIVE",
  LTS: "DVR",
  DVR: "DVR"
};
[
  "VOD",
  "LIVE",
  "LTS",
  "DVR"
].forEach((p) => {
  Object.defineProperty(StreamType, p, {
    get: () => {
      if (p === "DVR") {
        Deprecated.warn(`StreamType.DVR is deprecated in favor of StreamType.LTS; "DVR" will be removed April 1, 2025.`);
      }
      if (p === "LTS") {
        return "DVR";
      }
      return p;
    }
  });
});
var UiMetric = /* @__PURE__ */ ((UiMetric2) => {
  UiMetric2["SEEK_BY"] = "seek_by";
  return UiMetric2;
})(UiMetric || {});
class ActionKeyError extends PlayerError {
  constructor(message, cause) {
    super(ErrorCode.ACTION_KEY, message, cause, false, ErrorCategory.ACTION_KEY);
  }
}
class InvalidArgumentError extends PlayerError {
  constructor(message) {
    super(ErrorCode.INVALID_ARGUMENT, message, null, false, ErrorCategory.API);
    this.name = "InvalidArgumentError";
  }
}
class PluginError extends PlayerError {
  constructor(code, message, config2, cause) {
    super(code, message, cause, true, ErrorCategory.PLUGIN);
    this.name = "PluginError";
    this.config = config2;
  }
}
const _Timer = class _Timer extends Emitter {
  constructor(pInterval = 250) {
    super({});
    this.timer = NaN;
    this.pCount = 0;
    this.pInterval = pInterval;
  }
  destroy() {
    this.stop();
    super.destroy();
  }
  start() {
    if (this.running) {
      return;
    }
    this.timer = setInterval(() => {
      this.pCount++;
      this.emit(_Timer.TIC_EVENT, { count: this.pCount });
    }, this.pInterval);
  }
  stop() {
    clearInterval(this.timer);
    this.timer = NaN;
    this.pCount = 0;
  }
  get running() {
    return !isNaN(this.timer);
  }
  get interval() {
    return this.pInterval;
  }
  get count() {
    return this.pCount;
  }
};
_Timer.TICK = "tic";
_Timer.TIC_EVENT = _Timer.TICK;
let Timer = _Timer;
const defaultContext = {
  [KeyCode.ENTER]: ActionKey.SELECT,
  [KeyCode.ESCAPE]: ActionKey.CANCEL,
  [KeyCode.UP_ARROW]: ActionKey.UP,
  [KeyCode.DOWN_ARROW]: ActionKey.DOWN,
  [KeyCode.LEFT_ARROW]: ActionKey.LEFT,
  [KeyCode.RIGHT_ARROW]: ActionKey.RIGHT,
  [KeyCode.MEDIA_PLAY]: ActionKey.PLAY,
  [KeyCode.MEDIA_PAUSE]: ActionKey.PAUSE,
  [KeyCode.PAUSE]: ActionKey.PAUSE,
  [KeyCode.MEDIA_PLAY_PAUSE]: ActionKey.PLAY_PAUSE,
  [KeyCode.MEDIA_STOP]: ActionKey.STOP,
  [KeyCode.MEDIA_INCREASE_VOLUME]: ActionKey.INCREASE_VOLUME,
  [KeyCode.MEDIA_INCREASE_VOLUME_ALT]: ActionKey.INCREASE_VOLUME,
  [KeyCode.MEDIA_DECREASE_VOLUME]: ActionKey.DECREASE_VOLUME,
  [KeyCode.MEDIA_DECREASE_VOLUME_ALT]: ActionKey.DECREASE_VOLUME,
  [KeyCode.MEDIA_TRACK_NEXT]: ActionKey.PLAYLIST_NEXT,
  [KeyCode.MEDIA_TRACK_PREVIOUS]: ActionKey.PLAYLIST_PREVIOUS,
  [KeyCode.MEDIA_CAPTIONS]: ActionKey.TEXT_TRACK,
  [KeyCode.MEDIA_INFO]: ActionKey.INFO,
  [KeyCode.MEDIA_FAST_FORWARD]: ActionKey.FAST_FORWARD,
  [KeyCode.MEDIA_REWIND]: ActionKey.REWIND,
  [KeyCode.MEDIA_RECORD]: ActionKey.RECORD,
  [KeyCode.BACKSPACE]: ActionKey.BACK,
  [KeyCode.MEDIA_LIVE]: ActionKey.LIVE
};
const hotkeyContext = {
  [KeyCode.F]: ActionKey.FULLSCREEN,
  [KeyCode.UP_ARROW]: ActionKey.INCREASE_VOLUME,
  [KeyCode.DOWN_ARROW]: ActionKey.DECREASE_VOLUME,
  [KeyCode.LEFT_ARROW]: ActionKey.SKIP_BACKWARD,
  [KeyCode.RIGHT_ARROW]: ActionKey.SKIP_FORWARD,
  [KeyCode.SPACE]: ActionKey.PLAY_PAUSE,
  [KeyCode.M]: ActionKey.MUTE_UNMUTE,
  [KeyCode.SUBTRACT]: ActionKey.MUTE_UNMUTE,
  [KeyCode.MINUS]: ActionKey.MUTE_UNMUTE,
  [KeyCode.C]: ActionKey.TEXT_TRACK
};
const adContext = {
  [KeyCode.LEFT_ARROW]: ActionKey.NONE,
  [KeyCode.RIGHT_ARROW]: ActionKey.NONE,
  [KeyCode.MEDIA_FAST_FORWARD]: ActionKey.NONE,
  [KeyCode.MEDIA_REWIND]: ActionKey.NONE
};
const actionKeyMap = {
  [ActionKeyContext.DEFAULT]: defaultContext,
  [ActionKeyContext.HOTKEY]: hotkeyContext,
  [ActionKeyContext.AD]: adContext
};
function registerActionKeyContext(context, map) {
  if (!context) {
    throw new ActionKeyError(`Invalid action key context ${context}`);
  }
  if (!actionKeyMap[context]) {
    actionKeyMap[context] = {};
  }
  Object.assign(actionKeyMap[context], map);
}
function retrieveActionKeyContext(context) {
  return actionKeyMap[context];
}
function removeActionKeyContext(context) {
  const map = actionKeyMap[context];
  delete actionKeyMap[context];
  return map;
}
const DEFAULT_LANGUAGE = System.language || "en";
const externalData = {};
function load(url) {
  if (externalData[url] == null) {
    externalData[url] = request({ url, responseType: ResponseType.JSON });
  }
  return externalData[url];
}
const localizationData = {
  en: {
    [LocalizationId.MEDIA_PLAYER]: "Media Player",
    [LocalizationId.LEARN_MORE]: "Learn More"
  },
  es: {
    [LocalizationId.MEDIA_PLAYER]: "Reproductor multimedia",
    [LocalizationId.LEARN_MORE]: "Aprende más"
  }
};
class Localization {
  constructor(options = {}) {
    this.localizationData_ = /* @__PURE__ */ new Set();
    this.locale_ = {};
    this.parent_ = options.parent;
    this.logger_ = options.logger || logger;
  }
  get defaultLanguage() {
    return DEFAULT_LANGUAGE;
  }
  get parent() {
    return this.parent_;
  }
  get language() {
    return this.language_ || DEFAULT_LANGUAGE;
  }
  get languageTag() {
    return this.languageTag_;
  }
  getValue(id, language = this.language) {
    const find2 = (lang) => {
      var _a;
      const locale = ((_a = this.locale_) == null ? void 0 : _a[lang]) || {};
      return locale[id];
    };
    return find2(language) || find2(this.languageTag_.language);
  }
  changeLanguage(language) {
    this.language_ = language;
    this.languageTag_ = parseLanguageTag(this.language);
    const tag = new RegExp(`^${this.languageTag_.language}`, "i");
    const loader = ([k, v]) => {
      return load(v).then((data2) => [k, data2]).catch((error) => {
        this.logger_.error(`Could not load locale file ${v}`, error);
        return [k, {}];
      });
    };
    const data = Array.from(this.localizationData_).map((data2) => {
      const locale = entries(data2).filter((entry) => tag.test(entry[0])).map((entry) => typeof entry[1] === "string" ? loader(entry) : entry);
      return Promise.all(locale);
    });
    return Promise.all(data).then((entries2) => {
      const objs = entries2.map((entry) => fromEntries(entry));
      const data2 = merge(...objs);
      return this.locale_ = data2;
    });
  }
  create(options) {
    var _a;
    (_a = options.parent) != null ? _a : options.parent = this;
    return new Localization(options);
  }
  registerLocalizationData(data) {
    if (isEmpty(data)) {
      return;
    }
    this.localizationData_.add(data);
    this.changeLanguage(this.language);
  }
  localize(id, context, language = this.language) {
    var _a;
    const value = this.getValue(id, language) || ((_a = this.parent) == null ? void 0 : _a.localize(id, context, language));
    return template(value || id, context);
  }
  destroy() {
    this.parent_ = null;
    this.locale_ = null;
    this.languageTag_ = null;
    this.localizationData_ = null;
  }
}
const localization = new Localization();
localization.registerLocalizationData(localizationData);
function registerLocalizationData(data) {
  return localization.registerLocalizationData(data);
}
function changeLanguage(language) {
  return localization.changeLanguage(language);
}
function localize(id, context, language = this.language) {
  return localization.localize(id, context, language);
}
var ServiceName = /* @__PURE__ */ ((ServiceName2) => {
  ServiceName2["Logging"] = "Logging";
  ServiceName2["Tracking"] = "Tracking";
  ServiceName2["TrackingService"] = "TrackingService";
  ServiceName2["AutoplayCapabilities"] = "AutoplayCapabilities";
  return ServiceName2;
})(ServiceName || {});
var ProxyName = /* @__PURE__ */ ((ProxyName2) => {
  ProxyName2["AdDataProxy"] = "AdDataProxy";
  ProxyName2["ContentPlaybackStateProxy"] = "ContentPlaybackStateProxy";
  ProxyName2["VideoProxy"] = "VideoProxy";
  ProxyName2["PlayerDomProxy"] = "PlayerDomProxy";
  ProxyName2["ModelCollectionProxy"] = "ModelCollectionProxy";
  ProxyName2["ResourceProxy"] = "ResourceProxy";
  ProxyName2["TrackingConfigProxy"] = "TrackingConfigProxy";
  ProxyName2["PerformanceProxy"] = "PerformanceProxy";
  ProxyName2["TextTrackProxy"] = "TextTrackProxy";
  ProxyName2["LocalizationProxy"] = "LocalizationProxy";
  ProxyName2["AdapterProxy"] = "AdapterProxy";
  ProxyName2["HookProxy"] = "HookProxy";
  return ProxyName2;
})(ProxyName || {});
class MvcMessages {
  constructor() {
  }
}
const _ServiceContainer = class _ServiceContainer {
  constructor(key) {
    if (_ServiceContainer.serviceContainerMap[key]) {
      Logger.error(MvcMessages.ERROR_KEY_EXISTS.replace("$ACTOR_NAME$", "ServiceContainer"));
      return;
    }
    this.multiCoreKey = key;
    this.serviceMap = {};
  }
  static getInstance(key) {
    if (!key) {
      return null;
    }
    if (this.serviceContainerMap[key] == null) {
      this.serviceContainerMap[key] = new _ServiceContainer(key);
    }
    return this.serviceContainerMap[key];
  }
  static removeServiceContainer(key) {
    this.serviceContainerMap[key] && this.serviceContainerMap[key].destroy();
    delete this.serviceContainerMap[key];
  }
  destroy() {
    for (const q in this.serviceMap) {
      this.removeService(q);
    }
    this.serviceMap = null;
  }
  registerService(service) {
    this.serviceMap[service.name] = service;
    service.onRegister(this.multiCoreKey);
  }
  retrieveService(serviceName) {
    return this.serviceMap[serviceName] || null;
  }
  hasService(serviceName) {
    return this.serviceMap[serviceName] != null;
  }
  removeService(serviceName) {
    if (this.serviceMap[serviceName]) {
      this.serviceMap[serviceName].destroy();
    }
    delete this.serviceMap[serviceName];
  }
};
_ServiceContainer.serviceContainerMap = {};
let ServiceContainer = _ServiceContainer;
class Observer {
  constructor(notifyMethod, notifyContext) {
    this.setNotifyMethod(notifyMethod);
    this.setNotifyContext(notifyContext);
  }
  destroy() {
    this.context = null;
    this.notify = null;
  }
  setNotifyMethod(notifyMethod) {
    this.notify = notifyMethod;
  }
  setNotifyContext(notifyContext) {
    this.context = notifyContext;
  }
  getNotifyMethod() {
    return this.notify;
  }
  getNotifyContext() {
    return this.context;
  }
  notifyObserver(notification) {
    this.getNotifyMethod().call(this.getNotifyContext(), notification);
  }
  /**
      * Compare an object to this instance's notification context.
      */
  compareNotifyContext(object) {
    return object === this.context;
  }
}
const _View = class _View {
  constructor(key) {
    if (_View.viewMap[key] != null) {
      Logger.error(MvcMessages.ERROR_KEY_EXISTS.replace("$ACTOR_NAME$", "View"));
      return;
    }
    this.multiCoreKey = key;
    this.mediatorMap = {};
    this.observerMap = {};
    _View.viewMap[this.multiCoreKey] = this;
    this.initializeView();
  }
  static getInstance(key) {
    if (!key) {
      return null;
    }
    if (!this.viewMap[key]) {
      this.viewMap[key] = new _View(key);
    }
    return this.viewMap[key];
  }
  static removeView(key) {
    this.viewMap[key] && this.viewMap[key].destroy();
    delete this.viewMap[key];
  }
  destroy() {
    for (const q in this.mediatorMap) {
      this.removeMediator(this.mediatorMap[q].name);
    }
    this.mediatorMap = null;
    this.observerMap = null;
  }
  registerObserver(notificationName, observer) {
    if (this.observerMap[notificationName] != null) {
      this.observerMap[notificationName].push(observer);
    } else {
      this.observerMap[notificationName] = [observer];
    }
  }
  notifyObservers(notification) {
    let i, n;
    if (this.observerMap[notification.name] != null) {
      const observers_ref = this.observerMap[notification.name];
      const observers = [];
      let observer;
      for (i = 0, n = observers_ref.length; i < n; i++) {
        observer = observers_ref[i];
        observers.push(observer);
      }
      for (i = 0, n = observers.length; i < n; i++) {
        observer = observers[i];
        observer.notifyObserver(notification);
      }
    }
  }
  removeObserver(notificationName, notifyContext) {
    if (!this.observerMap) {
      return;
    }
    const observers = this.observerMap[notificationName];
    let i = observers.length;
    while (i--) {
      if (observers[i].compareNotifyContext(notifyContext) === true) {
        observers.splice(i, 1);
        break;
      }
    }
    if (observers.length === 0) {
      delete this.observerMap[notificationName];
    }
  }
  registerMediator(mediator) {
    const name = mediator.name;
    let i, n, obs;
    if (this.mediatorMap[name]) {
      return;
    }
    mediator.initializeNotifier(this.multiCoreKey);
    this.mediatorMap[name] = mediator;
    const interests = mediator.listNotificationInterests();
    if (interests.length > 0) {
      obs = new Observer(mediator.handleNotification, mediator);
      for (i = 0, n = interests.length; i < n; i++) {
        this.registerObserver(interests[i], obs);
      }
    }
    mediator.onRegister();
  }
  retrieveMediator(mediatorName) {
    return this.mediatorMap[mediatorName];
  }
  removeMediator(mediatorName) {
    const mediator = this.mediatorMap[mediatorName];
    if (mediator) {
      const interests = mediator.listNotificationInterests();
      let i = interests.length;
      while (i--) {
        this.removeObserver(interests[i], mediator);
      }
      delete this.mediatorMap[mediatorName];
      mediator.onRemove();
    }
  }
  hasMediator(mediatorName) {
    return this.mediatorMap[mediatorName] != null;
  }
  initializeView() {
  }
};
_View.viewMap = {};
let View = _View;
const _Controller = class _Controller {
  constructor(key) {
    if (_Controller.controllerMap[key]) {
      Logger.error(MvcMessages.ERROR_KEY_EXISTS.replace("$ACTOR_NAME$", "Controller"));
      return;
    }
    this.multiCoreKey = key;
    _Controller.controllerMap[this.multiCoreKey] = this;
    this.commandMap = {};
    this.view = null;
    this.initializeController();
  }
  static getInstance(key) {
    if (!key) {
      return null;
    }
    if (!this.controllerMap[key]) {
      this.controllerMap[key] = new _Controller(key);
    }
    return this.controllerMap[key];
  }
  static removeController(key) {
    this.controllerMap[key] && this.controllerMap[key].destroy();
    delete this.controllerMap[key];
  }
  destroy() {
    for (const q in this.commandMap) {
      this.removeCommand(q);
    }
    this.commandMap = null;
    this.view = null;
  }
  initializeController() {
    this.view = View.getInstance(this.multiCoreKey);
  }
  executeCommand(notification) {
    const commandClassRef = this.commandMap[notification.name];
    if (!commandClassRef) {
      return;
    }
    const commandInstance = new commandClassRef();
    commandInstance.initializeNotifier(this.multiCoreKey);
    commandInstance.execute(notification);
  }
  registerCommand(notificationName, commandClassRef) {
    if (!this.commandMap[notificationName]) {
      this.view.registerObserver(notificationName, new Observer(this.executeCommand, this));
    }
    this.commandMap[notificationName] = commandClassRef;
  }
  hasCommand(notificationName) {
    return !!this.commandMap[notificationName];
  }
  removeCommand(notificationName) {
    if (this.hasCommand(notificationName)) {
      this.view.removeObserver(notificationName, this);
      this.commandMap[notificationName] = null;
    }
  }
};
_Controller.controllerMap = {};
let Controller = _Controller;
const _Model = class _Model {
  constructor(key) {
    this.proxyMap = null;
    if (_Model.modelMap[key]) {
      Logger.error(MvcMessages.ERROR_KEY_EXISTS.replace("$ACTOR_NAME$", "Model"));
      return;
    }
    this.multiCoreKey = key;
    _Model.modelMap[key] = this;
    this.proxyMap = {};
    this.initializeModel();
  }
  static getInstance(key) {
    if (!key) {
      return null;
    }
    if (this.modelMap[key] == null) {
      this.modelMap[key] = new _Model(key);
    }
    return this.modelMap[key];
  }
  static removeModel(key) {
    this.modelMap[key] && this.modelMap[key].destroy();
    delete this.modelMap[key];
  }
  destroy() {
    for (const q in this.proxyMap) {
      this.removeProxy(q);
    }
    this.proxyMap = null;
  }
  initializeModel() {
  }
  registerProxy(proxy) {
    this.proxyMap[proxy.name] = proxy;
    proxy.initializeNotifier(this.multiCoreKey);
    proxy.onRegister();
  }
  retrieveProxy(proxyName) {
    return this.proxyMap[proxyName] || null;
  }
  hasProxy(proxyName) {
    return this.proxyMap[proxyName] != null;
  }
  removeProxy(proxyName) {
    const proxy = this.proxyMap[proxyName];
    if (proxy) {
      proxy.onRemove();
      this.proxyMap[proxyName] = null;
    }
  }
};
_Model.modelMap = {};
let Model = _Model;
class Notification {
  constructor(name, body, type) {
    this.pName = name;
    this.pBody = body;
    this.pType = type;
  }
  get name() {
    return this.pName;
  }
  get body() {
    return this.pBody;
  }
  get type() {
    return this.pType || null;
  }
  toString() {
    const bdy = `
Body: ${this.pBody == null ? "null" : JSON.stringify(this.body)}`, typ = `
Type: ${this.pType == null ? "null" : this.type}`;
    return `Notification Name: ${this.name + bdy + typ}`;
  }
}
const _Facade = class _Facade {
  constructor(key, commandMap) {
    this.model = null;
    this.view = null;
    this.controller = null;
    this.serviceContainer = null;
    this.initialized = false;
    this.multiCoreKey = key;
    this.initializeFacade();
    this.registerCommands(commandMap);
  }
  static removeCore(key) {
    if (!this.facadeMap[key]) {
      return;
    }
    Model.removeModel(key);
    View.removeView(key);
    Controller.removeController(key);
    ServiceContainer.removeServiceContainer(key);
    this.facadeMap[key].destroy();
    delete this.facadeMap[key];
  }
  static hasCore(key) {
    return _Facade.facadeMap[key] != null;
  }
  // used internally by mvc actors
  static getInstance(key) {
    if (!key) {
      throw new Error(MvcMessages.ERROR_NO_KEY);
    }
    return this.facadeMap[key];
  }
  static createFacade(key, commandMap) {
    if (!key) {
      throw new Error(MvcMessages.ERROR_NO_KEY);
    }
    if (this.facadeMap[key]) {
      const error = new Error(`Not creating facade - key "${key}" already exists!`);
      error.key = key;
      throw error;
    }
    this.facadeMap[key] = new _Facade(key, commandMap);
    return this.facadeMap[key];
  }
  ///////////////////////////////////////////////
  // Instance members
  destroy() {
    this.model = null;
    this.view = null;
    this.controller = null;
    this.serviceContainer = null;
  }
  get key() {
    return this.multiCoreKey;
  }
  // supplied as a semantic alternative to get key()
  get appId() {
    return this.multiCoreKey;
  }
  get logger() {
    return this.retrieveService(ServiceName.Logging).logger;
  }
  // Controller: Commands
  registerCommand(notificationName, commandClassRef) {
    this.controller.registerCommand(notificationName, commandClassRef);
  }
  removeCommand(notificationName) {
    this.controller.removeCommand(notificationName);
  }
  hasCommand(notificationName) {
    return this.controller.hasCommand(notificationName);
  }
  // Model: Proxies
  registerProxy(proxy) {
    this.model.registerProxy(proxy);
  }
  retrieveProxy(proxyName) {
    return this.model ? this.model.retrieveProxy(proxyName) : null;
  }
  removeProxy(proxyName) {
    this.model && this.model.removeProxy(proxyName);
  }
  hasProxy(proxyName) {
    return this.model.hasProxy(proxyName);
  }
  // View: Mediators
  registerMediator(mediator) {
    this.view.registerMediator(mediator);
  }
  retrieveMediator(mediatorName) {
    return this.view ? this.view.retrieveMediator(mediatorName) : null;
  }
  removeMediator(mediatorName) {
    this.view && this.view.removeMediator(mediatorName);
  }
  hasMediator(mediatorName) {
    return this.view.hasMediator(mediatorName);
  }
  // ServiceContainer: Services
  registerService(service) {
    this.serviceContainer.registerService(service);
  }
  retrieveService(serviceName) {
    return this.serviceContainer ? this.serviceContainer.retrieveService(serviceName) : null;
  }
  removeService(serviceName) {
    this.model && this.serviceContainer.removeService(serviceName);
  }
  hasService(serviceName) {
    return this.serviceContainer.hasService(serviceName);
  }
  registerGlobalServices(svcCollection) {
    for (const s in svcCollection) {
      this.registerService(svcCollection[s]);
    }
  }
  sendNotification(name, param1, param2) {
    let notification;
    if (typeof param1 === "string") {
      notification = new Notification(name, {}, param1);
    } else {
      notification = new Notification(name, param1, param2);
    }
    this.notifyObservers(notification);
  }
  /* eslint-enable*/
  notifyObservers(notification) {
    this.view != null && this.view.notifyObservers(notification);
  }
  // command reg
  registerCommands(map) {
    if (!map) {
      return;
    }
    for (const q in map) {
      !!map[q] && this.registerCommand(q, map[q]);
    }
  }
  // init
  initializeServiceContainer() {
    this.serviceContainer = ServiceContainer.getInstance(this.multiCoreKey);
  }
  initializeController() {
    this.controller = Controller.getInstance(this.multiCoreKey);
  }
  initializeModel() {
    this.model = Model.getInstance(this.multiCoreKey);
  }
  initializeView() {
    this.view = View.getInstance(this.multiCoreKey);
  }
  initializeFacade() {
    if (this.initialized) {
      throw new Error("Unexpected Condition: Facade already initialized");
    }
    this.initializeModel();
    this.initializeController();
    this.initializeView();
    this.initializeServiceContainer();
    this.initialized = true;
  }
};
_Facade.facadeMap = {};
let Facade = _Facade;
class ServiceBase {
  constructor(name) {
    this.pName = name;
  }
  get name() {
    return this.pName;
  }
  destroy() {
  }
  onRegister(key) {
    this.facadeKey = key;
  }
  getLogger() {
    const logSvc = this.getService(ServiceName.Logging);
    return logSvc.logger;
  }
  getService(name) {
    return Facade.getInstance(this.facadeKey).retrieveService(name);
  }
  getModel(name) {
    return this.getModelCollection().getModel(name);
  }
  getModelCollection() {
    var _a;
    return (_a = Facade.getInstance(this.facadeKey)) == null ? void 0 : _a.retrieveProxy(ProxyName.ModelCollectionProxy);
  }
}
class AutoplayCapabilitiesService extends ServiceBase {
  constructor() {
    super(ServiceName.AutoplayCapabilities);
    this.testDom = null;
    this.checkCompleted = false;
    this.testVideoSrc = AppResources.blankDataUrl;
    this.isMobile = null;
    this.info = {
      supportsUnmutedAutoplay: null,
      supportsMutedAutoplay: null
    };
    if (System.supportsUnrestrictedAutoplay) {
      this.setInfo(true, true);
      this.checkCompleted = true;
    }
  }
  static getInstance() {
    if (!this.instance) {
      this.instance = new AutoplayCapabilitiesService();
    }
    return this.instance;
  }
  get autoplayInfo() {
    return this.info;
  }
  destroy() {
    clearTimeout(this.timeout);
    super.destroy();
  }
  // Promise-based determination: Check unmuted first, then muted autoplay
  detectCapabilities(url) {
    if (this.detecting) {
      return this.detecting;
    }
    if (url) {
      this.testVideoSrc = url;
    }
    return this.detecting = new Promise((resolve) => {
      if (!this.checkCompleted) {
        this.createTestDom();
        this.internalCallback = () => resolve(this.info);
        this.checkUnmutedAutoplay();
      } else {
        resolve(this.info);
      }
    });
  }
  ///////////
  // PRIVATE
  finishCheck(unmutedOk, mutedOk) {
    this.setInfo(unmutedOk, mutedOk);
    this.checkCompleted = true;
    this.internalCallback();
    this.timeout = setTimeout(() => this.cleanUp(), 100);
  }
  setInfo(unmutedOk, mutedOk) {
    this.info.supportsUnmutedAutoplay = unmutedOk;
    this.info.supportsMutedAutoplay = mutedOk;
  }
  cleanUp() {
    this.testDom && this.testDom.parentNode.removeChild(this.testDom);
    this.testDom = null;
  }
  checkUnmutedAutoplay() {
    const v = this.createVideoElement(false);
    if (!v) {
      this.finishCheck(true, true);
      return;
    }
    v.load();
    const promise = v.play();
    if (promise === void 0) {
      if (this.isMobile) {
        this.detectMobileCapabilities();
      } else {
        this.finishCheck(true, true);
      }
    } else {
      promise.then(() => {
        this.finishCheck(true, true);
      }).catch((e) => {
        this.checkMutedAutoplay();
      });
    }
  }
  checkMutedAutoplay() {
    if (this.isEarlySafari11()) {
      this.finishCheck(false, false);
      return;
    }
    const v = this.createVideoElement(true);
    v.load();
    v.play().then(() => {
      this.finishCheck(false, true);
    }).catch((e) => {
      if (v.error && this.testVideoSrc !== AppResources.blankDataUrl) {
        this.testVideoSrc = AppResources.blankDataUrl;
        this.checkUnmutedAutoplay();
        return;
      }
      this.finishCheck(false, false);
    });
  }
  isEarlySafari11() {
    const isS = System.browser === Browser.SAFARI;
    const isD = isS && System.device === Device.DESKTOP;
    const maj = isD ? System.browserVersionInfo.majorVersion : null;
    const min = isD ? System.browserVersionInfo.minorVersion : null;
    const majMinMatch = maj === 11 && min === 0;
    const verStr = System.browserVersionInfo.versionString;
    const verArr = verStr ? verStr.split(".") : null;
    return majMinMatch && (!verArr[2] || parseInt(verArr[2]) < 3);
  }
  // mobile checks where no Promise available
  detectMobileCapabilities() {
    const unmutedOk = false;
    const mutedOk = this.isAutoplayEligibleAndroid() || this.isAutoplayEligibleIos();
    this.finishCheck(unmutedOk, mutedOk);
  }
  isAutoplayEligibleAndroid() {
    const isA = System.os === Os.ANDROID;
    const isOkChrome = isA && System.browser === Browser.CHROME && this.isChromeAutoplayEligible();
    return isOkChrome;
  }
  isAutoplayEligibleIos() {
    const is10 = System.os === Os.IOS && System.browserVersionInfo.majorVersion >= 10;
    const isOkSafari = is10 && System.browser === Browser.SAFARI;
    const isOkChrome = is10 && !isOkSafari && (System.browser === Browser.CHROME_IOS || System.browser === Browser.CHROME) && this.isChromeAutoplayEligible();
    return isOkSafari || isOkChrome;
  }
  isChromeAutoplayEligible() {
    return System.browserVersionInfo.majorVersion >= 54;
  }
  // util
  createVideoElement(muted) {
    const doc = this.document;
    if (!doc) {
      return null;
    }
    const v = doc.createElement("video");
    if (muted) {
      v.muted = true;
      v.playsInline = true;
    }
    v.volume = 5e-3;
    v.style.width = "100%";
    v.style.height = "100%";
    v.src = this.testVideoSrc;
    this.testDom.appendChild(v);
    return v;
  }
  createTestDom() {
    const doc = this.document;
    if (!this.document) {
      return null;
    }
    const d = doc.createElement("div"), ds = d.style, p = "-1000px";
    ds.position = "absolute";
    ds.top = p;
    ds.left = p;
    ds.width = "400px";
    ds.height = "225px";
    doc.body.appendChild(d);
    this.testDom = d;
    return d;
  }
  get document() {
    return System.document || null;
  }
}
let PlayerOptions$1 = class PlayerOptions {
  constructor(options = {}) {
    var _b, _c, _d, _e, _f, _g, _h;
    this.plugins = [];
    this.autoplay = Autoplay.NONE;
    this.network = {
      retryAttempts: 0,
      retryIntervals: [],
      timeout: Network.TIMEOUT
    };
    this.performanceMode = PerformanceMode.AUTO;
    this.renderTextTrackNatively = true;
    this.useNativeFullscreen = true;
    this.playsInline = true;
    this.useNativeControls = false;
    this.overrides = {};
    this.enableOm = false;
    this.enableMoat = false;
    this.keyboard = {};
    this.language = System.language;
    this.localization = {};
    this.idleDelay = 3e3;
    this.ignoreBlankTextTracks = false;
    const _a = options, { container } = _a, opts = __objRest(_a, ["container"]);
    const config2 = getConfiguration();
    Deprecated.checkPlayerOptions(opts);
    opts.network = merge({}, config2.network, {
      timeout: opts.networkTimeout,
      retryAttempts: (_b = opts.networkErrorRecovery) == null ? void 0 : _b.retryAttempts,
      retryIntervals: (_c = opts.networkErrorRecovery) == null ? void 0 : _c.retryIntervals
    }, opts.network);
    opts.keyboard = merge({}, config2.keyboard, {
      scope: opts.keyboardScope
    }, opts.keyboard);
    if (System.isBrowser) {
      if (container == null || !(container.constructor === HTMLDivElement || typeof container === "object" && typeof container.getBoundingClientRect === "function" || typeof container === "string" && document.querySelector(container) != null)) {
        throw new Error("Invalid player configuration: Missing presentation container.");
      }
    }
    merge(this, opts);
    (_d = this.id) != null ? _d : this.id = uid8();
    this.container = container;
    (_e = this.audioLanguage) != null ? _e : this.audioLanguage = this.language;
    (_f = this.textLanguage) != null ? _f : this.textLanguage = this.language;
    (_g = this.localizationLanguage) != null ? _g : this.localizationLanguage = this.language;
    (_h = this.reuseVideoElement) != null ? _h : this.reuseVideoElement = System.isIos;
  }
};
class ResourceConfiguration {
  constructor(config2 = {}) {
    this.sessionId = null;
    this.contentId = null;
    this.ad = {
      adapter: null,
      showPrerollOnNonZeroStart: false,
      viewabilityTracking: {
        partner: null,
        viewGuid: null,
        pageType: null
      },
      csai: null,
      ssai: null
    };
    this.location = {
      mediaUrl: null,
      textTrackUrl: null,
      thumbnailTrackUrl: null,
      posterImageUrl: null,
      drm: {
        playready: {
          url: null,
          header: null,
          priority: null,
          audioRobustness: null,
          videoRobustness: null
        },
        widevine: {
          url: null,
          header: null,
          priority: null,
          audioRobustness: null,
          videoRobustness: null
        },
        fairplay: {
          appCertUrl: null,
          licenseUrl: null,
          header: null
        },
        aes: {
          header: null,
          provider: null
        }
      }
    };
    this.playback = {
      id3OwnerIds: null,
      startTime: NaN,
      enableAdvancedCodecs: false,
      liveEdgeSyncFragmentCount: 3,
      abr: {
        maxBitrate: NaN,
        minBitrate: NaN,
        startBitrate: NaN,
        maxHeight: Infinity,
        maxCategory: null,
        capQualityToScreenSize: true,
        ignoreDevicePixelRatio: true
      },
      lts: {
        restrictionTimestamp: NaN,
        threshold: 1800,
        clearOutOfBoundsLtsBuffer: false
      }
    };
    this.metadata = {};
    this.tracking = {};
    this.cmcd = {
      enabled: true,
      sessionId: null,
      contentId: null,
      useHeaders: false
    };
    this.overrides = {};
    merge(this, config2);
    const { abr } = this.playback;
    const { maxCategory, maxHeight } = abr;
    if (maxCategory && !Number.isFinite(maxHeight)) {
      abr.maxHeight = getMaxHeightForQualityCategory(maxCategory);
    }
  }
  static validate(resource) {
    if (isEmpty(resource)) {
      throw new Error(AppResources.messages.RESOURCE_MISSING);
    }
    const missing = [];
    Object.keys(defaultResource).forEach((k) => {
      if (!(k in resource)) {
        missing.push(k);
      }
    });
    if (missing.length) {
      throw new Error(`One or more configuration properties not found: ${missing.join(", ")}`);
    }
  }
}
const defaultResource = new ResourceConfiguration();
var MediatorName = /* @__PURE__ */ ((MediatorName2) => {
  MediatorName2["APPLICATION"] = "AppMediator";
  MediatorName2["FULLSCREEN"] = "FullscreenMediator";
  MediatorName2["TRACKING_MEDIATOR"] = "TrackingMediator";
  MediatorName2["TIMER_MEDIATOR"] = "TimerMediator";
  MediatorName2["PRESENTATION_MEDIATOR"] = "PresentationMediator";
  MediatorName2["PLUGIN_MEDIATOR"] = "PluginMediator";
  MediatorName2["KEY_COMMAND"] = "KeyCommandMediator";
  MediatorName2["ACTIVITY"] = "ActivityMediator";
  return MediatorName2;
})(MediatorName || {});
var ModelName = /* @__PURE__ */ ((ModelName2) => {
  ModelName2["AdBreakInfo"] = "AdBreakInfo";
  ModelName2["AdItem"] = "AdItem";
  ModelName2["ContentPlaybackState"] = "ContentPlaybackState";
  ModelName2["PlayerDom"] = "PlayerDom";
  ModelName2["PlayerOptions"] = "PlayerOptions";
  ModelName2["PresentationState"] = "PresentationState";
  return ModelName2;
})(ModelName || {});
var NotificationName = /* @__PURE__ */ ((NotificationName2) => {
  NotificationName2["DEFAULT"] = "default";
  NotificationName2["BOOT_APP"] = "bootApp";
  NotificationName2["PREP_TRACKING"] = "prepTracking";
  NotificationName2["PREP_SERVICE"] = "prepService";
  NotificationName2["TIMER_TIC"] = "timerTic";
  NotificationName2["PREP_RESOURCE_COLLECTION"] = "prepResourceCollection";
  NotificationName2["PLAY_RESOURCE"] = "playResource";
  NotificationName2["PREP_PLUGINS"] = "prepPlugins";
  NotificationName2["LOAD_PLUGINS"] = "loadPlugins";
  NotificationName2["REMOVE_PLUGIN"] = "removePlugin";
  NotificationName2["START_PRESENTATION"] = "startPresentation";
  NotificationName2["RESOURCE_COMPLETE"] = "resourceComplete";
  NotificationName2["KILL_RESOURCE_PRESENTATION"] = "killResourcePresentation";
  NotificationName2["SUSPEND_PLAYBACK"] = "suspendPlayback";
  NotificationName2["RESUME_PLAYBACK"] = "resumePlayback";
  NotificationName2["AUTO_QUALITY_SWITCHING"] = "autoQualitySwitching";
  NotificationName2["MIN_BITRATE"] = "minBitrate";
  NotificationName2["MAX_BITRATE"] = "maxBitrate";
  NotificationName2["PLAY_ON_USER_GESTURE"] = "playOnUSerGesture";
  NotificationName2["PLAY"] = "play";
  NotificationName2["PAUSE"] = "pause";
  NotificationName2["SEEK"] = "seek";
  NotificationName2["SWITCH_BITRATE"] = "switchBitrate";
  NotificationName2["SWITCH_QUALITY_CATEGORY"] = "switchQualityCategory";
  NotificationName2["SWITCH_AUDIO_TRACK"] = "switchAudioTrack";
  NotificationName2["SWITCH_TEXT_TRACK"] = "switchTextTrack";
  NotificationName2["SWITCH_TEXT_MODE"] = "switchTextMode";
  NotificationName2["VIDEO_LOAD_START"] = "videoLoadStart";
  NotificationName2["FULLSCREEN_AVAILABLE"] = "fullscreenAvailable";
  NotificationName2["FULLSCREEN_CHANGE"] = "fullscreenChange";
  NotificationName2["ENTER_FULLSCREEN_REQUEST"] = "enterFullscreenRequest";
  NotificationName2["EXIT_FULLSCREEN_REQUEST"] = "exitFullscreenRequest";
  NotificationName2["TIMED_TEXT_OFFSET_REQUEST"] = "timedTextOffsetRequest";
  NotificationName2["CHANGE_LANGUAGE"] = "changeLanguage";
  NotificationName2["LOCALIZATION_CHANGE"] = "localizationChange";
  NotificationName2["PLAYER_ERROR"] = "playererror";
  NotificationName2["VIDEO_PLAYBACK_ERROR"] = "videoplaybackerror";
  NotificationName2["VIDEO_START_ERROR"] = "videostarterror";
  NotificationName2["RESOURCE_ERROR"] = "resourceerror";
  NotificationName2["AD_ERROR"] = "aderror";
  NotificationName2["AD_STALLED"] = "adstalled";
  return NotificationName2;
})(NotificationName || {});
var NotificationType = /* @__PURE__ */ ((NotificationType2) => {
  NotificationType2["EXTERNAL"] = "external";
  NotificationType2["INTERNAL"] = "internal";
  return NotificationType2;
})(NotificationType || {});
class Notifier {
  constructor() {
    this.multiCoreKey = null;
  }
  /**
  	 * @internal
  	 */
  destroy() {
  }
  /**
  	* @internal
  	*/
  onRemove() {
    this.multiCoreKey = null;
  }
  /**
  	* @internal
  	*/
  get facade() {
    return Facade.getInstance(this.multiCoreKey);
  }
  /**
  	* @internal
  	*/
  sendNotification(notificationName, body, type) {
    const f = this.facade;
    f && f.sendNotification(notificationName, body, type);
  }
  /**
  	* @internal
  	*/
  initializeNotifier(key) {
    this.multiCoreKey = key;
  }
}
class Proxy2 extends Notifier {
  constructor(name, data) {
    super();
    this.proxyName = null;
    this.pData = null;
    this.proxyName = name;
    this.pData = data || {};
  }
  /**
  	* @internal
  	*/
  get name() {
    return this.proxyName;
  }
  /**
  	* @internal
  	*/
  get data() {
    return this.pData;
  }
  /**
  	* @internal
  	*/
  onRegister() {
  }
  /**
  	* @internal
  	*/
  onRemove() {
    this.pData = null;
    super.onRemove();
  }
}
class HookProxy extends Proxy2 {
  // player-level hook mgt
  constructor(player) {
    super(ProxyName.HookProxy, null);
    this.pHookManager = null;
    this.pHookManager = new HookManager(player_hook_config, extensionContext, player);
  }
  onRemove() {
    var _a;
    (_a = this.pHookManager) == null ? void 0 : _a.destroy();
    this.pHookManager = null;
    super.onRemove();
  }
  defineHook(type, config2) {
    this.pHookManager.defineHook(type, config2);
  }
  hasHook(type) {
    return this.pHookManager.hasHook(type) || hasHook(type);
  }
  registerHook(type, hook) {
    this.pHookManager.registerHook(type, hook);
  }
  removeHook(type, hook) {
    this.pHookManager.removeHook(type, hook);
  }
  applyHook(type, value, metadata) {
    return __async(this, null, function* () {
      const val = yield applyHook(type, value, metadata);
      return this.pHookManager.applyHook(type, val, metadata);
    });
  }
}
class LogService extends ServiceBase {
  constructor(name, logger2) {
    super(name);
    this.pLogger = logger2;
  }
  destroy() {
    this.pLogger.destroy();
    this.pLogger = null;
  }
  get logger() {
    return this.pLogger;
  }
}
class AbstractApplication extends Emitter {
  constructor(options) {
    super(options || {});
    this.pAppId = options.id;
    this.pFacade = Facade.createFacade(
      this.pAppId,
      options.commandMap || null
    );
    const { logger: logger2 } = options;
    this.pFacade.registerService(new LogService(ServiceName.Logging, logger2));
    values(LoggerEvent).forEach((type) => logger2.on(type, (e) => this.sendEvent(e.type, e.detail)));
  }
  /**
  * @internal
  */
  destroy() {
    super.destroy();
    Facade.removeCore(this.pAppId);
    this.mdlCollProxy = null;
    this.pFacade = null;
  }
  /**
  * @internal
  */
  get appId() {
    return this.pAppId;
  }
  sendNotification(name, body, type) {
    this.pFacade.sendNotification(name, body, type);
  }
  registerGlobalServices(gServices) {
    const f = this.pFacade;
    for (const s in gServices) {
      f.registerService(gServices[s]);
    }
  }
  get facade() {
    return this.pFacade;
  }
  get modelCollectionProxy() {
    if (!this.mdlCollProxy) {
      this.mdlCollProxy = this.facade.retrieveProxy(ProxyName.ModelCollectionProxy);
    }
    return this.mdlCollProxy;
  }
  get appMediator() {
    return this.pFacade.retrieveMediator(MediatorName.APPLICATION);
  }
}
function apiMember(target, propertyKey, descriptor) {
  if (!isObject(target.__apiDescriptors)) {
    target.__apiDescriptors = {};
  }
  target.__apiDescriptors[propertyKey] = descriptor;
}
function apiMethod() {
  return apiMember;
}
function apiAccessor(readonly = false) {
  return apiMember;
}
function apiCollection(id, target) {
  const api = {};
  const destroyed = {};
  let base = target;
  const destroy = () => {
    base = destroyed;
    target.__apiDescriptors = null;
  };
  const destroyHandler = (key) => () => {
    throw new PlayerError(
      ErrorCode.CALL_AFTER_DESTROY,
      `Calling "${key}" on player "${id}" after it has been destroyed`,
      void 0,
      true,
      ErrorCategory.API
    );
  };
  for (const key in target.__apiDescriptors) {
    const descriptor = target.__apiDescriptors[key];
    const handler = destroyHandler(key);
    if (descriptor.value) {
      api[key] = function() {
        return base[key].apply(base, arguments);
      };
      destroyed[key] = handler;
    } else {
      Object.defineProperty(api, key, {
        get: descriptor.get ? () => base[key] : void 0,
        set: descriptor.set ? (value) => base[key] = value : void 0
      });
      Object.defineProperty(destroyed, key, {
        get: descriptor.get ? handler : void 0,
        set: descriptor.set ? handler : void 0
      });
    }
  }
  return { api, destroy };
}
class AbstractSimpleCommand extends Notifier {
  constructor() {
    super();
  }
  get system() {
    return System;
  }
  getModel(name) {
    return this.getModelCollection().getModel(name);
  }
  getProxy(name) {
    return this.facade ? this.facade.retrieveProxy(name) : null;
  }
  getService(name) {
    return this.facade ? this.facade.retrieveService(name) : null;
  }
  getModelCollection() {
    return this.facade ? this.facade.retrieveProxy(ProxyName.ModelCollectionProxy) : null;
  }
}
class LogAwareSimpleCommand extends AbstractSimpleCommand {
  constructor() {
    super();
  }
  get logger() {
    return this.facade.logger;
  }
}
class AbrSwitchCommand extends LogAwareSimpleCommand {
  execute(notification) {
    const presoMediator = this.facade.retrieveMediator(MediatorName.PRESENTATION_MEDIATOR);
    const stateProxy = this.facade.retrieveProxy(ProxyName.ContentPlaybackStateProxy);
    const adapter = presoMediator.adapter;
    const value = notification.body.value;
    if (!stateProxy.isAbrSwitchingAvailable) {
      stateProxy.qualitySwitchingMode = QualityMode.UNAVAILABLE;
      return;
    }
    switch (notification.name) {
      case NotificationName.SWITCH_BITRATE:
        const idx = getMaxBitrateIndex(stateProxy.qualities, value);
        this.switchToIndex(idx, stateProxy, adapter);
        break;
      case NotificationName.SWITCH_QUALITY_CATEGORY:
        stateProxy.userQualityCategory = value;
        this.switchQualityCategory(stateProxy, value, adapter);
        break;
      case NotificationName.AUTO_QUALITY_SWITCHING:
        adapter.setAutoQualitySwitching(value);
        stateProxy.qualitySwitchingMode = this.getAbrMode(value);
        break;
      case NotificationName.MIN_BITRATE:
        adapter.setMinBitrate(value);
        break;
      case NotificationName.MAX_BITRATE:
        adapter.setMaxBitrate(value);
        break;
    }
  }
  switchToIndex(index2, stateProxy, adapter) {
    const minIndex = stateProxy.minIndex;
    const maxIndex = stateProxy.maxIndex;
    if (inRange(index2, minIndex, maxIndex)) {
      adapter.setAutoQualitySwitching(false);
      stateProxy.qualitySwitchingMode = this.getAbrMode(false);
      adapter.setQuality(stateProxy.qualities[index2]);
    } else {
      this.logger.warn(index2 >= maxIndex ? AppResources.messages.ABR_MANUAL_SWITCHING_REACHED_UPPER_BOUNDS : AppResources.messages.ABR_MANUAL_SWITCHING_REACHED_LOWER_BOUNDS);
    }
  }
  switchQualityCategory(stateProxy, category, adapter) {
    if (category === QualityCategory.AUTO) {
      adapter.setAutoQualitySwitching(true);
      adapter.setMinBitrate(NaN);
      adapter.setMaxBitrate(NaN);
      return;
    }
    const qia = stateProxy.qualities;
    const { minBitrate, maxBitrate, minIndex, maxIndex } = getMinAndMaxValuesForCategory(qia, category);
    if (minIndex === maxIndex) {
      this.switchToIndex(minIndex, stateProxy, adapter);
    } else {
      adapter.setMinBitrate(minBitrate);
      adapter.setMaxBitrate(maxBitrate);
    }
  }
  getAbrMode(enabled) {
    return enabled ? QualityMode.AUTO : QualityMode.MANUAL;
  }
}
class AbstractMacroCommand extends Notifier {
  constructor() {
    super();
    this.subCommands = null;
    this.subCommands = [];
    this.initializeMacroCommand();
  }
  addSubCommand(commandClassRef) {
    this.subCommands.push(commandClassRef);
  }
  execute(notification) {
    let cmdClass, cmd;
    while (this.subCommands.length > 0) {
      cmdClass = this.subCommands.shift();
      cmd = new cmdClass();
      cmd.initializeNotifier(this.multiCoreKey);
      cmd.execute(notification);
    }
  }
}
var PlayerDom$1 = /* @__PURE__ */ ((PlayerDom2) => {
  PlayerDom2["MAIN_CONTAINER"] = "main";
  PlayerDom2["VIDEO_EL"] = "video";
  PlayerDom2["VIDEO_CONTAINER"] = "videoContainer";
  PlayerDom2["CC_CONTAINER"] = "ccContainer";
  PlayerDom2["AD_CONTAINER"] = "adContainer";
  PlayerDom2["AD_CLICK_EL"] = "adClickEl";
  PlayerDom2["STYLE"] = "style";
  return PlayerDom2;
})(PlayerDom$1 || {});
const containerCss = {
  position: "absolute",
  width: "100%",
  height: "100%",
  padding: "0",
  margin: "0",
  overflow: "hidden"
};
function initVideoElement(mainContainer, playerOptions, playerId) {
  const video = mainContainer.querySelector("video");
  if (video) {
    decorateVideoElement(video, playerOptions, playerId);
  }
  return video || createVideoElement(playerOptions, playerId);
}
function createVideoElement(playerOptions, playerId) {
  const video = document.createElement("video");
  decorateVideoElement(video, playerOptions, playerId);
  return video;
}
function decorateVideoElement(video, playerOptions, playerId) {
  video.style.height = "100%";
  video.style.width = "100%";
  video.style.backgroundColor = "#000";
  video.dataset.elementId = uid8();
  video.dataset.playerId = playerId;
  video.controls = playerOptions.useNativeControls === true;
  video.playsInline = playerOptions.playsInline !== false;
}
function createAdContainer() {
  const adContainer = createDiv(PlayerDom$1.AD_CONTAINER, containerCss);
  adContainer.dataset.elementId = uid8();
  return adContainer;
}
function createDiv(role, css) {
  const el = document.createElement("div");
  el.setAttribute("data-role", role);
  Object.assign(el.style, css);
  return el;
}
function createAdClickEl() {
  const css = {
    display: "none",
    padding: "4px 8px",
    fontSize: "12px",
    background: "#dedede",
    lineHeight: "14px",
    color: "#000",
    position: "absolute",
    right: "2px",
    top: "2px",
    textAlign: "center"
  };
  const el = createDiv("adClickEl", css);
  el.innerHTML = "Learn More";
  return el;
}
function createPlayerDom(mainContainer, skipEls, playerOptions, playerId) {
  const coll = {
    [PlayerDom$1.MAIN_CONTAINER]: mainContainer,
    [PlayerDom$1.VIDEO_EL]: null
  };
  const main = mainContainer;
  const roles = [
    PlayerDom$1.AD_CONTAINER,
    PlayerDom$1.CC_CONTAINER,
    PlayerDom$1.VIDEO_CONTAINER
  ];
  const style = main.style;
  style.position = style.position || "relative";
  style.padding = style.padding || "0";
  style.margin = style.margin || "0";
  style.width = style.width || "100%";
  style.height = style.height || "100%";
  style.backgroundColor = style.backgroundColor || "#000";
  style.overflow = style.overflow || "hidden";
  main.classList.add("avia-container");
  const styleEl = document.createElement("style");
  main.parentElement.insertAdjacentElement("beforebegin", styleEl);
  styleEl.innerText = ":root{--avia-timed-text-offset: 60px;}.avia-container.avia-cc-offset video::-webkit-media-text-track-container{bottom: var(--avia-timed-text-offset);height: auto;}";
  let refNode = main.hasChildNodes() ? main.firstChild : null;
  let el;
  roles.forEach((role) => {
    if (skipEls.includes(role)) {
      return;
    }
    if (role === PlayerDom$1.AD_CONTAINER) {
      el = createAdContainer();
    } else {
      el = createDiv(role, containerCss);
    }
    coll[role] = el;
    if (refNode) {
      main.insertBefore(el, refNode);
    } else {
      main.appendChild(el);
    }
    refNode = el;
  });
  if (playerOptions.reuseVideoElement === true) {
    const video = initVideoElement(main, playerOptions, playerId);
    coll[PlayerDom$1.VIDEO_CONTAINER].appendChild(video);
    coll[PlayerDom$1.VIDEO_EL] = video;
  }
  coll[PlayerDom$1.AD_CLICK_EL] = createAdClickEl();
  main.appendChild(coll[PlayerDom$1.AD_CLICK_EL]);
  return {
    [PlayerDom$1.MAIN_CONTAINER]: coll[PlayerDom$1.MAIN_CONTAINER],
    [PlayerDom$1.VIDEO_EL]: coll[PlayerDom$1.VIDEO_EL],
    [PlayerDom$1.VIDEO_CONTAINER]: coll[PlayerDom$1.VIDEO_CONTAINER],
    [PlayerDom$1.CC_CONTAINER]: coll[PlayerDom$1.CC_CONTAINER],
    [PlayerDom$1.AD_CONTAINER]: coll[PlayerDom$1.AD_CONTAINER],
    [PlayerDom$1.AD_CLICK_EL]: coll[PlayerDom$1.AD_CLICK_EL],
    [PlayerDom$1.STYLE]: styleEl
  };
}
class CreateDomCommand extends LogAwareSimpleCommand {
  execute(notification) {
    const cfg = notification.body.playerOptions;
    const container = cfg.container;
    const sys = this.system;
    const playerOpts = this.getModel(ModelName.PlayerOptions);
    if (!sys.isBrowser || !container) {
      return;
    }
    const c = typeof container === "string" ? sys.document.querySelector(container) : container;
    let skipEls = [];
    if (playerOpts.useNativeControls) {
      skipEls = [PlayerDom$1.CC_CONTAINER];
    }
    const domColl = createPlayerDom(c, skipEls, playerOpts, this.facade.appId);
    const domProxy = this.facade.retrieveProxy(ProxyName.PlayerDomProxy);
    domProxy.setModel(domColl);
    domProxy.showAdContainer(false);
    this.logger.info("Player DOM created.");
  }
}
class AdapterProxy extends Proxy2 {
  constructor(data) {
    super(ProxyName.AdapterProxy, data);
    this.adapterMap = {};
    this.defaultAdapters = {
      [AdapterRole.PLAYBACK]: Html5Adapter.config
    };
  }
  onRemove() {
    this.adapterMap = null;
    super.onRemove();
  }
  cloneConfig(adapterConfig) {
    return Object.assign({
      isSupported() {
        return true;
      }
    }, adapterConfig);
  }
  registerDefaultAdapter(role, adapterConfig) {
    this.defaultAdapters[role] = this.cloneConfig(adapterConfig);
  }
  registerAdapter(adapterConfig) {
    const { id } = adapterConfig;
    this.adapterMap[id] = this.cloneConfig(adapterConfig);
  }
  retrieveAdapter(id) {
    return this.adapterMap[id];
  }
  removeAdapter(id) {
    delete this.adapterMap[id];
  }
  getAdaptersByRole(role) {
    const adapters = values(this.adapterMap).filter((config2) => config2.role.includes(role));
    const dflt = this.defaultAdapters[role];
    if (dflt) {
      adapters.push(dflt);
    }
    return adapters;
  }
  createContext(config2, resource, getDelegate) {
    const services = this.facade.retrieveMediator(MediatorName.PLUGIN_MEDIATOR).createPluginServices(config2);
    const { dom, system } = services;
    const modelCollection = this.facade.retrieveProxy(ProxyName.ModelCollectionProxy);
    const presentationState = modelCollection.getModel(ModelName.PresentationState);
    const textTrackProxy = this.facade.retrieveProxy(ProxyName.TextTrackProxy);
    const performanceProxy = this.facade.retrieveProxy(ProxyName.PerformanceProxy);
    return Object.assign(services, {
      resource,
      video: system.isWebMaf ? system.webMafPlayer : dom.video,
      container: dom.main,
      autoplay: presentationState.isAutoplay,
      muted: presentationState.isMuteAtPlayStart,
      performanceSettings: performanceProxy,
      textTrackSettings: textTrackProxy,
      getDelegate
    });
  }
  createAdapter(role, resource, delegateFactory) {
    return __async(this, null, function* () {
      var _a;
      const adapters = this.getAdaptersByRole(role);
      const adapterConfig = ((_a = resource[role]) == null ? void 0 : _a.adapter) || {};
      const { id, options = {} } = adapterConfig;
      const list = id ? adapters.filter((adapter) => adapter.id === id) : adapters;
      for (const config2 of list) {
        const context = this.createContext(config2, resource, delegateFactory);
        const opts = merge({}, config2.options, options, adapterConfig[config2.id]);
        if (!id && !(yield config2.isSupported(context, opts))) {
          continue;
        }
        const adapter = yield config2.factory(context, opts);
        if (adapter) {
          this.facade.logger.info(`${config2.id} adapter created`);
          return adapter;
        }
      }
      let message = `Could not find adapter for role: ${role}`;
      if (id) {
        message += `, with id: ${id}`;
      }
      throw new PlayerError(ErrorCode.ADAPTER_NOT_FOUND, message);
    });
  }
}
var __defProp$2 = Object.defineProperty;
var __getOwnPropDesc$2 = Object.getOwnPropertyDescriptor;
var __decorateClass$2 = (decorators, target, key, kind) => {
  var result = __getOwnPropDesc$2(target, key);
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$2(target, key, result);
  return result;
};
class LocalizationProxy extends Proxy2 {
  constructor(name) {
    super(name, {});
  }
  onRegister() {
    this.localization = localization.create({ logger: this.facade.logger });
    this.delegate = apiCollection(`${this.facade.appId}.localization`, this);
  }
  onRemove() {
    this.localization.destroy();
    this.localization = null;
    this.delegate.destroy();
    this.delegate = null;
  }
  getApi() {
    return this.delegate.api;
  }
  get defaultLanguage() {
    return this.localization.defaultLanguage;
  }
  get language() {
    return this.localization.language;
  }
  get languageTag() {
    return this.localization.languageTag;
  }
  changeLanguage(language) {
    return this.localization.changeLanguage(language);
  }
  registerLocalizationData(data) {
    return this.localization.registerLocalizationData(data);
  }
  localize(messageId, context, language) {
    return this.localization.localize(messageId, context, language);
  }
}
__decorateClass$2([
  apiAccessor(true)
], LocalizationProxy.prototype, "defaultLanguage");
__decorateClass$2([
  apiAccessor(true)
], LocalizationProxy.prototype, "language");
__decorateClass$2([
  apiMethod()
], LocalizationProxy.prototype, "languageTag");
__decorateClass$2([
  apiMethod()
], LocalizationProxy.prototype, "changeLanguage");
__decorateClass$2([
  apiMethod()
], LocalizationProxy.prototype, "registerLocalizationData");
__decorateClass$2([
  apiMethod()
], LocalizationProxy.prototype, "localize");
class ModelCollectionProxy extends Proxy2 {
  constructor() {
    super(...arguments);
    this.resettables = [
      ModelName.ContentPlaybackState
    ];
  }
  onRemove() {
    this.resettables = null;
    super.onRemove();
  }
  get collection() {
    return this.data;
  }
  getModel(name) {
    return this.data.getModel(name);
  }
  reset() {
    const list = this.resettables;
    let i = list.length;
    while (i--) {
      this.getModel(list[i]).reset();
    }
    const psi = this.getModel(ModelName.PresentationState);
    psi.isAutoplay = true;
    psi.isTrackingAd = false;
    psi.adSegmentEntered = false;
    psi.started = false;
    psi.streamDuration = NaN;
    psi.streamTime = NaN;
  }
}
class AbstractMediator extends Notifier {
  constructor(name, viewControl) {
    super();
    this.pViewControl = null;
    this.mediatorName = name;
    viewControl && (this.viewControl = viewControl);
  }
  get name() {
    return this.mediatorName;
  }
  set viewControl(viewControl) {
    this.pViewControl = viewControl;
  }
  get viewControl() {
    return this.pViewControl;
  }
  get system() {
    return System;
  }
  getService(name) {
    return this.facade ? this.facade.retrieveService(name) : null;
  }
  getModel(name) {
    return this.getModelCollection().getModel(name);
  }
  getProxy(name) {
    return this.facade ? this.facade.retrieveProxy(name) : null;
  }
  getModelCollection() {
    return this.facade ? this.facade.retrieveProxy(ProxyName.ModelCollectionProxy) : null;
  }
  listNotificationInterests() {
    return [];
  }
  onRegister() {
  }
  onRemove() {
    this.pViewControl = null;
    super.onRemove();
  }
}
class LogAwareMediator extends AbstractMediator {
  // It may be useful to pass the logger to lower level components
  // (which don't have facade access), if logging is desired at that level.
  get logger() {
    return this.facade.logger;
  }
}
const _TimerMediator = class _TimerMediator extends LogAwareMediator {
  constructor(name) {
    super(name);
    this.timer = new Timer(_TimerMediator.INTERVAL);
    this.timer.on(Timer.TIC_EVENT, (e) => this.onTic(e));
  }
  killTimer() {
    var _a;
    (_a = this.timer) == null ? void 0 : _a.stop();
  }
  listNotificationInterests() {
    return [
      PlayerEvent.RESOURCE_START
    ];
  }
  handleNotification(notification) {
    var _a;
    switch (notification.name) {
      case PlayerEvent.RESOURCE_START:
        (_a = this.timer) == null ? void 0 : _a.start();
        break;
    }
  }
  onRegister() {
    super.onRegister();
  }
  onRemove() {
    this.timer.destroy();
    this.timer = null;
    super.onRemove();
  }
  onTic(e) {
    var _a, _b;
    (_a = this.facade) == null ? void 0 : _a.sendNotification(NotificationName.TIMER_TIC, e.detail, NotificationType.INTERNAL);
    (_b = this.facade) == null ? void 0 : _b.sendNotification(PlayerEvent.CLOCK, { count: e.detail.count }, NotificationType.INTERNAL);
  }
};
_TimerMediator.INTERVAL = 100;
let TimerMediator = _TimerMediator;
class PerformanceProxy extends Proxy2 {
  onRegister() {
    const mcp = this.facade.retrieveProxy(ProxyName.ModelCollectionProxy);
    const options = mcp.getModel(ModelName.PlayerOptions);
    this.pOverrides = options.overrides;
    this.pMode = options.performanceMode === PerformanceMode.AUTO ? this.calculatePerformanceMode() : options.performanceMode;
  }
  calculatePerformanceMode() {
    switch (true) {
      case System.isTv:
      case System.isEmbedded:
        return PerformanceMode.TV;
      case System.isMobile:
        return PerformanceMode.MOBILE;
      default:
        return PerformanceMode.DESKTOP;
    }
  }
  get mode() {
    return this.pMode;
  }
  get forwardBufferLength() {
    switch (this.pMode) {
      case PerformanceMode.MOBILE:
      case PerformanceMode.TV:
        return 20;
      case PerformanceMode.LOW:
        return 10;
      default:
        return void 0;
    }
  }
  get backBufferLength() {
    switch (this.pMode) {
      case PerformanceMode.MOBILE:
      case PerformanceMode.TV:
        return 30;
      case PerformanceMode.LOW:
        return 12;
      default:
        return 60;
    }
  }
  get topQualityForwardBufferLength() {
    switch (this.pMode) {
      case PerformanceMode.MOBILE:
      case PerformanceMode.TV:
        return 60;
      case PerformanceMode.LOW:
        return 30;
      default:
        return void 0;
    }
  }
  get bufferingSampleRate() {
    var _a;
    const override = (_a = this.pOverrides) == null ? void 0 : _a.bufferingSampleRate;
    if (override) {
      return override;
    }
    switch (this.pMode) {
      case PerformanceMode.TV:
      case PerformanceMode.LOW:
        return 300;
      default:
        return TimerMediator.INTERVAL;
    }
  }
}
class PlayerDomProxy extends Proxy2 {
  constructor(name, data, playerOptions) {
    super(name, data);
    this.controlVisCssClass = "cvui-ctrlbar-vis";
    this.useInitialVideo = false;
    this.adapterConfig = {
      id: DOM_VIDEO,
      role: [AdapterRole.VIDEO],
      factory: () => ({
        getId: () => DOM_VIDEO,
        isSupported: () => true,
        createVideo: () => {
          if (this.useInitialVideo) {
            this.useInitialVideo = false;
            return this.video;
          }
          this.recreateVideo();
          return this.video;
        }
      })
    };
    this.playerOptions = playerOptions;
  }
  setModel(coll) {
    for (const q in coll) {
      if (q === PlayerDom$1.VIDEO_EL && coll[q]) {
        this.useInitialVideo = true;
        this.video = coll[q];
      } else {
        this.model[q] = coll[q];
      }
    }
  }
  onRegister() {
    super.onRegister();
    const adapterProxy = this.facade.retrieveProxy(ProxyName.AdapterProxy);
    adapterProxy.registerDefaultAdapter(AdapterRole.VIDEO, this.adapterConfig);
  }
  onRemove() {
    var _a;
    const main = this.getMain();
    const children = main.childNodes;
    let i = children.length;
    while (i--) {
      main.removeChild(children[i]);
    }
    const style = this.getElement(PlayerDom$1.STYLE);
    (_a = style == null ? void 0 : style.parentElement) == null ? void 0 : _a.removeChild(style);
    super.onRemove();
  }
  setControlVisibility(controlsVisible) {
    const el = this.getMain();
    if (!el) {
      return;
    }
    const m = controlsVisible ? "add" : "remove";
    el.classList[m](this.controlVisCssClass);
  }
  getElement(n) {
    const el = this.model[n];
    return el || null;
  }
  getSafeZIndex() {
    const el = this.getElement(PlayerDom$1.AD_CONTAINER);
    if (!el) {
      return 10;
    }
    return Number(el.style.zIndex) + 10;
  }
  getTextTrackContainer() {
    return this.getElement(PlayerDom$1.CC_CONTAINER);
  }
  getMain() {
    return this.getElement(PlayerDom$1.MAIN_CONTAINER);
  }
  showAdClickElement(flag) {
    const el = this.getElement(PlayerDom$1.AD_CLICK_EL);
    if (el) {
      const l10nProxy = this.facade.retrieveProxy(ProxyName.LocalizationProxy);
      const txt = l10nProxy.localize(LocalizationId.LEARN_MORE);
      if (txt) {
        el.innerHTML = txt;
      }
      el.style.display = flag !== false ? "block" : "none";
    }
  }
  getDimensions() {
    const r = this.getPresentationRect();
    return r ? { width: r.width, height: r.height } : null;
  }
  showContainer(name, flag) {
    const el = this.getElement(name);
    if (el) {
      el.style.display = flag ? "inline-block" : "none";
    }
  }
  showAdContainer(flag) {
    this.showContainer(PlayerDom$1.AD_CONTAINER, flag);
  }
  getPresentationRect() {
    const m = this.getMain(), r = m && m.getBoundingClientRect();
    return r || null;
  }
  primeVideo(src = AppResources.blankDataUrl) {
    return Promise.resolve().then(() => {
      const { video } = this;
      if (video) {
        video.src = src;
        video.load();
        return video.play().catch((e) => {
          if (video.error && video.src !== AppResources.blankDataUrl) {
            return this.primeVideo(AppResources.blankDataUrl);
          }
        });
      }
    });
  }
  // Recreates ad container and ad click element as well
  // (a co-requisite for GAM client-side ads)
  recreateVideo() {
    const previous = this.video;
    const parent = this.getElement(PlayerDom$1.VIDEO_CONTAINER);
    const mdlC = this.facade.retrieveProxy(ProxyName.ModelCollectionProxy);
    const presentationState = mdlC.getModel(ModelName.PresentationState);
    let video;
    let vol;
    let muted;
    if (previous) {
      const exclude = ["src", "data-element-id"];
      video = createVideoElement(this.playerOptions, this.facade.appId);
      vol = previous.volume;
      muted = previous.muted;
      Array.from(previous.attributes).filter((attribute) => !exclude.includes(attribute.name)).forEach((attribute) => video.setAttribute(attribute.name, attribute.value));
      parent.replaceChild(video, previous);
    } else {
      video = initVideoElement(this.getElement(PlayerDom$1.MAIN_CONTAINER), this.playerOptions, this.facade.appId);
      vol = presentationState.volume;
      muted = presentationState.isMuted;
      parent.appendChild(video);
    }
    presentationState.volume = vol;
    video.muted = muted;
    video.volume = vol;
    this.recreateAdElements();
    this.video = video;
  }
  // Ad elements are created by default to make their replacement
  // more straightforward; they should *always* be in the DOM
  recreateAdElements() {
    const adContainer = createAdContainer();
    const adClickEl = createAdClickEl();
    const parent = this.getMain();
    const prevAdCtr = this.getElement(PlayerDom$1.AD_CONTAINER);
    const prevAdClickEl = this.getElement(PlayerDom$1.AD_CLICK_EL);
    parent.replaceChild(adContainer, prevAdCtr);
    parent.replaceChild(adClickEl, prevAdClickEl);
    this.setModel({
      [PlayerDom$1.AD_CONTAINER]: adContainer,
      [PlayerDom$1.AD_CLICK_EL]: adClickEl
    });
  }
  get model() {
    return this.data;
  }
}
class TextTrackProxy extends Proxy2 {
  constructor(name, data = {}) {
    super(name, {
      native: data.native !== false,
      mode: TextTrackMode.DISABLED,
      language: data.language
    });
  }
  set mode(value) {
    this.data.mode = value;
  }
  get mode() {
    return this.data.mode;
  }
  set enabled(value) {
    if (value) {
      this.mode = this.enabledMode;
    } else {
      this.mode = TextTrackMode.DISABLED;
    }
  }
  get enabled() {
    return this.data.mode !== TextTrackMode.DISABLED;
  }
  get enabledMode() {
    return this.data.native ? TextTrackMode.SHOWING : TextTrackMode.HIDDEN;
  }
  get native() {
    return this.data.native;
  }
  set language(value) {
    this.data.language = value;
  }
  get language() {
    return this.data.language;
  }
}
class VideoProxy extends Proxy2 {
  constructor(name, data) {
    super(name, data);
  }
  onRemove() {
    this.setVideo(null);
    this.adapter = null;
    this.data.logger = null;
    super.onRemove();
  }
  initVideo(resource) {
    return __async(this, null, function* () {
      var _a;
      if ((_a = this.adapter) == null ? void 0 : _a.destroy) {
        yield this.adapter.destroy();
      }
      const adapterProxy = this.facade.retrieveProxy(ProxyName.AdapterProxy);
      this.adapter = yield adapterProxy.createAdapter(AdapterRole.VIDEO, resource, null);
      const video = yield this.adapter.createVideo();
      this.setVideo(video);
      return video;
    });
  }
  getAdapter() {
    return this.adapter;
  }
  getVideo() {
    return this.data.video;
  }
  setVideo(video) {
    if (this.data.video) {
      this.applyProps(this.data.video, { player: null, avia: null });
      this.sendNotification(PlayerEvent.VIDEO_ELEMENT_REMOVED, { video: this.data.video });
    }
    this.data.video = video;
    if (video) {
      const appMediator = this.facade.retrieveMediator(MediatorName.APPLICATION);
      this.applyProps(video, { player: appMediator.getAppApi(), avia: System.appNamespace });
      this.sendNotification(PlayerEvent.VIDEO_ELEMENT_ADDED, { video: this.data.video });
    }
  }
  setVideoVolume(volume) {
    const video = this.getVideo();
    if (!video || this.getVideoVolume() === volume) {
      return;
    }
    video.volume = volume;
  }
  getVideoVolume() {
    const video = this.getVideo();
    return video ? video.volume : null;
  }
  muteVideo(flag) {
    const video = this.getVideo();
    if (!video) {
      return;
    }
    video.muted = flag;
  }
  applyProps(video, props) {
    for (const key in props) {
      try {
        video[key] = props[key];
      } catch (error) {
        this.facade.logger.debug(`Error applying video property ${key}`, error);
      }
    }
  }
}
class Validator {
  constructor() {
  }
  static checkType(val, type, allowNull) {
    if (typeof type === "string") {
      type = [type];
    }
    return allowNull && val === null ? true : type.some((t) => typeof val === t);
  }
  static notEmpty(obj) {
    return !isEmpty(obj);
  }
  static isArray(obj) {
    return Array.isArray(obj);
  }
  static validNumber(val, defVal) {
    return typeof val !== "number" ? defVal : val;
  }
  static isTypedArray(obj, type) {
    if (this.isArray(obj) && this.notEmpty(obj)) {
      let i = obj.length;
      while (i--) {
        if (typeof obj[i] !== type) {
          return false;
        }
      }
      return true;
    }
    return false;
  }
  static isType(value, type) {
    return value instanceof type;
  }
  static isPositiveNumber(value) {
    return typeof value === "number" && value >= 0;
  }
}
const content_playback_state_config = {
  qualities: {
    type: "object",
    defaultValue: []
  },
  quality: {
    type: "object",
    defaultValue: null
  },
  qualityMode: {
    type: "string",
    defaultValue: QualityMode.AUTO
  },
  qualityCappedToScreenSize: {
    type: "boolean",
    defaultValue: true
  },
  audioTracks: {
    type: "object",
    defaultValue: []
  },
  audioTrack: {
    type: "object",
    defaultValue: null
  },
  textTracks: {
    type: "object",
    defaultValue: []
  },
  textTrack: {
    type: "object",
    defaultValue: null
  },
  streamType: {
    type: "string",
    defaultValue: StreamType.VOD
  },
  liveStreamInfo: {
    type: "object",
    defaultValue: null
  },
  bufferLength: {
    type: "number",
    defaultValue: 0
  },
  cdn: {
    type: "string",
    defaultValue: null,
    validator: Validator.notEmpty
  },
  drmType: {
    type: "string",
    defaultValue: null,
    validator: Validator.notEmpty
  },
  contentSegment: {
    type: "number",
    defaultValue: NaN
  },
  maxBandwidth: {
    type: "number",
    defaultValue: NaN
  },
  time: {
    type: "number",
    defaultValue: 0
  },
  state: {
    type: "string",
    defaultValue: PlaybackState.IDLE
  },
  duration: {
    type: "number",
    defaultValue: NaN
  },
  bitrate: {
    type: "number",
    defaultValue: NaN
  },
  started: {
    type: "boolean",
    defaultValue: false
  },
  averageDroppedFps: {
    type: "number",
    defaultValue: NaN
  },
  framerate: {
    type: "number",
    defaultValue: NaN
  }
};
const player_dom_config = {
  main: {
    type: "object",
    defaultValue: null
  },
  video: {
    type: "object",
    defaultValue: null
  },
  videoContainer: {
    type: "object",
    defaultValue: null
  },
  ccContainer: {
    type: "object",
    defaultValue: null
  },
  adContainer: {
    type: "object",
    defaultValue: null
  },
  panelContainer: {
    type: "object",
    defaultValue: null
  },
  adClickEl: {
    type: "object",
    defaultValue: null
  }
};
const player_options_config = {
  container: {
    type: ["object", "string"],
    defaultValue: null
  },
  plugins: {
    type: "object",
    defaultValue: null
  },
  autoplay: {
    type: "string",
    defaultValue: Autoplay.NONE
  },
  id: {
    type: "string",
    defaultValue: null
  },
  network: {
    type: "object",
    defaultValue: null
  },
  performanceMode: {
    type: "string",
    defaultValue: PerformanceMode.AUTO
  },
  renderTextTrackNatively: {
    type: "boolean",
    defaultValue: true
  },
  useNativeFullscreen: {
    type: "boolean",
    defaultValue: true
  },
  playsInline: {
    type: "boolean",
    defaultValue: true
  },
  useNativeControls: {
    type: "boolean",
    defaultValue: false
  },
  overrides: {
    type: "object",
    defaultValue: {}
  },
  logLevel: {
    type: "string",
    defaultValue: LogLevel.OFF
  },
  keyboard: {
    type: "object",
    defaultValue: null
  },
  language: {
    type: "string",
    defaultValue: null
  },
  audioLanguage: {
    type: "string",
    defaultValue: null
  },
  audioRole: {
    type: "string",
    defaultValue: AudioRole.MAIN
  },
  textLanguage: {
    type: "string",
    defaultValue: null
  },
  localizationLanguage: {
    type: "string",
    defaultValue: null
  },
  localization: {
    type: "object",
    defaultValue: null
  },
  idleDelay: {
    type: "number",
    defaultValue: 3e3
  },
  enableOm: {
    type: "boolean",
    defaultValue: false
  },
  enableMoat: {
    type: "boolean",
    defaultValue: false
  },
  reuseVideoElement: {
    type: "boolean",
    defaultValue: false
  },
  ignoreBlankTextTracks: {
    type: "boolean",
    defaultValue: false
  },
  sizeCheckInterval: {
    type: "number",
    defaultValue: 1e3
  }
};
class Transformer {
  constructor() {
  }
  static clampValue(val, min, max) {
    if (typeof val !== "number") {
      return null;
    }
    return Math.max(min, Math.min(val, max));
  }
  static lowerCase(val) {
    return typeof val === "string" ? val.toLowerCase() : val;
  }
  static strToNum(val) {
    if (typeof val === "number") {
      return val;
    }
    if (typeof val === "string") {
      const pf = parseFloat(val);
      return isNaN(pf) ? val : pf;
    }
    return val;
  }
}
const presentation_state_config = {
  streamTime: {
    type: "number",
    defaultValue: 0,
    setterTransformer: (value) => {
      return Validator.isPositiveNumber(value) ? value : 0;
    }
  },
  streamDuration: {
    type: "number",
    defaultValue: NaN,
    setterTransformer: (value) => {
      return Validator.isPositiveNumber(value) ? value : NaN;
    }
  },
  adTime: {
    type: "number",
    defaultValue: NaN,
    setterTransformer: (value) => {
      return Validator.isPositiveNumber(value) ? value : NaN;
    }
  },
  adDuration: {
    type: "number",
    defaultValue: NaN,
    setterTransformer: (value) => {
      return Validator.isPositiveNumber(value) ? value : NaN;
    }
  },
  breakTime: {
    type: "number",
    defaultValue: NaN,
    setterTransformer: (value) => {
      return Validator.isPositiveNumber(value) ? value : NaN;
    }
  },
  breakDuration: {
    type: "number",
    defaultValue: NaN,
    setterTransformer: (value) => {
      return Validator.isPositiveNumber(value) ? value : NaN;
    }
  },
  isAutoplay: {
    type: "boolean",
    defaultValue: false
  },
  isTrackingAd: {
    type: "boolean",
    defaultValue: false
  },
  adSegmentEntered: {
    type: "boolean",
    defaultValue: false
  },
  isFullscreen: {
    type: "boolean",
    defaultValue: false
  },
  isMuted: {
    type: "boolean",
    defaultValue: false
  },
  isMuteAtPlayStart: {
    type: "boolean",
    defaultValue: false
  },
  started: {
    type: "boolean",
    defaultValue: false
  },
  userHasUnmuted: {
    type: "boolean",
    defaultValue: false
  },
  volume: {
    type: "number",
    defaultValue: 1,
    setterTransformer: (value) => {
      return Transformer.clampValue(value, 0, 1);
    }
  },
  usesSsai: {
    type: "boolean",
    defaultValue: false
  },
  streamId: {
    type: "string",
    defaultValue: null
  },
  suspended: {
    type: "boolean",
    defaultValue: false
  }
};
const config = {
  content_playback_state_config,
  player_dom_config,
  player_options_config,
  presentation_state_config
};
class Generator {
  constructor() {
  }
  static generateModel(scope, config2, dataContainer, defaultValueContainer) {
    for (const q in config2) {
      this.createProperty(q, config2[q], scope, dataContainer, defaultValueContainer);
    }
  }
  static createProperty(name, config2, scope, dataCtr, defaultValueCtr) {
    const validator = config2.validator, type = config2.type, defValue = config2.defaultValue, enumerable = config2.enumerable !== false, setterTransformer = this.getTransformer(config2, "setter", scope), getterTransformer = this.getTransformer(config2, "getter", scope);
    if (config2.writable === false) {
      Object.defineProperty(scope, name, {
        enumerable,
        value: defValue,
        writable: false
      });
      dataCtr[name] = defValue;
    } else {
      Object.defineProperty(scope, name, {
        enumerable,
        set: function(val) {
          const txVal = setterTransformer(val);
          if (validator && !validator(txVal)) {
            Logger.warn(`Invalid value '${txVal}' for property ${name}`);
            return;
          }
          if (!Validator.checkType(txVal, type, defValue == null)) {
            Logger.warn(`Invalid type supplied for property ${name}`);
            return;
          }
          dataCtr[name] = txVal;
        },
        get: function() {
          return getterTransformer(dataCtr[name]);
        }
      });
      dataCtr[name] = defValue;
    }
    defaultValueCtr[name] = defValue;
  }
  static getTransformer(pCfg, which, scope) {
    const tx = pCfg[which + "Transformer"];
    if (tx && typeof tx === "function") {
      return tx.bind(scope);
    }
    return this.blankTransformer;
  }
  static blankTransformer(val) {
    return val;
  }
}
class ConfigurablePropertyContainer {
  constructor(config2) {
    this.pData = {};
    this.defaultValues = {};
    Generator.generateModel(this, config2, this.pData, this.defaultValues);
  }
  /**
   * Returns a cloned, "read-only" object
   * (i.e, modifying values on this object has no effect on model)
   */
  get data() {
    return Object.assign({}, this.pData);
  }
  reset() {
    for (const q in this.defaultValues) {
      this.pData[q] = this.defaultValues[q];
    }
  }
}
class ContentPlaybackState {
  constructor(config2) {
    this.model = new ConfigurablePropertyContainer(config2);
  }
  static get modelName() {
    return "ContentPlaybackState";
  }
  get data() {
    return this.model.data;
  }
  reset() {
    this.model.reset();
  }
  set qualities(value) {
    this.model.qualities = value;
  }
  get qualities() {
    return this.model.qualities;
  }
  set quality(value) {
    this.model.quality = value;
  }
  get quality() {
    return this.model.quality;
  }
  set qualityMode(value) {
    this.model.qualityMode = value;
  }
  get qualityMode() {
    return this.model.qualityMode;
  }
  set qualityCappedToScreenSize(value) {
    this.model.qualityCappedToScreenSize = value;
  }
  get qualityCappedToScreenSize() {
    return this.model.qualityCappedToScreenSize;
  }
  set audioTracks(value) {
    this.model.audioTracks = value;
  }
  get audioTracks() {
    return this.model.audioTracks;
  }
  set audioTrack(value) {
    this.model.audioTrack = value;
  }
  get audioTrack() {
    return this.model.audioTrack;
  }
  set textTracks(value) {
    this.model.textTracks = value;
  }
  get textTracks() {
    return this.model.textTracks;
  }
  set textTrack(value) {
    this.model.textTrack = value;
  }
  get textTrack() {
    return this.model.textTrack;
  }
  set streamType(value) {
    this.model.streamType = value;
  }
  get streamType() {
    return this.model.streamType;
  }
  set liveStreamInfo(value) {
    this.model.liveStreamInfo = value;
  }
  get liveStreamInfo() {
    return this.model.liveStreamInfo;
  }
  set bufferLength(value) {
    this.model.bufferLength = value;
  }
  get bufferLength() {
    return this.model.bufferLength;
  }
  set cdn(value) {
    this.model.cdn = value;
  }
  get cdn() {
    return this.model.cdn;
  }
  set drmType(value) {
    this.model.drmType = value;
  }
  get drmType() {
    return this.model.drmType;
  }
  set contentSegment(value) {
    this.model.contentSegment = value;
  }
  get contentSegment() {
    return this.model.contentSegment;
  }
  set maxBandwidth(value) {
    this.model.maxBandwidth = value;
  }
  get maxBandwidth() {
    return this.model.maxBandwidth;
  }
  set time(value) {
    this.model.time = value;
  }
  get time() {
    return this.model.time;
  }
  set state(value) {
    this.model.state = value;
  }
  get state() {
    return this.model.state;
  }
  set duration(value) {
    this.model.duration = value;
  }
  get duration() {
    return this.model.duration;
  }
  set bitrate(value) {
    this.model.bitrate = value;
  }
  get bitrate() {
    return this.model.bitrate;
  }
  set started(value) {
    this.model.started = value;
  }
  get started() {
    return this.model.started;
  }
  set averageDroppedFps(value) {
    this.model.averageDroppedFps = value;
  }
  get averageDroppedFps() {
    return this.model.averageDroppedFps;
  }
  set framerate(value) {
    this.model.framerate = value;
  }
  get framerate() {
    return this.model.framerate;
  }
}
class PlayerDom {
  constructor(config2) {
    this.model = new ConfigurablePropertyContainer(config2);
  }
  static get modelName() {
    return "PlayerDom";
  }
  get data() {
    return this.model.data;
  }
  reset() {
    this.model.reset();
  }
  set main(value) {
    this.model.main = value;
  }
  get main() {
    return this.model.main;
  }
  set video(value) {
    this.model.video = value;
  }
  get video() {
    return this.model.video;
  }
  set videoContainer(value) {
    this.model.videoContainer = value;
  }
  get videoContainer() {
    return this.model.videoContainer;
  }
  set ccContainer(value) {
    this.model.ccContainer = value;
  }
  get ccContainer() {
    return this.model.ccContainer;
  }
  set adContainer(value) {
    this.model.adContainer = value;
  }
  get adContainer() {
    return this.model.adContainer;
  }
  set panelContainer(value) {
    this.model.panelContainer = value;
  }
  get panelContainer() {
    return this.model.panelContainer;
  }
  set adClickEl(value) {
    this.model.adClickEl = value;
  }
  get adClickEl() {
    return this.model.adClickEl;
  }
  set style(value) {
    this.model.style = value;
  }
  get style() {
    return this.model.style;
  }
}
class PlayerOptions2 {
  constructor(config2) {
    this.model = new ConfigurablePropertyContainer(config2);
  }
  static get modelName() {
    return "PlayerOptions";
  }
  get data() {
    return this.model.data;
  }
  reset() {
    this.model.reset();
  }
  set container(value) {
    this.model.container = value;
  }
  get container() {
    return this.model.container;
  }
  set plugins(value) {
    this.model.plugins = value;
  }
  get plugins() {
    return this.model.plugins;
  }
  set autoplay(value) {
    this.model.autoplay = value;
  }
  get autoplay() {
    return this.model.autoplay;
  }
  set id(value) {
    this.model.id = value;
  }
  get id() {
    return this.model.id;
  }
  set network(value) {
    this.model.network = value;
  }
  get network() {
    return this.model.network;
  }
  set performanceMode(value) {
    this.model.performanceMode = value;
  }
  get performanceMode() {
    return this.model.performanceMode;
  }
  set renderTextTrackNatively(value) {
    this.model.renderTextTrackNatively = value;
  }
  get renderTextTrackNatively() {
    return this.model.renderTextTrackNatively;
  }
  set useNativeFullscreen(value) {
    this.model.useNativeFullscreen = value;
  }
  get useNativeFullscreen() {
    return this.model.useNativeFullscreen;
  }
  set keyboard(value) {
    this.model.keyboard = value;
  }
  get keyboard() {
    return this.model.keyboard;
  }
  set playsInline(value) {
    this.model.playsInline = value;
  }
  get playsInline() {
    return this.model.playsInline;
  }
  set useNativeControls(value) {
    this.model.useNativeControls = value;
  }
  get useNativeControls() {
    return this.model.useNativeControls;
  }
  set overrides(value) {
    this.model.overrides = value;
  }
  get overrides() {
    return this.model.overrides;
  }
  set logLevel(value) {
    this.model.logLevel = value;
  }
  get logLevel() {
    return this.model.logLevel;
  }
  set language(value) {
    this.model.language = value;
  }
  get language() {
    return this.model.language;
  }
  set audioLanguage(value) {
    this.model.audioLanguage = value;
  }
  get audioLanguage() {
    return this.model.audioLanguage;
  }
  set audioRole(value) {
    this.model.audioRole = value;
  }
  get audioRole() {
    return this.model.audioRole;
  }
  set textLanguage(value) {
    this.model.textLanguage = value;
  }
  get textLanguage() {
    return this.model.textLanguage;
  }
  set localizationLanguage(value) {
    this.model.localizationLanguage = value;
  }
  get localizationLanguage() {
    return this.model.localizationLanguage;
  }
  set localization(value) {
    this.model.localization = value;
  }
  get localization() {
    return this.model.localization;
  }
  set idleDelay(value) {
    this.model.idleDelay = value;
  }
  get idleDelay() {
    return this.model.idleDelay;
  }
  set enableOm(value) {
    this.model.enableOm = value;
  }
  get enableOm() {
    return this.model.enableOm;
  }
  set enableMoat(value) {
    this.model.enableMoat = value;
  }
  get enableMoat() {
    return this.model.enableMoat;
  }
  set reuseVideoElement(value) {
    this.model.reuseVideoElement = value;
  }
  get reuseVideoElement() {
    return this.model.reuseVideoElement;
  }
  set ignoreBlankTextTracks(value) {
    this.model.ignoreBlankTextTracks = value;
  }
  get ignoreBlankTextTracks() {
    return this.model.ignoreBlankTextTracks;
  }
  set sizeCheckInterval(value) {
    this.model.sizeCheckInterval = value;
  }
  get sizeCheckInterval() {
    return this.model.sizeCheckInterval;
  }
}
class PresentationState {
  constructor(config2) {
    this.model = new ConfigurablePropertyContainer(config2);
  }
  static get modelName() {
    return "PresentationState";
  }
  get data() {
    return this.model.data;
  }
  reset() {
    this.model.reset();
  }
  set streamTime(value) {
    this.model.streamTime = value;
  }
  get streamTime() {
    return this.model.streamTime;
  }
  set adTime(value) {
    this.model.adTime = value;
  }
  get adTime() {
    return this.model.adTime;
  }
  set adDuration(value) {
    this.model.adDuration = value;
  }
  get adDuration() {
    return this.model.adDuration;
  }
  set breakTime(value) {
    this.model.breakTime = value;
  }
  get breakTime() {
    return this.model.breakTime;
  }
  set breakDuration(value) {
    this.model.breakDuration = value;
  }
  get breakDuration() {
    return this.model.breakDuration;
  }
  set streamDuration(value) {
    this.model.streamDuration = value;
  }
  get streamDuration() {
    return this.model.streamDuration;
  }
  set isAutoplay(value) {
    this.model.isAutoplay = value;
  }
  get isAutoplay() {
    return this.model.isAutoplay;
  }
  set isTrackingAd(value) {
    this.model.isTrackingAd = value;
  }
  get isTrackingAd() {
    return this.model.isTrackingAd;
  }
  set adSegmentEntered(value) {
    this.model.adSegmentEntered = value;
  }
  get adSegmentEntered() {
    return this.model.adSegmentEntered;
  }
  set isFullscreen(value) {
    this.model.isFullscreen = value;
  }
  get isFullscreen() {
    return this.model.isFullscreen;
  }
  set isMuted(value) {
    this.model.isMuted = value;
  }
  get isMuted() {
    return this.model.isMuted;
  }
  set isMuteAtPlayStart(value) {
    this.model.isMuteAtPlayStart = value;
  }
  get isMuteAtPlayStart() {
    return this.model.isMuteAtPlayStart;
  }
  set started(value) {
    this.model.started = value;
  }
  get started() {
    return this.model.started;
  }
  set userHasUnmuted(value) {
    this.model.userHasUnmuted = value;
  }
  get userHasUnmuted() {
    return this.model.userHasUnmuted;
  }
  set volume(value) {
    this.model.volume = value;
  }
  get volume() {
    return this.model.volume;
  }
  set usesSsai(value) {
    this.model.usesSsai = value;
  }
  get usesSsai() {
    return this.model.usesSsai;
  }
  set streamId(value) {
    this.model.streamId = value;
  }
  get streamId() {
    return this.model.streamId;
  }
  set suspended(value) {
    this.model.suspended = value;
  }
  get suspended() {
    return this.model.suspended;
  }
}
class ModelCollection {
  constructor() {
    this.mdlCollection = {};
    this.createModels();
  }
  destroy() {
    for (const q in this.mdlCollection) {
      delete this.mdlCollection[q];
    }
    this.mdlCollection = null;
  }
  getModel(name) {
    return this.mdlCollection[name];
  }
  get ContentPlaybackState() {
    return this.mdlCollection.ContentPlaybackState;
  }
  get PlayerDom() {
    return this.mdlCollection.PlayerDom;
  }
  get PlayerOptions() {
    return this.mdlCollection.PlayerOptions;
  }
  get PresentationState() {
    return this.mdlCollection.PresentationState;
  }
  createModels() {
    const models = [
      ContentPlaybackState,
      PlayerDom,
      PlayerOptions2,
      PresentationState
    ];
    let i = models.length;
    while (i--) {
      const c = models[i];
      const n = c.modelName;
      const cfg = config[this.classToCfgName(n)];
      this.mdlCollection[n] = new c(cfg);
    }
  }
  classToCfgName(str) {
    return str.replace(/(?:^|\.?)([A-Z])/g, function(x, y) {
      return "_" + y.toLowerCase();
    }).replace(/^_/, "") + "_config";
  }
}
class PrepModelCommand extends LogAwareSimpleCommand {
  execute(notification) {
    const sys = this.system;
    const mdlColl = new ModelCollection();
    const mdlCollProxy = new ModelCollectionProxy(ProxyName.ModelCollectionProxy, mdlColl);
    const playerOptions = notification.body.playerOptions;
    this.facade.registerProxy(mdlCollProxy);
    this.setPlayerOptions(mdlCollProxy, playerOptions);
    this.facade.registerProxy(new AdapterProxy());
    this.facade.registerProxy(new PerformanceProxy(ProxyName.PerformanceProxy));
    const loc = new LocalizationProxy(ProxyName.LocalizationProxy);
    this.facade.registerProxy(loc);
    this.facade.registerProxy(new TextTrackProxy(ProxyName.TextTrackProxy, { native: playerOptions.renderTextTrackNatively, language: playerOptions.textLanguage }));
    this.facade.registerProxy(new VideoProxy(ProxyName.VideoProxy, { video: null }));
    sys.isBrowser && this.createDomProxy(mdlCollProxy, playerOptions);
    this.logger.debug("Model prepared");
  }
  setPlayerOptions(proxy, options) {
    const model = proxy.getModel(ModelName.PlayerOptions);
    for (const q in options) {
      !isUndefined(model[q]) && (model[q] = options[q]);
    }
  }
  createDomProxy(proxy, playerOptions) {
    const mdl = proxy.getModel(ModelName.PlayerDom), domCollProxy = new PlayerDomProxy(ProxyName.PlayerDomProxy, mdl, playerOptions);
    this.facade.registerProxy(domCollProxy);
  }
}
class PluginServices {
  constructor(options) {
    this.event = {
      dispatchPluginEvent: (data) => {
        this.options.dispatch(data);
      }
    };
    this.util = {
      queryStrFromObj(obj, encode) {
        return QueryString.encode(obj);
      }
    };
    this.options = options;
  }
  get player() {
    return this.options.player;
  }
  get logger() {
    return this.options.logger;
  }
  get system() {
    return System;
  }
  get appNamespace() {
    return this.system.appNamespace;
  }
  get avia() {
    return this.system.appNamespace;
  }
  get playerOptions() {
    return this.options.playerOptions;
  }
  get buildInfo() {
    return buildInfo;
  }
  get localization() {
    return this.options.localization;
  }
  get dom() {
    const { domProxy, videoProxy } = this.options;
    return {
      main: domProxy == null ? void 0 : domProxy.getMain(),
      get video() {
        return videoProxy.getVideo();
      },
      videoContainer: domProxy == null ? void 0 : domProxy.getElement(PlayerDom$1.VIDEO_CONTAINER),
      ccContainer: domProxy == null ? void 0 : domProxy.getElement(PlayerDom$1.CC_CONTAINER),
      adContainer: domProxy == null ? void 0 : domProxy.getElement(PlayerDom$1.AD_CONTAINER),
      adClickEl: domProxy == null ? void 0 : domProxy.getElement(PlayerDom$1.AD_CLICK_EL),
      style: domProxy == null ? void 0 : domProxy.getElement(PlayerDom$1.STYLE)
    };
  }
  get hookManager() {
    return this.options.hookManager;
  }
}
class PluginMediator extends LogAwareMediator {
  constructor(name) {
    super(name);
    this.plugins = {};
    this.pendingLoads = null;
    this.services = null;
  }
  destroy() {
    return __async(this, null, function* () {
      yield Promise.all(Object.keys(this.plugins).map((id) => __async(this, null, function* () {
        try {
          yield this.killPlugin(id);
        } catch (error) {
          this.logger.warn(`Error destroying plugin ${id}: ${error}`);
        }
      })));
    });
  }
  onRemove() {
    this.plugins = null;
    this.pendingLoads = null;
    this.services = null;
    super.onRemove();
  }
  removePlugin(id) {
    this.killPlugin(id);
  }
  getPlugin(id) {
    return this.plugins[id] || null;
  }
  loadPlugin(cfg) {
    return this.createPlugin(cfg);
  }
  listNotificationInterests() {
    return [
      NotificationName.LOAD_PLUGINS,
      PlayerEvent.AD_BREAK_START,
      PlayerEvent.CONTENT_START,
      NotificationName.REMOVE_PLUGIN
    ];
  }
  handleNotification(notification) {
    switch (notification.name) {
      case NotificationName.LOAD_PLUGINS:
        this.loadPlugins(notification.body);
        break;
      case NotificationName.REMOVE_PLUGIN:
        this.removePlugin(notification.body.name);
        break;
      case PlayerEvent.AD_BREAK_START:
      case PlayerEvent.CONTENT_START:
        this.loadPendingPlugins();
        break;
    }
  }
  createPluginServices(config2) {
    const { id, options = {} } = config2;
    return new PluginServices(__spreadProps(__spreadValues({}, this.services), {
      logger: this.logger.create({ id, debug: options.debug, logLevel: options.logLevel })
    }));
  }
  get playerOptions() {
    return this.getModel(ModelName.PlayerOptions).data;
  }
  initPluginServices() {
    if (this.services) {
      return;
    }
    const am = this.facade.retrieveMediator(MediatorName.APPLICATION);
    this.services = {
      player: am.getAppApi(),
      domProxy: this.facade.retrieveProxy(ProxyName.PlayerDomProxy),
      videoProxy: this.facade.retrieveProxy(ProxyName.VideoProxy),
      localization: this.facade.retrieveProxy(ProxyName.LocalizationProxy).getApi(),
      playerOptions: this.playerOptions,
      dispatch: (data) => {
        am.dispatchPluginEvent(data);
      },
      hookManager: this.facade.retrieveProxy(ProxyName.HookProxy),
      logger: null
    };
  }
  createPlugins(plugins) {
    return Promise.all(plugins.map((plugin) => this.createPlugin(plugin)));
  }
  createPlugin(config2) {
    return __async(this, null, function* () {
      var _a;
      const { id, factory, options } = config2;
      if (!isFunction(factory)) {
        throw new PluginError(ErrorCode.PLUGIN_FACTORY_ERROR, ErrorMessage.PLUGIN_FACTORY_ERROR, config2);
      }
      let plugin;
      try {
        const context = this.createPluginServices(config2);
        plugin = yield factory(context, options);
      } catch (error) {
        throw new PluginError(ErrorCode.PLUGIN_LOAD_ERROR, ErrorMessage.PLUGIN_LOAD_ERROR, config2, error);
      }
      if (!plugin) {
        return;
      }
      const pluginId = (_a = plugin.getId) == null ? void 0 : _a.call(plugin);
      if (!pluginId) {
        throw new PluginError(ErrorCode.PLUGIN_ID_ERROR, ErrorMessage.PLUGIN_ID_ERROR, config2);
      }
      this.plugins[id] = plugin;
      this.logger.info(`Created plugin '${id}'`);
      return plugin;
    });
  }
  killPlugin(id) {
    return __async(this, null, function* () {
      const plugin = this.plugins[id];
      if (!plugin) {
        return;
      }
      if (isFunction(plugin.destroy)) {
        yield plugin.destroy();
      }
      delete this.plugins[id];
    });
  }
  loadPendingPlugins() {
    if (!this.pendingLoads) {
      return;
    }
    this.createPlugins(this.pendingLoads).catch((error) => {
      this.sendNotification(NotificationName.PLAYER_ERROR, error);
    });
    this.pendingLoads = null;
  }
  loadPlugins(obj) {
    this.initPluginServices();
    const { callback, plugins } = obj;
    if (!(plugins == null ? void 0 : plugins.length)) {
      callback();
      return;
    }
    const ps = this.getModel(ModelName.PresentationState);
    const notStarted = !ps.started;
    const low = plugins.filter((plugin) => plugin.priority === PluginPriority.LOW);
    const high = plugins.filter((plugin) => plugin.priority !== PluginPriority.LOW);
    if (notStarted) {
      this.pendingLoads = low;
    }
    const queue2 = notStarted ? high : low.concat(high);
    this.createPlugins(queue2).then(() => callback()).catch((error) => callback(error));
  }
}
class PrepPluginsCommand extends LogAwareSimpleCommand {
  execute(notification) {
    this.facade.registerMediator(new PluginMediator(MediatorName.PLUGIN_MEDIATOR));
    this.logger.debug("Plugins Prepared");
  }
}
class PrepTimerCommand extends LogAwareSimpleCommand {
  execute(notification) {
    this.facade.registerMediator(new TimerMediator(MediatorName.TIMER_MEDIATOR));
    this.logger.debug("Timer mediator registered");
  }
}
function increaseVolume(context) {
  const { player, metadata } = context;
  const v = clampValue(player.volume + 0.05, 0, 1);
  metadata.volume = v;
  player.volume = v;
}
function decreaseVolume(context) {
  const { player, metadata } = context;
  const v = clampValue(player.volume - 0.05, 0, 1);
  metadata.volume = v;
  player.volume = v;
}
function skipBackward(context) {
  const { player, metadata } = context;
  const d = player.contentDuration;
  const v = clampValue(player.contentTime - 0.05 * d, 0, d);
  metadata.position = v;
  metadata.duration = d;
  player.seek(v);
}
function skipForward(context) {
  const { player, metadata } = context;
  const d = player.contentDuration;
  const v = clampValue(player.contentTime + 0.05 * d, 0, d);
  metadata.position = v;
  metadata.duration = d;
  player.seek(v);
}
function toggleFullscreen(context) {
  const { player } = context;
  if (player.isFullscreen) {
    player.exitFullscreen();
  } else {
    player.enterFullscreen();
  }
}
function togglePlay(context) {
  const { player } = context;
  if (player.streamType !== StreamType.LIVE) {
    player.togglePlayPause();
  }
}
function toggleMute(context) {
  const { player, metadata } = context;
  player.muted = !player.muted;
  metadata.muted = player.muted;
}
function toggleText(context) {
  const { player } = context;
  player.textTrackEnabled = !player.textTrackEnabled;
}
function play(context) {
  const { player } = context;
  player.play();
}
function pause(context) {
  const { player } = context;
  player.pause();
}
function stop(context) {
  const { player } = context;
  player.pause();
}
function live(context) {
  const { player } = context;
  if (player.streamType === StreamType.LIVE) {
    player.goLive();
  }
}
function getDefaultActions() {
  return {
    [ActionKey.PLAY]: play,
    [ActionKey.PAUSE]: pause,
    [ActionKey.PLAY_PAUSE]: togglePlay,
    [ActionKey.TEXT_TRACK]: toggleText,
    [ActionKey.SKIP_BACKWARD]: skipBackward,
    [ActionKey.SKIP_FORWARD]: skipForward,
    [ActionKey.STOP]: stop,
    [ActionKey.LIVE]: live,
    [ActionKey.INCREASE_VOLUME]: increaseVolume,
    [ActionKey.DECREASE_VOLUME]: decreaseVolume,
    [ActionKey.MUTE_UNMUTE]: toggleMute,
    [ActionKey.FULLSCREEN]: toggleFullscreen
  };
}
class ActionKeyMediator extends LogAwareMediator {
  constructor(name, scope = KeyboardScope.NONE) {
    super(name);
    this.scope = null;
    this.disabled = false;
    this.contextStack = [];
    this.onKeydown = (event) => __async(this, null, function* () {
      if (this.disabled) {
        return;
      }
      const target = event.target;
      if (!this.inScope(target)) {
        return;
      }
      const keyCode = this.getKeyCode(event.keyCode);
      const actionKey = this.getActionKey(keyCode);
      if (!actionKey || actionKey === ActionKey.NONE) {
        return;
      }
      event.preventDefault();
      const detail = this.createDetail(actionKey);
      const playerEvent = new CoreEvent(PlayerEvent.ACTION_KEY, this.player, detail);
      this.sendNotification(PlayerEvent.ACTION_KEY, playerEvent, NotificationType.INTERNAL);
      const domEvent = new CustomEvent(PlayerEvent.ACTION_KEY, {
        bubbles: true,
        cancelable: true,
        composed: true,
        detail
      });
      if (playerEvent.defaultPrevented) {
        domEvent.preventDefault();
      }
      target.dispatchEvent(domEvent);
      this.sendNotification(PlayerEvent.HOTKEY_ACTION, __spreadValues({ action: detail.action }, detail.metadata), NotificationType.INTERNAL);
      this.sendNotification(PlayerEvent.ACTION_KEY_METADATA, detail, NotificationType.INTERNAL);
    });
    this.onActionKeyDefault = (event) => {
      if (event.defaultPrevented) {
        return;
      }
      const { action } = event.detail;
      const defaultAction = getDefaultActions()[action];
      if (!defaultAction) {
        return;
      }
      try {
        defaultAction(event.detail);
      } catch (error) {
        this.sendNotification(PlayerEvent.ERROR, { error: new ActionKeyError(error.message, error) });
      }
    };
    this.setScope(scope);
    this.enterActionKeyContext(ActionKeyContext.DEFAULT);
    this.enterActionKeyContext(ActionKeyContext.HOTKEY);
  }
  onRegister() {
    this.defaultKeyEventType = this.getKeyboardOption("eventType", KeyboardEventType.DOWN);
    const app = this.facade.retrieveMediator(MediatorName.APPLICATION);
    this.player = app.getAppApi();
  }
  onRemove() {
    this.removeListeners();
    this.player = null;
    super.onRemove();
  }
  handleNotification(notification) {
  }
  // aviajs-337; intended to be invoked from ReadyCommand only
  initialize() {
    this.addListeners();
  }
  disable() {
    this.disabled = true;
  }
  enable() {
    if (!this.hasScope) {
      this.logger.warn("Attempted to enable key command mediator that has scope of NONE.");
      return;
    }
    this.disabled = false;
  }
  getKeyEventTarget() {
    if (typeof this.scope !== "string") {
      return this.scope;
    }
    switch (this.scope) {
      case KeyboardScope.PLAYER:
        return this.playerContainer;
      case KeyboardScope.DOCUMENT:
        return System.global.document;
      case KeyboardScope.NONE:
        return null;
      default:
        return System.global.document.querySelector(this.scope);
    }
  }
  enterActionKeyContext(context) {
    if (this.contextStack[0] === context) {
      return;
    }
    this.contextStack.unshift(context);
  }
  getActionKeyContext() {
    return this.contextStack;
  }
  exitActionKeyContext(context) {
    this.contextStack = this.contextStack.filter((item) => item !== context);
  }
  //////////////////////////////////////////
  setScope(scope) {
    this.scope = scope;
    if (this.hasScope) {
      this.enable();
    } else {
      this.disable();
    }
  }
  inScope(element) {
    var _a;
    return (_a = this.getKeyEventTarget()) == null ? void 0 : _a.contains(element);
  }
  getKeyCode(keyCode) {
    var _a;
    const map = this.getKeyboardOption("map", {});
    return (_a = map[keyCode]) != null ? _a : keyCode;
  }
  getActionKey(keyCode) {
    for (const context of this.getActionKeyContext()) {
      const map = retrieveActionKeyContext(context);
      if (map == null ? void 0 : map[keyCode]) {
        return map[keyCode];
      }
    }
    return null;
  }
  getKeyboardOption(name, dflt) {
    var _a, _b, _c, _d;
    return (_d = (_c = (_a = this.playerOptions.keyboard) == null ? void 0 : _a[name]) != null ? _c : (_b = getConfiguration().keyboard) == null ? void 0 : _b[name]) != null ? _d : dflt;
  }
  get playerOptions() {
    if (!this.playerOptions_) {
      this.playerOptions_ = this.getModel(ModelName.PlayerOptions);
    }
    return this.playerOptions_;
  }
  addListeners() {
    document.addEventListener(this.defaultKeyEventType, this.onKeydown);
    document.addEventListener(PlayerEvent.ACTION_KEY, this.onActionKeyDefault);
  }
  removeListeners() {
    document.removeEventListener(this.defaultKeyEventType, this.onKeydown);
    document.removeEventListener(PlayerEvent.ACTION_KEY, this.onActionKeyDefault);
  }
  get hasScope() {
    return this.scope && this.scope !== KeyboardScope.NONE;
  }
  createDetail(action) {
    return {
      action,
      avia: System.appNamespace,
      player: this.player,
      system: System,
      buildInfo,
      metadata: {},
      logger: this.facade.logger
    };
  }
  get playerContainer() {
    var _a;
    const domProxy = (_a = this.facade) == null ? void 0 : _a.retrieveProxy(ProxyName.PlayerDomProxy);
    return domProxy == null ? void 0 : domProxy.getMain();
  }
}
class ActivityMediator extends LogAwareMediator {
  constructor(name, data) {
    super(name);
    this.data = {};
    this.mouseDown = false;
    this.mouseOver = false;
    this.idleEvents = [
      "mousemove",
      "mousedown",
      "keypress",
      "DOMMouseScroll",
      "mousewheel",
      "touchmove",
      "touchstart",
      "MSPointerMove",
      "MSPointerDown",
      "pointermove",
      "pointerdown"
    ];
    this.data = { activeState: ActiveState.INACTIVE, idleDelay: data.idleDelay };
    this.container = data.container;
    this.document = data.document;
  }
  handleNotification(notification) {
  }
  onRegister() {
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onFocusOut = this.onFocusOut.bind(this);
    this.reset = this.reset.bind(this);
    this.idle = this.idle.bind(this);
    this.container.addEventListener("mouseenter", this.onMouseEnter);
    this.container.addEventListener("mouseleave", this.onMouseLeave);
    this.container.addEventListener("mousedown", this.onMouseDown);
    this.document.addEventListener("mouseup", this.onMouseUp);
    this.document.addEventListener("focusout", this.onFocusOut);
  }
  onRemove() {
    this.container.removeEventListener("mouseenter", this.onMouseEnter);
    this.container.removeEventListener("mouseleave", this.onMouseLeave);
    this.container.removeEventListener("mousedown", this.onMouseDown);
    this.document.removeEventListener("mouseup", this.onMouseUp);
    this.document.removeEventListener("focusout", this.onFocusOut);
    this.stop();
    this.container = null;
    this.document = null;
    super.onRemove();
  }
  applyListeners(add = true) {
    const action = add ? "add" : "remove";
    this.idleEvents.forEach((event) => this.container[`${action}EventListener`](event, this.reset, { passive: true }));
  }
  start() {
    this.stop();
    this.applyListeners();
    this.timeout = setTimeout(this.idle, this.idleDelay);
  }
  stop() {
    clearTimeout(this.timeout);
    this.applyListeners(false);
  }
  idle() {
    this.activeState = this.mouseOver ? ActiveState.IDLE : ActiveState.INACTIVE;
  }
  reset() {
    this.activeState = ActiveState.ACTIVE;
    this.start();
  }
  onMouseEnter() {
    this.reset();
    this.mouseOver = true;
    this.activeState = ActiveState.ACTIVE;
    this.start();
  }
  onMouseLeave() {
    this.reset();
    this.mouseOver = false;
    this.activeState = ActiveState.INACTIVE;
  }
  onMouseDown() {
    this.mouseDown = true;
  }
  onMouseUp() {
    if (!this.mouseDown) {
      return;
    }
    this.mouseDown = false;
    this.start();
  }
  onFocusOut(event) {
    const { relatedTarget } = event;
    const active = this.container.contains(relatedTarget);
    if (active) {
      this.stop();
    }
    this.activeState = active ? ActiveState.ACTIVE : ActiveState.INACTIVE;
  }
  set activeState(value) {
    if (this.mouseDown) {
      value = ActiveState.ACTIVE;
    }
    if (value === this.data.activeState) {
      return;
    }
    this.data.activeState = value;
    this.sendNotification(PlayerEvent.ACTIVE_STATE_CHANGE, { activeState: value });
  }
  get activeState() {
    return this.data.activeState;
  }
  get idleDelay() {
    return this.data.idleDelay;
  }
}
class AppMediator extends LogAwareMediator {
  constructor(name, app) {
    super(name);
    this.app = app;
  }
  get presentationMediator() {
    return this.facade.retrieveMediator(MediatorName.PRESENTATION_MEDIATOR);
  }
  get actionKeyMediator() {
    return this.facade.retrieveMediator(MediatorName.KEY_COMMAND);
  }
  getBuffered(asStreamTime = false) {
    var _a;
    return ((_a = this.presentationMediator) == null ? void 0 : _a.getBuffered(asStreamTime)) || [];
  }
  primeVideoElement() {
    var _a;
    const domProxy = this.facade.retrieveProxy(ProxyName.PlayerDomProxy);
    const opts = this.getModel(ModelName.PlayerOptions);
    return domProxy.primeVideo((_a = opts.overrides) == null ? void 0 : _a.blankVideoUrl);
  }
  offsetTimedText(pixelOffset) {
    var _a;
    (_a = this.presentationMediator) == null ? void 0 : _a.offsetTimedText(pixelOffset);
  }
  setFullscreenElement(el) {
    const fsm = this.facade.retrieveMediator(MediatorName.FULLSCREEN);
    fsm.fullscreenElement = el;
  }
  getFullscreenElement() {
    const fsm = this.facade.retrieveMediator(MediatorName.FULLSCREEN);
    return fsm.fullscreenElement;
  }
  getSessionTime() {
    var _a;
    return ((_a = this.presentationMediator) == null ? void 0 : _a.getSessionTime()) || null;
  }
  getPlaybackTime() {
    var _a;
    return ((_a = this.presentationMediator) == null ? void 0 : _a.getPlaybackTime()) || null;
  }
  updateDimensions() {
    var _a;
    (_a = this.presentationMediator) == null ? void 0 : _a.checkSize();
  }
  onRemove() {
    this.app = null;
    super.onRemove();
  }
  getAppApi() {
    return this.app.getApi();
  }
  getConfigAsJson(spacing = 2) {
    const model = this.getProxy(ProxyName.ModelCollectionProxy);
    const playerOptions = model.getModel(ModelName.PlayerOptions).data;
    return JSON.stringify(
      {
        resource: this.getCurrentResource(),
        playerOptions,
        buildInfo
      },
      (key, value) => value instanceof HTMLElement ? void 0 : value,
      spacing
    );
  }
  validateSeek(position, duration) {
    if (isNaN(position)) {
      this.logger.warn(`Invalid seek() time [${position}] supplied`);
      return null;
    }
    const pm = this.getModel(ModelName.PresentationState);
    const pbp = this.getProxy(ProxyName.ContentPlaybackStateProxy);
    const linear = pbp && pbp.model.streamType === StreamType.LIVE;
    if (!pm || !pbp || pm.isTrackingAd || linear) {
      this.logger.warn("seek() may not be called in the current context");
      return null;
    }
    return clampValue(position, 0, duration);
  }
  isPlaybackSuspended() {
    const pm = this.getModel(ModelName.PresentationState);
    return pm.suspended;
  }
  getContainerRect() {
    const domProxy = this.getProxy(ProxyName.PlayerDomProxy);
    return domProxy ? domProxy.getPresentationRect() : null;
  }
  getCurrentResource() {
    const p = this.getProxy(ProxyName.ResourceProxy);
    return (p == null ? void 0 : p.resource) || null;
  }
  killCurrentResource() {
    const resourceProxy = this.getProxy(ProxyName.ResourceProxy);
    if (!resourceProxy) {
      return Promise.resolve();
    }
    const resource = resourceProxy.resource;
    const playbackProxy = this.getProxy(ProxyName.ContentPlaybackStateProxy);
    const isLive = playbackProxy.model.streamType === StreamType.LIVE || playbackProxy.model.streamType === StreamType.LTS;
    const pm = this.presentationMediator;
    this.logger.info("Killing current resource");
    if (pm) {
      return pm.close().then(() => {
        isLive && this.sendNotification(PlayerEvent.LIVE_PRESENTATION_STOPPED, { resource });
      }).catch((e) => {
        this.logger.error(e);
      });
    } else {
      return Promise.resolve();
    }
  }
  skipAd() {
    const pm = this.presentationMediator;
    pm.skipAd();
  }
  getPlugin(name) {
    const pim = this.facade.retrieveMediator(MediatorName.PLUGIN_MEDIATOR);
    return pim ? pim.getPlugin(name) : null;
  }
  dispatchPluginEvent(data) {
    this.app.sendEvent(PlayerEvent.PLUGIN_EVENT, data);
  }
  getMuteState() {
    const presoModel = this.getModel(ModelName.PresentationState);
    return presoModel ? presoModel.isMuted : null;
  }
  getVolume() {
    const presoModel = this.getModel(ModelName.PresentationState);
    return presoModel ? presoModel.volume : NaN;
  }
  getDimensions() {
    const domProxy = this.getProxy(ProxyName.PlayerDomProxy);
    return domProxy ? domProxy.getDimensions() : null;
  }
  getAdBreakTimes() {
    var _a;
    return ((_a = this.presentationMediator) == null ? void 0 : _a.getAdBreakTimes()) || null;
  }
  grabFrame() {
    const videoProxy = this.getProxy(ProxyName.VideoProxy);
    const vidEl = videoProxy == null ? void 0 : videoProxy.getVideo();
    if (!vidEl) {
      return null;
    }
    const cvs = document.createElement("canvas");
    const ctx = cvs.getContext("2d");
    const w = cvs.width = vidEl.videoWidth;
    const h = cvs.height = vidEl.videoHeight;
    ctx.drawImage(vidEl, 0, 0, w, h);
    const dUrl = cvs.toDataURL();
    const img = document.createElement("img");
    img.setAttribute("src", dUrl);
    return img;
  }
  getKeyEventTarget() {
    var _a;
    return (_a = this.actionKeyMediator) == null ? void 0 : _a.getKeyEventTarget();
  }
  disableKeyCommands(flag = true) {
    var _a, _b;
    if (flag) {
      (_a = this.actionKeyMediator) == null ? void 0 : _a.disable();
    } else {
      (_b = this.actionKeyMediator) == null ? void 0 : _b.enable();
    }
  }
  enterActionKeyContext(context) {
    var _a;
    (_a = this.actionKeyMediator) == null ? void 0 : _a.enterActionKeyContext(context);
  }
  getActionKeyContext() {
    var _a;
    return (_a = this.actionKeyMediator) == null ? void 0 : _a.getActionKeyContext();
  }
  exitActionKeyContext(context) {
    var _a;
    (_a = this.actionKeyMediator) == null ? void 0 : _a.exitActionKeyContext(context);
  }
  listNotificationInterests() {
    return values(PlayerEvent);
  }
  sendErrorEvent(type, error) {
    this.app.sendEvent(type, error);
  }
  handleNotification(notification) {
    this.app.sendEvent(notification.name, notification.body);
  }
  onRegister() {
    super.onRegister();
  }
}
class FullscreenMediator extends LogAwareMediator {
  constructor(name, viewControl) {
    super(name, viewControl);
    this.isFullscreen = false;
    this.fsElement = null;
    this.enabled = false;
    this.pIsAndroidFirefox = null;
    this.fsApiSupported = true;
    this.fsMgr = null;
    this.useCustomFullscreen = true;
    this.metadataLoadedDelayHandle = null;
    this.iosPropNames = {
      ENTER_EVENT: "webkitbeginfullscreen",
      EXIT_EVENT: "webkitendfullscreen",
      ENTER_METHOD: "webkitEnterFullscreen",
      EXIT_METHOD: "webkitExitFullscreen",
      SUPPORTED: "webkitSupportsFullscreen"
    };
    this.fsMgr = screenfull;
    this.changeHandler = (e) => this.hChange(e);
  }
  set fullscreenElement(el) {
    if (!(el instanceof HTMLElement)) {
      return;
    }
    const sys = this.system;
    if (!sys.isIos && !sys.isAndroid) {
      this.fsElement = el;
    }
  }
  get fullscreenElement() {
    return this.fsElement;
  }
  onRemove() {
    clearTimeout(this.metadataLoadedDelayHandle);
    if (!this.fsApiSupported && this.fsElement) {
      this.fsElement.removeEventListener(this.iosPropNames.ENTER_EVENT, this.changeHandler);
      this.fsElement.removeEventListener(this.iosPropNames.EXIT_EVENT, this.changeHandler);
    }
    if (this.fsMgr && isFunction(this.fsMgr.off)) {
      this.fsMgr.off("change", this.changeHandler);
    }
    this.fsElement = null;
    this.fsMgr = null;
    super.onRemove();
  }
  enter() {
    if (!this.enabled) {
      return;
    }
    if (this.useCustomFullscreen) {
      this.isFullscreen = true;
      this.sendFullscreenNotification();
      return;
    }
    this.fsApiSupported ? this.fsMgr.request(this.fsElement) : this.enterFsIos();
  }
  exit() {
    if (!this.enabled) {
      return;
    }
    if (this.useCustomFullscreen) {
      this.isFullscreen = false;
      this.sendFullscreenNotification();
      return;
    }
    this.fsApiSupported ? this.fsMgr.exit() : this.exitFsIos();
  }
  isFullScreenPermitted() {
    return this.enabled;
  }
  isFullScreen() {
    return this.isFullscreen;
  }
  ///////////////////////////////////
  // PRIVATE / MVC
  get isAndroidFirefox() {
    if (this.pIsAndroidFirefox == null) {
      const sys = this.system;
      this.pIsAndroidFirefox = sys.os === Os.ANDROID && sys.browser === Browser.FIREFOX;
    }
    return this.pIsAndroidFirefox;
  }
  handleNotification(notification) {
    const n = notification.name;
    if (n === PlayerEvent.VIDEO_ELEMENT_ADDED) {
      this.onRegister();
      return;
    }
    if (n === PlayerEvent.STREAM_METADATA) {
      this.metadataLoadedDelayHandle = setTimeout(() => this.handleMetadataLoaded(), 20);
      return;
    }
    if (!this.enabled) {
      return;
    }
    const enter = n === NotificationName.ENTER_FULLSCREEN_REQUEST;
    enter ? this.enter() : this.exit();
  }
  listNotificationInterests() {
    return [
      PlayerEvent.VIDEO_ELEMENT_ADDED,
      PlayerEvent.STREAM_METADATA,
      NotificationName.ENTER_FULLSCREEN_REQUEST,
      NotificationName.EXIT_FULLSCREEN_REQUEST
    ];
  }
  handleMetadataLoaded() {
    this.enabled = this.enabled || this.webkitIosEnabled();
    this.enabled && this.sendNotification(NotificationName.FULLSCREEN_AVAILABLE, null);
  }
  hChange(e) {
    this.isFullscreen = this.fsApiSupported ? screenfull.isFullscreen : this.checkWebkitIosState(e);
    if (this.isAndroidFirefox) {
      this.isFullscreen && this.fsElement.setAttribute("controls", "");
      !this.isFullscreen && this.fsElement.removeAttribute("controls");
    }
    this.sendFullscreenNotification();
  }
  sendFullscreenNotification() {
    this.sendNotification(
      NotificationName.FULLSCREEN_CHANGE,
      { isFullscreen: this.isFullscreen },
      NotificationType.INTERNAL
    );
  }
  enterFsIos() {
    this.fsElement[this.iosPropNames.ENTER_METHOD]();
  }
  exitFsIos() {
    this.fsElement[this.iosPropNames.EXIT_METHOD]();
  }
  webkitIosEnabled() {
    return this.system.isIos && this.fsElement[this.iosPropNames.SUPPORTED];
  }
  checkWebkitIosState(e) {
    return e.type === this.iosPropNames.ENTER_EVENT;
  }
  onRegister() {
    this.useCustomFullscreen = !this.getModel(ModelName.PlayerOptions).useNativeFullscreen;
    if (this.useCustomFullscreen) {
      this.enabled = true;
      return;
    }
    const dp = this.facade.retrieveProxy(ProxyName.PlayerDomProxy);
    const videoProxy = this.facade.retrieveProxy(ProxyName.VideoProxy);
    const supportsFsApi = this.fsMgr.isEnabled;
    if (!supportsFsApi) {
      this.fsApiSupported = false;
      this.fsElement = videoProxy.getVideo();
    } else {
      this.fsElement = dp.getMain();
    }
    if (this.fsApiSupported && this.fsElement && this.fsMgr.isEnabled) {
      this.enabled = true;
      this.fsMgr.on("change", this.changeHandler);
    } else if (this.fsElement && !this.fsApiSupported) {
      this.fsElement.addEventListener(this.iosPropNames.ENTER_EVENT, this.changeHandler);
      this.fsElement.addEventListener(this.iosPropNames.EXIT_EVENT, this.changeHandler);
    }
  }
}
class PrepViewCommand extends LogAwareSimpleCommand {
  execute(notification) {
    const facade = this.facade;
    const app = notification.body.app;
    facade.registerMediator(new AppMediator(MediatorName.APPLICATION, app));
    const system = this.system;
    if (!system.isBrowser) {
      this.logger.info("Skipping view creation");
      return;
    }
    if (!system.isTv) {
      facade.registerMediator(new FullscreenMediator(MediatorName.FULLSCREEN));
    }
    const { playerOptions } = notification.body;
    const domProxy = this.facade.retrieveProxy(ProxyName.PlayerDomProxy);
    const scope = this.getScope(system, playerOptions);
    const actionKeyMediator = new ActionKeyMediator(MediatorName.KEY_COMMAND, scope);
    facade.registerMediator(actionKeyMediator);
    this.logger.info(`Key handling scope is "${scope}"`);
    const target = actionKeyMediator.getKeyEventTarget();
    const container = domProxy.getMain();
    this.facade.registerMediator(new ActivityMediator(MediatorName.ACTIVITY, {
      container: target && target !== system.document ? target : container,
      document: system.document,
      idleDelay: playerOptions.idleDelay
    }));
    this.logger.debug("View prepared");
  }
  getScope(system, playerOptions) {
    var _a;
    let playerScopeObj = {};
    if ((_a = playerOptions.keyboard) == null ? void 0 : _a.scope) {
      playerScopeObj = playerOptions.keyboard;
    } else if (playerOptions.keyboardScope) {
      playerScopeObj = { scope: playerOptions.keyboardScope };
    }
    const { keyboard } = getConfiguration();
    const { scope } = merge({}, keyboard || {}, playerScopeObj);
    if (!system.isBrowser) {
      return KeyboardScope.NONE;
    }
    return scope || KeyboardScope.DOCUMENT;
  }
}
class BootCommand extends AbstractMacroCommand {
  initializeMacroCommand() {
    this.addSubCommand(PrepModelCommand);
    this.addSubCommand(CreateDomCommand);
    this.addSubCommand(PrepTimerCommand);
    this.addSubCommand(PrepViewCommand);
    this.addSubCommand(PrepPluginsCommand);
  }
}
class HandleErrorCommand extends LogAwareSimpleCommand {
  execute(notification) {
    const appMed = this.facade.retrieveMediator(MediatorName.APPLICATION);
    if (!appMed) {
      return;
    }
    const name = notification.name;
    const body = notification.body;
    const details = body.error || body;
    this.setDetails(name, details);
    if (details.fatal) {
      this.logger.error(details.message);
    } else {
      this.logger.warn(details.message);
    }
    this.sendNotification(PlayerEvent.ERROR, { error: details });
  }
  setDetails(name, info) {
    let cat = null;
    let msg = null;
    switch (name) {
      case NotificationName.RESOURCE_ERROR:
        cat = ErrorCategory.RESOURCE;
        break;
      case NotificationName.VIDEO_START_ERROR:
        cat = ErrorCategory.VIDEO_START;
        break;
      case NotificationName.VIDEO_PLAYBACK_ERROR:
        cat = ErrorCategory.PLAYBACK;
        break;
      case NotificationName.AD_ERROR:
        cat = ErrorCategory.AD;
        break;
      case NotificationName.AD_STALLED:
        cat = ErrorCategory.AD;
        msg = ErrorMessage.AD_STALLED;
        break;
    }
    if (msg) {
      info.message = msg;
    }
    if (cat) {
      info.category = cat;
    }
  }
}
class KillResourcePresentationCommand extends LogAwareSimpleCommand {
  execute(notification) {
    this.facade.removeMediator(MediatorName.PRESENTATION_MEDIATOR);
    this.facade.removeProxy(ProxyName.ResourceProxy);
    this.facade.removeProxy(ProxyName.ContentPlaybackStateProxy);
    const p = this.facade.retrieveProxy(ProxyName.ModelCollectionProxy);
    p.reset();
  }
}
class LocalizationCommand extends LogAwareSimpleCommand {
  execute(notification) {
    const { name, body } = notification;
    switch (name) {
      case NotificationName.CHANGE_LANGUAGE:
        const localization2 = this.facade.retrieveProxy(ProxyName.LocalizationProxy);
        const { language } = body;
        localization2.changeLanguage(language).then((localeData) => {
          const dom = this.facade.retrieveProxy(ProxyName.PlayerDomProxy);
          if (dom) {
            const main = dom.getMain();
            main.setAttribute("aria-label", localization2.localize(LocalizationId.MEDIA_PLAYER));
            main.setAttribute("lang", localization2.language);
          }
          this.sendNotification(PlayerEvent.LANGUAGE_CHANGE, { language });
          this.sendNotification(NotificationName.LOCALIZATION_CHANGE, { localeData });
        });
        break;
    }
  }
}
function getKey(value) {
  return `${value.id}:${value.name}`;
}
const WARNING = "Performance API error";
class MetricCommand extends LogAwareSimpleCommand {
  execute(notification) {
    var _a, _b;
    const { type, value } = notification.body.metric;
    if (!performance) {
      return;
    }
    switch (type) {
      case MetricType.MARK:
        try {
          (_a = performance.mark) == null ? void 0 : _a.call(performance, getKey(value), { startTime: value.startTime });
        } catch (error) {
          this.logger.warn(`${WARNING}: ${error}`);
        }
        break;
      case MetricType.MEASURE:
        try {
          const key = getKey(value);
          (_b = performance == null ? void 0 : performance.measure) == null ? void 0 : _b.call(performance, key, key + ":start", key + ":end");
        } catch (error) {
          this.logger.warn(`${WARNING}: ${error}`);
        }
        break;
    }
  }
}
class PlaybackCommand extends LogAwareSimpleCommand {
  execute(notification) {
    var _a;
    const presoMediator = this.facade.retrieveMediator(MediatorName.PRESENTATION_MEDIATOR);
    const resourceProxy = this.facade.retrieveProxy(ProxyName.ResourceProxy);
    const resource = resourceProxy == null ? void 0 : resourceProxy.resource;
    const cps = (_a = this.contentPlaybackStateProxy) == null ? void 0 : _a.model;
    if (!cps || !resource) {
      this.logger.debug("play() can not be invoked in this context.");
      return;
    }
    switch (notification.name) {
      case NotificationName.PLAY:
        const hasPreso = !!presoMediator, started = hasPreso && this.getModel(ModelName.PresentationState).started;
        if (hasPreso && notification.type === NotificationType.EXTERNAL && !started) {
          this.invokePlayOnUserGesture(presoMediator);
        } else if (started) {
          presoMediator == null ? void 0 : presoMediator.play();
        }
        break;
      case NotificationName.PAUSE:
        presoMediator == null ? void 0 : presoMediator.pause();
        break;
      case NotificationName.SEEK:
        presoMediator.seek(notification.body.value);
        break;
      case NotificationName.SWITCH_AUDIO_TRACK:
        presoMediator.adapter.setAudioTrack(notification.body.value);
        break;
      case NotificationName.SWITCH_TEXT_TRACK:
        const track = notification.body.value;
        if (track) {
          this.facade.retrieveProxy(ProxyName.TextTrackProxy).language = track.language;
          const textTrack = this.contentPlaybackStateProxy.getTextTrackById(track.id);
          presoMediator.adapter.setTextTrack(textTrack);
        }
        break;
      case NotificationName.SWITCH_TEXT_MODE:
        const enabled = notification.body.value;
        const textTrackProxy = this.facade.retrieveProxy(ProxyName.TextTrackProxy);
        textTrackProxy.enabled = enabled;
        if (presoMediator == null ? void 0 : presoMediator.adapter) {
          presoMediator.adapter.setTextTrackMode(textTrackProxy.mode);
        }
        break;
      case PlayerEvent.MUTE_CHANGE:
        presoMediator.mute(notification.body.muted);
        break;
      case PlayerEvent.VOLUME_CHANGE:
        const value = notification.body.volume;
        !isNaN(value) && presoMediator.setVolume(value);
        break;
    }
  }
  get contentPlaybackStateProxy() {
    return this.facade.retrieveProxy(ProxyName.ContentPlaybackStateProxy);
  }
  invokePlayOnUserGesture(presoMediator) {
    const domProxy = this.facade.retrieveProxy(ProxyName.PlayerDomProxy);
    const playerOpts = this.getModel(ModelName.PlayerOptions);
    const overrides = playerOpts.overrides;
    const sys = this.system;
    const shouldSkipPriming = !domProxy || sys.supportsUnrestrictedAutoplay || (overrides == null ? void 0 : overrides.skipPriming) === true;
    presoMediator.beforePlayOnUserGesture();
    if (!shouldSkipPriming) {
      const p = domProxy.primeVideo(overrides == null ? void 0 : overrides.blankVideoUrl);
      p.then(() => {
        if (sys.device === Device.IPHONE) {
          const ev = "timeupdate";
          const v = this.facade.retrieveProxy(ProxyName.VideoProxy).getVideo(), h = (e) => {
            v.removeEventListener(ev, h);
            setTimeout(() => presoMediator.playOnUserGesture(), 200);
          };
          v.addEventListener(ev, h);
        } else {
          presoMediator.playOnUserGesture();
        }
      }).catch((error) => {
        this.logger.error(`ERROR - PlaybackCommand: Priming FAILED.  ${error.message}`);
        this.facade.sendNotification(PlayerEvent.AUTOPLAY_BLOCKED, error, NotificationType.INTERNAL);
      });
    } else {
      presoMediator && presoMediator.playOnUserGesture();
    }
  }
}
class ContentPlaybackStateProxy extends Proxy2 {
  constructor() {
    super(...arguments);
    this.isReady = false;
    this.pUserQualityCategory = QualityCategory.AUTO;
  }
  onRegister() {
    super.onRegister();
    const mcp = this.facade.retrieveProxy(ProxyName.ModelCollectionProxy);
    this.contentPlaybackState = mcp.getModel(ContentPlaybackState.modelName);
    this.isReady = true;
  }
  onRemove() {
    this.contentPlaybackState = null;
    this.thumbnailTrack = null;
    super.onRemove();
  }
  processQualityProfile(qualities) {
    const frozen = freeze(qualities.map((quality) => processQuality(quality)));
    this.contentPlaybackState.qualities = frozen;
    if (this.qualitySwitchingMode !== QualityMode.MANUAL) {
      this.qualitySwitchingMode = qualities.length ? QualityMode.AUTO : QualityMode.UNAVAILABLE;
    }
  }
  addTextTracks(tracks) {
    this.contentPlaybackState.textTracks = tracks;
  }
  getTextTrackById(id) {
    return this.contentPlaybackState.textTracks.find((track) => track.id === id);
  }
  getThumbnail(time) {
    var _a;
    return (_a = this.thumbnailTrack) == null ? void 0 : _a.getCueAt(time);
  }
  get textTracks() {
    return this.contentPlaybackState.textTracks;
  }
  set textTrack(value) {
    this.contentPlaybackState.textTrack = value;
  }
  get textTrack() {
    return this.contentPlaybackState.textTrack;
  }
  get isAbrSwitchingAvailable() {
    return this.qualities ? this.qualities.length > 1 : false;
  }
  set userQualityCategory(q) {
    this.pUserQualityCategory = q;
  }
  get userQualityCategory() {
    return this.pUserQualityCategory;
  }
  set qualitySwitchingMode(mode) {
    this.contentPlaybackState.qualityMode = mode;
  }
  get qualitySwitchingMode() {
    return this.contentPlaybackState.qualityMode;
  }
  set qualities(value) {
    this.contentPlaybackState.qualities = value;
  }
  get qualities() {
    return this.contentPlaybackState.qualities;
  }
  set maxBandwidth(value) {
    this.contentPlaybackState.maxBandwidth = isNaN(this.contentPlaybackState.maxBandwidth) ? value : Math.max(value, this.contentPlaybackState.maxBandwidth);
  }
  get model() {
    return this.contentPlaybackState;
  }
  get minIndex() {
    return this.contentPlaybackState.qualities.findIndex((quality) => quality.enabled);
  }
  get maxIndex() {
    return this.contentPlaybackState.qualities.reduce((result, quality, index2) => {
      return quality.enabled ? index2 : result;
    }, 0);
  }
  get minBitrate() {
    return this.contentPlaybackState.qualities[this.minIndex].bitrate;
  }
  get maxBitrate() {
    return this.contentPlaybackState.qualities[this.maxIndex].bitrate;
  }
  get quality() {
    return this.contentPlaybackState.quality;
  }
  set quality(value) {
    this.contentPlaybackState.quality = value;
  }
  set qualityCappedToScreenSize(value) {
    this.contentPlaybackState.qualityCappedToScreenSize = value;
  }
  get qualityCappedToScreenSize() {
    return this.contentPlaybackState.qualityCappedToScreenSize;
  }
  get audioTracks() {
    return this.contentPlaybackState.audioTracks;
  }
  set audioTracks(value) {
    this.contentPlaybackState.audioTracks = value;
  }
  get audioTrack() {
    return this.contentPlaybackState.audioTrack;
  }
  set audioTrack(value) {
    this.contentPlaybackState.audioTrack = value;
  }
}
class ResourceProxy extends Proxy2 {
  //TODO: can we annotate to be removed during compilation? Or use Object.assign?
  mock(r) {
    this.pResource = r;
  }
  onRemove() {
    this.pResource = null;
    super.onRemove();
  }
  onRegister() {
    super.onRegister();
    this.pResource = this.data;
  }
  get resource() {
    return this.pResource;
  }
  get location() {
    return this.pResource.location;
  }
  get playback() {
    return this.pResource.playback;
  }
  get metadata() {
    return this.pResource.metadata;
  }
  get ad() {
    return this.pResource.ad;
  }
  get adTrackingSettings() {
    return this.pResource.ad.viewabilityTracking;
  }
  get hasValidMediaUrl() {
    return !isEmpty(this.location.mediaUrl);
  }
}
class WebVTTParser {
  /**
   * Parses a single WebVTT caption into a CaptionCue.
   *
   * @param caption - The text of the caption
   * @returns The CaptionCue
   */
  static parseCaption(caption, id = 0, style = {}) {
    const parts = caption.trim().split("\n");
    const timecode = /([0-9:.]+)\s*-->\s*([0-9:.]+)([^\n]*)/;
    const setting = /\s*([A-Za-z]+)\s*:\s*([\w\-%]+)/g;
    try {
      if (!timecode.test(parts[0])) {
        id = parseInt(parts.shift());
      }
      const times = parts[0].match(timecode).slice(1);
      const settings = times[2];
      const startTime = hmsToSec(times[0]);
      const endTime = hmsToSec(times[1]);
      const text = parts.slice(1).join("\n");
      if (settings != null) {
        settings.replace(setting, (match, key, value) => style[key] = value);
      }
      return __spreadValues({ id, startTime, endTime, text }, style);
    } catch (error) {
      return null;
    }
  }
  /**
   * Parses a WebVTT file into CaptionCue objects and attaches them to a given track.
   *
   * @param txt -   The text of the webvtt file
   * @returns The populated caption track
   */
  static parse(txt) {
    txt = txt.replace(/\r/g, "");
    const captions = txt.split("\n\n");
    const ignore = /^(WEBVTT|NOTE|STYLE)/;
    const cues = captions.reduce((acc, caption) => {
      if (!(ignore.test(caption) || !caption)) {
        const cue = this.parseCaption(caption, acc.length);
        if (cue) {
          acc.push(cue);
        }
      }
      return acc;
    }, []);
    return cues;
  }
}
class ThumbnailTrackSurface {
  constructor(url, cues) {
    this.url = url;
    this.cues = cues;
  }
  getCueAt(time) {
    return this.cues.find((cue) => cue.startTime <= time && cue.endTime >= time);
  }
  renderCueAt(time, container) {
    renderThumbnail(this.getCueAt(time), container);
  }
  static create(url, hookManager2) {
    const a = document.createElement("a");
    a.href = url;
    const absolute = a.protocol + "//" + a.hostname;
    const relative = absolute + a.pathname.split("/").slice(0, -1).join("/") + "/";
    return hookManager2.applyHook(PlayerHookType.REQUEST, { url }, { objectType: RequestObjectType.OTHER }).then((req) => request(req)).then((response) => hookManager2.applyHook(PlayerHookType.RESPONSE, { url, data: response }, { objectType: RequestObjectType.OTHER })).then((response) => response.data).then((response) => {
      const cues = WebVTTParser.parse(response);
      cues.forEach((cue) => {
        const [file, params] = cue.text.split("#");
        let src = file;
        if (!/^(https?:)?\/\//.test(src)) {
          if (/^\//.test(src)) {
            src = absolute + src;
          } else {
            src = relative + src;
          }
        }
        const kv = params.split("=");
        const keys = kv[0];
        const values2 = kv[1].split(",");
        const style = {
          backgroundImage: `url(${src})`
        };
        const data = { url: src };
        forEach(keys, (key, i) => {
          const value = values2[i];
          switch (key) {
            case "w":
              data.width = parseInt(value);
              style.width = `${value}px`;
              break;
            case "h":
              data.height = parseInt(value);
              style.height = `${value}px`;
              break;
            case "x":
              data.x = parseInt(value);
              style.backgroundPositionX = `-${value}px`;
              break;
            case "y":
              data.y = parseInt(value);
              style.backgroundPositionY = `-${value}px`;
          }
        });
        cue.style = style;
        cue.data = data;
      });
      return new ThumbnailTrackSurface(url, cues);
    });
  }
}
class AbstractPresentationMediator extends LogAwareMediator {
  constructor() {
    super(...arguments);
    this.loaded = false;
    this.startedPlaying = false;
    this.preloadContent = true;
    this.minLtsThreshold = 1800;
    this.sizeCheckInterval = 1e3;
    this.lastSizeCheckTime = null;
    this.adapterTask = Promise.resolve();
    this.seeking_ = false;
    this.paused_ = false;
    this.previousPlaybackState = {
      state: null,
      overrides: {},
      buffer: NaN
    };
    this.contentIsBuffering = false;
    this.endFreezeTimeoutHandle = null;
    this.timedTextOffset = 0;
    this.isMonitoringCueEvents = false;
    this.endFreezeThreshold = 0.75;
    this.endFreezeDebounceDelay = 200;
    this.shouldSendTextTrackAvailable = false;
    this.onLoadError = (error) => {
      const { message, cause } = error;
      this.sendErrorNotification(message, cause || error);
    };
    this.qualityChange = (quality) => {
      var _a, _b;
      if (!quality) {
        this.logger.warn("Invalid quality change");
        return;
      }
      const { contentPlaybackStateProxy } = this;
      if (!((_a = contentPlaybackStateProxy.qualities) == null ? void 0 : _a.length)) {
        this.logger.warn("Invalid qualities list. Make sure qualitiesChange is called before qualityChange");
        return;
      }
      if (quality.enabled === false) {
        const qualities = contentPlaybackStateProxy.qualities.map((q) => __spreadProps(__spreadValues({}, q), { enabled: q.enabled || q.index === quality.index }));
        this.qualitiesChange(qualities);
      }
      const frozenQuality = contentPlaybackStateProxy.qualities.find((q) => q.index === quality.index);
      if (((_b = contentPlaybackStateProxy.quality) == null ? void 0 : _b.bitrate) !== frozenQuality.bitrate) {
        contentPlaybackStateProxy.quality = frozenQuality;
        contentPlaybackStateProxy.model.bitrate = frozenQuality.bitrate;
        this.respondToQualityChange(frozenQuality);
      }
    };
    this.qualitiesChange = (qualities) => {
      const { contentPlaybackStateProxy } = this;
      const { model } = contentPlaybackStateProxy;
      this.contentPlaybackStateProxy.processQualityProfile(qualities);
      if (!contentPlaybackStateProxy.isAbrSwitchingAvailable) {
        this.logger.info(AppResources.messages.ABR_UNAVAILABLE);
      }
      this.logger.info("Qualities: ", model.qualities);
      this.notify(PlayerEvent.QUALITIES_CHANGE, { qualities: model.qualities });
    };
    this.error = (err) => {
      if (err.fatal) {
        this.adapterTask = Promise.resolve();
      }
      this.respondToError(err);
    };
    this.audioTrackChange = (audioTrack) => {
      audioTrack = clone(audioTrack, true);
      this.contentPlaybackStateProxy.audioTrack = audioTrack;
      this.notify(PlayerEvent.AUDIO_TRACK_CHANGE, { audioTrack });
    };
    this.audioTracksChange = (audioTracks) => {
      audioTracks = clone(audioTracks, true);
      this.contentPlaybackStateProxy.audioTracks = audioTracks;
      this.notify(PlayerEvent.AUDIO_TRACKS_CHANGE, { audioTracks });
    };
    this.cdnChange = (cdn) => {
      const { contentPlaybackStateProxy } = this;
      if (cdn !== contentPlaybackStateProxy.model.cdn) {
        contentPlaybackStateProxy.model.cdn = cdn;
        this.notify(PlayerEvent.CDN_CHANGE, { cdn });
      }
    };
    this.drmKeySystemCreated = (keysystem) => {
      this.contentPlaybackStateProxy.model.drmType = keysystem;
      this.notify(PlayerEvent.DRM_KEY_SYSTEM_CREATED, { keysystem });
    };
    this.timeUpdate = () => {
      if (!this.pAdapter) {
        return;
      }
      const t = this.pAdapter.getCurrentTime();
      const d = this.presoModel.streamDuration;
      this.updateLiveStreamInfo();
      if (!this.pAdapter.getIsLiveStream() && !isNaN(d) && d - t <= this.endFreezeThreshold) {
        this.respondToVideoEndDebounced();
      }
      this.respondToVideoTimeUpdate(t);
    };
    this.playing = () => {
      this.paused_ = false;
      this.updateLiveStreamInfo();
      this.respondToVideoPlaying();
    };
    this.paused = () => {
      this.paused_ = true;
      this.respondToVideoPaused();
    };
    this.seeking = () => {
      if (!this.seeking_) {
        this.seeking_ = true;
        this.respondToVideoSeeking();
        this.respondToWaiting("seeking", true);
      }
    };
    this.seeked = () => {
      this.seeking_ = false;
      this.respondToVideoSeeked();
      this.respondToWaiting("seeking", false);
    };
    this.ended = () => {
      this.respondToVideoEndDebounced.cancel();
      this.respondToVideoEnd();
    };
    this.durationChange = () => {
      const duration = this.pAdapter.getDuration();
      if (duration > 0) {
        this.respondToDurationChange(duration);
      }
      this.updateLiveStreamInfo();
    };
    this.volumeChange = (volume, muted) => {
      if (volume !== this.presoModel.volume) {
        this.notify(PlayerEvent.VOLUME_CHANGE, { volume });
      }
      if (muted != null && muted !== this.presoModel.isMuted) {
        this.notify(PlayerEvent.MUTE_CHANGE, { muted });
      }
    };
    this.metadataCuepoint = (data) => {
      this.respondToId3Data(data);
    };
    this.textCuepoints = (activeCues, forced = false) => {
      if (!this.textTrackProxy.enabled && !forced) {
        return;
      }
      if (this.isMonitoringCueEvents) {
        activeCues.forEach((cue) => this.respondToTtCue(cue));
      }
      this.notify(PlayerEvent.TEXT_CUEPOINT, { activeCues, forced });
    };
    this.textTrackDisplayModeChange = (mode) => {
      const textTrackEnabled = mode !== TextTrackMode.DISABLED;
      this.textTrackProxy.mode = mode;
      this.notify(PlayerEvent.TEXT_TRACK_ENABLED_CHANGE, { textTrackEnabled });
      this.respondToTextTrackModeChange(textTrackEnabled);
    };
    this.textTracksChange = (textTracks) => {
      textTracks = clone(textTracks, true);
      this.contentPlaybackStateProxy.addTextTracks(textTracks);
      this.notify(PlayerEvent.TEXT_TRACKS_CHANGE, { textTracks });
      this.shouldSendTextTrackAvailable = true;
      this.respondToTextTrackInfoChange();
    };
    this.textTrackChange = (textTrack) => {
      textTrack = clone(textTrack, true);
      this.contentPlaybackStateProxy.textTrack = textTrack;
      this.notify(PlayerEvent.TEXT_TRACK_CHANGE, { textTrack });
      this.respondToTextTrackInfoChange();
    };
    this.waitingChange = (waiting) => {
      this.respondToWaiting("waiting", waiting);
      this.notify(PlayerEvent.WAITING_CHANGE, { waiting });
    };
  }
  get adapter() {
    return this.pAdapter;
  }
  get timedTextContainer() {
    if (!this.timedTextContainer_) {
      const dp = this.facade.retrieveProxy(ProxyName.PlayerDomProxy);
      this.timedTextContainer_ = dp.getElement(PlayerDom$1.CC_CONTAINER);
    }
    return this.timedTextContainer_;
  }
  onRemove() {
    var _a;
    (_a = this.respondToVideoEndDebounced) == null ? void 0 : _a.cancel();
    this.pAdapter = null;
    this.contentPlaybackStateProxy = null;
    this.resourceProxy = null;
    this.textTrackProxy = null;
    this.presoModel = null;
    this.playerOptions = null;
    super.onRemove();
  }
  setVolume(value) {
    this.presoModel.volume = value;
  }
  load() {
    return this.loadVideo().catch((error) => {
      const detail = error.type ? error.data || error.detail : null;
      const cause = detail ? detail.error || detail : error;
      throw new CoreError(NotificationName.VIDEO_START_ERROR, cause);
    });
  }
  play() {
    return this.playVideo();
  }
  pause() {
    this.pauseVideo();
  }
  suspend() {
    this.pAdapter.suspend();
  }
  resume() {
    this.pAdapter.resume();
  }
  offsetTimedText(pixelOffset) {
    const isOffset = pixelOffset > 0;
    this.timedTextOffset = pixelOffset;
    if (this.playerOptions.renderTextTrackNatively && this.system.browser === Browser.FIREFOX) {
      this.monitorTtCues(isOffset);
    } else if (this.playerOptions.renderTextTrackNatively === false && this.timedTextContainer) {
      this.timedTextContainer.style.bottom = `${pixelOffset}px`;
    } else {
      const domProxy = this.facade.retrieveProxy(ProxyName.PlayerDomProxy);
      const main = domProxy.getMain();
      document == null ? void 0 : document.documentElement.style.setProperty("--avia-timed-text-offset", `${pixelOffset}px`);
      main == null ? void 0 : main.classList[isOffset ? "add" : "remove"]("avia-cc-offset");
    }
  }
  getBuffered(asStreamTime = false) {
    var _a;
    return ((_a = this.pAdapter) == null ? void 0 : _a.getBuffered(asStreamTime)) || [];
  }
  loadVideo() {
    if (this.pendingLoad) {
      return this.pendingLoad;
    }
    if (this.loaded) {
      return Promise.resolve();
    }
    this.respondToWaiting("loading", true);
    this.logger.time(Measurement.RESOURCE_LOAD);
    return this.pendingLoad = this.pAdapter.load().then((streamMetadata) => {
      this.loaded = true;
      this.respondToWaiting("loading", false);
      this.pendingLoad = null;
      const resource = this.resourceProxy.resource;
      this.notify(PlayerEvent.STREAM_METADATA, { streamMetadata });
      const url = resource.location.thumbnailTrackUrl;
      if (!this.contentPlaybackStateProxy.thumbnailTrack && url) {
        ThumbnailTrackSurface.create(url, this.getProxy(ProxyName.HookProxy)).then((thumbnailTrack) => {
          this.contentPlaybackStateProxy.thumbnailTrack = thumbnailTrack;
          this.notify(PlayerEvent.THUMBNAIL_TRACK_AVAILABLE, { thumbnailTrack });
        }).catch((e) => this.logger.warn("Could not load thumbnail track", e));
      }
      this.logger.timeEnd(Measurement.RESOURCE_LOAD);
    });
  }
  playVideo() {
    this.logger.time(Measurement.RESOURCE_PLAYBACK);
    return this.pAdapter.play().then(() => {
      this.startedPlaying = true;
      this.logger.timeEnd(Measurement.RESOURCE_PLAYBACK);
    }).catch((error) => {
      if (error.code !== 0) {
        this.logger.warn(`Video element play() error: ${error}`);
        return;
      }
      this.sendNotification(PlayerEvent.AUTOPLAY_BLOCKED, error);
    });
  }
  pauseVideo() {
    var _a;
    (_a = this.pAdapter) == null ? void 0 : _a.pause();
  }
  muteVideo(flag) {
    if (!flag && !this.presoModel.userHasUnmuted) {
      this.presoModel.userHasUnmuted = true;
    }
    this.presoModel.isMuted = flag;
  }
  seekVideo(position) {
    return this.pAdapter.seek(position);
  }
  checkVideoBuffering(count) {
    const mod = Math.max(Math.floor(this.bufferingSampleRate / TimerMediator.INTERVAL), 1);
    if (isFinite(mod) && count % mod) {
      return;
    }
    let buffering = false;
    if (!this.paused_) {
      const threshold = this.previousPlaybackState.buffer + 1e-3;
      const currentTime = this.video.currentTime;
      this.previousPlaybackState.buffer = currentTime;
      const stalled = currentTime < threshold;
      buffering = stalled && !this.seeking_;
    }
    if (this.contentIsBuffering !== buffering) {
      this.contentIsBuffering = buffering;
      this.notify(PlayerEvent.RESOURCE_BUFFERING, { buffering });
    }
  }
  get video() {
    return this.viewControl;
  }
  notify(name, data) {
    this.sendNotification(name, data, NotificationType.INTERNAL);
  }
  respondToIsPlayingLiveChange(isLive) {
    this.notify(PlayerEvent.CONTENT_IS_PLAYING_LIVE, { isLive });
  }
  respondToStreamTypeChange(streamType) {
    if (this.streamType === streamType) {
      return;
    }
    const cps = this.contentPlaybackStateProxy.model;
    this.streamType = streamType;
    cps.streamType = streamType;
    this.notify(PlayerEvent.STREAM_TYPE_CHANGE, { streamType });
  }
  respondToWaiting(key, value) {
    this.previousPlaybackState.overrides[key] = value;
    const waiting = !this.previousPlaybackState.state || values(this.previousPlaybackState.overrides).includes(true);
    this.respondToPlaybackStateChange(waiting ? PlaybackState.WAITING : this.previousPlaybackState.state);
  }
  respondToPlaybackStateChange(playbackState) {
    const cps = this.contentPlaybackStateProxy.model;
    const notWaiting = playbackState !== PlaybackState.WAITING;
    if (cps.state !== playbackState) {
      if (playbackState !== PlaybackState.IDLE && notWaiting) {
        this.previousPlaybackState.state = playbackState;
      }
      if (this.seeking_ && notWaiting) {
        return;
      }
      cps.state = playbackState;
      this.notify(PlayerEvent.PLAYBACK_STATE_CHANGE, { playbackState });
    }
  }
  // Only for Firefox at present
  monitorTtCues(flag) {
    const ctt = Array.from(this.video.textTracks).find((track) => isTextTrack(track.kind) && track.mode === TextTrackMode.SHOWING);
    const cues = ctt == null ? void 0 : ctt.activeCues;
    this.isMonitoringCueEvents = flag;
    if (!cues) {
      return;
    }
    for (let i = 0, n = cues.length || 0; i < n; i++) {
      this.respondToTtCue(cues[i]);
    }
  }
  // invoked for Firefox only
  respondToTtCue(cue) {
    cue.line = this.isMonitoringCueEvents ? this.timedTextOffset * 0.21875 : "auto";
  }
  //////////////////////////
  // private and mvc internal
  handleNotification(notification) {
    var _a, _b;
    switch (notification.name) {
      case NotificationName.TIMER_TIC:
        (_b = (_a = this.pAdapter) == null ? void 0 : _a.onTick) == null ? void 0 : _b.call(_a);
        this.respondToBufferingStatusCheck(notification.body.count);
        if (!this.lastSizeCheckTime || this.shouldCheckSize()) {
          this.lastSizeCheckTime = Date.now();
          this.checkSize();
        }
        break;
      case NotificationName.FULLSCREEN_CHANGE:
        const data = notification.body;
        this.presoModel.isFullscreen = data.isFullscreen;
        this.respondToFullscreenChange(data.isFullscreen);
        break;
    }
  }
  listNotificationInterests() {
    return [
      NotificationName.TIMER_TIC,
      NotificationName.FULLSCREEN_CHANGE
    ];
  }
  onRegister() {
    var _a;
    super.onRegister();
    this.contentPlaybackStateProxy = this.facade.retrieveProxy(ProxyName.ContentPlaybackStateProxy);
    this.resourceProxy = this.facade.retrieveProxy(ProxyName.ResourceProxy);
    this.performanceProxy = this.facade.retrieveProxy(ProxyName.PerformanceProxy);
    this.textTrackProxy = this.facade.retrieveProxy(ProxyName.TextTrackProxy);
    this.presoModel = this.getModel(ModelName.PresentationState);
    this.playerOptions = this.getModel(ModelName.PlayerOptions);
    if (this.playerOptions.sizeCheckInterval !== void 0) {
      this.sizeCheckInterval = this.playerOptions.sizeCheckInterval;
    }
    const ltsCfg = (_a = this.resourceProxy.resource.playback) == null ? void 0 : _a.lts;
    if (!isNaN(ltsCfg == null ? void 0 : ltsCfg.threshold) && isNumber(ltsCfg == null ? void 0 : ltsCfg.threshold)) {
      this.minLtsThreshold = ltsCfg.threshold;
    }
    const optionsOverrides = this.playerOptions.overrides;
    if (optionsOverrides == null ? void 0 : optionsOverrides.endFreezeThreshold) {
      this.endFreezeThreshold = optionsOverrides.endFreezeThreshold;
    }
    if (optionsOverrides == null ? void 0 : optionsOverrides.endFreezeDebounceDelay) {
      this.endFreezeDebounceDelay = optionsOverrides.endFreezeDebounceDelay;
    }
    this.respondToVideoEndDebounced = debounce(() => this.respondToVideoEnd(), this.endFreezeDebounceDelay);
    if (this.presoModel.isMuteAtPlayStart && !this.presoModel.userHasUnmuted) {
      this.muteVideo(true);
      this.presoModel.isMuted = true;
    }
    this.bufferingSampleRate = this.performanceProxy.bufferingSampleRate;
  }
  prepareForPlayback(forcePlay = false) {
    if (this.initializing) {
      return;
    }
    const config2 = {
      system: this.system,
      playerOptions: this.playerOptions,
      resource: this.resourceProxy.resource,
      performanceSettings: this.performanceProxy,
      textTrackSettings: this.textTrackProxy,
      video: this.viewControl,
      logger: this.logger
    };
    this.adapterTask = this.initializeAdapter(config2, forcePlay).catch(this.onLoadError);
  }
  sendErrorNotification(name, error) {
    this.notify(name, error);
  }
  createAdapter(config2) {
    return __async(this, null, function* () {
      const proxy = this.facade.retrieveProxy(ProxyName.AdapterProxy);
      const adapter = yield proxy.createAdapter(AdapterRole.PLAYBACK, config2.resource, () => this);
      return adapter;
    });
  }
  initializeAdapter(config2, forcePlay) {
    return __async(this, null, function* () {
      try {
        this.logger.time(Measurement.PLAYBACK_ADAPTER_CREATION);
        this.initializing = true;
        if (this.closing) {
          return;
        }
        try {
          this.pAdapter = yield this.createAdapter(config2);
          if (this.closing) {
            return;
          }
        } catch (error) {
          const mimeType = getResourceMimeType(config2.resource);
          if (mimeType) {
            error.message += `. Attempting to play a stream of type ${mimeType}`;
          }
          throw new CoreError(NotificationName.RESOURCE_ERROR, error);
        }
        this.logger.timeEnd(Measurement.PLAYBACK_ADAPTER_CREATION);
        if (this.preloadContent) {
          yield this.load();
        }
        try {
          if (this.closing) {
            return;
          }
          if (!(this.presoModel.isAutoplay || forcePlay)) {
            return;
          }
          yield this.play();
        } catch (error) {
          throw new CoreError(NotificationName.VIDEO_PLAYBACK_ERROR, error);
        }
      } finally {
        this.initializing = false;
      }
    });
  }
  respondToTextTrackInfoChange() {
    const { textTrack, textTracks } = this.contentPlaybackStateProxy;
    if (this.shouldSendTextTrackAvailable && textTrack && textTracks.length) {
      this.notify(PlayerEvent.TEXT_TRACK_AVAILABLE);
      this.shouldSendTextTrackAvailable = false;
    }
  }
  calculateStreamType() {
    if (this.pAdapter.getIsLiveStream()) {
      const liveStreamInfo = this.pAdapter.getLiveStreamInfo();
      const lts = liveStreamInfo.ltsWindowSize;
      const isLiveLinearStream = lts < this.minLtsThreshold || isNaN(lts);
      return isLiveLinearStream ? StreamType.LIVE : StreamType.LTS;
    } else {
      return StreamType.VOD;
    }
  }
  updateLiveStreamInfo() {
    if (!this.pAdapter.getIsLiveStream()) {
      this.respondToStreamTypeChange(StreamType.VOD);
      return;
    }
    const cps = this.contentPlaybackStateProxy.model;
    const liveStreamInfo = this.pAdapter.getLiveStreamInfo();
    cps.liveStreamInfo = liveStreamInfo;
    const streamType = this.calculateStreamType();
    this.respondToStreamTypeChange(streamType);
    const isPlayingLive = streamType === StreamType.LIVE ? true : liveStreamInfo.isPlayingLive;
    if (this.isPlayingLive !== isPlayingLive) {
      this.isPlayingLive = isPlayingLive;
      this.respondToIsPlayingLiveChange(isPlayingLive);
    }
    if (cps.streamType === StreamType.LTS) {
      this.respondToDurationChange(liveStreamInfo.relativeDuration);
    }
  }
  shouldCheckSize() {
    return this.playerOptions.sizeCheckInterval > 0 && (!this.lastSizeCheckTime || Date.now() - this.lastSizeCheckTime >= this.sizeCheckInterval);
  }
  ////////////////////////
  // Delegate functions //
  ////////////////////////
  hasHook(type) {
    const hp = this.getProxy(ProxyName.HookProxy);
    return hp.hasHook(type);
  }
  applyHook(type, value, metadata) {
    const hp = this.getProxy(ProxyName.HookProxy);
    return hp.applyHook(type, value, metadata).catch((error) => {
      this.error(error);
      throw error;
    });
  }
}
class CommonPresentationMediator extends AbstractPresentationMediator {
  constructor() {
    super(...arguments);
    this.contentDurationReleased = false;
    this.resumeTimeMaxProximityToAdBreak = 5;
    this.isClickToPlay = false;
    this.fullscreenRestrictedDuringAdPlay = false;
    this._hasContent = true;
    this.contentComplete = false;
    this.timeSpent = {
      startTime: null,
      lastTime: 0,
      sessionTime: 0,
      playbackTime: 0,
      elapsedTime: 0
    };
  }
  onRemove() {
    super.onRemove();
  }
  start() {
    const mUrl = this.resourceProxy.location.mediaUrl;
    this._hasContent = isString(mUrl) && !isEmpty(mUrl);
  }
  get hasContent() {
    return this._hasContent;
  }
  startSession() {
    this.updateTimeSpent();
  }
  close() {
    var _a;
    if (this.closing) {
      return this.closing;
    }
    const contentPlaybackState = (_a = this.contentPlaybackStateProxy) == null ? void 0 : _a.model;
    const contentTime = (contentPlaybackState == null ? void 0 : contentPlaybackState.time) || 0;
    const contentDuration = (contentPlaybackState == null ? void 0 : contentPlaybackState.duration) || 0;
    const adPlaying = this.isAdPlaying();
    const resource = this.resourceProxy.resource;
    this.respondToPlaybackStateChange(PlaybackState.STOPPED);
    this.contentPlaybackStateProxy.isReady = false;
    return this.closing = this.adapterTask.then(() => {
      if (this.startedPlaying) {
        this.pause();
      }
      this.logger.info("Closing Presentation");
      this.closeAds();
    }).then(() => this.destroyAdapters()).then(() => {
      const contentInterrupted = !adPlaying && this.hasContent && !this.isContentComplete();
      const adInterrupted = adPlaying;
      this.notify(PlayerEvent.RESOURCE_END, {
        resource,
        contentTime,
        contentDuration,
        contentInterrupted,
        adInterrupted,
        interrupted: contentInterrupted || adInterrupted
      });
    }).catch((e) => {
      Logger.error(e);
      throw e;
    }).then(() => {
      this.closing = null;
    });
  }
  destroyAdapters() {
    return __async(this, null, function* () {
      var _a;
      yield (_a = this.adapter) == null ? void 0 : _a.destroy();
    });
  }
  getPlayerVersionInfo() {
    return `${buildInfo.playerName}_${buildInfo.playerVersion}`;
  }
  startContentSegment() {
  }
  closeAds() {
  }
  beforePlayOnUserGesture() {
  }
  playOnUserGesture() {
    this.notify(NotificationName.VIDEO_LOAD_START);
    this.prepareForPlayback(true);
  }
  mute(flag) {
    this.muteVideo(flag);
  }
  play() {
    if (this.contentComplete) {
      this.contentComplete = false;
    }
    return super.play();
  }
  seek(position) {
    if (this.contentComplete) {
      this.contentComplete = false;
    }
    return this.seekVideo(position);
  }
  setVolume(value) {
    this.videoProxy.setVideoVolume(value);
    super.setVolume(value);
  }
  getAdBreakTimes() {
    return [];
  }
  getSessionTime() {
    if (this.timeSpent.startTime == null) {
      return null;
    }
    return this.updateTimeSpent().sessionTime;
  }
  getPlaybackTime() {
    if (this.timeSpent.startTime == null) {
      return null;
    }
    return this.updateTimeSpent().playbackTime;
  }
  checkSize() {
    if (!this.domProxy) {
      return;
    }
    const rect = this.domProxy.getPresentationRect();
    if (rect.width !== this.currentRect.width || rect.height !== this.currentRect.height) {
      this.currentRect = rect;
      this.respondToSizeChange();
      this.notify(PlayerEvent.PRESENTATION_SIZE_CHANGE, {
        width: this.currentRect.width,
        height: this.currentRect.height
      });
    }
  }
  releaseContentDuration(duration) {
    this.contentDurationReleased = true;
    this.notify(PlayerEvent.CONTENT_DURATION_AVAILABLE, {
      contentDuration: duration
    });
  }
  updateTimeSpent() {
    const now = performance.now();
    if (this.timeSpent.startTime == null) {
      this.timeSpent.startTime = now;
      const name = Measurement.FIRST_FRAME;
      const mark = { id: this.facade.appId, name, startTime: now };
      this.sendNotification(PlayerEvent.METRIC, { metric: new Metric(name, mark, MetricType.MARK) });
      this.sendNotification(PlayerEvent.PLAYBACK_STARTED);
    }
    if (this.timeSpent.lastTime == null) {
      this.timeSpent.lastTime = now;
    }
    const elapsed = now - this.timeSpent.startTime;
    this.timeSpent.elapsedTime = elapsed;
    this.timeSpent.sessionTime = elapsed / 1e3;
    const cps = this.contentPlaybackStateProxy.model;
    if (cps.state !== PlaybackState.PAUSED) {
      this.timeSpent.playbackTime += (now - this.timeSpent.lastTime) / 1e3;
      this.timeSpent.lastTime = now;
    }
    return this.timeSpent;
  }
  adjustStartTimeForAdBreakProximity(requestedStartTime, breaks) {
    for (let i = 0, n = breaks.length; i < n; i++) {
      const bs = breaks[i].startTime, diff = bs - requestedStartTime;
      if (diff >= 0 && diff < this.resumeTimeMaxProximityToAdBreak) {
        return requestedStartTime - this.resumeTimeMaxProximityToAdBreak;
      }
    }
    return requestedStartTime;
  }
  get domProxy() {
    return this.facade.retrieveProxy(ProxyName.PlayerDomProxy);
  }
  get videoProxy() {
    return this.facade.retrieveProxy(ProxyName.VideoProxy);
  }
  muteVideo(flag) {
    super.muteVideo(flag);
    this.videoProxy.muteVideo(flag);
  }
  respondToPlaybackStateChange(playbackState) {
    super.respondToPlaybackStateChange(playbackState);
    this.timeSpent.lastTime = null;
  }
  respondToFullscreenChange(fullscreen) {
    this.checkSize();
    this.notify(PlayerEvent.FULLSCREEN_CHANGE, { fullscreen });
  }
  respondToVideoPaused() {
    this.respondToPlaybackStateChange(PlaybackState.PAUSED);
  }
  respondToVideoPlaying() {
    if (!this.presoModel.started) {
      this.presoModel.started = true;
    }
    this.respondToPlaybackStateChange(PlaybackState.PLAYING);
  }
  respondToVideoSeeking() {
    this.notify(PlayerEvent.SEEK_START);
  }
  respondToVideoSeeked() {
    this.notify(PlayerEvent.SEEK_COMPLETE);
  }
  respondToQualityChange(quality = null) {
    this.notify(PlayerEvent.QUALITY_CHANGE, { quality });
  }
  respondToError(data) {
    if (!data.message) {
      data.message = AppResources.messages.UNSPECIFIED_ERROR;
    }
    if (!data.code) {
      data.code = ErrorCode.UNSPECIFIED_VIDEO_PLAYBACK_ERROR;
    }
    const name = this.startedPlaying || !data.category ? NotificationName.VIDEO_PLAYBACK_ERROR : NotificationName.PLAYER_ERROR;
    this.sendErrorNotification(name, data);
  }
  /*
  		Resource end only applies when the resource has completed
  */
  respondToVideoEnd() {
    this.notify(NotificationName.RESOURCE_COMPLETE);
  }
  respondToBufferingStatusCheck(count) {
    const t = this.presoModel.streamTime;
    !isNaN(t) && t > 0 && this.checkVideoBuffering(count);
  }
  respondToId3Data(d) {
    this.notify(PlayerEvent.METADATA_CUEPOINT, { cue: d });
  }
  updateContentProgress(streamTime) {
    const contentPlaybackState = this.contentPlaybackStateProxy.model;
    const { duration, liveStreamInfo, streamType, time } = contentPlaybackState;
    const data = {
      contentTime: time,
      contentDuration: duration,
      streamTime,
      streamDuration: this.presoModel.streamDuration,
      sessionTime: this.timeSpent.sessionTime,
      playbackTime: this.timeSpent.playbackTime
    };
    if (streamType !== StreamType.VOD) {
      const { relativeTime, relativeDuration } = liveStreamInfo;
      data.contentTime = relativeTime;
      data.contentDuration = relativeDuration;
      data.streamTime = relativeTime;
      data.streamDuration = relativeDuration;
      data.elapsedTimeMs = this.timeSpent.elapsedTime;
      this.presoModel.streamTime = relativeTime;
      this.presoModel.streamDuration = relativeDuration;
      contentPlaybackState.time = relativeTime;
      contentPlaybackState.duration = relativeDuration;
    }
    return data;
  }
  respondToVideoTimeUpdate(streamTime) {
    this.updateTimeSpent();
    const data = this.updateContentProgress(streamTime);
    this.notify(PlayerEvent.CONTENT_PROGRESS, data);
  }
  respondToSizeChange() {
    if (!this.adapter) {
      return;
    }
    this.adapter.resize();
  }
  respondToDurationChange(dur) {
  }
  respondToTextTrackModeChange(enabled) {
  }
  // helpers
  setForClickToPlay() {
    const po = this.getModel(ModelName.PlayerOptions);
    if (po.useNativeControls) {
      const m = this.domProxy.getMain();
      const lr = () => {
        m.removeEventListener("click", lr);
        this.notify(NotificationName.PLAY_ON_USER_GESTURE);
      };
      m.addEventListener("click", lr);
    }
  }
  isContentComplete() {
    if (this.contentComplete) {
      return true;
    }
    const cps = this.contentPlaybackStateProxy.model;
    return cps.streamType !== StreamType.LIVE && cps.streamType !== StreamType.LTS && !(isNaN(cps.time) || cps.time < cps.duration);
  }
  // TODO: Move this to an AdPresentationMediator base class
  isAdPlaying() {
    return this.presoModel.isTrackingAd;
  }
  handleNotification(notification) {
    super.handleNotification(notification);
  }
  listNotificationInterests() {
    return super.listNotificationInterests().concat([]);
  }
  onRegister() {
    super.onRegister();
    const o = this.playerOptions.overrides;
    if (o.resumeTimeMaxProximityToAdBreak) {
      this.resumeTimeMaxProximityToAdBreak = o.resumeTimeMaxProximityToAdBreak;
    }
    this.isClickToPlay = !this.presoModel.isAutoplay;
    const sys = this.system;
    this.fullscreenRestrictedDuringAdPlay = sys.isIos || sys.isAndroid;
    if (this.domProxy) {
      this.currentRect = this.domProxy.getPresentationRect();
    }
  }
}
var __defProp$1 = Object.defineProperty;
var __getOwnPropDesc$1 = Object.getOwnPropertyDescriptor;
var __decorateClass$1 = (decorators, target, key, kind) => {
  var result = __getOwnPropDesc$1(target, key);
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$1(target, key, result);
  return result;
};
class AdPresentationMediator extends CommonPresentationMediator {
  constructor(name, viewControl) {
    super(name, viewControl);
    this.pAdAdapter = null;
    this.adAdapterStarted = false;
    this.contentSegmentStarted = false;
    this.contentStartReleased = false;
    this.contentCompleteReleased = false;
    this.fatalContentErrorReceived = false;
    this.hasMidRolls = false;
    this.pendingSeekTime = null;
    this.currentAd = null;
    this.currentBreak = null;
    this.pointerLocked = false;
    this.isPreloading = false;
    this.cancelPointerLock = () => {
      var _a;
      document.removeEventListener("mousemove", this.cancelPointerLock);
      (_a = document.exitPointerLock) == null ? void 0 : _a.call(document);
      this.pointerLocked = false;
    };
    this.setPointerState = () => __async(this, null, function* () {
      var _a;
      if (this.pointerLocked && !this.isFullScreenAd()) {
        this.cancelPointerLock();
        return;
      } else if (!this.pointerLocked && this.isFullScreenAd()) {
        const element = (_a = this.domProxy) == null ? void 0 : _a.getMain();
        if (!element || !element.requestPointerLock) {
          return;
        }
        try {
          this.pointerLocked = true;
          yield element.requestPointerLock();
          this.cancelTimeout = setTimeout(() => document == null ? void 0 : document.addEventListener("mousemove", this.cancelPointerLock), 100);
        } catch (error) {
          this.pointerLocked = false;
          this.logger.warn(error);
        }
      }
    });
    this.hMovement = (e) => {
      if (this.presoModel.isFullscreen) {
        this.pointerLockDebouncer();
      }
    };
    this.preloadContent = false;
  }
  set adAdapter(adapter) {
    this.pAdAdapter = adapter;
  }
  get adAdapter() {
    return this.pAdAdapter;
  }
  get adInProgress() {
    return this.presoModel.isTrackingAd;
  }
  get appMediator() {
    return this.facade.retrieveMediator(MediatorName.APPLICATION);
  }
  destroyAdapters() {
    return Promise.resolve().then(() => {
      var _a;
      return (_a = this.adAdapter) == null ? void 0 : _a.destroy();
    }).then(() => super.destroyAdapters());
  }
  onRemove() {
    var _a, _b;
    (_b = (_a = this.pAdAdapter) == null ? void 0 : _a.destroy) == null ? void 0 : _b.call(_a);
    this.pAdAdapter = null;
    clearTimeout(this.playingTimeout);
    if (this.domProxy) {
      this.cancelPointerLock();
      this.pointerLockDebouncer.cancel();
      clearTimeout(this.cancelTimeout);
      this.monitorActivity(false);
    }
    this.delegate.destroy();
    this.delegate = null;
    super.onRemove();
  }
  closeAds() {
    var _a, _b;
    (_a = this.domProxy) == null ? void 0 : _a.showAdContainer(false);
    (_b = this.adAdapter) == null ? void 0 : _b.destroy();
    this.pAdAdapter = null;
  }
  beforePlayOnUserGesture() {
    var _a;
    (_a = this.adAdapter) == null ? void 0 : _a.playClicked();
  }
  playOnUserGesture() {
    if (this.hasContent) {
      super.playOnUserGesture();
    } else {
      this.play();
    }
  }
  start() {
    var _a, _b, _c;
    const contentStartTime = this.resourceProxy.playback.startTime;
    const showPreRoll = this.resourceProxy.ad.showPrerollOnNonZeroStart;
    const nonZeroStart = !isNaN(contentStartTime) && contentStartTime > 0;
    super.start();
    this.mute(this.presoModel.isMuted);
    if (nonZeroStart && showPreRoll) {
      this.pendingSeekTime = contentStartTime;
    }
    if (this.isClickToPlay) {
      this.setForClickToPlay();
    } else {
      const r = this.resourceProxy.resource;
      if (((_b = (_a = r.ad) == null ? void 0 : _a.csai) == null ? void 0 : _b.adCallUrl) && !((_c = r.location) == null ? void 0 : _c.mediaUrl)) {
        this.play();
      } else {
        this.notify(NotificationName.VIDEO_LOAD_START);
        this.prepareForPlayback();
      }
    }
  }
  /** override */
  getAdBreakTimes() {
    var _a;
    const aci = [];
    (_a = this.breakSchedule) == null ? void 0 : _a.forEach((b) => {
      aci.push(__spreadValues({
        start: b.startTime,
        streamTimeStart: b.streamStartTime,
        end: b.endTime,
        streamTimeEnd: b.streamStartTime + b.duration,
        played: b.hasPlayed
      }, b));
    });
    return aci;
  }
  createDelegate(id) {
    this.delegate = apiCollection(`${id}.adAdapterDelegate`, this);
  }
  getDelegate() {
    return this.delegate.api;
  }
  play() {
    var _a;
    if (!this.presoModel.started) {
      this.presoModel.started = true;
      this.adAdapterStarted = true;
      return Promise.resolve(this.adAdapter.start());
    } else {
      if (this.adInProgress && ((_a = this.adAdapter) == null ? void 0 : _a.resume)) {
        return Promise.resolve(this.adAdapter.resume());
      }
      return this.playVideo();
    }
  }
  pause() {
    var _a;
    if (this.adInProgress && ((_a = this.adAdapter) == null ? void 0 : _a.pause)) {
      this.adAdapter.pause();
      return;
    }
    this.pauseVideo();
  }
  getBuffered(asStreamTime = false) {
    const b = super.getBuffered(asStreamTime);
    if (asStreamTime === true) {
      return b;
    }
    return b.map((r) => {
      var _a, _b, _c, _d;
      return {
        startTime: ((_b = (_a = this.adAdapter).contentTimeForStreamTime) == null ? void 0 : _b.call(_a, r.startTime)) || r.startTime,
        endTime: ((_d = (_c = this.adAdapter).contentTimeForStreamTime) == null ? void 0 : _d.call(_c, r.endTime)) || r.endTime
      };
    });
  }
  // override
  mute(flag) {
    var _a;
    (_a = this.adAdapter) == null ? void 0 : _a.setMuteState(flag);
    super.mute(flag);
  }
  setVolume(value) {
    var _a;
    (_a = this.adAdapter) == null ? void 0 : _a.setVolume(value);
    super.setVolume(value);
  }
  // override
  seek(position) {
    const streamSeekTimeRequested = this.streamTimeForContentTime(position);
    const permittedStreamSeekTime = this.getPermittedSeekTime(position);
    if (this.hasMidRolls && this.adAdapter && permittedStreamSeekTime !== streamSeekTimeRequested) {
      this.pendingSeekTime = streamSeekTimeRequested;
      this.notify(PlayerEvent.SEEK_REDIRECT_START, {
        requestedSeekTime: position,
        actualSeekTime: this.contentTimeForStreamTime(permittedStreamSeekTime)
      });
    }
    if (this.contentComplete && !this.contentSegmentStarted) {
      this.contentSegmentStarted = true;
    }
    return super.seek(permittedStreamSeekTime);
  }
  skipAd() {
    var _a;
    (_a = this.adAdapter) == null ? void 0 : _a.skipAd();
  }
  pauseContent() {
    var _a;
    this.pauseVideo();
    (_a = this.domProxy) == null ? void 0 : _a.showAdContainer(true);
  }
  resumeContent() {
    var _a, _b;
    this.currentAd = null;
    this.currentBreak = null;
    (_a = this.domProxy) == null ? void 0 : _a.showAdClickElement(false);
    (_b = this.domProxy) == null ? void 0 : _b.showAdContainer(false);
    if (this.fatalContentErrorReceived) {
      return;
    }
    if (!this.hasContent || this.contentComplete) {
      super.respondToVideoEnd();
      return;
    }
    if (!this.contentStartReleased) {
      const contentStartTime = this.resourceProxy.playback.startTime, nonZeroStart = !isNaN(contentStartTime) && contentStartTime > 0;
      if (nonZeroStart) {
        const breaks = this.getAdBreakTimes();
        const adjustedStart = this.adjustStartTimeForAdBreakProximity(contentStartTime, breaks);
        this.resourceProxy.playback.startTime = adjustedStart;
      }
      this.load().then(() => {
        this.resumeContentPlayComplete();
      }).catch(this.onLoadError);
      return;
    }
    this.resumeContentPlayComplete();
  }
  streamIdAvailable(id) {
    this.notify(PlayerEvent.STREAM_ID_AVAILABLE, {
      sessionId: this.resourceProxy.resource.sessionId || "",
      streamId: id
    });
  }
  applyHook(type, value, metadata) {
    return super.applyHook(type, value, metadata);
  }
  adSkippableStateChanged() {
    this.notify(PlayerEvent.AD_SKIPPABLE_STATE_CHANGE);
  }
  adSegmentStarted() {
    this.endContentSegment();
    this.presoModel.adSegmentEntered = true;
    this.notify(PlayerEvent.AD_SEGMENT_START);
  }
  adSegmentReentered() {
    this.notify(PlayerEvent.AD_SEGMENT_REENTERED);
  }
  adSegmentEnded() {
    this.contentSegmentStarted = false;
    if (this.presoModel) {
      this.presoModel.isTrackingAd = false;
      this.presoModel.adSegmentEntered = false;
    }
    this.notify(PlayerEvent.AD_SEGMENT_END);
  }
  adBreaksAvailable(adBreaks) {
    this.hasMidRolls = adBreaks.some((b) => b.type === AdBreakType.MID);
    this.breakSchedule = adBreaks;
    const times = adBreaks.map((b) => b.startTime);
    this.notify(PlayerEvent.AD_CUEPOINTS_AVAILABLE, {
      cuepoints: times,
      adBreaks
    });
  }
  seekToStreamTime(t) {
    this.seekVideo(t);
  }
  adBreakStart() {
    var _a;
    this.endContentSegment();
    this.updateSize();
    (_a = this.domProxy) == null ? void 0 : _a.showAdContainer(true);
    this.presoModel.isTrackingAd = true;
    if (this.timeSpent.startTime === null) {
      this.startSession();
    }
    this.enterAdActionKeyContext(true);
    this.notify(PlayerEvent.AD_BREAK_START);
  }
  adBreakMetadata(breakInfo) {
    this.currentBreak = breakInfo;
    this.notify(PlayerEvent.AD_BREAK_METADATA, { adBreakInfo: breakInfo });
  }
  adLoaded() {
  }
  adStart(adData) {
    this.currentAd = adData;
    this.respondToPlaybackStateChange(PlaybackState.PLAYING);
    this.notify(PlayerEvent.AD_START, { adInfo: adData });
  }
  adProgress(currentTime, duration, breakTime, breakDuration) {
    const { streamTime, streamDuration } = this.presoModel;
    this.presoModel.adTime = currentTime;
    this.presoModel.adDuration = duration;
    this.presoModel.breakTime = breakTime;
    this.presoModel.breakDuration = breakDuration;
    this.notify(PlayerEvent.AD_PROGRESS, {
      currentTime,
      duration,
      breakTime,
      breakDuration,
      streamTime,
      streamDuration
    });
    this.checkPreload(currentTime, duration);
  }
  adFirstQuartile() {
    this.notify(PlayerEvent.AD_FIRST_QUARTILE);
  }
  adMidpoint() {
    this.notify(PlayerEvent.AD_MIDPOINT);
  }
  adThirdQuartile() {
    this.notify(PlayerEvent.AD_THIRD_QUARTILE);
  }
  adComplete() {
    this.currentAd = null;
    this.notify(PlayerEvent.AD_COMPLETE);
  }
  adBreakComplete() {
    var _a, _b;
    this.currentBreak = null;
    this.currentAd = null;
    this.isPreloading = false;
    (_a = this.domProxy) == null ? void 0 : _a.showAdContainer(false);
    (_b = this.domProxy) == null ? void 0 : _b.showAdClickElement(false);
    this.presoModel.isTrackingAd = false;
    this.presoModel.adSegmentEntered = false;
    this.notify(PlayerEvent.AD_BREAK_COMPLETE);
    this.enterAdActionKeyContext(false);
    if (this.isContentComplete()) {
      super.respondToVideoEnd();
      return;
    }
    if (this.pendingSeekTime && this.contentStartReleased) {
      const t = this.pendingSeekTime;
      this.pendingSeekTime = null;
      this.contentPlaybackStateProxy.model.started && this.notify(PlayerEvent.SEEK_REDIRECT_COMPLETE);
      this.seekVideo(t);
    }
  }
  adClicked(url = "") {
    var _a, _b;
    const cp = (_b = (_a = this.contentPlaybackStateProxy) == null ? void 0 : _a.model) == null ? void 0 : _b.state;
    if (cp === PlaybackState.PLAYING) {
      this.pause();
    }
    this.notify(PlayerEvent.AD_CLICK, { clickThroughUrl: url });
  }
  adError(info) {
    this.currentAd = null;
    if (!info.message) {
      info.message = AppResources.messages.UNSPECIFIED_ERROR;
    }
    this.notify(NotificationName.AD_ERROR, info);
  }
  adPaused() {
    this.respondToPlaybackStateChange(PlaybackState.PAUSED);
    this.notify(PlayerEvent.AD_PAUSED);
  }
  adResumed() {
    this.notify(PlayerEvent.RESOURCE_BUFFERING, { buffering: false });
    this.respondToPlaybackStateChange(PlaybackState.PLAYING);
    this.notify(PlayerEvent.AD_PLAYING);
  }
  adStalled(adInfo) {
    this.logger.dir(LogLevel.WARN, adInfo, "Stalled Ad Info");
    this.notify(PlayerEvent.AD_STALLED, new PlayerError(
      ErrorCode.AD_STALLED,
      ErrorMessage.AD_STALLED,
      adInfo,
      false,
      ErrorCategory.AD
    ));
  }
  adBreakDiscarded() {
    this.notify(PlayerEvent.AD_BREAK_DISCARDED);
  }
  adSkipped() {
    this.notify(PlayerEvent.AD_SKIPPED);
  }
  onShowAdUi(adUi) {
    this.notify(PlayerEvent.SHOW_AD_UI, { adUi });
  }
  onHideAdUi() {
    this.notify(PlayerEvent.HIDE_AD_UI);
  }
  allAdsComplete() {
  }
  adBuffering(state) {
  }
  displayAdClickElement(flag) {
    var _a;
    (_a = this.domProxy) == null ? void 0 : _a.showAdClickElement(flag);
  }
  setContentDuration(duration) {
    if (duration && !isNaN(duration) && duration > 0) {
      this.contentPlaybackStateProxy.model.duration = duration;
      this.releaseContentDuration(duration);
    }
  }
  ///////////////////////////////////////////////////////////
  // END Delegate interface
  ///////////////////////////////////////////////////////////
  enterAdActionKeyContext(flag) {
    if (flag) {
      this.appMediator.enterActionKeyContext(ActionKeyContext.AD);
    } else {
      this.appMediator.exitActionKeyContext(ActionKeyContext.AD);
    }
  }
  resumeContentPlayComplete() {
    return __async(this, null, function* () {
      if (this.pendingSeekTime && this.contentStartReleased) {
        yield this.seekVideo(this.pendingSeekTime).catch((error) => {
          this.logger.warn("APM#resumeContentPlayComplete; A seek() call failed.");
          this.logger.debug(error, "Error");
        });
        this.notify(PlayerEvent.SEEK_REDIRECT_COMPLETE);
        this.pendingSeekTime = null;
      }
      this.play();
    });
  }
  // Hides cursor during ad play in fullscreen if mouse is idle
  isFullScreenAd() {
    return this.presoModel.isFullscreen && this.adInProgress;
  }
  monitorActivity(flag = false) {
    var _a, _b;
    if (!System.isDesktop || !System.isBrowser) {
      return;
    }
    const verb = flag ? "addEventListener" : "removeEventListener";
    (_b = (_a = this.domProxy) == null ? void 0 : _a.getMain()) == null ? void 0 : _b[verb]("mousemove", this.hMovement);
  }
  ///////////////////////////////////////////////////////////
  // Respond to playback commands and adapter events
  // +  calls to adapter
  handleNotification(notification) {
    var _a, _b, _c;
    const { name, body } = notification;
    let fsEvent = false;
    switch (name) {
      case PlayerEvent.FULLSCREEN_CHANGE:
        (_a = this.adAdapter) == null ? void 0 : _a.setFullscreenState(body.fullscreen);
        fsEvent = true;
        break;
      case PlayerEvent.QUALITY_CHANGE:
        const br = ((_b = body.quality) == null ? void 0 : _b.bitrate) ? Math.round(body.quality.bitrate * 1e-3) : -1;
        (_c = this.adAdapter) == null ? void 0 : _c.setContentBitrate(br);
        break;
    }
    super.handleNotification(notification);
    if (fsEvent) {
      this.monitorActivity(body.fullscreen);
    }
  }
  updateSize() {
    var _a, _b;
    const dimensions = (_a = this.domProxy) == null ? void 0 : _a.getPresentationRect();
    if (dimensions) {
      (_b = this.adAdapter) == null ? void 0 : _b.updateSize(dimensions);
    }
  }
  respondToSizeChange() {
    this.updateSize();
    super.respondToSizeChange();
  }
  respondToId3Data(d) {
    this.adAdapter.handleTimedMetadata(d);
    super.respondToId3Data(d);
  }
  respondToVideoPaused() {
    super.respondToVideoPaused();
    if (this.adInProgress) {
      this.notify(PlayerEvent.AD_PAUSED);
    } else {
      this.respondToPlaybackStateChange(PlaybackState.PAUSED);
      this.notify(PlayerEvent.CONTENT_PAUSED);
    }
  }
  respondToPlaybackStateChange(state) {
    if (this.isPreloading && state === PlaybackState.WAITING) {
      return;
    }
    super.respondToPlaybackStateChange(state);
  }
  respondToVideoPlaying() {
    super.respondToVideoPlaying();
    this.signalPlaying();
  }
  // Call plugin.setStreamTime()
  respondToVideoTimeUpdate(streamTime) {
    var _a;
    const cps = this.contentPlaybackStateProxy.model;
    const validStreamTime = streamTime > 0.75;
    this.presoModel.streamTime = streamTime;
    (_a = this.adAdapter) == null ? void 0 : _a.setStreamTime(streamTime);
    cps.time = this.contentTimeForStreamTime(streamTime);
    if (this.adInProgress) {
      this.updateContentProgress(streamTime);
      return;
    }
    if (this.fatalContentErrorReceived) {
      return;
    }
    if (validStreamTime && !this.presoModel.adSegmentEntered && !this.contentSegmentStarted) {
      this.startContentSegment();
    }
    if (validStreamTime && this.contentSegmentStarted || this.presoModel.adSegmentEntered) {
      super.respondToVideoTimeUpdate(streamTime);
    }
    if (cps.streamType !== StreamType.LIVE && cps.time >= cps.duration && !this.contentCompleteReleased) {
      this.signalContentComplete();
    }
  }
  endContentSegment() {
    if (this.contentSegmentStarted) {
      this.contentSegmentStarted = false;
      if (this.hasMidRolls || this.isLiveOrLts()) {
        this.notify(PlayerEvent.CONTENT_SEGMENT_END);
      }
    }
  }
  isLiveOrLts() {
    const { streamType } = this.contentPlaybackStateProxy.model;
    return streamType === StreamType.LIVE || streamType === StreamType.LTS;
  }
  respondToVideoEnd() {
    var _a, _b;
    if (!this.contentCompleteReleased) {
      this.signalContentComplete();
    }
    (_a = this.adAdapter) == null ? void 0 : _a.contentComplete();
    const hasPost = (_b = this.breakSchedule) == null ? void 0 : _b.find((b) => b.type === AdBreakType.POST);
    if (!hasPost) {
      super.respondToVideoEnd();
    }
  }
  respondToDurationChange(duration) {
    if (duration && !isNaN(duration) && duration > 0) {
      this.adAdapter.setStreamDuration(duration);
      this.presoModel.streamDuration = duration;
      const contentDur = this.contentTimeForStreamTime(duration);
      this.contentPlaybackStateProxy.model.duration = contentDur;
      if (!this.contentDurationReleased) {
        this.releaseContentDuration(contentDur);
      }
    }
  }
  respondToError(data) {
    this.fatalContentErrorReceived = data.fatal;
    super.respondToError(data);
  }
  isContentComplete() {
    return this.contentComplete;
  }
  checkVideoBuffering(count) {
    var _a, _b;
    super.checkVideoBuffering(count);
    (_b = (_a = this.adAdapter) == null ? void 0 : _a.setBuffering) == null ? void 0 : _b.call(_a, this.contentIsBuffering);
  }
  ///////////
  // PRIVATE
  startContentSegment() {
    var _a, _b;
    const cps = this.contentPlaybackStateProxy.model;
    this.contentSegmentStarted = true;
    cps.started = true;
    (_a = this.domProxy) == null ? void 0 : _a.showAdClickElement(false);
    (_b = this.domProxy) == null ? void 0 : _b.showAdContainer(false);
    if (!this.contentStartReleased) {
      this.signalContentStart();
    }
    if (this.hasMidRolls || cps.streamType === StreamType.LIVE || cps.streamType === StreamType.LTS) {
      this.notify(PlayerEvent.CONTENT_SEGMENT_START);
    }
  }
  checkPreload(currentTime, duration) {
    var _a, _b, _c, _d, _e, _f;
    if (this.isPreloading) {
      return;
    }
    const preload = ((_d = (_c = (_b = (_a = this.resourceProxy) == null ? void 0 : _a.resource) == null ? void 0 : _b.ad) == null ? void 0 : _c.csai) == null ? void 0 : _d.preloadContentAtEndOfPreRoll) === true;
    if (!preload) {
      return;
    }
    const lastAd = ((_e = this.currentAd) == null ? void 0 : _e.adPosition) === ((_f = this.currentBreak) == null ? void 0 : _f.adTotal);
    if (lastAd && !this.system.isIos) {
      const threshold = clampValue(Math.ceil(duration / 4), 2, 10);
      const time = Math.round(currentTime);
      if (time >= threshold) {
        this.isPreloading = true;
        this.load().catch(this.onLoadError);
      }
    }
  }
  signalPlaying() {
    return __async(this, null, function* () {
      clearTimeout(this.playingTimeout);
      if (!this.adAdapterStarted) {
        this.adAdapterStarted = true;
        yield this.adAdapter.start();
      }
      if (this.adInProgress) {
        this.notify(PlayerEvent.AD_PLAYING);
      } else {
        const t = this.contentPlaybackStateProxy.model.time;
        if (t < 0.5) {
          this.playingTimeout = setTimeout(() => this.respondToVideoPlaying(), (0.5 - t) * 1e3);
          return;
        }
        this.notify(PlayerEvent.CONTENT_PLAYING);
      }
    });
  }
  signalContentStart() {
    this.contentStartReleased = true;
    this.notify(PlayerEvent.CONTENT_START);
  }
  signalContentComplete() {
    this.contentComplete = true;
    if (this.contentSegmentStarted) {
      this.endContentSegment();
    }
    this.contentCompleteReleased = true;
    this.notify(PlayerEvent.CONTENT_COMPLETE);
  }
  contentTimeForStreamTime(time) {
    var _a;
    return ((_a = this.adAdapter) == null ? void 0 : _a.contentTimeForStreamTime) ? this.adAdapter.contentTimeForStreamTime(time) : time;
  }
  streamTimeForContentTime(time) {
    var _a;
    return ((_a = this.adAdapter) == null ? void 0 : _a.streamTimeForContentTime) ? this.adAdapter.streamTimeForContentTime(time) : time;
  }
  getPermittedSeekTime(time) {
    var _a;
    return ((_a = this.adAdapter) == null ? void 0 : _a.getPermittedSeekTime) ? this.adAdapter.getPermittedSeekTime(time) : time;
  }
  listNotificationInterests() {
    return super.listNotificationInterests().concat([
      PlayerEvent.FULLSCREEN_CHANGE,
      PlayerEvent.QUALITY_CHANGE
    ]);
  }
  onRegister() {
    super.onRegister();
    if (this.domProxy) {
      const { idleDelay } = this.facade.retrieveMediator(MediatorName.ACTIVITY);
      this.pointerLockDebouncer = debounce(this.setPointerState, idleDelay);
      this.domProxy.showAdContainer(false);
      this.domProxy.showAdClickElement(false);
    }
  }
}
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "pauseContent");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "resumeContent");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "streamIdAvailable");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "applyHook");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "adSkippableStateChanged");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "adSegmentStarted");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "adSegmentReentered");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "adSegmentEnded");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "adBreaksAvailable");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "seekToStreamTime");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "adBreakStart");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "adBreakMetadata");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "adLoaded");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "adStart");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "adProgress");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "adFirstQuartile");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "adMidpoint");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "adThirdQuartile");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "adComplete");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "adBreakComplete");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "adClicked");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "adError");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "adPaused");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "adResumed");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "adStalled");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "adBreakDiscarded");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "adSkipped");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "onShowAdUi");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "onHideAdUi");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "allAdsComplete");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "adBuffering");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "displayAdClickElement");
__decorateClass$1([
  apiMethod()
], AdPresentationMediator.prototype, "setContentDuration");
class ContentPresentationMediator extends CommonPresentationMediator {
  // start the presentation
  start() {
    if (this.isClickToPlay) {
      this.setForClickToPlay();
    } else {
      this.notify(NotificationName.VIDEO_LOAD_START);
    }
  }
  respondToVideoPlaying() {
    const cps = this.contentPlaybackStateProxy.model;
    let sendStart = false;
    cps.started = true;
    if (!this.presoModel.started) {
      sendStart = true;
    }
    super.respondToVideoPlaying();
    if (sendStart) {
      this.notify(PlayerEvent.CONTENT_START);
    }
    this.notify(PlayerEvent.CONTENT_PLAYING);
  }
  respondToVideoTimeUpdate(streamTime) {
    if (this.contentComplete) {
      return;
    }
    const cps = this.contentPlaybackStateProxy.model;
    this.presoModel.streamTime = streamTime;
    cps.time = streamTime;
    if (this.presoModel.started) {
      super.respondToVideoTimeUpdate(streamTime);
    }
  }
  respondToVideoPaused() {
    super.respondToVideoPaused();
    this.notify(PlayerEvent.CONTENT_PAUSED);
  }
  respondToIsPlayingLiveChange(isLive) {
    super.respondToIsPlayingLiveChange(isLive);
  }
  respondToVideoEnd() {
    this.contentComplete = true;
    this.notify(PlayerEvent.CONTENT_COMPLETE);
    super.respondToVideoEnd();
  }
  respondToDurationChange(duration) {
    this.presoModel.streamDuration = duration;
    this.contentPlaybackStateProxy.model.duration = duration;
    if (!this.contentDurationReleased) {
      this.releaseContentDuration(duration);
    }
  }
  onRegister() {
    super.onRegister();
    this.domProxy && this.domProxy.showAdContainer(false);
    !this.isClickToPlay && this.prepareForPlayback();
  }
}
class PrepPlaybackCommand extends LogAwareSimpleCommand {
  execute(notification) {
    var _a, _b, _c;
    const sys = this.system;
    const resource = notification.body;
    if (System.isBrowser && !((_a = sys.global) == null ? void 0 : _a.document)) {
      this.sendNotification(NotificationName.VIDEO_START_ERROR, { error: AppResources.messages.ENVIRONMENT_NOT_SUPPORTED, fatal: true });
      return;
    }
    const presoState = this.getModel(ModelName.PresentationState);
    const playerOpts = this.getModel(ModelName.PlayerOptions);
    const playbackStateProxy = new ContentPlaybackStateProxy(ProxyName.ContentPlaybackStateProxy);
    this.facade.registerProxy(playbackStateProxy);
    if (((_c = (_b = resource.playback) == null ? void 0 : _b.abr) == null ? void 0 : _c.capQualityToScreenSize) === false) {
      playbackStateProxy.qualityCappedToScreenSize = false;
    }
    this.checkAutoplay(playerOpts).then((result) => {
      this.processAutoplaySupport(result, presoState, playerOpts);
      this.createPresentation(resource, playerOpts);
    });
  }
  createPresentation(resource, playerOpts) {
    return __async(this, null, function* () {
      const presoMed = yield this.getPresentationMediator(resource, playerOpts);
      if (!presoMed) {
        return;
      }
      this.facade.registerMediator(presoMed);
      this.sendNotification(NotificationName.START_PRESENTATION);
    });
  }
  getPresentationMediator(resource, playerOpts) {
    return __async(this, null, function* () {
      var _a, _b, _c;
      const video = yield this.getVideo(playerOpts, resource);
      let ret = null;
      if (!video) {
        this.sendNotification(NotificationName.RESOURCE_ERROR, {
          code: ErrorCode.UNEXPECTED_CONDITION,
          message: AppResources.messages.VIDEO_PLAYBACK_UNAVAILABLE,
          fatal: true
        });
        return ret;
      }
      const name = MediatorName.PRESENTATION_MEDIATOR;
      const adEnabled = ((_a = resource == null ? void 0 : resource.ad) == null ? void 0 : _a.csai) || ((_b = resource == null ? void 0 : resource.ad) == null ? void 0 : _b.ssai);
      if (adEnabled) {
        try {
          this.logger.time(Measurement.AD_ADAPTER_CREATION);
          const mediator = new AdPresentationMediator(name, video);
          mediator.createDelegate(this.facade.appId);
          const adapterProxy = this.facade.retrieveProxy(ProxyName.AdapterProxy);
          const adapter = yield adapterProxy.createAdapter(
            AdapterRole.AD,
            resource,
            () => mediator.getDelegate()
          );
          mediator.adAdapter = adapter;
          this.logger.timeEnd(Measurement.AD_ADAPTER_CREATION);
          this.logger.time(Measurement.AD_RESOURCE_CREATION);
          const resourceOverride = yield (_c = adapter.getResource) == null ? void 0 : _c.call(adapter);
          this.logger.timeEnd(Measurement.AD_RESOURCE_CREATION);
          if (resourceOverride) {
            resource = resourceOverride;
          }
          ret = mediator;
        } catch (error) {
          this.sendNotification(NotificationName.AD_ERROR, {
            code: error.code || ErrorCode.AD_ADAPTER_ERROR,
            message: error.message,
            cause: error,
            fatal: true
          });
        }
      } else {
        ret = new ContentPresentationMediator(name, video);
      }
      this.createResourceProxy(resource);
      return ret;
    });
  }
  createResourceProxy(resource) {
    const resourceProxy = new ResourceProxy(ProxyName.ResourceProxy, resource);
    this.facade.registerProxy(resourceProxy);
  }
  getVideo(playerOpts, resource) {
    return __async(this, null, function* () {
      const sys = this.system;
      if (sys.isWebMaf) {
        return sys.webMafPlayer;
      } else if (!sys.isBrowser) {
        return {};
      }
      const videoProxy = this.facade.retrieveProxy(ProxyName.VideoProxy);
      if (!videoProxy.getVideo() || playerOpts.reuseVideoElement !== true) {
        yield videoProxy.initVideo(resource);
      }
      return videoProxy.getVideo();
    });
  }
  ////////////
  // autoplay
  processAutoplaySupport(result, presoMdl, playerOpts) {
    if (presoMdl.isAutoplay) {
      return;
    }
    const apOpt = playerOpts.autoplay;
    const mutedOk = result.supportsMutedAutoplay;
    const unmutedOk = result.supportsUnmutedAutoplay;
    const wantsMuted = apOpt === Autoplay.ATTEMPT_MUTED || apOpt === Autoplay.ATTEMPT_UNMUTED_THEN_MUTED;
    const wantsUnmuted = apOpt === Autoplay.ATTEMPT_UNMUTED;
    const conflict = wantsMuted && !mutedOk || wantsUnmuted && !unmutedOk;
    if (conflict) {
      this.sendNotification(PlayerEvent.AUTOPLAY_BLOCKED, new Error("Autoplay capability conflict."), NotificationType.INTERNAL);
    }
    presoMdl.isMuteAtPlayStart = apOpt === Autoplay.ATTEMPT_MUTED && mutedOk || apOpt === Autoplay.ATTEMPT_UNMUTED_THEN_MUTED && !unmutedOk && mutedOk;
    presoMdl.isAutoplay = this.shouldAutoplay(apOpt, result);
  }
  shouldAutoplay(opt, info) {
    if (isEmpty(opt) || opt === Autoplay.NONE) {
      return false;
    }
    const mutedOk = info.supportsMutedAutoplay;
    const unmutedOk = info.supportsUnmutedAutoplay;
    const muteOnly = opt === Autoplay.ATTEMPT_MUTED && mutedOk;
    const soundOnly = opt === Autoplay.ATTEMPT_UNMUTED && unmutedOk;
    const fallback = !soundOnly && (opt === Autoplay.ATTEMPT_UNMUTED_THEN_MUTED && mutedOk);
    return muteOnly || soundOnly || fallback;
  }
  checkAutoplay(playerOpts) {
    var _a;
    const apc = this.getService(ServiceName.AutoplayCapabilities);
    return apc.detectCapabilities((_a = playerOpts.overrides) == null ? void 0 : _a.blankVideoUrl);
  }
}
class PrepResourceCommand extends LogAwareSimpleCommand {
  execute(notification) {
    if (!notification.body.resource) {
      this.invalidResource(AppResources.messages.RESOURCE_MISSING);
      return;
    }
    const hooks = this.getProxy(ProxyName.HookProxy);
    hooks.applyHook(PlayerHookType.ATTACH_RESOURCE, new ResourceConfiguration(notification.body.resource)).then((resource) => {
      try {
        ResourceConfiguration.validate(resource);
      } catch (error) {
        this.invalidResource(error.message);
      }
      if (!resource.sessionId) {
        resource.sessionId = uuid();
      }
      if (!resource.cmcd.sessionId) {
        resource.cmcd.sessionId = resource.sessionId;
      }
      if (resource.contentId && !resource.cmcd.contentId) {
        resource.cmcd.contentId = resource.contentId;
      }
      this.facade.sendNotification(NotificationName.PLAY_RESOURCE, resource, NotificationType.INTERNAL);
    }).catch((error) => {
      this.facade.sendNotification(NotificationName.RESOURCE_ERROR, error.cause || error, NotificationType.INTERNAL);
    });
  }
  invalidResource(message) {
    this.facade.sendNotification(NotificationName.RESOURCE_ERROR, {
      message: `${AppResources.messages.INVALID_RESOURCE}: ${message}`,
      code: ErrorCode.INVALID_RESOURCE_FORMAT,
      fatal: true
    }, NotificationType.INTERNAL);
  }
}
class PresentationStateChangeCommand extends LogAwareSimpleCommand {
  execute(notification) {
    var _a, _b;
    const { facade } = this;
    switch (notification.name) {
      case NotificationName.RESOURCE_COMPLETE:
        const playerOptions = this.getModel(ModelName.PlayerOptions);
        if (((_a = playerOptions.overrides) == null ? void 0 : _a.closeOnEnded) === false) {
          return;
        }
        const presoM = facade.retrieveMediator(MediatorName.PRESENTATION_MEDIATOR);
        presoM == null ? void 0 : presoM.close();
        return;
      case PlayerEvent.RESOURCE_END:
        facade.retrieveMediator(MediatorName.TIMER_MEDIATOR).killTimer();
        this.sendNotification(NotificationName.KILL_RESOURCE_PRESENTATION, null, NotificationType.INTERNAL);
        break;
      case PlayerEvent.RESOURCE_BUFFERING:
        const dom = facade.retrieveProxy(ProxyName.PlayerDomProxy);
        const main = dom == null ? void 0 : dom.getMain();
        main == null ? void 0 : main.setAttribute("aria-busy", notification.body.buffering.toString());
        break;
      case PlayerEvent.AD_BREAK_START:
        const pres = facade.retrieveMediator(MediatorName.PRESENTATION_MEDIATOR);
        (_b = pres == null ? void 0 : pres.adapter) == null ? void 0 : _b.clearText();
        break;
    }
  }
}
class ReadyCommand extends LogAwareSimpleCommand {
  execute() {
    const dom = this.facade.retrieveProxy(ProxyName.PlayerDomProxy);
    if (dom) {
      const main = dom.getMain();
      main.setAttribute("role", "region");
      const tabindex = main.getAttribute("tabindex") || "0";
      main.setAttribute("tabindex", tabindex);
      const kcm = this.facade.retrieveMediator(MediatorName.KEY_COMMAND);
      kcm.initialize();
    }
  }
}
class ResumePlaybackCommand extends LogAwareSimpleCommand {
  execute(notification) {
    const presoState = this.getModel(ModelName.PresentationState);
    const pm = this.facade.retrieveMediator(MediatorName.PRESENTATION_MEDIATOR);
    presoState.suspended = false;
    pm.resume();
    const cps = this.getProxy(ProxyName.ContentPlaybackStateProxy);
    this.sendNotification(PlayerEvent.PLAYBACK_RESUMED, { contentTime: cps.model.time });
  }
}
class StartPresentationCommand extends LogAwareSimpleCommand {
  execute(notification) {
    const presentationMediator = this.facade.retrieveMediator(MediatorName.PRESENTATION_MEDIATOR);
    const resourceProxy = this.facade.retrieveProxy(ProxyName.ResourceProxy);
    this.sendNotification(PlayerEvent.RESOURCE_START, { resource: resourceProxy.resource });
    presentationMediator.start();
  }
}
class SuspendPlaybackCommand extends LogAwareSimpleCommand {
  execute(notification) {
    const presoState = this.getModel(ModelName.PresentationState);
    const pm = this.facade.retrieveMediator(MediatorName.PRESENTATION_MEDIATOR);
    pm.suspend();
    presoState.suspended = true;
    const cps = this.getProxy(ProxyName.ContentPlaybackStateProxy);
    this.sendNotification(PlayerEvent.PLAYBACK_SUSPENDED, { contentTime: cps.model.time });
  }
}
const CommandMap = {
  [NotificationName.DEFAULT]: null,
  [NotificationName.BOOT_APP]: BootCommand,
  [PlayerEvent.READY]: ReadyCommand,
  [PlayerEvent.MUTE_CHANGE]: PlaybackCommand,
  [PlayerEvent.VOLUME_CHANGE]: PlaybackCommand,
  [PlayerEvent.RESOURCE_END]: PresentationStateChangeCommand,
  [PlayerEvent.RESOURCE_BUFFERING]: PresentationStateChangeCommand,
  [PlayerEvent.AD_BREAK_START]: PresentationStateChangeCommand,
  [PlayerEvent.METRIC]: MetricCommand,
  [NotificationName.RESOURCE_COMPLETE]: PresentationStateChangeCommand,
  [NotificationName.PLAY_ON_USER_GESTURE]: PlaybackCommand,
  [NotificationName.PLAY]: PlaybackCommand,
  [NotificationName.PAUSE]: PlaybackCommand,
  [NotificationName.SEEK]: PlaybackCommand,
  [NotificationName.SWITCH_AUDIO_TRACK]: PlaybackCommand,
  [NotificationName.SWITCH_TEXT_TRACK]: PlaybackCommand,
  [NotificationName.SWITCH_TEXT_MODE]: PlaybackCommand,
  [NotificationName.SUSPEND_PLAYBACK]: SuspendPlaybackCommand,
  [NotificationName.RESUME_PLAYBACK]: ResumePlaybackCommand,
  [NotificationName.SWITCH_BITRATE]: AbrSwitchCommand,
  [NotificationName.SWITCH_QUALITY_CATEGORY]: AbrSwitchCommand,
  [NotificationName.AUTO_QUALITY_SWITCHING]: AbrSwitchCommand,
  [NotificationName.MIN_BITRATE]: AbrSwitchCommand,
  [NotificationName.MAX_BITRATE]: AbrSwitchCommand,
  [NotificationName.PREP_RESOURCE_COLLECTION]: PrepResourceCommand,
  [NotificationName.START_PRESENTATION]: StartPresentationCommand,
  [NotificationName.PLAY_RESOURCE]: PrepPlaybackCommand,
  [NotificationName.KILL_RESOURCE_PRESENTATION]: KillResourcePresentationCommand,
  [NotificationName.CHANGE_LANGUAGE]: LocalizationCommand,
  [NotificationName.PLAYER_ERROR]: HandleErrorCommand,
  [NotificationName.VIDEO_START_ERROR]: HandleErrorCommand,
  [NotificationName.VIDEO_PLAYBACK_ERROR]: HandleErrorCommand,
  [NotificationName.RESOURCE_ERROR]: HandleErrorCommand,
  [NotificationName.AD_ERROR]: HandleErrorCommand,
  [NotificationName.AD_STALLED]: HandleErrorCommand
};
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = __getOwnPropDesc(target, key);
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp2(target, key, result);
  return result;
};
class VideoPlayer extends AbstractApplication {
  /**
   * @internal
   */
  constructor(options) {
    super(Object.assign({
      commandMap: CommandMap,
      id: options.playerOptions.id || null
    }, options));
    this.pIsReady = false;
    this.seekTime = NaN;
    this.hSeekRedirect = (e) => {
      if (e.type === PlayerEvent.SEEK_REDIRECT_START && !isNaN(e.detail.actualSeekTime)) {
        this.seekTime = e.detail.actualSeekTime;
      } else if (e.type === PlayerEvent.SEEK_REDIRECT_COMPLETE) {
        this.seekTime = NaN;
      }
    };
    this.delegate = apiCollection(this.appId, this);
    this.target = this.delegate.api;
    this.logger = options.logger;
    this.init(options);
  }
  initialize() {
    const options = this.modelCollectionProxy.getModel(ModelName.PlayerOptions);
    const plugins = options.plugins || [];
    const api = this.getApi();
    const note = { name: NotificationName.CHANGE_LANGUAGE, body: { language: options.localizationLanguage }, type: NotificationType.INTERNAL };
    this.on(PlayerEvent.SEEK_REDIRECT_START, this.hSeekRedirect);
    this.on(PlayerEvent.SEEK_REDIRECT_COMPLETE, this.hSeekRedirect);
    return api.registerPlugins(plugins).then(() => {
      this.localization.registerLocalizationData(options.localization);
      return this.sendAsyncNotification(note, [PlayerEvent.LANGUAGE_CHANGE]);
    }).then(() => {
      this.pIsReady = true;
      this.sendNotification(PlayerEvent.READY, api);
      return api;
    }).catch((error) => {
      this.logger.error(error);
      throw error;
    });
  }
  /**
   * @internal
   */
  destroy() {
    this.off(PlayerEvent.SEEK_REDIRECT_START, this.hSeekRedirect);
    this.off(PlayerEvent.SEEK_REDIRECT_COMPLETE, this.hSeekRedirect);
    this.disableKeyCommands();
    const destroy = super.destroy.bind(this);
    const logger2 = this.logger;
    return this.killCurrentResource().then(() => this.plugins.destroy()).then(() => {
      destroy();
      this.delegate.destroy();
      this.delegate = null;
    }).catch((e) => {
      logger2.error(e);
      throw e;
    }).then(() => {
      logger2.destroy();
    });
  }
  /**
   * @internal
   */
  getApi() {
    return this.delegate.api;
  }
  /**
  * @internal
  */
  killCurrentResource() {
    return this.appMediator.killCurrentResource();
  }
  hasListenerFor(type) {
    if (!isString(type)) {
      throw this.invalidArgException("hasListenerFor(type)", type);
    }
    return super.hasListenerFor(type);
  }
  on(type, func) {
    if (!isString(type) || typeof func !== "function") {
      throw this.invalidArgException("on(type, func)", type, func);
    }
    Deprecated.checkEventName(type);
    super.on(type, func);
  }
  once(type, func) {
    if (!isString(type) || typeof func !== "function") {
      throw this.invalidArgException("on(type, func)", type, func);
    }
    super.once(type, func);
  }
  off(type, func) {
    if (!isString(type)) {
      throw this.invalidArgException("on(type, func)", type, func);
    }
    super.off(type, func);
  }
  get isReady() {
    return this.pIsReady;
  }
  get id() {
    return this.appId;
  }
  get dimensions() {
    return this.appMediator.getDimensions() || null;
  }
  get video() {
    return this.videoProxy.getVideo();
  }
  get isAutoplay() {
    return this.presentationState.isAutoplay;
  }
  get isFullscreen() {
    return this.presentationState.isFullscreen;
  }
  get isAd() {
    const { isTrackingAd, adSegmentEntered } = this.presentationState;
    return isTrackingAd || adSegmentEntered;
  }
  get muted() {
    return this.appMediator.getMuteState();
  }
  set muted(value) {
    if (typeof value !== "boolean") {
      throw this.invalidArgException("player.muted = boolean", value);
    }
    if (this.muted !== value) {
      this.transmitExtRequest(PlayerEvent.MUTE_CHANGE, { muted: value });
    }
  }
  get options() {
    var _a;
    const mdl = (_a = this.modelCollectionProxy.getModel(ModelName.PlayerOptions)) == null ? void 0 : _a.model;
    return mdl ? clone(mdl) : null;
  }
  get volume() {
    return this.appMediator.getVolume();
  }
  set volume(value) {
    if (!isNumber(value) || !inRange(value, 0, 1)) {
      throw this.invalidArgException("player.volume = number [0,1]", value);
    }
    if (this.volume !== value) {
      this.transmitExtRequest(PlayerEvent.VOLUME_CHANGE, { volume: value });
    }
  }
  get language() {
    return this.localization.language;
  }
  get contentTime() {
    if (!isNaN(this.seekTime)) {
      return this.seekTime;
    }
    return this.contentPlaybackStateProxy ? this.contentPlaybackStateProxy.model.time : 0;
  }
  get sessionTime() {
    const t = this.appMediator.getSessionTime();
    return t == null ? 0 : t;
  }
  get playbackTime() {
    const t = this.appMediator.getPlaybackTime();
    return t == null ? 0 : t;
  }
  get contentDuration() {
    return this.contentPlaybackStateProxy ? this.contentPlaybackStateProxy.model.duration : NaN;
  }
  get streamTime() {
    return this.presentationState.streamTime;
  }
  get streamDuration() {
    return this.presentationState.streamDuration;
  }
  get adTime() {
    return this.presentationState.adTime;
  }
  get adDuration() {
    return this.presentationState.adDuration;
  }
  get breakTime() {
    return this.presentationState.breakTime;
  }
  get breakDuration() {
    return this.presentationState.breakDuration;
  }
  get playbackState() {
    var _a;
    return ((_a = this.contentPlaybackStateProxy) == null ? void 0 : _a.model.state) || PlaybackState.IDLE;
  }
  get autoQualitySwitching() {
    var _a;
    return ((_a = this.contentPlaybackStateProxy) == null ? void 0 : _a.qualitySwitchingMode) === QualityMode.AUTO || false;
  }
  set autoQualitySwitching(value) {
    if (!isBoolean(value)) {
      throw this.invalidArgException("player.autoQualitySwitching = boolean", value);
    }
    if (this.contentPlaybackStateReady) {
      this.transmitExtRequest(NotificationName.AUTO_QUALITY_SWITCHING, { value });
    } else {
      this.logger.debug(AppResources.messages.CONTENT_PLAYBACK_SETTING_IGNORED);
    }
  }
  get quality() {
    var _a;
    return ((_a = this.contentPlaybackStateProxy) == null ? void 0 : _a.quality) || null;
  }
  get qualities() {
    var _a;
    return ((_a = this.contentPlaybackStateProxy) == null ? void 0 : _a.qualities) || [];
  }
  get qualityMode() {
    var _a;
    return ((_a = this.contentPlaybackStateProxy) == null ? void 0 : _a.qualitySwitchingMode) || QualityMode.AUTO;
  }
  get qualityCappedToScreenSize() {
    var _a;
    return ((_a = this.contentPlaybackStateProxy) == null ? void 0 : _a.qualityCappedToScreenSize) === true;
  }
  set qualityCappedToScreenSize(value) {
    var _a;
    if (!isBoolean(value)) {
      throw this.invalidArgException("player.qualityCappedToScreenSize = boolean", value);
    }
    if (!this.contentPlaybackStateProxy) {
      this.logger.debug(AppResources.messages.CONTENT_PLAYBACK_SETTING_IGNORED);
      return;
    }
    this.contentPlaybackStateProxy.qualityCappedToScreenSize = value;
    (_a = this.getAdapter(AdapterRole.PLAYBACK)) == null ? void 0 : _a.setQualityCappedToScreenSize(value);
  }
  get bitrate() {
    const quality = this.quality || { bitrate: NaN };
    const bitrate = quality.bitrate != null ? quality.bitrate : NaN;
    return bitrate;
  }
  set bitrate(bitrate) {
    if (!isNumber(bitrate)) {
      throw this.invalidArgException("player.bitrate = number", bitrate);
    }
    if (this.contentPlaybackStateReady) {
      this.transmitExtRequest(NotificationName.SWITCH_BITRATE, { value: bitrate });
    } else {
      this.logger.debug(AppResources.messages.CONTENT_PLAYBACK_SETTING_IGNORED);
    }
  }
  get qualityCategory() {
    return this.contentPlaybackStateProxy ? this.contentPlaybackStateProxy.userQualityCategory : null;
  }
  set qualityCategory(category) {
    if (!isString(category)) {
      throw this.invalidArgException("player.qualityCategory = string", category);
    }
    if (this.contentPlaybackStateReady) {
      this.transmitExtRequest(NotificationName.SWITCH_QUALITY_CATEGORY, { value: category });
    } else {
      this.logger.debug(AppResources.messages.CONTENT_PLAYBACK_SETTING_IGNORED);
    }
  }
  get minBitrate() {
    return this.contentPlaybackStateProxy ? this.contentPlaybackStateProxy.minBitrate : NaN;
  }
  set minBitrate(value) {
    if (!isNumber(value)) {
      throw this.invalidArgException("player.minBitrate = number", value);
    }
    if (this.contentPlaybackStateReady) {
      this.transmitExtRequest(NotificationName.MIN_BITRATE, { value });
    } else {
      this.logger.debug(AppResources.messages.CONTENT_PLAYBACK_SETTING_IGNORED);
    }
  }
  get maxBitrate() {
    return this.contentPlaybackStateProxy ? this.contentPlaybackStateProxy.maxBitrate : NaN;
  }
  set maxBitrate(value) {
    if (!isNumber(value)) {
      throw this.invalidArgException("player.maxBitrate = number", value);
    }
    if (this.contentPlaybackStateReady) {
      this.transmitExtRequest(NotificationName.MAX_BITRATE, { value });
    } else {
      this.logger.debug(AppResources.messages.CONTENT_PLAYBACK_SETTING_IGNORED);
    }
  }
  get audioTracks() {
    var _a;
    return ((_a = this.contentPlaybackStateProxy) == null ? void 0 : _a.audioTracks) || [];
  }
  get audioTrack() {
    return this.contentPlaybackStateProxy ? this.contentPlaybackStateProxy.audioTrack : null;
  }
  set audioTrack(track) {
    if (!track) {
      throw this.invalidArgException("player.audioTrack = AudioTrackInterface", track);
    }
    if (this.contentPlaybackStateReady) {
      this.transmitExtRequest(NotificationName.SWITCH_AUDIO_TRACK, { value: track });
    } else {
      this.logger.debug(AppResources.messages.CONTENT_PLAYBACK_SETTING_IGNORED);
    }
  }
  attachResource(resource) {
    this.logger.time(Measurement.RESOURCE_ATTACHMENT);
    return this.stop().then(() => {
      if (!resource || isEmpty(resource)) {
        throw this.invalidArgException("attachResource(resource)", resource);
      }
    }).then(() => {
      return this.sendAsyncNotification({
        name: NotificationName.PREP_RESOURCE_COLLECTION,
        body: { resource, start: true }
      }, [PlayerEvent.RESOURCE_START]);
    }).then(() => {
      this.logger.timeEnd(Measurement.RESOURCE_ATTACHMENT);
      return this.resource;
    }).catch((event) => {
      throw PlayerError.eventToError(event, ErrorCategory.RESOURCE);
    });
  }
  get resource() {
    return this.appMediator.getCurrentResource();
  }
  get textTrackEnabled() {
    return this.facade.retrieveProxy(ProxyName.TextTrackProxy).enabled;
  }
  set textTrackEnabled(value) {
    if (!isBoolean(value)) {
      throw this.invalidArgException("player.textTrackEnabled = boolean", value);
    }
    this.transmitExtRequest(NotificationName.SWITCH_TEXT_MODE, { value });
  }
  get textTrack() {
    var _a;
    return ((_a = this.contentPlaybackStateProxy) == null ? void 0 : _a.textTrack) || null;
  }
  set textTrack(value) {
    if (!value || !value.kind) {
      throw this.invalidArgException("player.textTrack = TextTrackInterface", value);
    }
    if (this.contentPlaybackStateReady) {
      this.transmitExtRequest(NotificationName.SWITCH_TEXT_TRACK, { value });
    } else {
      this.logger.debug(AppResources.messages.CONTENT_PLAYBACK_SETTING_IGNORED);
    }
  }
  get textTracks() {
    var _a;
    return ((_a = this.contentPlaybackStateProxy) == null ? void 0 : _a.textTracks) || [];
  }
  get streamType() {
    return this.contentPlaybackStateProxy ? this.contentPlaybackStateProxy.model.streamType : null;
  }
  get isPlayingLive() {
    const lsi = this.contentPlaybackStateProxy ? this.contentPlaybackStateProxy.model.liveStreamInfo : null;
    return (lsi == null ? void 0 : lsi.isPlayingLive) === true;
  }
  get liveStreamUtcStart() {
    const lsi = this.contentPlaybackStateProxy ? this.contentPlaybackStateProxy.model.liveStreamInfo : null;
    return lsi ? lsi.absoluteStart : NaN;
  }
  get liveStreamUtcTime() {
    const lsi = this.contentPlaybackStateProxy ? this.contentPlaybackStateProxy.model.liveStreamInfo : null;
    return lsi ? lsi.absoluteTime : NaN;
  }
  get liveStreamUtcDuration() {
    const lsi = this.contentPlaybackStateProxy ? this.contentPlaybackStateProxy.model.liveStreamInfo : null;
    return lsi ? lsi.absoluteDuration : NaN;
  }
  get isSuspended() {
    return this.appMediator.isPlaybackSuspended();
  }
  get fullscreenElement() {
    return this.appMediator.getFullscreenElement();
  }
  set fullscreenElement(value) {
    var _a, _b;
    if (!value || !/element/.test((_b = (_a = value.constructor) == null ? void 0 : _a.name) == null ? void 0 : _b.toLowerCase())) {
      throw this.invalidArgException("player.fullscreenElement = HTMLElement", value);
    }
    this.appMediator.setFullscreenElement(value);
  }
  get pausable() {
    var _a;
    const pausable = ((_a = this.opts.playerOptions.overrides) == null ? void 0 : _a.liveStreamPausable) !== false;
    return pausable ? pausable : this.streamType !== StreamType.LIVE;
  }
  updateDimensions() {
    this.appMediator.updateDimensions();
  }
  enterFullscreen() {
    this.transmitExtRequest(NotificationName.ENTER_FULLSCREEN_REQUEST);
  }
  exitFullscreen() {
    this.transmitExtRequest(NotificationName.EXIT_FULLSCREEN_REQUEST);
  }
  play() {
    this.recordMetric(MetricType.API, ApiMetric.PLAY);
    if (this.appMediator.isPlaybackSuspended()) {
      this.transmitExtRequest(NotificationName.RESUME_PLAYBACK);
    }
    const note = { name: NotificationName.PLAY, type: NotificationType.EXTERNAL };
    return this.sendAsyncNotification(note, [PlayerEvent.CONTENT_PLAYING, PlayerEvent.AD_PLAYING]);
  }
  pause() {
    this.recordMetric(MetricType.API, ApiMetric.PAUSE);
    if (!this.pausable) {
      this.logger.debug(AppResources.messages.PAUSING_LINEAR_LIVE_STREAM_NOT_ALLOWED);
      return this.stop();
    } else {
      if (this.playbackState === PlaybackState.PAUSED) {
        return Promise.resolve();
      }
      const note = { name: NotificationName.PAUSE, type: NotificationType.EXTERNAL };
      return this.sendAsyncNotification(note, [PlayerEvent.CONTENT_PAUSED, PlayerEvent.AD_PAUSED]);
    }
  }
  togglePlayPause() {
    return this.playbackState === PlaybackState.PLAYING ? this.pause() : this.play();
  }
  toggleMuted() {
    return this.muted = !this.muted;
  }
  toggleFullscreen() {
    this.isFullscreen ? this.exitFullscreen() : this.enterFullscreen();
  }
  toggleTextTrack() {
    return this.textTrackEnabled = !this.textTrackEnabled;
  }
  seek(position) {
    this.recordMetric(MetricType.API, ApiMetric.SEEK, position);
    return this.hooks.applyHook(PlayerHookType.SEEK, {
      position,
      contentTime: this.contentTime,
      contentDuration: this.contentDuration,
      streamTime: this.streamTime,
      streamDuration: this.streamDuration
    }).then((result) => {
      if (result == null) {
        return void 0;
      }
      const value = this.appMediator.validateSeek(result.position, this.contentDuration);
      if (value == null) {
        return Promise.reject(this.invalidArgException("seek(position)", result));
      }
      return this.seekInternal(value);
    });
  }
  jump(increment) {
    return this.seek(this.contentTime + increment);
  }
  getAdBreakTimes() {
    return this.appMediator.getAdBreakTimes() || [];
  }
  grabFrame() {
    return this.appMediator.grabFrame();
  }
  getThumbnails(time) {
    var _a;
    if (!isNumber(time)) {
      throw this.invalidArgException("getThumbnails(time)", time);
    }
    return Promise.resolve((_a = this.getAdapter(AdapterRole.PLAYBACK)) == null ? void 0 : _a.getThumbnails(time)).then((thumbs) => thumbs || []).then((thumbs) => {
      var _a2;
      const thumb = (_a2 = this.contentPlaybackStateProxy) == null ? void 0 : _a2.getThumbnail(time);
      if (thumb) {
        thumbs.push(thumb.data);
      }
      return thumbs;
    });
  }
  getContainerRect() {
    return this.appMediator.getContainerRect();
  }
  registerPlugins(plugins, callback) {
    if (!Array.isArray(plugins)) {
      return Promise.reject(this.invalidArgException("registerPlugins(cfgArray, callback?)", plugins, callback));
    }
    if (callback) {
      Deprecated.registerPlugins();
    }
    return new Promise((resolve, reject) => {
      this.transmitExtRequest(NotificationName.LOAD_PLUGINS, {
        plugins,
        callback: (error) => {
          if (typeof callback === "function") {
            callback(error);
          }
          return error ? reject(error) : resolve();
        }
      });
    });
  }
  removePlugin(name) {
    if (!isString(name)) {
      throw this.invalidArgException("removePlugin(name)", name);
    }
    this.transmitExtRequest(NotificationName.REMOVE_PLUGIN, {
      name
    });
  }
  registerAdapter(adapterConfig) {
    if (isEmpty(adapterConfig)) {
      throw this.invalidArgException("registerAdapter(adapterConfig)", adapterConfig);
    }
    return this.adapters.registerAdapter(adapterConfig);
  }
  retrieveAdapter(id) {
    if (!isString(id)) {
      throw this.invalidArgException("retrieveAdapter(id)", id);
    }
    return this.adapters.retrieveAdapter(id);
  }
  removeAdapter(id) {
    if (!isString(id)) {
      this.invalidArgException("removeAdapter(id)", id);
    }
    return this.adapters.removeAdapter(id);
  }
  registerHook(type, hook) {
    if (!isString(type) || typeof hook !== "function") {
      throw this.invalidArgException("registerHook(type, hook)", type, hook);
    }
    return this.hooks.registerHook(type, hook);
  }
  removeHook(type, hook) {
    if (!isString(type) || typeof hook !== "function") {
      throw this.invalidArgException("removeHook(type, hook)", type, hook);
    }
    return this.hooks.removeHook(type, hook);
  }
  getPlugin(name) {
    if (!isString(name)) {
      throw this.invalidArgException("getPlugin(name)", name);
    }
    return this.appMediator.getPlugin(name);
  }
  getAdapter(role) {
    const presentationMediator = this.presentationMediator;
    if (!isString(role)) {
      throw this.invalidArgException("getAdapter(role)", role);
    }
    if (!presentationMediator) {
      return null;
    }
    switch (role) {
      case AdapterRole.AD:
        return presentationMediator.adAdapter || null;
      case AdapterRole.PLAYBACK:
        return presentationMediator.adapter || null;
      case AdapterRole.VIDEO:
        return this.videoProxy.getAdapter() || null;
      default:
        return null;
    }
  }
  stop() {
    var _a;
    if (!((_a = this.contentPlaybackStateProxy) == null ? void 0 : _a.model) || !this.presentationMediator) {
      return Promise.resolve();
    }
    return this.appMediator.killCurrentResource();
  }
  goLive() {
    this.recordMetric(MetricType.API, ApiMetric.GO_LIVE);
    if (this.streamType && this.streamType !== StreamType.VOD) {
      return this.seekInternal(this.contentDuration);
    }
    return Promise.reject(`goLive() can not be invoked on streams of type ${this.streamType}`);
  }
  skipAd() {
    this.appMediator.skipAd();
  }
  focus(options) {
    var _a;
    const main = (_a = this.dom) == null ? void 0 : _a.getMain();
    if (main) {
      main.focus(options);
    }
  }
  blur() {
    const main = this.dom.getMain();
    if (main) {
      main.blur();
    }
  }
  getKeyEventTarget() {
    return this.appMediator.getKeyEventTarget();
  }
  disableKeyCommands(flag) {
    this.appMediator.disableKeyCommands(flag);
  }
  enterActionKeyContext(context) {
    this.appMediator.enterActionKeyContext(context);
  }
  getActionKeyContext() {
    return this.appMediator.getActionKeyContext();
  }
  exitActionKeyContext(context) {
    this.appMediator.exitActionKeyContext(context);
  }
  getConfigAsJson(spacing) {
    return this.appMediator.getConfigAsJson(spacing);
  }
  suspendPlayback() {
    if (!this.appMediator.isPlaybackSuspended()) {
      this.pause().then(() => {
        this.transmitExtRequest(NotificationName.SUSPEND_PLAYBACK);
      });
    }
  }
  resumePlayback() {
    this.play();
  }
  recordMetric(type, key, value) {
    if (!isString(type) || !isString(key)) {
      throw this.invalidArgException("recordMetric(type, key, value?)", type, key, value);
    }
    this.sendNotification(PlayerEvent.METRIC, { metric: new Metric(key, value, type) });
  }
  offsetTimedText(pixelOffset) {
    if (!isNumber(pixelOffset)) {
      throw this.invalidArgException("offsetTimedText(pixelOffset)", pixelOffset);
    }
    this.appMediator.offsetTimedText(pixelOffset);
  }
  primeVideoElement() {
    return this.appMediator.primeVideoElement();
  }
  selectAudioLanguage(language, type) {
    if (!isString(language)) {
      throw this.invalidArgException("player.selectAudioLanguage(language)", language);
    }
    const playerOptions = this.modelCollectionProxy.getModel(ModelName.PlayerOptions);
    playerOptions.audioLanguage = language;
    if (!this.contentPlaybackStateReady) {
      return Promise.resolve(null);
    }
    const { preferSpatialAudio } = this.resource.playback || {};
    let matches = findLanguageTracks(this.audioTracks, language).filter((track) => type === void 0 || track.type === type);
    if (matches.length > 1 && preferSpatialAudio !== void 0) {
      matches = matches.filter((track) => track.spatialAudio === preferSpatialAudio);
    }
    const audioTrack = matches[0] || findDefaultTrack(this.audioTracks, language);
    if (!audioTrack || audioTrack === this.audioTrack) {
      return Promise.resolve(audioTrack);
    }
    const note = { name: NotificationName.SWITCH_AUDIO_TRACK, body: { value: audioTrack }, type: NotificationType.EXTERNAL };
    return this.sendAsyncNotification(note, [PlayerEvent.AUDIO_TRACK_CHANGE]).then((data) => {
      return audioTrack;
    });
  }
  selectTextLanguage(language, type) {
    if (!isString(language)) {
      throw this.invalidArgException("player.selectTextLanguage(language)", language);
    }
    const playerOptions = this.modelCollectionProxy.getModel(ModelName.PlayerOptions);
    playerOptions.textLanguage = language;
    this.facade.retrieveProxy(ProxyName.TextTrackProxy).language = language;
    if (!this.contentPlaybackStateReady) {
      return Promise.resolve(null);
    }
    const textTrack = findDefaultTrack(this.textTracks, language);
    if (!textTrack || textTrack === this.textTrack) {
      return Promise.resolve(textTrack);
    }
    const note = { name: NotificationName.SWITCH_TEXT_TRACK, body: { value: textTrack }, type: NotificationType.EXTERNAL };
    return this.sendAsyncNotification(note, [PlayerEvent.TEXT_TRACK_CHANGE]).then((data) => {
      return textTrack;
    });
  }
  selectLocalizationLanguage(language) {
    if (!isString(language)) {
      throw this.invalidArgException("player.selectLocalizationLanguage(language)", language);
    }
    const playerOptions = this.modelCollectionProxy.getModel(ModelName.PlayerOptions);
    playerOptions.language = language;
    const note = { name: NotificationName.CHANGE_LANGUAGE, body: { language }, type: NotificationType.EXTERNAL };
    return this.sendAsyncNotification(note, [PlayerEvent.LANGUAGE_CHANGE]).then((data) => {
      return data.localeData;
    });
  }
  waitForEvent(success, fail, timeout) {
    return waitForEvent(this, success, fail, timeout);
  }
  waitForTime(time, prop) {
    return waitForTime(this, time, prop);
  }
  getBuffered(asStreamTime = false) {
    return this.appMediator.getBuffered(asStreamTime) || [];
  }
  localize(key, context, language) {
    return this.localization.localize(key, context, language);
  }
  registerLocalizationData(data) {
    return this.localization.registerLocalizationData(data);
  }
  // end methods
  ////////////////////
  // END PUBLIC API //
  ////////////////////
  /**
   * @internal
   */
  sendEvent(name, data = {}) {
    if (data instanceof CoreEvent) {
      this.dispatchEvt(data);
    } else {
      this.emit(name, data);
    }
  }
  get contentPlaybackStateProxy() {
    return this.facade.retrieveProxy(ProxyName.ContentPlaybackStateProxy);
  }
  get contentPlaybackStateReady() {
    var _a;
    return ((_a = this.contentPlaybackStateProxy) == null ? void 0 : _a.isReady) || false;
  }
  get localization() {
    return this.facade.retrieveProxy(ProxyName.LocalizationProxy);
  }
  get dom() {
    return this.facade.retrieveProxy(ProxyName.PlayerDomProxy);
  }
  get videoProxy() {
    return this.facade.retrieveProxy(ProxyName.VideoProxy);
  }
  get adapters() {
    return this.facade.retrieveProxy(ProxyName.AdapterProxy);
  }
  get plugins() {
    return this.facade.retrieveMediator(MediatorName.PLUGIN_MEDIATOR);
  }
  get presentationState() {
    return this.modelCollectionProxy.getModel(ModelName.PresentationState);
  }
  get presentationMediator() {
    return this.facade.retrieveMediator(MediatorName.PRESENTATION_MEDIATOR);
  }
  get hooks() {
    return this.facade.retrieveProxy(ProxyName.HookProxy);
  }
  transmitExtRequest(name, data) {
    this.sendNotification(name, data, NotificationType.EXTERNAL);
  }
  init(options) {
    const hookProxy = new HookProxy(this.getApi());
    this.facade.registerProxy(hookProxy);
    const gServices = this.opts.globalServices;
    this.logger.info(`${buildInfo.playerName}@${buildInfo.playerVersion}  ${buildInfo.buildTime}`);
    this.registerGlobalServices(gServices);
    delete this.opts.globalServices;
    this.sendNotification(NotificationName.BOOT_APP, __spreadProps(__spreadValues({}, this.opts), {
      app: this
    }), NotificationType.INTERNAL);
    this.logger.on(LoggerEvent.TIME_EVENT, (event) => {
      const { id, label, item } = event.detail;
      const name = `${label}:start`;
      this.recordMetric(MetricType.MARK, name, { id, name, startTime: item.startTime });
    });
    this.logger.on(LoggerEvent.TIME_END_EVENT, (event) => {
      const { id, label, item } = event.detail;
      const { startTime, duration } = item;
      const name = `${label}:end`;
      this.recordMetric(MetricType.MARK, name, { id, name, startTime: startTime + duration });
      this.recordMetric(MetricType.MEASURE, label, { id, name: label, startTime, duration });
    });
  }
  sendAsyncNotification(notification, events) {
    const promise = eventsToPromise(
      [{ target: this, events }],
      [{ target: this, events: [PlayerEvent.ERROR] }]
    );
    this.sendNotification(notification.name, notification.body, notification.type);
    return promise;
  }
  invalidArgException(name, ...rest) {
    const rm = rest == null ? void 0 : rest.map((i) => i === void 0 ? "undefined" : i);
    const value = (rm == null ? void 0 : rm.toString()) || null;
    const msg = `${name}; ${AppResources.messages.API_INVALID_ARG}; supplied arg(s): ${value}`;
    this.logger.debug(msg);
    return new InvalidArgumentError(msg);
  }
  seekInternal(value) {
    this.seekTime = value;
    if (this.seekPending) {
      return this.seekPending.then(() => {
        return this.seekTime === value ? this.seekInternal(this.seekTime) : void 0;
      });
    }
    const note = { name: NotificationName.SEEK, body: { value }, type: NotificationType.EXTERNAL };
    this.seekPending = this.sendAsyncNotification(note, [PlayerEvent.SEEK_COMPLETE]);
    return this.seekPending.then(() => {
      const diff = Math.abs(value - this.seekTime);
      if (diff <= 1) {
        this.seekTime = NaN;
      }
      this.seekPending = null;
    }).catch((e) => {
      this.seekPending = null;
      throw new PlayerError(
        ErrorCode.UNEXPECTED_CONDITION,
        (e == null ? void 0 : e.message) || `An error occurred on seek to ${value}`,
        e || null,
        false,
        ErrorCategory.API
      );
    }).then(() => {
      this.seekPending = null;
    });
  }
}
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "hasListenerFor");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "on");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "once");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "off");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "isReady");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "id");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "dimensions");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "video");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "isAutoplay");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "isFullscreen");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "isAd");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "muted");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "options");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "volume");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "language");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "contentTime");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "sessionTime");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "playbackTime");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "contentDuration");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "streamTime");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "streamDuration");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "adTime");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "adDuration");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "breakTime");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "breakDuration");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "playbackState");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "autoQualitySwitching");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "quality");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "qualities");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "qualityMode");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "qualityCappedToScreenSize");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "bitrate");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "qualityCategory");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "minBitrate");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "maxBitrate");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "audioTracks");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "audioTrack");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "attachResource");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "resource");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "textTrackEnabled");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "textTrack");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "textTracks");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "streamType");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "isPlayingLive");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "liveStreamUtcStart");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "liveStreamUtcTime");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "liveStreamUtcDuration");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "isSuspended");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "fullscreenElement");
__decorateClass([
  apiAccessor()
], VideoPlayer.prototype, "pausable");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "updateDimensions");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "enterFullscreen");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "exitFullscreen");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "play");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "pause");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "togglePlayPause");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "toggleMuted");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "toggleFullscreen");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "toggleTextTrack");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "seek");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "jump");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "getAdBreakTimes");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "grabFrame");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "getThumbnails");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "getContainerRect");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "registerPlugins");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "removePlugin");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "registerAdapter");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "retrieveAdapter");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "removeAdapter");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "registerHook");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "removeHook");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "getPlugin");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "getAdapter");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "stop");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "goLive");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "skipAd");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "focus");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "blur");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "getKeyEventTarget");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "disableKeyCommands");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "enterActionKeyContext");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "getActionKeyContext");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "exitActionKeyContext");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "getConfigAsJson");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "suspendPlayback");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "resumePlayback");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "recordMetric");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "offsetTimedText");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "primeVideoElement");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "selectAudioLanguage");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "selectTextLanguage");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "selectLocalizationLanguage");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "waitForEvent");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "waitForTime");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "getBuffered");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "localize");
__decorateClass([
  apiMethod()
], VideoPlayer.prototype, "registerLocalizationData");
let polyfillsChecked = false;
let initialized;
let serviceCollection = null;
const playerCollection = {};
const pendingPlayerCreates = {};
const pendingPlayerDestroys = {};
function checkPolyfills() {
  if (polyfillsChecked) {
    return;
  }
  polyfillsChecked = true;
  const tests = {
    "Array.from": () => Array.from,
    "Array.prototype.find": () => Array.prototype.find,
    "Array.prototype.findIndex": () => Array.prototype.findIndex,
    "Array.prototype.includes": () => Array.prototype.includes,
    "Map": () => typeof Map !== "undefined",
    "Object.assign": () => Object.assign,
    "Object.entries": () => Object.entries,
    "Object.values": () => Object.values,
    "Promise": () => typeof Promise !== "undefined",
    "Set": () => typeof Set !== "undefined",
    "String.prototype.includes": () => String.prototype.includes,
    "String.prototype.repeat": () => String.prototype.repeat
  };
  Object.keys(tests).forEach((key) => {
    let passed = false;
    try {
      passed = !!tests[key]();
    } catch (error) {
      passed = false;
    } finally {
      if (!passed) {
        logger.warn(`Polyfill warning: ${key} is not defined`);
      }
    }
  });
}
function initialize(options) {
  if (initialized) {
    return initialized;
  }
  checkPolyfills();
  const autoplayCapabilities = AutoplayCapabilitiesService.getInstance();
  const overrides = options.overrides;
  const deferAutoplayDetection = (overrides == null ? void 0 : overrides.deferAutoplayDetection) !== false;
  return initialized = Promise.all([
    !deferAutoplayDetection && autoplayCapabilities.detectCapabilities(overrides == null ? void 0 : overrides.blankVideoUrl)
  ]).then(() => {
    serviceCollection = {
      [ServiceName.AutoplayCapabilities]: autoplayCapabilities
    };
  });
}
function getVideoPlayerIds() {
  return Object.keys(pendingPlayerCreates).concat(Object.keys(playerCollection)).reduce((acc, id) => {
    if (!acc.includes(id)) {
      acc.push(id);
    }
    return acc;
  }, []);
}
function getDeviceCapabilities() {
  return __async(this, null, function* () {
    return yield applyHook(AviaHookType.DEVICE_CAPABILITIES, __spreadValues({
      drm: {
        keySystemStatus: [],
        hdcpStatus: []
      }
    }, System.supportedMedia));
  });
}
function createVideoPlayer(playerOptions) {
  const playerCreateStart = performance.now();
  const options = new PlayerOptions$1(playerOptions);
  const { id } = options;
  const playerLogger = logger.create({ logLevel: options.logLevel || logger.logLevel, id });
  return pendingPlayerCreates[id] = initialize(options).then(() => __async(this, null, function* () {
    try {
      const opts = yield applyHook(AviaHookType.CREATE_PLAYER, options);
      const player = new VideoPlayer({
        globalServices: serviceCollection,
        playerOptions: opts,
        logger: playerLogger
      });
      playerLogger.time(Measurement.PLAYER_CREATION, playerCreateStart);
      return player.initialize().then((api) => ({ api, player }));
    } catch (error) {
      if (error.key) {
        error.message = `A player with id "${error.key}" a already exists`;
      }
      throw error;
    }
  })).then(({ api, player }) => {
    playerCollection[id] = player;
    delete pendingPlayerCreates[id];
    playerLogger.timeEnd(Measurement.PLAYER_CREATION);
    return api;
  });
}
function retrieveVideoPlayer(playerId) {
  const player = playerCollection[playerId];
  if (player) {
    return Promise.resolve(player);
  }
  const destroy = pendingPlayerDestroys[playerId];
  if (destroy) {
    return destroy.then(() => null);
  }
  const pending = pendingPlayerCreates[playerId];
  if (pending) {
    return pending;
  }
  return Promise.resolve(null);
}
function removeVideoPlayer(playerId) {
  const pending = pendingPlayerDestroys[playerId];
  if (pending) {
    return pending;
  }
  return Promise.resolve().then(() => {
    if (pendingPlayerCreates[playerId]) {
      return pendingPlayerCreates[playerId];
    }
    return null;
  }).then(() => __async(this, null, function* () {
    const player = playerCollection[playerId];
    if (!player) {
      return Promise.resolve();
    }
    const { logLevel } = player.options;
    delete playerCollection[playerId];
    yield applyHook(AviaHookType.REMOVE_PLAYER, player);
    return pendingPlayerDestroys[playerId] = player.destroy().then(() => {
      delete pendingPlayerDestroys[playerId];
      if (logLevel === LogLevel.INFO || logLevel === LogLevel.DEBUG) {
        logger.info(`[Avia] Player with id "${playerId}" removed.`);
      }
    });
  }));
}
function createResourceConfig(config2) {
  return new ResourceConfiguration(config2);
}
function getSystemInfo() {
  return System;
}
function getAutoplayCapabilities(url) {
  return AutoplayCapabilitiesService.getInstance().detectCapabilities(url);
}
const avia = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AccessibilityAction,
  ActionKey,
  ActionKeyContext,
  ActionKeyError,
  ActiveState,
  AdBreakType,
  AdTechnology,
  AdapterRole,
  ApiMetric,
  AudioRole,
  AudioTrackType,
  Autoplay,
  AviaHookType,
  Browser,
  CoreEvent,
  DEFAULT_LANGUAGE,
  DOM_VIDEO,
  Device,
  DrmKeySystemAvailability,
  DrmRobustness,
  DrmType,
  Emitter,
  ErrorCategory,
  ErrorCode,
  ErrorMessage,
  FileExtensionToMimeType,
  HTML5,
  HdcpStatus,
  Header,
  HookError,
  Html5Adapter,
  InvalidArgumentError,
  KeyCode,
  KeyboardEventType,
  KeyboardScope,
  Localization,
  LocalizationId,
  LocalizedLanguage,
  LogLevel,
  Logger,
  LoggerEvent,
  Measurement,
  Metric,
  MetricType,
  MimeType,
  Os,
  PerformanceMode,
  Platform,
  PlaybackAdapterBase,
  PlaybackState,
  PlayerError,
  PlayerEvent,
  PlayerHookType,
  PluginError,
  PluginPriority,
  QualityCategory,
  QualityLabel,
  QualityMode,
  QueryString,
  RequestCredentials,
  RequestMethod,
  RequestObjectType,
  ResponseType,
  StreamType,
  System,
  TextTrackEvent,
  TextTrackKind,
  TextTrackMode,
  Timer,
  UiMetric,
  Util,
  VideoFormat,
  WILDCARD,
  applyHook,
  buildInfo,
  changeLanguage,
  checkPolyfills,
  cmcd: index,
  configure,
  createResourceConfig,
  createThumbnailStyles,
  createVideoPlayer,
  defineHook,
  eventsToPromise,
  extensionContext,
  getAutoplayCapabilities,
  getConfiguration,
  getDeviceCapabilities,
  getSystemInfo,
  getVideoPlayerIds,
  hasHook,
  id3,
  localization,
  localize,
  logger,
  queue,
  registerActionKeyContext,
  registerHook,
  registerLocalizationData,
  removeActionKeyContext,
  removeHook,
  removeVideoPlayer,
  renderThumbnail,
  request,
  retrieveActionKeyContext,
  retrieveVideoPlayer,
  use,
  waitFor,
  waitForEvent,
  waitForTime,
  waitUntil
}, Symbol.toStringTag, { value: "Module" }));
System.appNamespace = avia;
export {
  AccessibilityAction,
  ActionKey,
  ActionKeyContext,
  ActionKeyError,
  ActiveState,
  AdBreakType,
  AdTechnology,
  AdapterRole,
  ApiMetric,
  AudioRole,
  AudioTrackType,
  Autoplay,
  AviaHookType,
  Browser,
  CoreEvent,
  DEFAULT_LANGUAGE,
  DOM_VIDEO,
  Device,
  DrmKeySystemAvailability,
  DrmRobustness,
  DrmType,
  Emitter,
  ErrorCategory,
  ErrorCode,
  ErrorMessage,
  FileExtensionToMimeType,
  HTML5,
  HdcpStatus,
  Header,
  HookError,
  Html5Adapter,
  InvalidArgumentError,
  KeyCode,
  KeyboardEventType,
  KeyboardScope,
  Localization,
  LocalizationId,
  LocalizedLanguage,
  LogLevel,
  Logger,
  LoggerEvent,
  Measurement,
  Metric,
  MetricType,
  MimeType,
  Os,
  PerformanceMode,
  Platform,
  PlaybackAdapterBase,
  PlaybackState,
  PlayerError,
  PlayerEvent,
  PlayerHookType,
  PluginError,
  PluginPriority,
  QualityCategory,
  QualityLabel,
  QualityMode,
  QueryString,
  RequestCredentials,
  RequestMethod,
  RequestObjectType,
  ResponseType,
  StreamType,
  System,
  TextTrackEvent,
  TextTrackKind,
  TextTrackMode,
  Timer,
  UiMetric,
  Util,
  VideoFormat,
  WILDCARD,
  applyHook,
  buildInfo,
  changeLanguage,
  checkPolyfills,
  index as cmcd,
  configure,
  createResourceConfig,
  createThumbnailStyles,
  createVideoPlayer,
  defineHook,
  eventsToPromise,
  extensionContext,
  getAutoplayCapabilities,
  getConfiguration,
  getDeviceCapabilities,
  getSystemInfo,
  getVideoPlayerIds,
  hasHook,
  id3,
  localization,
  localize,
  logger,
  queue,
  registerActionKeyContext,
  registerHook,
  registerLocalizationData,
  removeActionKeyContext,
  removeHook,
  removeVideoPlayer,
  renderThumbnail,
  request,
  retrieveActionKeyContext,
  retrieveVideoPlayer,
  use,
  waitFor,
  waitForEvent,
  waitForTime,
  waitUntil
};
//# sourceMappingURL=avia.esm.js.map
